{
  "common": {
    "knowledgeAreaInfo": {
      "tooltip": "Knowledge Areas overview",
      "title": "Knowledge Areas",
      "description": "Available areas with description",
      "noDescription": "No description provided",
      "empty": "No Knowledge Areas available"
    },
    "changeLanguage": "Change language",
    "logout": "Logout",
    "reset": "Reset",
    "search": "Search...",
    "resetting": "Resetting...",
    "loading": "Loading...",
    "saving": "Saving...",
    "back": "Back",
    "create": "Create",
    "creating": "Creating...",
    "save": "Save",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "close": "Close",
    "open": "Open",
    "show": "Show",
    "hide": "Hide",
    "on": "On",
    "off": "Off",
    "actions": "Actions",
    "openMenu": "Open menu",
    "copy": "Copy",
    "edit": "Edit",
    "delete": "Delete",
    "locale": "en-US",
    "select": "Select...",
    "markAsRead": "Mark as read",
    "refresh": "Refresh",
    "success": "Success",
    "optional": "Optional",
    "add": "Add",
    "copied": "Copied to clipboard",
    "copyFailed": "Failed to copy",
    "download": "Download",
    "of": "of",
    "noResults": "No results",
    "eyedropper": "Use eyedropper",
    "eyedropperUnavailable": "Eyedropper unavailable",
    "currentColor": "Current color",
    "autoVerifyTl1": "Auto-Verify TL1",
    "autoVerifyTl1Description": "Mark nodes and edges as TL1-verified directly",
    "retry": "Retry",
    "info": "Info",
    "error": "Error",
    "next": "Next",
    "done": "Done",
    "all": "All",
    "clear": "Clear",
    "application": "Application",
    "name": "Name",
    "description": "Description",
    "pleaseSelect": "Please select",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "remove": "Remove",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomReset": "Actual size",
    "yes": "Yes",
    "no": "No",
    "justNow": "just now",
    "showLess": "Show less",
    "showMore": "Show more",
    "scrollToTop": "Scroll to top",
    "dragToMove": "Drag to move",
    "switchToLightMode": "Switch to light mode",
    "switchToDarkMode": "Switch to dark mode"
  },
  "notifications": {
    "events": {
      "documentUploadCompletedTitle": "Document upload completed",
      "documentUploadCompletedMessage": "The document \"{{documentTitle}}\" was uploaded successfully.",
      "sessionAssignedTitle": "New session assigned",
      "sessionAssignedMessage": "You have been assigned to the session \"{{sessionTitle}}\".",
      "sessionAssignedMessageWithDeadline": "You have been assigned to the session \"{{sessionTitle}}\". Deadline: {{deadline}}.",
      "defaultSessionName": "Session",
      "promptSharedTitle": "Prompt shared",
      "promptSharedMessage": "The prompt \"{{promptTitle}}\" has been shared with you.",
      "newBugReportTitle": "New bug report",
      "newBugReportMessage": "A new bug report has been submitted: \"{{title}}\".",
      "newFeatureRequestTitle": "New feature request",
      "newFeatureRequestMessage": "A new feature request has been submitted: \"{{title}}\".",
      "documentUploadFailedTitle": "Upload incomplete",
      "documentUploadFailedMessage": "{{failed}} of {{total}} file(s) not uploaded: {{files}}",
      "quotaRequestTitle": "Quota request",
      "quotaRequestMessage": "{{name}} has used up their monthly budget and is asking for more quota.",
      "quotaClientRequestTitle": "Client budget exhausted",
      "quotaClientRequestMessage": "A budget increase is being requested for {{client}}.",
      "quotaApprovedTitle": "Quota granted",
      "quotaApprovedMessage": "Your quota was raised for this month. You can carry on working.",
      "quotaDeclinedTitle": "Quota request declined",
      "quotaDeclinedMessage": "Your request for more quota was declined.",
      "processingNounVideo": "Video",
      "processingNounDocument": "Document",
      "processingCompletedTitle": "{{noun}} “{{name}}” processed",
      "processingFailedTitle": "{{noun}} “{{name}}” failed",
      "processingCompletedTitleNoName": "{{noun}} processed",
      "processingFailedTitleNoName": "{{noun}} failed",
      "processingCompletedMessage": "Searchable in {{knowledgeArea}}.",
      "processingFailedMessage": "Processing failed.",
      "transcriptionCompletedTitle": "Transcript “{{name}}” ready",
      "transcriptionCompletedTitleNoName": "Transcript ready",
      "transcriptionCompletedMessage": "You can review the transcript now.",
      "transcriptionFailedTitle": "Transcript “{{name}}” failed",
      "transcriptionFailedTitleNoName": "Transcript failed",
      "transcriptionFailedMessage": "The recording could not be transcribed.",
      "bugReportReplyTitle": "New reply on “{{reportTitle}}”",
      "bugReportReplyTitleNoName": "New reply on a ticket",
      "bugReportReplyMessageActorExcerpt": "{{name}}: {{excerpt}}",
      "bugReportReplyMessageActor": "{{name}} replied.",
      "bugReportStatusChangedTitle": "Status changed: “{{reportTitle}}”",
      "bugReportStatusChangedTitleNoName": "Ticket status changed",
      "bugReportStatusChangedMessage": "New status: {{status}}",
      "bugReportStatusChangedMessageReason": "New status: {{status}} ({{reason}})",
      "bugReportStatus": {
        "open": "Open",
        "in_progress": "In progress",
        "waiting_for_reporter": "Waiting for your reply",
        "planned": "Planned",
        "resolved": "Resolved",
        "closed": "Closed"
      },
      "bugReportCloseReason": {
        "done": "done",
        "declined": "declined",
        "duplicate": "duplicate",
        "not_a_bug": "not a bug",
        "no_response": "no response"
      },
      "bugReportTypeChangedTitle": "Reclassified: “{{reportTitle}}”",
      "bugReportTypeChangedTitleNoName": "Ticket reclassified",
      "bugReportTypeChangedMessage": "Now filed as {{type}} (was {{fromType}})",
      "bugReportType": {
        "bug": "bug",
        "feature": "feature request"
      },
      "documentUploadBatchCompletedMessage": "{{count}} file(s) uploaded to “{{knowledgeArea}}”",
      "reviewTasksTitle": "Review suggestions",
      "reviewTasksMessage": "{{count}} new review suggestions in \"{{documentTitle}}\""
    }
  },
  "time": {
    "justNow": "Just now",
    "minutesAgo": "{{count}} min ago",
    "hoursAgo": "{{count}} hours ago",
    "daysAgo_one": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago",
    "daysAgo": "{{count}} days ago"
  },
  "error": {
    "noActiveSession": "No active session",
    "loadApiKeysFailed": "Failed to load API keys",
    "createApiKeyFailed": "Failed to create API key",
    "loadingUsers": "Error loading users",
    "loadingAssignments": "Error loading user assignments",
    "changingAssignment": "Error changing user assignment. See console for details."
  },
  "cortex": {
    "title": "Administration",
    "subtitle": "User and app management",
    "tabError": {
      "title": "This section failed to load",
      "message": "This tab could not be loaded — most likely after an update. Please reload the page.",
      "renderMessage": "Something went wrong while showing this section. Please report it with the message below.",
      "retry": "Reload"
    },
    "communicatorHub": {
      "tabs": {
        "tiers": "Tiers",
        "clients": "Clients",
        "skills": "Skills",
        "systems": "Connected systems",
        "diagnostics": "Diagnostics",
        "settings": "Settings",
        "workflows": "Workflows",
        "benchmark": "Benchmark"
      },
      "skills": {
        "capabilityBadgeHint": "Access is decided by capability tiering (Tiers tab) — on top of the permissions here.",
        "apiKeyBadge": "API key",
        "apiKeyBadgeHint": "visibility: public — also reachable externally via API keys (external_m2m manifest). Editable in Skills → Management.",
        "tabs": {
          "map": "Capability map",
          "management": "Management",
          "manifest": "Manifest"
        }
      },
      "tiers": {
        "title": "Capability tiers",
        "subtitle": "What a customer gets — rows come from the code-owned registry, columns are freely editable. Clients without an assignment fall back to the minimal behaviour.",
        "newTier": "New tier",
        "productFilterAll": "All products",
        "capabilityColumn": "Capability",
        "systemTier": "System tier (cannot be deleted)",
        "assignedCount": "{{count}} clients",
        "editMeta": "Edit name/description",
        "duplicate": "Duplicate as template",
        "saved": "Tier “{{name}}” saved",
        "saveError": "Saving failed",
        "deleted": "Tier “{{name}}” deleted",
        "deleteError": "Deletion failed",
        "loadError": "Tiers could not be loaded.",
        "resetToUnset": "Back to platform default (unset)",
        "unsetHint": "Not set in this tier — the platform default applies. Changing it sets an explicit value.",
        "unsetMarker": "Def",
        "createTitle": "Create new tier",
        "editTitle": "Edit tier “{{name}}”",
        "duplicateHint": "Capability values are copied from the template.",
        "productLabel": "Product label (editor filter only)",
        "productAny": "— no label —",
        "deleteTitle": "Delete tier “{{name}}”?",
        "deleteHint": "Assigned tiers cannot be deleted — move the clients first.",
        "groups": {
          "sources": "Sources",
          "memory": "Memory",
          "generation": "Generation",
          "models": "Models",
          "features": "Features",
          "staff": "Staff",
          "connectors": "Connected systems"
        }
      },
      "clients": {
        "title": "Tier assignment",
        "subtitle": "Tier per client and product. Without an assignment the minimal behaviour applies — existing customers therefore need an explicit assignment. Overrides are rare exceptions on top of the tier.",
        "clientColumn": "Client",
        "overridesColumn": "Overrides",
        "productGroup": "cdbChat",
        "productCdb": "OS",
        "productPdb": "Focus",
        "productPortal": "Portal",
        "notBooked": "not booked (minimal)",
        "inheritCdb": "inherits CDB",
        "assignError": "Assignment failed",
        "loadError": "Client assignments could not be loaded.",
        "viewOverrides": "View {{count}}",
        "addOverride": "Add",
        "overridesTitle": "Overrides — {{name}}",
        "overridesHint": "Rare exceptions on top of the assigned tier. “Back to tier” removes the exception.",
        "resetToTier": "Back to tier",
        "tierApplies": "Tier",
        "overrideCta": "Set override",
        "restrictionsTitle": "Skill role restrictions",
        "restrictionsHint": "Narrows a skill to specific roles within this client — other clients are unaffected. With no role selected it is blocked for everyone. Removing the row lifts the restriction.",
        "restrictedToNobody": "Blocked for everyone",
        "restrictNobodyCta": "Block for everyone",
        "restrictNobodyHint": "No role selected: nobody in this client may call the skill. Admins are exempt.",
        "restrictSomeHint": "Only users holding one of the selected roles may call the skill.",
        "noRestrictions": "No restrictions — all skills apply client-wide.",
        "removeRestriction": "Lift restriction",
        "addRestrictionLabel": "Restrict a skill (upserts an existing row)",
        "pickSkill": "Pick a skill…",
        "noClientRoles": "No roles available for this client.",
        "restrictCta": "Restrict",
        "restrictionError": "Restriction could not be saved",
        "overrideError": "Override could not be saved"
      },
      "workflows": {
        "title": "Workflows",
        "subtitle": "Agent workflows are fixed step chains over connected systems (look up, check, map, ask back, present). Every active workflow is its own tool in cdbChat (wf__<slug>), executed by the server; the model supplies the inputs and presents the result. The chain is maintained here as JSON and tested with a dry-run against the real source. Visible only to clients with the capability features.agent_workflows.",
        "clientScope": {
          "label": "Client",
          "own": "Own client",
          "hint": "Shows this client's workflows and packages plus the global ones every client sees."
        },
        "empty": "No workflows yet. Create one from a template.",
        "confirmDelete": "Really delete workflow \"{{name}}\"?",
        "scopeLabel": "Visibility",
        "scope": {
          "user": "Only me",
          "client": "My organisation",
          "global": "All organisations"
        },
        "scopeBlocked": {
          "current": "already there",
          "uploaderOnly": "creator only"
        },
        "columns": {
          "name": "Name",
          "tool": "Tool",
          "version": "Version",
          "active": "Active",
          "enabled": "Enabled",
          "actions": "Actions",
          "audience": "Visible to"
        },
        "fields": {
          "name": "Name",
          "slug": "Slug",
          "slugHint": "Tool name in the chat: {{tool}}",
          "description": "Description for the model",
          "descriptionHint": "The model reads this to decide when to call the workflow. Name the purpose and typical phrasings. {{count}}/1024 characters."
        },
        "create": {
          "button": "New workflow",
          "title": "Create workflow",
          "description": "From a template or blank. You edit the step chain afterwards in the detail view.",
          "template": "Template",
          "blank": "Blank (skeleton)",
          "confirm": "Create",
          "ai": {
            "modeManual": "Blank or template",
            "modeAi": "Draft with AI",
            "text": "Describe the workflow in one sentence",
            "textPlaceholder": "e.g. Quote proposal: find customer and item, check blocks, fill header and line",
            "language": "Language of the definition",
            "sources": "Sources",
            "sourcesNone": "No queryable sources. Without a source there is no chain.",
            "sourcesHint": "No selection = all sources.",
            "tables": "({{count}} tables)",
            "draft": "Draft",
            "redraft": "Draft again",
            "invalidTitle": "The draft was not valid",
            "retryHint": "Describe the procedure more precisely or try again.",
            "refineLabel": "What should be different?",
            "refinePlaceholder": "e.g. “Search by name, not by contact, and put the price in the line.”",
            "refine": "Apply",
            "fixNotes": "Resolve these notes",
            "stepsTitle": "Proposed steps ({{count}})",
            "notesTitle": "Notes on the draft",
            "presentLabel": "Result",
            "confirm": "Create as draft"
          }
        },
        "publish": {
          "button": "Publish",
          "title": "Change visibility",
          "description": "Where should \"{{name}}\" be visible?",
          "hint": "Publishing is a decision, not an edit: within the organisation every user sees the tool in the chat once it is active.",
          "confirm": "Apply"
        },
        "detail": {
          "versionHint": "Saving the chain, the inputs or the slug bumps the version.",
          "activeHint": "Active = in the manifest of every user who may see the workflow.",
          "enabledHint": "Disabled keeps the workflow but hides it from the chat.",
          "saveChainFirst": "Save the changes to the chain first, then name, slug or description.",
          "audienceHint": "\"Only through packages\": only people whose role holds a package with this workflow. \"Everyone in scope\": everyone in the client, or everyone for a global workflow."
        },
        "runs": {
          "empty": "No runs yet. Every call from the chat shows up here with its steps.",
          "loadFailed": "Runs could not be loaded.",
          "failed": "Error",
          "noInputs": "no inputs",
          "question": "Question",
          "candidates": "({{n}} candidates)",
          "resolutions": "Answers applied",
          "warnings": "Notes",
          "errors": "Errors",
          "showInvocations": "Invocations of this turn"
        },
        "dryRun": {
          "run": "Start dry-run",
          "hint": "Runs against the real source as you, read-only.",
          "noInputs": "This workflow declares no inputs.",
          "resolutions": "Answers to questions (resolutions)",
          "resolutionPlaceholder": "Value from the question",
          "trace": "Steps",
          "status": {
            "completed": "completed",
            "aborted": "aborted",
            "needs_input": "question",
            "needs_connection": "Connect account"
          },
          "freeAnswer": "Free-text answer: enter it above under \"{{key}}\" and run again.",
          "columns": {
            "field": "Field",
            "value": "Value",
            "origin": "Origin",
            "note": "Note"
          },
          "warnings": "Notes",
          "llmSummary": "What the model reads (llm_summary)",
          "knowledge": "Knowledge: {{label}} ({{area}})",
          "knowledgeQuery": "Query: {{query}}",
          "knowledgeEmpty": "No passages found.",
          "instructions": "Writing instruction to the model",
          "source": {
            "graph": "Knowledge graph, unreviewed",
            "fact": "Knowledge graph, verified"
          },
          "artifact": "Document: {{name}}",
          "artifactHint": "The dry run creates no file. This is the request the model gets in the chat.",
          "artifactContext": "Results the model reads ({{n}} characters)",
          "jsonInvalid": "Not valid JSON ({{type}}) – the test does not start like this.",
          "jsonHint": "JSON expected ({{type}}).",
          "applied": "{{n}} values taken over from the user.",
          "resetOverrides": "Reset confirmations"
        },
        "toasts": {
          "created": "Workflow created",
          "createFailed": "Create failed",
          "updateFailed": "Save failed",
          "deleted": "Workflow deleted",
          "deleteFailed": "Delete failed",
          "moved": "Visibility changed",
          "moveFailed": "Visibility could not be changed"
        },
        "views": {
          "workflows": "Workflows",
          "packages": "Packages"
        },
        "audience": {
          "packages": "Packages only",
          "scope": "Everyone in scope",
          "personal": "Only me"
        },
        "packages": {
          "subtitle": "A package bundles workflows and is assigned to roles – like knowledge areas. Whoever holds one of the roles sees all of the package's workflows set to \"Packages only\"; everyone else in the client does not.",
          "create": "New package",
          "name": "Name",
          "description": "Description",
          "scope": "Scope",
          "client": "Client",
          "global": "Global",
          "empty": "No packages yet.",
          "counts": "{{workflows}} workflows · {{roles}} roles",
          "confirmDelete": "Delete package \"{{name}}\"? The workflows stay, only the assignment to the roles goes.",
          "back": "Back to packages",
          "workflows": "Workflows in the package",
          "workflowsHint": "Only shared workflows of this client or global ones – personal workflows cannot go into a package.",
          "noWorkflows": "No matching workflows. A workflow has to be published to the client first.",
          "openHint": "This workflow is visible to everyone in its scope – the package does not restrict it.",
          "roles": "Roles holding this package",
          "rolesHint": "Roles of this client or global roles.",
          "noRoles": "No matching roles.",
          "users": "{{count}} users",
          "toasts": {
            "createFailed": "Could not create the package",
            "deleteFailed": "Could not delete the package",
            "saved": "Package saved",
            "saveFailed": "Could not save the package"
          }
        }
      },
      "benchmark": {
        "title": "Benchmark",
        "subtitle": "Measures cdbChat with a fixed set of test questions: whether it picks the right tools, how long each phase takes, what a run costs and how an AI judge rates the answers. The run is a background job in TQS.",
        "env": {
          "staging": "Staging",
          "production": "Production"
        },
        "switchedOff": {
          "title": "The benchmark is not switched on in this environment",
          "body": "TQS does not answer the benchmark interface here. An admin switches it on in the TQS settings; then open this page again."
        },
        "loadError": "The benchmark could not be loaded. Please open it again later.",
        "seed": {
          "button": "Create test data",
          "result": "Test data in the knowledge area “{{area}}”: {{created}} created, {{existing}} already there.",
          "failed": "The test data could not be created."
        },
        "form": {
          "title": "New run",
          "groups": "Question groups",
          "presets": "Configurations",
          "questions_one": "{{count}} question",
          "questions_other": "{{count}} questions",
          "presetsProductionHint": "On production only “Today” runs, i.e. the deployed configuration. Other reasoning levels are blocked there so that no user's chat can be changed.",
          "presetsOverridesOffHint": "Other configurations are switched off in this environment. Without the switch for per-request reasoning levels only the deployed configuration runs.",
          "repeat": "Repeats",
          "repeatHint": "1 to {{max}}",
          "label": "Label",
          "labelPlaceholder": "e.g. routing low, 6 s",
          "start": "Start run",
          "starting": "Starting …",
          "busy": "While a run is active, no other one starts.",
          "pickBoth": "Pick at least one question group and one configuration."
        },
        "estimate": {
          "loading": "Estimating duration and cost …",
          "summary": "{{turns}} turns · about {{minutes}} min · about {{cost}} (cap {{cap}})",
          "notAllowed": "Cannot start: {{reason}}",
          "notAllowedNoReason": "Cannot start.",
          "failed": "The estimate failed. No run starts without an estimate."
        },
        "start": {
          "conflict": "A run is already active. A new one can only start after it.",
          "rejected": "TQS refused this run. Check the selection and let it estimate again.",
          "failed": "The run could not be started."
        },
        "progress": {
          "title": "Active run",
          "queued": "Waiting to start …",
          "count": "{{done}} of {{total}} turns",
          "currentGroup": "now: {{group}}",
          "leaveHint": "You can close this page; the run keeps going in the background.",
          "cancel": "Cancel run",
          "cancelConfirm": "Really cancel this run? Results so far are kept, the rest is not measured.",
          "keepRunning": "Keep running",
          "cancelFailed": "The run could not be cancelled."
        },
        "result": {
          "title": "Result",
          "meta": {
            "started": "Started",
            "finished": "Finished",
            "commit": "Commit",
            "judgeModel": "AI judge",
            "repeat": "Repeats"
          },
          "failed": "The run failed.",
          "cancelled": "The run was cancelled.",
          "noResult": "There is no result for this run.",
          "perPreset": "Per configuration",
          "phaseHint": "Time per phase: p50 / p95 in seconds.",
          "perGroup": "Per question group",
          "comparison": "Comparison of configurations",
          "comparisonHint": "The better value in each row is highlighted.",
          "better": "better value",
          "spotChecks": "Spot checks ({{count}})",
          "report": "Show report"
        },
        "spot": {
          "passed": "passed",
          "failed": "failed",
          "answer": "Answer",
          "tools": "Tools",
          "noTools": "No tool used.",
          "judge": "AI judge's verdict",
          "score": "Score: {{score}}",
          "noJudge": "Not rated by the AI judge."
        },
        "columns": {
          "preset": "Configuration",
          "group": "Question group",
          "pass": "Passed",
          "cost": "Cost",
          "judge": "AI judge avg.",
          "metric": "Metric",
          "date": "Date",
          "label": "Label",
          "environment": "Environment",
          "status": "Status",
          "p50Total": "p50 total",
          "actions": "Actions"
        },
        "phases": {
          "first_event": "First event",
          "router_decision": "Routing",
          "first_tool": "First tool",
          "first_token": "First text",
          "total": "Total"
        },
        "status": {
          "queued": "queued",
          "running": "running",
          "done": "done",
          "failed": "failed",
          "cancelled": "cancelled"
        },
        "history": {
          "title": "Earlier runs",
          "empty": "No run yet. Start the first one above.",
          "openRun": "Open run “{{label}}”",
          "shown": "Shown",
          "newer": "Newer",
          "older": "Older",
          "range": "{{from}}–{{to}} of {{total}}"
        }
      },
      "soul": {
        "title": "Assistant personality (Soul)",
        "hint": "Defines who the assistant in cdbChat is (character, values, voice) — separate from personal memory. Applies platform-wide to all users and takes effect immediately, without a deploy.",
        "body": {
          "label": "Persona (markdown)"
        },
        "anchor": {
          "label": "Core anchor",
          "hint": "The non-negotiable lines are re-stated at the end of the prompt (drift protection)."
        },
        "locale": {
          "de": "German",
          "en": "English"
        },
        "version": "Version {{version}}",
        "save": "Save",
        "saved": "Soul saved.",
        "saveError": "Saving failed.",
        "loadError": "Could not load the Soul."
      },
      "settings": {
        "routingTitle": "Routing strategy"
      }
    },
    "voiceAgent": {
      "title": "Voice Agent Widget",
      "settingsTitle": "Voice Agent Settings",
      "settingsDescription": "Configure transcription prompt, system prompt, and greeting for the Voice Agent per client. System prompt and greeting can be provided in German and English.",
      "selectClient": "Select client",
      "selectClientPlaceholder": "Select client...",
      "settingsFor": "Settings for:",
      "errorTitle": "Error",
      "errorLoadClients": "Error loading clients",
      "errorNoAuth": "Not authenticated",
      "errorLoadSettings": "Error loading settings",
      "errorSelectClient": "Please select a client first",
      "errorSave": "Error saving settings",
      "savedTitle": "Saved",
      "savedDescription": "Settings have been saved successfully",
      "tabs": {
        "transcription": "Transcription Prompt",
        "system": "System Prompt",
        "greeting": "Initial Greeting"
      },
      "transcriptionLabel": "Transcription Prompt",
      "transcriptionPlaceholder": "e.g. domain-specific terms, company names, technical vocabulary...",
      "transcriptionHint": "Hint for Whisper API to improve transcription accuracy (e.g. technical terms). Used for both languages.",
      "systemLabel": "System Prompt",
      "systemPlaceholderDe": "Du bist ein hilfreicher Voice Assistant...",
      "systemPlaceholderEn": "You are a helpful voice assistant...",
      "systemHint": "Defines the behavior and personality of the Voice Agent. If no English text is provided, the German text will be used as fallback.",
      "greetingLabel": "Initial Greeting",
      "greetingPlaceholderDe": "Hallo! Wie kann ich Ihnen heute helfen?",
      "greetingPlaceholderEn": "Hello! How can I help you today?",
      "greetingHint": "First message the Voice Agent says when starting a session. If no English text is provided, the German text will be used as fallback.",
      "save": "Save",
      "saving": "Saving...",
      "reset": "Reset",
      "unsavedChanges": "Unsaved changes"
    },
    "transcriptAssistant": {
      "title": "Transcript Assistant",
      "infoTitle": "Transcript AI Assistant prompts",
      "infoDescription": "Set the system prompt and quick actions per organization. An empty field uses the built-in text. English also applies to Dutch; if it is missing, German is used.",
      "selectPrompt": "Prompt",
      "placeholder": "Empty: built-in text",
      "saved": "Settings saved",
      "errorLoad": "The settings could not be loaded. Please try again.",
      "errorSave": "The settings could not be saved. Please try again.",
      "keys": {
        "system_prompt": "System prompt (for every action)",
        "shorten": "Summary: Shorten",
        "expand": "Summary: Expand",
        "formal": "Summary: Formal",
        "by_topic": "Summary: By topic",
        "cleanup": "Transcript: Clean up",
        "fix_terms": "Transcript: Fix terms"
      }
    },
    "maintenance": {
      "title": "Maintenance",
      "description": "Manually run backend maintenance endpoints",
      "running": "Running...",
      "run": "Run",
      "success": "Success",
      "error": "Error",
      "cleanupDuplicates": {
        "name": "Clean up duplicate jobs",
        "description": "Removes duplicate jobs per document and keeps only the newest one."
      }
    },
    "urls": {
      "title": "Portal URLs",
      "description": "Direct links to CDB OS portals",
      "noPassword": "No password protection",
      "loginRequired": "User login required",
      "password": "Password:",
      "hidePassword": "Hide password",
      "showPassword": "Show password",
      "copyPassword": "Copy password",
      "openPortal": "Open portal"
    },
    "apiKeys": {
      "title": "API Keys",
      "tokenLimitInfo": "API key requests count toward the client's monthly token limit. When a client's limit is exceeded, API calls for that client are also blocked.",
      "description": "Create and manage API keys for programmatic access to the cdb_tqs backend",
      "createKey": "Create API Key",
      "loading": "Loading API Keys...",
      "noKeys": "No API keys created yet.",
      "noKeysHint": "Create a key for programmatic access.",
      "createDialog": {
        "title": "Create New API Key",
        "description": "Create an API key for programmatic access. The key will only be shown once!",
        "nameLabel": "Name *",
        "namePlaceholder": "e.g. Production API Key",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "e.g. Used for production data sync",
        "clientLabel": "Client (optional)",
        "clientNone": "No Client",
        "clientPlaceholder": "Select client (optional)",
        "clientHint": "Assign the API key to a client for client-specific Voice Agent prompts",
        "knowledgeAreasLabel": "Knowledge Areas * (at least one)",
        "noKnowledgeAreas": "No Knowledge Areas available",
        "twLevelsLabel": "Allowed Trust Levels & Tools",
        "twLevelsHint": "Defines which trust levels and tools this API key may use in the AI chat",
        "alwaysActive": "always active",
        "expiresLabel": "Expiry date (optional)",
        "expiresHint": "Leave empty for unlimited validity",
        "creating": "Creating...",
        "validationError": "Name and at least one Knowledge Area are required"
      },
      "created": {
        "title": "API Key created successfully!",
        "warning": "Copy the key now — it will not be shown again!",
        "keyLabel": "Your API Key",
        "authHint": "Use this key in the Authorization header:",
        "done": "Done"
      },
      "table": {
        "name": "Name",
        "keyPrefix": "Key Prefix",
        "client": "Client",
        "permissions": "Permissions",
        "knowledgeAreas": "Knowledge Areas",
        "twLevels": "TW Levels",
        "allowlist": "Allowlist",
        "usage": "Usage",
        "status": "Status",
        "actions": "Actions",
        "calls": "Calls",
        "lastUsed": "Last:"
      },
      "status": {
        "active": "Active",
        "revoked": "Revoked",
        "expired": "Expired"
      },
      "revokeTitle": "Revoke API Key",
      "deleteConfirm": "Are you sure you want to delete the API key \"{{name}}\"?",
      "deleteCannotUndo": "This action cannot be undone",
      "usageNotes": {
        "title": "Notes on API Key usage:",
        "shownOnce": "API keys are only shown once when created",
        "usage": "Usage:",
        "kaRestrict": "Knowledge Areas restrict access to documents",
        "noReactivate": "Expired or revoked keys cannot be reactivated"
      },
      "allowlist": {
        "label": "Endpoint allowlist",
        "hint": "Restricts this key to specific endpoints. An empty list means no restriction (default for internal keys). One pattern per line, format: METHOD /path, e.g. POST /api/v1/skills/*/invoke.",
        "templateLabel": "Apply template",
        "templatePlaceholder": "Choose template…",
        "templates": {
          "internal_service": "Internal Service Key (no restriction)",
          "external_toolbox": "External Toolbox Customer (skills + tools)",
          "external_webhook": "External Webhook Sender"
        },
        "emptyWarning": "Empty = no restriction. For external customer keys, please pick a template.",
        "patternsLabel": "Allowed Patterns",
        "patternsLabel_one": "pattern",
        "patternsLabel_other": "patterns",
        "unrestricted": "unrestricted",
        "unrestrictedTooltip": "No restriction — all endpoints reachable",
        "tableTooltip": "Endpoint allowlist (#316): empty list = no restriction",
        "edit": {
          "action": "Edit allowlist",
          "title": "Edit endpoint allowlist",
          "description": "Key “{{name}}”. The change applies immediately to every call made with this key; the key itself stays the same.",
          "liftWarningTitle": "This removes every restriction",
          "liftWarning_one": "This key is currently restricted to {{count}} pattern. With an empty list it can reach every endpoint its permissions allow. Click again to confirm.",
          "liftWarning_other": "This key is currently restricted to {{count}} patterns. With an empty list it can reach every endpoint its permissions allow. Click again to confirm.",
          "confirmLift": "Remove restriction",
          "invalidPattern": "At least one pattern is invalid: {{detail}}. Format: METHOD /path, e.g. POST /api/v1/documents/upload.",
          "notFound": "This key no longer exists. Please reload the list.",
          "forbidden": "Not permitted: only admins can change the allowlist. You may need to sign in again.",
          "saveFailed": "The allowlist could not be saved ({{detail}}). Please try again later."
        }
      },
      "voiceLive": {
        "action": "Set up Voice One",
        "badge": "Voice One",
        "badgeTooltip": "Voice One is allowed for this key: portal visitors can talk with the Brain.",
        "title": "Voice One for this key",
        "description": "Key \"{{name}}\". With Voice One, visitors of a portal using this key can talk with the Brain, only over the key's knowledge areas. Every visitor gets their own session.",
        "allow": "Voice One allowed",
        "allowHint": "Default: off. Only takes effect where Voice One is switched on for the environment.",
        "maxConcurrent": "Concurrent sessions",
        "maxMinutes": "Minutes per day",
        "limitsHint": "Empty = default (3 sessions, 60 minutes per day, UTC). When a limit is reached, the portal gets a clear message.",
        "invalidLimit": "Please enter whole numbers: sessions 1–50, minutes 1–1440, or leave empty.",
        "allowlistWarning": "This key's endpoint allowlist has no voice-live routes. Please add \"* /api/v1/voice-live/*\" and \"GET /api/v1/knowledge-areas\", or TQS refuses the calls.",
        "notFound": "This key no longer exists. Please reload the list.",
        "forbidden": "Not allowed: only admins can set up Voice One for a key. Sign in again if needed.",
        "saveFailed": "The setting could not be saved ({{detail}}). Please try again later."
      }
    },
    "cdbTqsKnowledgeAreas": {
      "title": "Knowledge Areas",
      "description": "Manage Knowledge Areas from the CDB-TQS system ({{total}} total)",
      "descriptionFiltered": "Manage Knowledge Areas from the CDB-TQS system ({{shown}} of {{total}})",
      "clientFilterAll": "All clients",
      "clientFilterGlobal": "Global (no client)",
      "clientFilterPlaceholder": "Filter by client",
      "noAreasForClient": "No Knowledge Areas for this client",
      "createNew": "New Knowledge Area",
      "errorLoading": "Error loading Knowledge Areas",
      "errorHint": "Make sure the CDB-TQS backend is running and VITE_CDB_TQS_API_URL is configured correctly.",
      "noAreas": "No Knowledge Areas found",
      "table": {
        "name": "Name",
        "description": "Description",
        "graphInstance": "Graph Instance",
        "documents": "Documents",
        "status": "Status"
      },
      "active": "Active",
      "inactive": "Inactive",
      "systemCannotDelete": "System Knowledge Areas cannot be deleted",
      "deleteTitle": "Delete Knowledge Area"
    },
    "kaWizard": {
      "title": "New knowledge area",
      "breadcrumbLabel": "Breadcrumb",
      "breadcrumbList": "Knowledge areas",
      "stepsLabel": "Steps",
      "stepDone": "done",
      "steps": {
        "name": {
          "title": "Name",
          "hint": "Name, description, colour"
        },
        "access": {
          "title": "Access",
          "hint": "Who may work with it"
        },
        "content": {
          "title": "Content",
          "hint": "First documents (optional)"
        }
      },
      "adminOnly": "admins only",
      "next": "Next",
      "back": "Back",
      "backToList": "Back to the list",
      "retry": "Try again",
      "errors": {
        "generic": "That did not work. Please try again."
      },
      "colors": {
        "blue": "Blue",
        "green": "Green",
        "yellow": "Yellow",
        "orange": "Orange",
        "purple": "Purple",
        "red": "Red",
        "pink": "Pink",
        "gray": "Grey"
      },
      "name": {
        "heading": "What should the area be called?",
        "intro": "A name your colleagues understand right away.",
        "displayNameLabel": "Name",
        "displayNamePlaceholder": "e.g. Customer service",
        "idLabel": "ID:",
        "idDerived": "derived from the name",
        "idEmpty": "—",
        "idUnknown": "assigned on creation",
        "idChange": "change",
        "idReset": "derive again",
        "idPattern": "Lower-case letters, digits and underscores, starting with a letter. Empty = derived.",
        "idFixed": "fixed after creation",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "What is this area for? Which documents belong in it?",
        "colorLabel": "Colour",
        "sizeLabel": "Size",
        "clientLabel": "Client",
        "clientPlaceholder": "Choose a client",
        "clientFixed": "The client is fixed after creation.",
        "graphHint": "The area lives in the client's graph ({{graph}}).",
        "noGraph": "This client has no graph yet. Assign one under Clients first.",
        "manageClients": "Go to Clients",
        "createHint": "“Next” creates the area."
      },
      "size": {
        "tiers": {
          "klein": "Small",
          "mittel": "Medium",
          "gross": "Large",
          "unbegrenzt": "Unlimited"
        },
        "chunks": "{{chunks}} sections",
        "chunksDefault": "{{chunks}} sections · default",
        "unlimited": "no upper limit",
        "hint": "How many sections the area takes at most. Can be raised later.",
        "previous": "So far: {{chunks}} sections – none of the sizes. Pick one, or the value stays.",
        "previousUnlimited": "So far: unlimited – only admins can choose it. Without a choice it stays."
      },
      "content": {
        "label": "Kind of content",
        "default": "General",
        "defaultHint": "Standard types: people, organisations, places, documents, concepts, events",
        "custom": "Own",
        "customHint": "Ontologies of the client",
        "customSelectLabel": "Choose an ontology of the client",
        "customNone": "This client has no ontology of its own yet.",
        "customNoClient": "Choose a client first.",
        "hint": "Decides which things and relations the knowledge graph extracts.",
        "manage": "Manage ontologies"
      },
      "access": {
        "heading": "Who may work with “{{name}}”?",
        "intro": "The area is added to the chosen roles of {{client}}, for the apps the role already has. You can change this later in the role.",
        "legend": "Access",
        "loading": "Loading roles …",
        "all": "All roles of {{client}}",
        "allHint_one": "The client's {{count}} role gets the area. Roles created later do not get it automatically.",
        "allHint_other": "All {{count}} roles of the client get the area. Roles created later do not get it automatically.",
        "selected": "Only certain roles",
        "selectedHint": "Choose the roles that get the area.",
        "search": "Search roles",
        "rolesLabel": "Roles",
        "forApps": "for {{apps}}",
        "noApps": "The role has no app that works with knowledge areas",
        "noRoles": "This client has no roles yet.",
        "noMatch": "No role matches the search.",
        "none": "Do not assign to a role yet",
        "noneHint": "The area exists but users cannot see it yet. Admins and supervisors see it in Cortex, can fill it and share it later.",
        "footnote": "Admins see the roles of the client chosen in step 1, supervisors those of their own. Which app may read or fill the area stays a setting of the role."
      },
      "files": {
        "heading": "Add first documents",
        "intro": "Optional. You can also upload later.",
        "drop": "Drop files here",
        "or": "or",
        "choose": "choose from your computer",
        "formats": "PDF, Word, PowerPoint, text, e-mails, HTML. Excel sheets through the Knowledge Extractor.",
        "listLabel": "Uploaded files",
        "status": {
          "queued": "Waiting …",
          "uploading": "Uploading …",
          "uploadingProgress": "Uploading … {{progress}} %",
          "uploaded": "Uploaded · processing",
          "failed": "Failed"
        },
        "errors": {
          "unsupported": "The area cannot take this format.",
          "tooLarge": "Too large (at most {{maxMb}} MB).",
          "duplicate": "This document is already in the area.",
          "rateLimited": "Too many uploads right now. Please upload again later."
        },
        "waitHint": "Wait until all files are uploaded.",
        "skip": "Skip",
        "finish": "Done"
      },
      "done": {
        "heading": "{{name}} has been created",
        "intro": "You can now add documents or try the area in the chat.",
        "processing_one": "{{count}} document is being processed. It can be found in the chat in a few minutes.",
        "processing_other": "{{count}} documents are being processed. They can be found in the chat in a few minutes.",
        "client": "Client",
        "clientWithGraph": "{{client}} · graph {{graph}}",
        "access": "Access",
        "accessAll": "All roles of {{client}}",
        "accessSelected": "Roles {{roles}}",
        "accessNone": "Not assigned to a role yet",
        "accessUnknown": "—",
        "documents": "Documents",
        "documentsNone": "None yet",
        "documentsUploaded_one": "{{count}} uploaded, processing",
        "documentsUploaded_other": "{{count}} uploaded, processing",
        "documentsFailed_one": "{{count}} failed",
        "documentsFailed_other": "{{count}} failed",
        "moreDocuments": "More documents",
        "tryInChat": "Try in the chat",
        "openArea": "Go to the knowledge area"
      }
    },
    "kaDetail": {
      "documents_one": "{{formatted}} document",
      "documents_other": "{{formatted}} documents",
      "chunks_one": "{{formatted}} chunk",
      "chunks_other": "{{formatted}} chunks",
      "id": "ID",
      "usage": "{{chunks}} of {{limit}} sections used",
      "usageUnlimited_one": "{{chunks}} section used · no limit",
      "usageUnlimited_other": "{{chunks}} sections used · no limit",
      "usageLabel": "Usage",
      "saved": "Saved.",
      "tabs": {
        "overview": "Overview",
        "access": "Access",
        "contents": "Contents",
        "settings": "Settings"
      },
      "overview": {
        "edit": "Edit",
        "noDescription": "No description",
        "ontologyUnknown": "Unknown ontology",
        "sizeOther": "None of the sizes",
        "created": "Created",
        "updated": "Last changed"
      },
      "access": {
        "save": "Save access"
      },
      "contents": {
        "heading": "Documents",
        "loading": "Loading documents …",
        "empty": "No documents yet.",
        "columns": {
          "title": "Title",
          "type": "Type",
          "status": "Status",
          "date": "Uploaded"
        },
        "more": "The newest {{shown}} of {{total}} documents. All documents are in the Knowledge Extractor.",
        "uploadHeading": "Add documents",
        "noClient": "This area belongs to no client. Uploads only go into areas of a client."
      },
      "settings": {
        "contentHint": "Applies to documents processed from now on. Documents already processed stay as they are until they are read in again.",
        "contentCurrent": "Current: {{name}} – not selectable here. It stays unless you pick another.",
        "standardNote": "Text preparation and sectioning (chunking) are a global standard and cannot be set here.",
        "save": "Save settings",
        "lifecycleHeading": "Deactivate or delete the area",
        "lifecycleHint": "Deactivated: hidden, the data stays. Deleting is only possible when the area is empty.",
        "deactivate": "Deactivate",
        "activate": "Activate",
        "deleteConfirm": "Delete “{{name}}” for good? This cannot be undone.",
        "deleteBlocked": {
          "default": "The default area cannot be deleted.",
          "notEmpty_one": "Deleting is possible once the area is empty: it still holds {{count}} document ({{chunks}} sections). Remove it in the Knowledge Extractor.",
          "notEmpty_other": "Deleting is possible once the area is empty: it still holds {{count}} documents ({{chunks}} sections). Remove them in the Knowledge Extractor."
        }
      }
    },
    "tabs": {
      "overview": "Overview",
      "accessRequests": "Access Requests",
      "users": "Users",
      "roles": "Roles",
      "permissions": "App Permissions",
      "appPermissions": "App Permissions",
      "knowledgeAreas": "Knowledge Areas",
      "kaRelations": "KA Relations",
      "graphInstances": "Graph Instances",
      "communicator": "cdbChat",
      "prompts": "Prompt Library",
      "tools": "Tool Library",
      "themes": "Themes",
      "clients": "Clients",
      "organization": "Organization",
      "apps": "Apps",
      "clientAppVisibility": "App Visibility",
      "bugReports": "Tickets",
      "tokenUsage": "Token Usage",
      "maintenance": "Maintenance",
      "urls": "Portal URLs"
    },
    "sidebar": {
      "sections": {
        "general": "General",
        "appConfiguration": "App Configuration"
      },
      "collapse": "Collapse sidebar",
      "expand": "Expand sidebar",
      "bugReportsUnread_one": "{{count}} ticket with new replies",
      "bugReportsUnread_other": "{{count}} tickets with new replies"
    },
    "overview": {
      "title": "System Overview",
      "description": "Statistics and important information",
      "stats": {
        "pendingRequests": "Pending Access Requests",
        "clickToView": "Click to view",
        "totalUsers": "Registered Users",
        "registeredUsers": "Registered Users",
        "activeUsers": "Active",
        "totalApps": "Available Apps",
        "activeApps": "Active",
        "knowledgeAreas": "Knowledge Areas",
        "adminUsers": "Administrators",
        "normalUsers": "Normal Users"
      }
    },
    "accessRequests": {
      "title": "Access Requests",
      "description": "Manage incoming access requests",
      "noPendingRequests": "No pending access requests",
      "received": "Received",
      "reject": "Reject",
      "approve": "Approve",
      "pending": "Pending",
      "client": "Client"
    },
    "users": {
      "title": "User Management",
      "description": "Manage user roles and status",
      "noApprovedUsers": "No approved users available",
      "active": "Active",
      "inactive": "Inactive",
      "readOnly": "Read Only",
      "created": "Created",
      "approved": "Approved",
      "searchPlaceholder": "Search by name or email...",
      "allRoles": "All Roles",
      "allClients": "All Clients",
      "showingResults": "Showing {{count}} of {{total}} users",
      "autoVerifyTl1": "Auto-Verify TL1",
      "autoVerifyTl1Tooltip": "Extracted nodes and edges will be automatically marked as verified",
      "role": {
        "user": "User",
        "admin": "Admin"
      },
      "table": {
        "nameEmail": "Name / Email",
        "client": "Client",
        "userType": "User Type",
        "roles": "Roles",
        "role": "Role",
        "status": "Status",
        "applications": "Applications",
        "created": "Created",
        "actions": "Actions"
      },
      "userTypes": {
        "admin": "Admin",
        "user": "User"
      },
      "deleteUser": "Delete User",
      "deleteConfirm": "Are you sure you want to delete this user?",
      "deleteWarning": "This action cannot be undone.",
      "deleteSuccess": "User successfully deleted",
      "deleteError": "Error deleting user",
      "pending": "Pending",
      "unknownApp": "Unknown App",
      "applications": {
        "webos": "WebOS",
        "editor": "Editor",
        "composer": "Composer",
        "pdb": "cdbChat",
        "controlCenter": "Control Center"
      },
      "assignRoles": "Assign roles",
      "editRoles": "Edit roles",
      "roles": "Roles",
      "deleteConfirmDetails": {
        "willDelete": "This action will delete:",
        "userData": "All user data in the database",
        "appAssignments": "All app assignments",
        "accessRequests": "All access requests",
        "authAccount": "The auth account (sessions, tokens)",
        "logoutImmediate": "The user will be logged out immediately",
        "cannotUndo": "This action cannot be undone!"
      },
      "knowledgeAccess": {
        "dialogTitle": "Assign knowledge access",
        "hint": "Applies on top of the user's roles: each app gets the knowledge areas it may work with.",
        "saved": "Knowledge access saved"
      },
      "applicationFailed": "The application could not be changed. Please try again.",
      "noProducts": "Your organisation has no products you can grant."
    },
    "roles": {
      "title": "Role Management",
      "description": "Create and manage roles with app, knowledge area, and trust level permissions",
      "createRole": "Create New Role",
      "editRole": "Edit Role",
      "noRoles": "No roles available",
      "roleType": "Role Type",
      "roleTypeLabel": "Role Type",
      "roleTypeUser": "User Role",
      "roleTypeUserDesc": "Standard role for users with assigned permissions",
      "roleTypeSupervisor": "Supervisor",
      "roleTypeSupervisorDesc": "Can delegate assigned apps and trust levels to users in their own client",
      "supervisorBadge": "Supervisor",
      "table": {
        "name": "Name",
        "description": "Description",
        "client": "Client",
        "apps": "Apps",
        "knowledgeAreas": "KAs",
        "users": "Users",
        "actions": "Actions"
      },
      "systemRole": "System role (not editable)",
      "supervisorRoleMembersOnly": "Members only – admins change what a supervisor role holds",
      "usersRemovesSelf": "You are removing yourself from this supervisor role. After saving you lose your supervisor access in Cortex unless you hold another supervisor role.",
      "basicInfo": "Basic Information",
      "nameLabel": "Name *",
      "namePlaceholder": "e.g. Marketing Manager",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Optional description of the role",
      "clientLabel": "Client *",
      "clientPlaceholder": "Select client (required)",
      "clientKAHint": "Only Knowledge Areas of this client are available",
      "clientFilterPlaceholder": "Filter by client",
      "clientFilterGlobal": "Global",
      "twLevelsTitle": "Allowed Trust Levels & Tools (AI Chat)",
      "capabilities": {
        "title": "cdbChat capabilities",
        "hint": "Checked = the role inherits the capability from the client package. Unchecked = restricted for this role. Capabilities outside the package cannot be added.",
        "inherited": "inherited from tier",
        "restricted": "restricted for this role",
        "unavailable": "not enabled for this client",
        "global": "global role – no client tier",
        "loading": "Loading client capabilities …",
        "loadError": "Client capabilities could not be loaded. Saving is disabled.",
        "items": {
          "sources_fulltext": {
            "label": "Full-text search",
            "description": "Searches the organisation's documents for exact words and phrases."
          },
          "web_search": {
            "label": "Web search",
            "description": "The assistant may search the internet for its answers."
          },
          "connectors_microsoft365": {
            "label": "Microsoft 365",
            "description": "Users can connect their mailbox and calendar; the assistant reads mail, writes drafts and schedules meetings."
          },
          "sources_router_toolbox": {
            "label": "Connected systems",
            "description": "The assistant may query data from connected business systems, e.g. ERP or databases."
          },
          "sources_router_free_query": {
            "label": "Free query in connected systems",
            "description": "If a prepared query finds nothing, the assistant may write its own query. Such results are less reliable."
          },
          "skills_structured_query": {
            "label": "Imported table data",
            "description": "The assistant also answers from imported Excel data, e.g. parts lists."
          },
          "memory_cross_session": {
            "label": "Memory across chats",
            "description": "The assistant remembers earlier conversations and the person's preferences."
          },
          "features_routines": {
            "label": "Routines",
            "description": "Users can schedule questions that are answered automatically on a regular basis."
          },
          "skills_office_generation": {
            "label": "Create Office documents",
            "description": "The assistant creates and edits Word, Excel, PowerPoint and PDF files."
          },
          "features_deep_research": {
            "label": "Deep research",
            "description": "The assistant researches in several steps with sources; takes longer and uses more tokens."
          },
          "features_remote_mcp": {
            "label": "Access from Claude",
            "description": "Users can connect Claude to cdbOS and search their knowledge areas from there. Content then reaches their Claude account."
          },
          "features_agent_workflows": {
            "label": "Workflows",
            "description": "Users can start prepared procedures in the chat that fetch data from connected systems step by step."
          },
          "skills_bpmn_generation": {
            "label": "Process diagrams (BPMN)",
            "description": "The assistant creates and edits process diagrams."
          },
          "skills_html_generation": {
            "label": "Web pages (HTML)",
            "description": "The assistant creates and edits HTML pages, e.g. interactive overviews."
          },
          "skills_image_generation": {
            "label": "Create images",
            "description": "The assistant creates and edits images."
          },
          "widget_table": {
            "label": "Interactive tables",
            "description": "Large results appear as a sortable table with Excel export."
          },
          "ingest_knowledge_area": {
            "label": "Add to knowledge areas",
            "description": "The assistant may save documents and web pages into knowledge areas."
          }
        }
      },
      "trainingModulesTitle": "Training App Module",
      "trainingModulesHint": "Controls which areas of the CDB Training Hub users with this role can see and use. Default is training only.",
      "trainingModulesSchulungLabel": "Training (trainings, materials, quiz)",
      "trainingModulesUmfrageLabel": "Survey (standalone surveys)",
      "appPermissions": "App Permissions",
      "kaPermissions": "Knowledge Area Permissions",
      "kaSelectClientFirst": "Please select a client first",
      "kaNoAreasForClient": "This client has no Knowledge Areas assigned",
      "graphInstanceTitle": "Graph Instance",
      "graphInstanceHint": "Supervisor can create and manage knowledge areas in this graph instance.",
      "graphInstanceNone": "No graph instances available. Please create a graph instance first.",
      "deleteTitle": "Delete Role",
      "deleteConfirm": "Do you really want to delete the role \"{{name}}\"?",
      "deleteWarningUsers": "Warning: This role is assigned to {{count}} user(s).",
      "createError": "Error creating role",
      "updateError": "Error updating role",
      "deleteError": "Error deleting role",
      "nameRequired": "Please enter a role name",
      "clientRequired": "Please select a client",
      "usersTitle": "Manage Users: {{name}}",
      "usersRoleAssignment": "Role assignment for app access request",
      "usersLoadFailed": "The assignments could not be loaded. Nothing can be changed without them.",
      "usersSaveFailed": "Not saved for: {{users}}. The other changes were saved.",
      "usersPendingChanges_one": "{{count}} unsaved change",
      "usersPendingChanges_other": "{{count}} unsaved changes",
      "usersChanged": "Changed",
      "noUsersForClient": "No users available for client \"{{client}}\"",
      "noUsers": "No users available",
      "requestBadge": "Request",
      "all": "All",
      "tabs": {
        "roles": "Roles",
        "templates": "Templates"
      },
      "copyName": "{{name}} (Copy)",
      "createFromRole": "Create a new role from this role",
      "saveAsTemplate": "Save role as template",
      "templates": {
        "title": "Role Templates",
        "description": "Client-agnostic presets for new roles — client and knowledge areas are picked when the role is created",
        "createTemplate": "New Template",
        "editTemplate": "Edit Template",
        "noTemplates": "No templates available",
        "useTemplate": "Create Role",
        "useTemplateHint": "Create a new role from this template",
        "namePlaceholder": "e.g. Standard Employee",
        "clientAgnosticHint": "Templates hold no client and no knowledge areas — those are picked when the role is created.",
        "nameRequired": "Please enter a template name",
        "deleteTitle": "Delete Template",
        "deleteConfirm": "Do you really want to delete the template \"{{name}}\"? Roles already created from it remain unchanged.",
        "createError": "Error creating template",
        "updateError": "Error updating template",
        "deleteError": "Error deleting template",
        "table": {
          "name": "Name",
          "description": "Description",
          "apps": "Apps",
          "actions": "Actions"
        },
        "appsKnowledgeHint": "Which knowledge areas the marked apps receive is decided when the role is created."
      },
      "wizard": {
        "steps": {
          "basics": "Basics",
          "apps": "Apps",
          "knowledge": "Knowledge access",
          "communicator": "cdbChat",
          "modules": "Modules",
          "review": "Summary"
        },
        "stepCounter": "Step {{current}} of {{total}} — {{title}}",
        "back": "Back",
        "next": "Next",
        "appsHint": "Apps that work with knowledge areas get theirs assigned in the next step.",
        "noKnowledgeApps": "None of the selected apps works with knowledge areas. Pick e.g. cdbChat or the Knowledge Extractor in the previous step.",
        "supervisorNoAreas": "Your supervisor role contains no knowledge areas. Please contact your admin.",
        "knowledgeTitle": "Knowledge areas per app",
        "knowledgeHint": "Each app gets the knowledge areas it may work with. What it can do in them follows from the app itself — cdbChat reads, the Extractor feeds, the Verifier checks.",
        "reviewNone": "None",
        "appColumn": "App",
        "appKnowledgeAware": "Knowledge areas",
        "locked": "Locked",
        "lockedHint": "Locked: granted by an admin and not part of your supervisor role. Stays unchanged when you save.",
        "areaInactive": "inactive",
        "areaRemoved": "Removed knowledge area",
        "areaRemovedDrop": "Remove permission",
        "areaRemovedHint_one": "One permission points at a knowledge area that no longer exists. It grants no access and can be removed here.",
        "areaRemovedHint_other": "{{count}} permissions point at knowledge areas that no longer exist. They grant no access and can be removed here.",
        "verifyMode": {
          "read": "Read",
          "verify": "Verify",
          "verifierHint": "For the Knowledge Verifier, choose per knowledge area whether it may only be read or also verified.",
          "verifyNotAllowed": "You can only grant \"Verify\" where you may verify yourself."
        },
        "saveRefused": "Saving was refused"
      },
      "workflowPackages": {
        "title": "Workflow packages",
        "hint": "Whoever holds this role gets all workflows of the selected packages in the chat.",
        "none": "There are no workflow packages for this client yet.",
        "count": "{{count}} workflows"
      },
      "ticketTypes": {
        "title": "Tickets",
        "hint": "Which tickets users with this role may create. If someone has several roles, one that allows it is enough. With both off, they no longer see the Tickets area.",
        "bug": "Report a bug",
        "feature": "Suggest an improvement"
      }
    },
    "clients": {
      "description": "Manage clients and their storage buckets",
      "createNew": "New Client",
      "user": "User",
      "users": "Users",
      "table": {
        "name": "Name",
        "bucket": "Storage Bucket",
        "graph": "Graph instance",
        "users": "Users",
        "created": "Created",
        "actions": "Actions"
      },
      "createTitle": "Create New Client",
      "createDescription": "Create a new client. A storage bucket will be automatically created.",
      "nameLabel": "Name",
      "nameHint": "The bucket will be automatically created: client-{name}",
      "editTitle": "Edit Client",
      "editDescription": "Modify the client information.",
      "currentBucket": "Current Bucket",
      "bucketWarning": "Note: Bucket name does not change automatically",
      "graphLabel": "Graph instance",
      "graphPlaceholder": "Select graph instance",
      "graphHint": "All knowledge areas of this client live in this graph instance. Once the client has knowledge areas, it can no longer be changed.",
      "graphLockedHint": "The client already has {{count}} knowledge area(s), so its graph instance can no longer be changed.",
      "graphNotSet": "Not set",
      "graphHasKnowledgeAreas": "The client already has knowledge areas, so its graph instance can no longer be changed. The name was saved.",
      "graphSaveError": "The graph instance could not be saved: {{reason}}. The name was saved.",
      "graphRequired": "Please select a graph instance.",
      "createGraphError": "The client \"{{name}}\" was created, but its graph instance could not be set: {{reason}}. Please set it via \"Edit\".",
      "deleteTitle": "Delete Client",
      "deleteDescription": "Are you sure you want to delete this client?",
      "deleteWithBucket": "Also delete storage bucket",
      "deletingWithBucket": "Deleting...",
      "noClients": "No clients available",
      "createError": "Error creating client",
      "updateError": "Error updating client",
      "deleteError": "Error deleting client",
      "deleteErrorHasUsers": "Cannot delete client with active users",
      "deleteBucketHint": "Also deletes the associated storage bucket",
      "deleteBucketLabel": "Delete storage bucket",
      "deleteBucketWarning": "This action cannot be undone!",
      "namePlaceholder": "Enter client name",
      "usersAssigned": "{{count}} users assigned"
    },
    "themes": {
      "title": "Theme Management",
      "description": "Configure background image, icon color, and button color",
      "createTheme": "New Theme",
      "noThemes": "No themes available",
      "table": {
        "name": "Name",
        "background": "Background",
        "iconColor": "Icon Color",
        "buttonColor": "Button Color",
        "actions": "Actions",
        "noImage": "No Image"
      },
      "actions": {
        "preview": "Preview",
        "copy": "Copy",
        "edit": "Edit",
        "delete": "Delete"
      },
      "modal": {
        "createTitle": "Create New Theme",
        "editTitle": "Edit Theme",
        "description": "Configure background image and icon color for the desktop"
      },
      "form": {
        "nameId": "Name (ID) *",
        "nameIdPlaceholder": "e.g., corporate-theme",
        "nameIdHint": "Internal identifier (lowercase letters and hyphens only)",
        "cssClass": "CSS Class:",
        "displayName": "Display Name *",
        "displayNamePlaceholder": "e.g., Corporate Theme",
        "client": "Client",
        "clientNone": "No Client (Global)",
        "clientOptional": "Optional",
        "publicTheme": "Public Theme (for all users)",
        "themeMode": "Theme Mode",
        "themeModeLight": "Light",
        "themeModeDark": "Dark",
        "themeModePlaceholder": "Select theme mode",
        "themeModeHint": "Determines whether the theme is treated as Dark or Light.",
        "backgroundImage": "Background Image",
        "currentlySelected": "Currently selected:",
        "uploadNew": "Upload New Image",
        "uploading": "Uploading...",
        "remove": "Remove",
        "maxSize": "Max 5MB, recommended: 1920x1080px",
        "deriveFromImage": "Derive colors from background image",
        "applyNow": "Apply Now",
        "applying": "Applying...",
        "autoApplyHint": "When active, colors will be re-derived on mode change and image change.",
        "loadingImages": "Loading images...",
        "selectExisting": "Select existing images",
        "selected": "Selected",
        "noImagesAvailable": "No images available in bucket. Upload a new image.",
        "colorsTitle": "Colors"
      },
      "colorFields": {
        "iconColor": "Icon Color",
        "iconTextColor": "Icon Text Color",
        "textColor": "Text Color",
        "secondaryTextColor": "Secondary Text Color",
        "backgroundColor": "Background Color",
        "taskbarColor": "Taskbar Color",
        "titlebarColor": "Window Titlebar Color",
        "accentColor": "Button/Toggle Color",
        "borderColor": "Border Color",
        "iconColorLabel": "Icon Color *",
        "iconColorHint": "Color for desktop icons",
        "iconTextColorLabel": "Icon Text Color *",
        "iconTextColorHint": "Color for icon labels on the desktop",
        "textColorLabel": "General Text Color *",
        "textColorHint": "Text color for the entire UI",
        "secondaryTextColorLabel": "Secondary Text Color *",
        "secondaryTextColorHint": "Color for placeholder text, labels, and less prominent text elements",
        "backgroundColorLabel": "Background Color *",
        "backgroundColorHint": "Background color for windows and surfaces",
        "accentColorLabel": "Button/Toggle Color *",
        "accentColorHint": "Color for buttons, switches, toggles",
        "taskbarColorLabel": "Taskbar Color *",
        "taskbarColorHint": "Background color of the taskbar",
        "titlebarColorLabel": "Window Titlebar Color *",
        "titlebarColorHint": "Background color of window titlebars",
        "borderColorLabel": "Border Color *",
        "borderColorHint": "Color for borders of sidebars, cards, filters, text fields, main areas, etc."
      },
      "warnings": {
        "uppercaseConverted": "Uppercase letters were automatically converted to lowercase.",
        "whitespaceConverted": "Spaces were converted to hyphens.",
        "invalidCharsRemoved": "Invalid characters removed: {{chars}}",
        "namePatternInvalid": "Name (ID) may only contain lowercase letters and hyphens.",
        "nameExists": "Name (ID) already exists.",
        "displayNameExists": "Display name already exists.",
        "invalidColors": "Invalid colors: {{fields}}",
        "contrastWarning": "Contrast warning: Text color and background color may be difficult to read (Ratio {{ratio}}).",
        "secondaryContrastHint": "Note: Secondary text color has low contrast (Ratio {{ratio}}).",
        "iconContrastHint": "Note: Icon text color and icon color have low contrast (Ratio {{ratio}})."
      },
      "alerts": {
        "selectImageFirst": "Please select a background image first.",
        "colorDeriveFailed": "Colors could not be derived from the background image.",
        "selectImageFile": "Please select an image file",
        "imageTooLarge": "Image file is too large (max 5MB)",
        "uploadError": "Error uploading image",
        "nameRequired": "Name and display name are required",
        "namePatternRequired": "Name (ID) may only contain lowercase letters and hyphens",
        "nameConflict": "Name or display name already exists",
        "invalidHexColors": "Please provide valid HEX colors: {{fields}}",
        "createError": "Error creating theme",
        "updateError": "Error updating theme",
        "deleteError": "Error deleting theme",
        "canvasContextUnavailable": "Canvas context unavailable",
        "noColorData": "No color data found",
        "imageLoadError": "Image could not be loaded"
      },
      "buttons": {
        "cancel": "Cancel",
        "saving": "Saving...",
        "create": "Create",
        "save": "Save",
        "deleting": "Deleting...",
        "delete": "Delete",
        "close": "Close"
      },
      "delete": {
        "title": "Delete Theme",
        "confirm": "Are you sure you want to delete the theme \"{{name}}\"?"
      },
      "preview": {
        "title": "Theme Preview: {{name}}",
        "nameId": "Name (ID)",
        "public": "Public",
        "yes": "Yes",
        "no": "No",
        "mode": "Mode",
        "darkMode": "Dark Mode",
        "lightMode": "Light Mode",
        "desktopBackground": "Desktop Background",
        "noBackground": "No Background Image",
        "themeColors": "Theme Colors"
      }
    },
    "permissions": {
      "title": "App Permission Management",
      "description": "Manage app assignments for regular users. Administrators have automatic access to all apps and don't need assignments. System apps are automatically available to all users.",
      "selectUser": "Select User (regular users only)",
      "selectUserPlaceholder": "Select a regular user...",
      "appPermissionsFor": "App Permissions for",
      "id": "ID",
      "role": "Role",
      "adminSelected": "Administrator Selected",
      "adminWarning": "Administrators have automatic access to all available apps and don't need explicit app assignments.",
      "availableApps": "Available Apps",
      "assignedApps": "Assigned Apps",
      "allAppsAssigned": "All available apps are already assigned",
      "noAppsAssigned": "No apps assigned",
      "assigned": "Assigned",
      "notAssigned": "Not assigned",
      "appAssignmentsTitle": "App Assignments",
      "searchApps": "Search apps...",
      "assignAll": "Assign all",
      "removeAllApps": "Remove all",
      "totalApps": "Total Apps",
      "by": "by",
      "selectUserToManage": "Select User",
      "selectUserDescription": "Select a regular user from the dropdown menu to manage their app permissions. Administrators don't need app assignments."
    },
    "appPermissions": {
      "title": "App Permissions",
      "description": "Manage which users can access each app. System and admin apps are handled automatically.",
      "noAssignableApps": "No assignable apps found",
      "headers": {
        "app": "App",
        "category": "Category",
        "status": "Status",
        "assignedUsers": "Assigned users",
        "actions": "Actions"
      },
      "status": {
        "implemented": "Implemented",
        "unavailable": "Not available"
      },
      "actions": {
        "manage": "Manage"
      },
      "modal": {
        "title": "Manage users: {{app}}",
        "description": "Assign or remove users for this app. Admins automatically have access and are not listed.",
        "noUsers": "No users found",
        "assign": "Assign",
        "remove": "Remove",
        "unknownApp": "Unknown app"
      },
      "errors": {
        "load": "Error loading app assignments",
        "assignmentChange": "Error changing user assignment. See console for details."
      }
    },
    "appsHub": {
      "tabs": {
        "management": "Management",
        "visibility": "Visibility"
      }
    },
    "organizationHub": {
      "tabs": {
        "organizations": "Organizations",
        "access": "Access & seats",
        "knowledgeAreas": "Knowledge Areas",
        "relations": "Relations",
        "graphs": "Graphs",
        "databases": "Databases",
        "apiKeys": "API Keys",
        "staffAccess": "Staff Access",
        "externalAccess": "External access",
        "ontologies": "Ontologies"
      },
      "sections": {
        "organizations": "Organisations",
        "knowledge": "Knowledge",
        "infrastructure": "Infrastructure",
        "accessControl": "Access"
      },
      "accessControl": {
        "title": "Access",
        "subtitle": "Who reaches organisations from outside or with raised rights.",
        "back": "Back to Access",
        "loadFailed": "Could not be loaded.",
        "apiKeys": {
          "title": "API keys",
          "active": "Active",
          "expiring": "Expires within 30 days",
          "calls": "Calls in total",
          "create": "+ New key",
          "manage": "Manage all keys"
        },
        "claude": {
          "title": "Claude (MCP)",
          "on": "on",
          "off": "off",
          "enabledOrgs": "Enabled organisations",
          "users": "Active users (30 days)",
          "lastAccess": "Last access",
          "manage": "Configuration and enablement"
        },
        "staff": {
          "title": "Staff elevation",
          "start": "Start elevation",
          "active": "Active",
          "none": "none",
          "activeUntil": "{{organisation}} · until {{time}}",
          "enforcement": "Enforcement",
          "enforced": "prod: enforced",
          "notEnforced": "not enforced",
          "last30": "Last 30 days",
          "endNow": "End now",
          "endOne": "End {{organisation}}",
          "manage": "Elevations and log"
        },
        "log": {
          "title": "Log",
          "organisation": "Organisation",
          "kind": "Kind",
          "allOrganisations": "All organisations",
          "allKinds": "All kinds",
          "kinds": {
            "claude": "Claude",
            "elevation": "Elevation"
          },
          "columns": {
            "time": "Time",
            "kind": "Kind",
            "who": "Who",
            "organisation": "Organisation",
            "what": "What",
            "status": "Status"
          },
          "elevationStatus": {
            "active": "running",
            "endedEarly": "ended early",
            "expired": "expired"
          },
          "hint": "Claude calls and staff elevations. API-key calls are only counted, not logged one by one.",
          "empty": "No entries.",
          "loadMore": "Load older"
        }
      },
      "infrastructure": {
        "title": "Infrastructure",
        "description": "Graphs and databases your organisations use. An organisation's graph is set on the organisation.",
        "checkAll": "Check all",
        "add": "Add instance",
        "addGraphProvision": "Create graph on Aura",
        "addGraphConnect": "Connect existing graph",
        "addDatabase": "Add database",
        "tiles": {
          "graphs": "Graphs (Neo4j)",
          "databases": "Databases (Postgres)",
          "cost": "estimated per month",
          "costMissing_one": "{{count}} without price",
          "costMissing_other": "{{count}} without price",
          "problems": "with problems"
        },
        "filterLabel": "Type",
        "filter": {
          "all": "All",
          "graph": "Graph",
          "database": "Database"
        },
        "rowHint": "A row opens the instance: edit, size, password and delete in one place.",
        "table": {
          "name": "Name",
          "type": "Type",
          "host": "Host",
          "size": "Size",
          "content": "Content",
          "organisations": "Organisations",
          "cost": "Cost/month",
          "state": "State"
        },
        "type": {
          "graph": "Graph",
          "database": "Database"
        },
        "health": {
          "ok": "Reachable",
          "problem": "Problem",
          "unknown": "Not checked",
          "checking": "Checking"
        },
        "noOrganisations": "none",
        "empty": "No instances set up yet.",
        "emptyFiltered": "No instance of this type.",
        "loadError": "The instances could not be loaded.",
        "mappingsError": "Which organisation uses which instance could not be loaded, so the Organisations column is empty.",
        "detail": {
          "noDescription": "No description",
          "id": "ID",
          "database": "Database",
          "health": "Connection",
          "check": "Check",
          "password": "Password",
          "graphAssignHint": "An organisation's graph is set on the organisation.",
          "databaseFallbackHint": "Organisations without an assignment keep their data in the default database.",
          "assignPlaceholder": "Choose organisation",
          "assign": "Assign",
          "inactiveNoAssign": "An inactive database takes no further organisations."
        }
      },
      "knowledge": {
        "filter": {
          "label": "Organisation",
          "all": "All organisations",
          "global": "No organisation"
        },
        "areas": {
          "title": "Knowledge Areas",
          "create": "New Knowledge Area",
          "loading": "Loading knowledge areas",
          "loadError": "Knowledge areas could not be loaded: {{reason}}",
          "empty": "No knowledge areas yet.",
          "emptyFiltered": "This organisation has no knowledge areas yet.",
          "relationsNote": "Edit “Linked with” on a knowledge area’s detail page under Settings › Links."
        },
        "table": {
          "name": "Name",
          "content": "Type of content",
          "size": "Size",
          "documents": "Documents",
          "access": "Access",
          "linkedWith": "Linked with",
          "status": "Status"
        },
        "content": {
          "general": "General",
          "own": "own"
        },
        "size": {
          "unlimited": "{{chunks}} / unlimited"
        },
        "access": {
          "all": "All roles",
          "none": "no role yet",
          "roles_one": "{{count}} role",
          "roles_other": "{{count}} roles",
          "pickOrganisation": "Pick an organisation to see access."
        },
        "badge": {
          "system": "System",
          "default": "Default"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "ontologies": {
          "title": "Ontologies",
          "titleOrganisation": "Ontologies of this organisation"
        },
        "relations": {
          "heading": "Links",
          "hint": "A search in this knowledge area automatically includes the linked ones.",
          "none": "This organisation has no other knowledge areas.",
          "otherOrganisation": "other organisation: {{name}}",
          "save": "Save links",
          "saveError": "Links could not be saved: {{reason}}",
          "loadError": "Links could not be loaded."
        }
      },
      "organizations": {
        "description": "Everything about an organisation in one place: access, knowledge, storage and access control.",
        "eyebrow": "Organisation",
        "search": "Search organisations",
        "filter": {
          "attention": "Needs attention"
        },
        "empty": "No organisation yet.",
        "loadFailed": "The organisations could not be loaded.",
        "notLoaded": "Not available – the data could not be loaded.",
        "supervisorNoOrganization": "Your account has no organisation.",
        "graphNotSet": "No graph",
        "noTenant": "No tenant",
        "autoApprove": "Auto-approve",
        "manualApprove": "Manual approval",
        "openPoints_one": "{{count}} open point",
        "openPoints_other": "{{count}} open points",
        "columns": {
          "organization": "Organisation",
          "users": "Users",
          "seats": "Seats",
          "signIn": "Sign-in",
          "knowledge": "Knowledge",
          "storage": "Storage",
          "status": "Status"
        },
        "status": {
          "ok": "OK",
          "active": "active",
          "notEnabled": "not enabled",
          "short": {
            "tenantNotOnAllowlist": "Tenant pending",
            "noTenant": "Setup pending",
            "noGraph": "No graph",
            "seatsFull": "Seats full",
            "seatsOver": "Over the limit"
          }
        },
        "facts": {
          "users_one": "{{count}} user",
          "users_other": "{{count}} users",
          "tenants_one": "{{count}} tenant",
          "tenants_other": "{{count}} tenants",
          "knowledgeAreas_one": "{{count}} knowledge area",
          "knowledgeAreas_other": "{{count}} knowledge areas",
          "since": "since {{date}}"
        },
        "tabs": {
          "overview": "Overview",
          "access": "Access & seats",
          "knowledge": "Knowledge",
          "accessControl": "Access control",
          "settings": "Settings"
        },
        "issues": {
          "tenantNotOnAllowlist": "Tenant “{{name}}” is mapped, but sign-in is not enabled yet.",
          "noTenant": "No Entra tenant mapped yet – nobody can sign in for this organisation.",
          "noGraph": "No graph instance set – knowledge areas cannot be created without one.",
          "seatsFull": "All seats are taken – new users wait for manual approval.",
          "seatsOver": "More users than seats – auto-approvals are paused.",
          "goTo": {
            "access": "Go to access & seats",
            "settings": "Go to settings"
          }
        },
        "overview": {
          "seats": "Seats",
          "seatsOf": "{{used}} of {{limit}}",
          "noRole": "No role",
          "signIn": "Sign-in",
          "tenants_one": "{{count}} Entra tenant",
          "tenants_other": "{{count}} Entra tenants",
          "appsForNewUsers": "Apps for new users",
          "knowledge": "Knowledge",
          "knowledgeAreas_one": "{{count}} knowledge area",
          "knowledgeAreas_other": "{{count}} knowledge areas",
          "documents": "Documents",
          "activeAreas": "Active",
          "storage": "Storage",
          "accessControl": "Access control",
          "mcp": "Claude (MCP)",
          "mcpEnabled": "enabled",
          "mcpDisabled": "not enabled",
          "roles": "User roles",
          "recent": "Recent"
        },
        "recent": {
          "created": "Organisation created",
          "knowledgeArea": "Knowledge area “{{name}}” created",
          "tenant": "Tenant “{{name}}” mapped"
        },
        "knowledge": {
          "summary_one": "{{count}} knowledge area with {{documents}} documents.",
          "summary_other": "{{count}} knowledge areas with {{documents}} documents in total.",
          "open": "Open this organisation's knowledge"
        },
        "accessControl": {
          "summary": "API keys, external access and staff access are managed under access control.",
          "open": "Go to access control"
        },
        "fields": {
          "name": "Name",
          "bucket": "File storage (storage bucket)",
          "graph": "Graph instance",
          "graphPlaceholder": "Choose graph instance",
          "graphHint": "All knowledge areas of this organisation live in this graph instance. Once it has knowledge areas, it can no longer be changed."
        },
        "create": {
          "button": "New organisation",
          "title": "New organisation",
          "description": "Creates the organisation. Its file storage is created automatically.",
          "namePlaceholder": "Organisation name",
          "nameHint": "The file storage will be called client-{name}.",
          "graphRequired": "Please choose a graph instance.",
          "failed": "The organisation could not be created: {{reason}}",
          "graphFailed": "The organisation “{{name}}” was created, but its graph instance could not be set: {{reason}}. Please set it under settings."
        },
        "settings": {
          "general": "General",
          "dangerZone": "Delete organisation",
          "bucketHint": "The file storage keeps its name when the organisation is renamed.",
          "graphLocked_one": "The organisation already has {{count}} knowledge area, so its graph instance can no longer be changed.",
          "graphLocked_other": "The organisation already has {{count}} knowledge areas, so its graph instance can no longer be changed.",
          "graphHasKnowledgeAreas": "The organisation has knowledge areas by now, so its graph instance can no longer be changed.",
          "graphSaveFailed": "The graph instance could not be saved: {{reason}}",
          "saveFailed": "Saving failed: {{reason}}",
          "saved": "Settings saved"
        },
        "delete": {
          "title": "Delete organisation",
          "description": "“{{name}}” will be deleted permanently.",
          "hint": "Deletes the organisation. This only works while no users belong to it.",
          "hasUsersCount_one": "{{count}} user still belongs to it – the organisation can be deleted once nobody does.",
          "hasUsersCount_other": "{{count}} users still belong to it – the organisation can be deleted once nobody does.",
          "hasUsers": "An organisation with users cannot be deleted.",
          "failed": "Deleting failed: {{reason}}",
          "bucketLabel": "Delete file storage too",
          "bucketHint": "Also deletes every file in the organisation's storage bucket.",
          "bucketWarning": "This cannot be undone."
        }
      }
    },
    "usersHub": {
      "tabs": {
        "users": "Users",
        "requests": "Requests",
        "roles": "Roles"
      }
    },
    "clientAppVisibility": {
      "title": "Client App Visibility",
      "description": "Apps without assignments are visible to all clients (general). Apps with assignments are only visible to the assigned clients.",
      "addAssignment": "Add Assignment",
      "generalApps": "General Apps",
      "clientSpecificApps": "Client-Specific Apps",
      "noClientSpecificApps": "No client-specific apps configured",
      "allAppsGeneral": "All apps are currently visible to all clients",
      "removeAll": "Remove All",
      "table": {
        "app": "App",
        "clients": "Visible for Clients",
        "actions": "Actions"
      },
      "addDialog": {
        "title": "Add Client App Assignment",
        "description": "Select a client and an app. The app will then only be visible to this client (and other assigned clients).",
        "client": "Client",
        "app": "App",
        "selectClient": "Select client...",
        "selectApp": "Select app...",
        "add": "Add"
      },
      "errors": {
        "load": "Error loading client app assignments"
      }
    },
    "knowledgeAreas": {
      "title": "Knowledge Area Management",
      "description": "Create and manage Knowledge Areas. Administrators have automatic access to all Knowledge Areas.",
      "newKnowledgeArea": "New Knowledge Area",
      "availableKnowledgeAreas": "Available Knowledge Areas",
      "noKnowledgeAreas": "No Knowledge Areas available",
      "name": "Name",
      "bucket": "Bucket",
      "active": "Active",
      "inactive": "Inactive",
      "delete": "Delete",
      "createKnowledgeArea": "Create Knowledge Area",
      "areaName": "Knowledge Area Name",
      "areaDescription": "Description",
      "create": "Create",
      "cancel": "Cancel",
      "creating": "Creating...",
      "createSuccess": "Knowledge Area created successfully",
      "createError": "Error creating Knowledge Area",
      "deleteConfirm": "Delete Knowledge Area",
      "deleteWarning": "Are you sure you want to delete this Knowledge Area? This action cannot be undone.",
      "deleteSuccess": "Knowledge Area deleted successfully",
      "deleteError": "Error deleting Knowledge Area"
    },
    "kaRelations": {
      "title": "Knowledge Area Relations",
      "description": "When a Knowledge Area is selected, linked areas are automatically included in the search.",
      "infoBanner": {
        "title": "How does this work?",
        "description": "Example: If 'Meeting' is linked with 'Products', selecting 'Meeting' will automatically include results from 'Products'."
      },
      "table": {
        "sourceKA": "Knowledge Area",
        "includes": "Automatically includes",
        "actions": "Action"
      },
      "noAreas": "No Knowledge Areas available",
      "noRelations": "No relations",
      "edit": "Edit",
      "relationTypeLabel": "Type",
      "dialog": {
        "title": "Relations for: {{name}}",
        "description": "Select the areas that should be automatically included in search."
      },
      "error": "Error loading relations",
      "saveError": "Relations could not be saved"
    },
    "graphInstances": {
      "title": "Graph Instances",
      "description": "Manage Neo4j graph instances used by Knowledge Areas. {{total}} configured.",
      "createNew": "Connect instance",
      "noInstances": "No graph instances configured yet.",
      "default": "Default",
      "active": "Active",
      "inactive": "Inactive",
      "retry": "Retry",
      "table": {
        "displayName": "Display Name",
        "name": "Identifier",
        "uri": "URI (host)",
        "database": "Database",
        "status": "Status",
        "health": "Health",
        "actions": "Actions",
        "size": "Size",
        "content": "Content",
        "cost": "Cost/month (estimated)"
      },
      "createTitle": "Connect an existing instance",
      "createDescription": "Connect an existing Neo4j instance with its credentials. The password is stored encrypted and never returned.",
      "editTitle": "Edit Graph Instance",
      "editDescription": "Update connection details. Use the key icon on the row to rotate the password.",
      "fields": {
        "name": "Identifier",
        "nameHint": "lowercase, e.g. \"aura-prod-eu\"",
        "displayName": "Display Name",
        "description": "Description",
        "uri": "Neo4j URI",
        "uriHint": "e.g. neo4j+s://xxxxx.databases.neo4j.io",
        "user": "User",
        "password": "Password",
        "passwordHint": "Write-only. The current password is never returned by the API.",
        "database": "Database",
        "databaseHint": "Usually \"neo4j\"",
        "active": "Active",
        "activeHint": "Inactive instances are skipped by Knowledge Areas.",
        "memory": "Size",
        "memoryHint": "Memory of the Aura instance. Aura starts with the smallest storage for it; more storage is available later via \"Resize\".",
        "displayNameProvisionHint": "Used verbatim as the instance name in Aura, at most {{max}} characters.",
        "memoryOption": "{{memory}} · approx. {{cost}} per month"
      },
      "validation": {
        "nameRequired": "Identifier is required.",
        "displayNameRequired": "Display name is required.",
        "displayNameTooLongForAura": "Aura allows at most {{max}} characters for the instance name. Please shorten it.",
        "uriRequired": "Neo4j URI is required.",
        "userRequired": "User is required.",
        "passwordRequired": "Password is required.",
        "databaseRequired": "Database is required."
      },
      "testConnection": {
        "label": "Test connection",
        "hint": "Tests the saved credentials against the Neo4j instance. Save edited fields first to test the new values.",
        "createHint": "Save first — you can test the connection afterwards from the Edit dialog.",
        "button": "Test connection",
        "testing": "Testing…",
        "success": "Connection successful.",
        "failure": "Connection failed."
      },
      "rotatePassword": {
        "button": "Rotate password",
        "title": "Rotate password",
        "description": "Sets a new random password directly at the Neo4j instance \"{{name}}\" and records it here. The password is not shown; nothing else needs it.",
        "submit": "Rotate password",
        "recordLink": "Password already changed at the provider? Enter it here",
        "recordTitle": "Record password",
        "recordDescription": "Enter the password that already applies at instance \"{{name}}\". It is verified against the instance before saving; a wrong password is not stored.",
        "recordSubmit": "Record password",
        "backToRotate": "Back to rotation",
        "staleHint": "The stored password no longer works at the instance. Enter the current password.",
        "newPassword": "Current password",
        "confirmPassword": "Confirm password",
        "mismatch": "Passwords do not match."
      },
      "setDefault": {
        "button": "Set as default"
      },
      "delete": {
        "title": "Delete Graph Instance",
        "confirm": "Delete graph instance \"{{name}}\"?",
        "warning": "This cannot be undone. Knowledge Areas pointing at this instance will lose their graph backend.",
        "checkingRefs": "Checking for Knowledge Areas using this instance…",
        "warningReferenced_one": "{{count}} Knowledge Area still references this instance:",
        "warningReferenced_other": "{{count}} Knowledge Areas still reference this instance:",
        "alsoDeleteAura": "Also delete the Aura database",
        "alsoDeleteAuraWarning": "The database and all data in it are deleted permanently.",
        "keepAuraHint": "Only the registration is removed. The Aura database stays and can be registered again."
      },
      "errors": {
        "load": "Failed to load graph instances",
        "create": "Could not connect the instance",
        "update": "Failed to update graph instance",
        "delete": "Failed to delete graph instance",
        "rotatePassword": "Failed to rotate password",
        "setDefault": "Failed to set default instance",
        "testConnection": "Connection test failed",
        "provision": "Could not create the instance"
      },
      "provisionNew": "Create instance",
      "provisionTitle": "Create a new Aura instance",
      "provisionDescription": "Creates a new Neo4j Aura database and registers it in one step. Credentials are generated by Aura and stored encrypted.",
      "provisionHint": "The database is newly created at Neo4j Aura and is not reachable for a few minutes. No connection test is possible until then.",
      "provisionCostConfirm": "I understand that this creates a paid Aura instance with recurring cost.",
      "provisionSubmit": "Create instance",
      "provisioning": "Creating",
      "provisioningFailed": "Failed",
      "sizeValue": "{{memory}} RAM · {{storage}} storage",
      "selfHosted": "self-hosted",
      "usageValue": "{{nodes}} nodes · {{relationships}} relationships",
      "totalCost": "Estimated cost: {{amount}} per month (Neo4j Aura list price)",
      "totalCostMissing_one": "– unknown for {{count}} instance",
      "totalCostMissing_other": "– unknown for {{count}} instances",
      "resizing": "Resizing to {{memory}}",
      "resizingHint": "The database stays reachable meanwhile.",
      "resize": {
        "button": "Resize",
        "notPossible": "Only for Aura instances that are ready",
        "title": "Resize: {{name}}",
        "description": "Change the memory and storage of the Aura instance.",
        "storage": "Storage",
        "costChange": "Estimated {{from}} → {{to}} per month",
        "costUnknown": "No price is set for this size.",
        "costBasis": "Neo4j Aura list price: memory × price per GB-hour × 730 hours. Storage is included. The actual bill may differ.",
        "duration": "Resizing takes about three minutes. The database stays reachable meanwhile.",
        "confirm": "I understand that this may change the recurring cost of the Aura instance.",
        "submit": "Resize",
        "error": "Could not resize the instance",
        "loadError": "Could not load the available sizes"
      },
      "usageMeasured": "counted {{ago}}",
      "usageNever": "not counted yet",
      "recount": "Count again",
      "recountAll": "Count all again",
      "recountFailed": "Counting failed"
    },
    "postgresInstances": {
      "title": "Postgres Instances",
      "description": "Manage PostgreSQL tenant databases for per-client data isolation. {{total}} configured.",
      "createNew": "New Instance",
      "noInstances": "No Postgres instances configured yet.",
      "active": "Active",
      "inactive": "Inactive",
      "retry": "Retry",
      "tabs": {
        "instances": "Instances",
        "assignment": "Client Assignment"
      },
      "table": {
        "displayName": "Display Name",
        "name": "Identifier",
        "host": "Host:Port",
        "database": "Database",
        "clients": "Clients",
        "status": "Status",
        "health": "Health",
        "actions": "Actions"
      },
      "createTitle": "Create Postgres Instance",
      "createDescription": "Register a new PostgreSQL tenant database. The password is stored encrypted and never returned by the API.",
      "editTitle": "Edit Postgres Instance",
      "editDescription": "Update connection details. Use the key icon on the row to rotate the password.",
      "fields": {
        "name": "Identifier",
        "nameHint": "lowercase, e.g. \"tenant-test_a\"",
        "displayName": "Display Name",
        "description": "Description",
        "host": "Host",
        "hostHint": "e.g. psql-cdb-dev-bik.postgres.database.azure.com",
        "port": "Port",
        "database": "Database",
        "databaseHint": "e.g. cdb_tqs_test_a",
        "user": "User",
        "password": "Password",
        "passwordHint": "Write-only. The current password is never returned by the API.",
        "active": "Active",
        "activeHint": "Inactive instances cannot be assigned to clients."
      },
      "validation": {
        "nameRequired": "Identifier is required.",
        "displayNameRequired": "Display name is required.",
        "hostRequired": "Host is required.",
        "portInvalid": "Port must be between 1 and 65535.",
        "databaseRequired": "Database is required.",
        "userRequired": "User is required.",
        "passwordRequired": "Password is required."
      },
      "testConnection": {
        "label": "Test connection",
        "hint": "Tests the saved credentials against the PostgreSQL instance. Save edited fields first to test the new values.",
        "createHint": "Tests the values entered above without saving.",
        "needsConnFields": "Enter host, port, database, user and password to test.",
        "button": "Test connection",
        "testing": "Testing…",
        "success": "Connection successful.",
        "failure": "Connection failed."
      },
      "rotatePassword": {
        "button": "Rotate password",
        "title": "Rotate Password",
        "description": "Set a new password for \"{{name}}\". The current password cannot be retrieved.",
        "newPassword": "New password",
        "confirmPassword": "Confirm new password",
        "mismatch": "Passwords do not match.",
        "submit": "Rotate"
      },
      "delete": {
        "title": "Delete Postgres Instance",
        "confirm": "Delete Postgres instance \"{{name}}\"?",
        "warning": "This cannot be undone.",
        "warningClients_one": "{{count}} client is still assigned to this instance. Please reassign it first.",
        "warningClients_other": "{{count}} clients are still assigned to this instance. Please reassign them first."
      },
      "assign": {
        "panelTitle": "Client Assignment",
        "panelDescription": "Set which Postgres instance owns each client's data. Clients without a mapping use the default instance. {{total}} clients.",
        "noClients": "No clients found.",
        "title": "Assign Client",
        "description": "Choose a Postgres instance for \"{{client}}\".",
        "instance": "Postgres instance",
        "instancePlaceholder": "Select an instance…",
        "instanceRequired": "Please select an instance.",
        "notes": "Notes",
        "notesHint": "Optional, e.g. ticket reference or provisioning date.",
        "defaultFallback": "Default",
        "change": "Change assignment",
        "assign": "Assign",
        "unassign": "Reset to default",
        "table": {
          "client": "Client",
          "instance": "Instance",
          "notes": "Notes",
          "actions": "Actions"
        }
      },
      "errors": {
        "load": "Failed to load Postgres instances",
        "loadMappings": "Failed to load client assignments",
        "create": "Failed to create Postgres instance",
        "update": "Failed to update Postgres instance",
        "delete": "Failed to delete Postgres instance",
        "rotatePassword": "Failed to rotate password",
        "assign": "Failed to assign client",
        "unassign": "Failed to remove assignment"
      }
    },
    "supervisorKA": {
      "title": "Knowledge Areas",
      "createNew": "New Knowledge Area",
      "noAreas": "No knowledge areas yet",
      "errorLoading": "Error loading knowledge areas"
    },
    "voiceAgentPrompts": {
      "infoTitle": "Voice Agent Widget - Prompts Management",
      "infoDescription": {
        "intro": "Manage prompts for the Voice Agent Widget:",
        "systemPrompts": "All prompts - activate/deactivate via toggle switch"
      },
      "tabs": {
        "system": "System Prompts",
        "knowledgeArea": "Knowledge Area Prompts",
        "allKnowledgeAreas": "All Knowledge Areas"
      },
      "systemPrompts": {
        "title": "System Prompts",
        "description": "Global app-level prompts for the Voice Agent"
      },
      "knowledgeAreaPrompts": {
        "title": "Knowledge Area Prompts",
        "description": "Prompts specific to individual knowledge areas"
      },
      "allKnowledgeAreasPrompts": {
        "title": "All Knowledge Areas Prompts",
        "description": "Prompts that apply across all knowledge areas"
      }
    },
    "promptManagement": {
      "assignedPrompts": {
        "title": "Assigned Prompts",
        "description": "Prompts currently assigned to this app/area",
        "empty": "No prompts assigned yet. Drag prompts from the Prompt Library to assign them."
      },
      "dropZone": {
        "hint": "Drag prompts here to assign",
        "dropping": "Drop to assign",
        "description": "Open the Prompt Library, drag a prompt and drop it here"
      },
      "assigning": "Assigning prompt...",
      "alreadyAssigned": "This prompt is already assigned and active",
      "edit": "Edit Prompt",
      "remove": "Remove Assignment",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "table": {
        "name": "Name",
        "promptKey": "Prompt Key",
        "type": "Type",
        "application": "Application",
        "status": "Status",
        "actions": "Actions"
      },
      "editDialog": {
        "title": "Edit Assigned Prompt",
        "description": "Edit the content and status of this prompt",
        "metadata": "Prompt Information",
        "activeStatus": "Active",
        "activeDescription": "Inactive prompts are not used by the application",
        "content": "Prompt Content",
        "characters": "characters"
      },
      "deleteConfirm": {
        "title": "Remove Assignment",
        "description": "Are you sure you want to remove the prompt \"{{name}}\"?",
        "inline": "Remove assignment for \"{{name}}\"?",
        "inlineHint": "This will set the prompt to inactive",
        "confirm": "Remove"
      }
    },
    "prompts": {
      "searchPlaceholder": "Search prompts...",
      "languagePlaceholder": "Select language",
      "loading": "Loading prompt library...",
      "filters": {
        "placeholder": "Filter by category",
        "all": "All prompts",
        "system": "System",
        "session": "Session",
        "turn": "Turn",
        "answer": "Answer",
        "tool": "Tool",
        "utility": "Utility"
      },
      "scope": {
        "general": "Global",
        "placeholder": "Select scope",
        "info": "Knowledge-area prompts for \"{{name}}\". Changes only affect this knowledge area."
      },
      "stats": {
        "visible": "Showing {{visible}} of {{total}} prompts"
      },
      "emptyState": {
        "title": "No matching prompts",
        "subtitle": "Adjust the filter or search term."
      },
      "actions": {
        "edit": "Edit",
        "createSystem": "Create System Prompt",
        "delete": "Delete"
      },
      "editor": {
        "editTitle": "Edit Prompt",
        "createTitle": "Create System Prompt",
        "id": "ID",
        "category": "Category",
        "usage": "Usage",
        "mode": "Mode",
        "modePlaceholder": "e.g. system",
        "tags": "Tags (comma separated)",
        "tagsPlaceholder": "context, system",
        "title": "Title",
        "titlePlaceholder": "Clear name, e.g. Greeting KA",
        "content": "Content",
        "contentPlaceholder": "Write the full prompt text...",
        "description": "Description",
        "descriptionPlaceholder": "Optional context or internal notes",
        "optional": "optional",
        "cancel": "Cancel",
        "save": "Save",
        "saving": "Saving...",
        "generatedIdInfo": "The prompt ID is generated automatically and stays unique. Existing prompts keep their ID.",
        "systemInfo": "Prompts are stored as system prompts automatically and apply to the selected knowledge area or globally.",
        "tabs": {
          "new": "Create new",
          "library": "Existing prompts"
        },
        "library": {
          "subtitle": "Reuse an existing prompt from another knowledge area as a template.",
          "loading": "Loading prompts...",
          "empty": "No suitable prompts were found in other knowledge areas.",
          "error": "Failed to load prompt templates.",
          "knowledgeAreaLabel": "Knowledge Area",
          "actions": {
            "use": "Apply"
          }
        },
        "errors": {
          "requiredId": "An ID is required.",
          "requiredContent": "Please provide a title and content.",
          "duplicateId": "This ID is already in use."
        },
        "deleteConfirm": "Delete prompt \"{{title}}\"?"
      },
      "badges": {
        "usage": {
          "system": "System",
          "session": "Session",
          "turn": "Turn",
          "answer": "Answer",
          "tool": "Tool",
          "utility": "Utility",
          "greeting": "Greeting",
          "instruction": "Instruction"
        },
        "mode": {
          "simple": "Simple",
          "deep": "Deep",
          "web": "Web",
          "system": "System"
        }
      },
      "toasts": {
        "copiedTitle": "Prompt copied",
        "copiedDescription": "The content is now on the clipboard.",
        "copyFailedTitle": "Copy failed",
        "copyFailedDescription": "Please copy the prompt manually."
      },
      "errors": {
        "loadFailed": "Failed to load prompt library."
      }
    },
    "aiKnowledgeExtractor": {
      "title": "AI Knowledge Extractor",
      "knowledgeArea": "Knowledge Area",
      "selectDocument": "Select Document",
      "noDocuments": "No PDF documents available",
      "noFilterResults": "No documents found",
      "errorLoadingDocuments": "Error loading documents",
      "welcomeTitle": "Welcome to AI Knowledge Extractor",
      "welcomeDescription": "Select a PDF document from the sidebar to start knowledge extraction.",
      "startExtraction": "Start Extraction",
      "extracting": "Extracting...",
      "progress": "Progress: {{progress}}%",
      "extractionComplete": "Extraction completed successfully!",
      "extractionError": "Extraction error",
      "downloadResults": "Download Results",
      "summary": "Summary",
      "keywords": "Keywords",
      "entities": "Entities",
      "extractedText": "Extracted Text",
      "searchPlaceholder": "Search title or filename",
      "filterAll": "All Statuses",
      "filterCompleted": "Completed",
      "filterProcessing": "Processing",
      "filterPending": "Pending",
      "statusCompleted": "Completed",
      "statusProcessing": "Processing",
      "statusPending": "Pending",
      "statusFailed": "Failed",
      "columnFilename": "Filename",
      "columnKnowledgeArea": "Knowledge Area",
      "columnCreated": "Created",
      "documentCount": "{{count}} documents",
      "viewResults": "View Results",
      "viewGraph": "View Knowledge Graph"
    },
    "common": {
      "loading": "Loading...",
      "saving": "Saving...",
      "deleting": "Deleting...",
      "error": "Error",
      "success": "Success",
      "cancel": "Cancel",
      "save": "Save",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "confirm": "Confirm",
      "yes": "Yes",
      "no": "No",
      "webSearch": "Web search"
    },
    "apps": {
      "urlApp": "URL App",
      "title": "App Management",
      "description": "Create, edit and manage apps",
      "create": "Create App",
      "createTitle": "Create New App",
      "editTitle": "Edit App",
      "deleteTitle": "Delete App",
      "deleteConfirm": "Are you sure you want to delete this app?",
      "deleteWarning": "This action cannot be undone.",
      "createSuccess": "App created successfully",
      "updateSuccess": "App updated successfully",
      "deleteSuccess": "App deleted successfully",
      "deleteError": "Failed to delete app",
      "saveError": "Failed to save app",
      "loadError": "Failed to load apps",
      "toggleError": "Failed to toggle status",
      "clientVisibilityError": "Failed to update client visibility",
      "active": "Active",
      "inactive": "Inactive",
      "activated": "App activated",
      "deactivated": "App deactivated",
      "noApps": "No apps found",
      "nameRequired": "Name is required",
      "invalidName": "Invalid app name",
      "allClients": "All Clients",
      "form": {
        "name": "Name",
        "nameHint": "Unique identifier (lowercase, hyphens)",
        "displayName": "Display Name",
        "description": "Description",
        "icon": "Icon",
        "category": "Category",
        "isActive": "Active",
        "externalUrl": "External URL (optional)",
        "externalUrlHint": "If set, this app opens the given address instead of its own interface.",
        "knowledgeAreaAware": "Works with knowledge areas",
        "knowledgeAreaAwareHint": "Only such apps can be granted knowledge areas in a role. What an app may do in a granted area follows from its endpoints and is not configurable.",
        "openMode": "Open in",
        "openModeWindow": "Desktop window",
        "openModeTab": "Browser tab",
        "openModeHint": "Window needs https. Some sites forbid embedding or need a sign-in that does not work inside a window; choose \"Browser tab\" for those.",
        "namePlaceholder": "my-app",
        "displayNamePlaceholder": "My App",
        "descriptionPlaceholder": "App description..."
      },
      "table": {
        "name": "Name",
        "displayName": "Display Name",
        "category": "Category",
        "status": "Status",
        "clients": "Clients",
        "actions": "Actions"
      },
      "urlAppWindow": "URL app · window",
      "categories": {
        "system": "System",
        "productivity": "Productivity",
        "multimedia": "Multimedia",
        "admin": "Administration",
        "tools": "Tools",
        "communication": "Communication"
      }
    },
    "colorPicker": {
      "palette": "Palette",
      "recentlyUsed": "Recently used",
      "openPicker": "Click to open color picker"
    },
    "staffAccess": {
      "title": "Staff Access (Elevation)",
      "enforced": "Enforcement active (prod)",
      "notEnforced": "Not enforced (dev/staging)",
      "description": "Time-boxed, reasoned access to another customer's data (PIM-lite). The elevation doubles as its audit-log entry and is visible to all admins. Without an active elevation, prod exposes only the control plane (status, errors, file names).",
      "activeTitle_other": "Active elevations ({{count}})",
      "expiresAt": "expires: {{time}}",
      "endNow": "End now",
      "form": {
        "title": "New elevation",
        "client": "Target organization",
        "clientPlaceholder": "Select organization…",
        "reason": "Reason (required)",
        "reasonPlaceholder": "e.g. support ticket #123: failed upload",
        "ttl": "Duration",
        "ttlHours_other": "{{count}} hours",
        "submit": "Start elevation",
        "hint": "Default 4 h, maximum 24 h. The elevation appears in the log immediately and can be ended early at any time.",
        "ttlHours_one": "{{count}} hour"
      },
      "toast": {
        "created": "Elevation started",
        "createFailed": "Elevation failed",
        "ended": "Elevation ended",
        "endFailed": "Ending failed"
      },
      "log": {
        "empty": "No elevations logged yet.",
        "status": "Status",
        "actor": "Admin",
        "client": "Organization",
        "reason": "Reason",
        "started": "Started",
        "until": "Until",
        "active": "Active",
        "endedEarly": "Ended early",
        "expired": "Expired"
      },
      "badge": {
        "single": "Elevated: {{client}}",
        "multiple": "{{count}} active elevations"
      },
      "activeTitle_one": "Active elevation ({{count}})"
    },
    "externalAccess": {
      "title": "External access",
      "subtitle": "Ways in which clients outside cdbOS reach corporate knowledge. Click one for its configuration, who has it, and its log.",
      "claude": {
        "title": "Claude (MCP connector)",
        "description": "Search knowledge areas from Claude – with each person's own account and permissions."
      },
      "serverOn": "Active on this environment",
      "serverOff": "Off on this environment",
      "loadFailed": "Could not be loaded.",
      "enabledClients": "Enabled organisations",
      "users30": "Active users (30 days)",
      "calls30": "Calls (30 days)",
      "lastCall": "Last access",
      "back": "Overview",
      "configuration": "Configuration",
      "url": "Server URL",
      "clientId": "OAuth client ID",
      "openEntra": "Open the app registration in Entra",
      "revokeHint": "To revoke access: revoke the person's sessions in Entra or remove the consent for the app.",
      "noClients": "No organisation enabled yet.",
      "capabilityHint": "Enable it with the capability “features.remote_mcp” (cdbChat → Tiers or Clients). Without it the server refuses every call.",
      "audit": "Log",
      "auditHint": "Tool, knowledge areas searched and number of results per call. Search text is not stored.",
      "allClients": "All organisations",
      "columns": {
        "time": "Time",
        "user": "Person",
        "client": "Organisation",
        "tool": "Tool",
        "areas": "Knowledge areas",
        "results": "Results",
        "status": "Status",
        "duration": "Duration"
      },
      "status": {
        "success": "Succeeded",
        "error": "Failed",
        "rate_limited": "Limit reached",
        "permission_denied": "Refused",
        "timeout": "Timed out"
      },
      "noCalls": "No calls yet.",
      "loadMore": "Load more"
    },
    "organizationAccess": {
      "supervisor": {
        "title": "Supervisor",
        "hint": "What this organisation's supervisors may do. Admins are not affected.",
        "createKnowledgeAreas": {
          "label": "Create knowledge areas",
          "description": "Off: supervisors no longer see “New knowledge area”. They can still edit and delete existing knowledge areas."
        }
      },
      "title": "Access & seats",
      "description": "Seats and automatic approval of new users per organisation.",
      "organizationPlaceholder": "Select organisation",
      "loadFailed": "The access settings of the organisation could not be loaded.",
      "seats": {
        "title": "Seats & approval",
        "used": "Seats in use",
        "usedOfLimit": "{{used}} / {{limit}}",
        "usedUnlimited": "{{used}} · unlimited",
        "full": "All seats taken – new users wait for manual approval.",
        "over": "Over the limit – nobody is deactivated, automatic approvals pause.",
        "limit": "Number of seats",
        "limitPlaceholder": "Unlimited",
        "hint": "Active users of the organisation, not counting BIK administrators and training participants."
      },
      "autoApprove": {
        "label": "Approve automatically",
        "description": "New users from this organisation’s tenants are active right away while a seat is free."
      },
      "defaultRole": {
        "label": "Default role",
        "placeholder": "Select role",
        "hint": "Only user roles of this organisation, no supervisor roles.",
        "none": "No user role yet – create one under Users → Roles, or approve without a role.",
        "noRole": "No role – a supervisor assigns one",
        "noRoleHint": "New users are created without a role. They stay on the sign-in screen until a supervisor assigns them a role."
      },
      "theme": {
        "label": "Default theme",
        "placeholder": "Select theme",
        "hint": "Applies to every new user of the organisation, manual approvals included.",
        "none": "No theme available – create one under Themes first."
      },
      "tenants": {
        "title": "Entra tenants",
        "hint": "Users from these tenants belong to this organisation.",
        "empty": "No tenant mapped yet.",
        "addedBy": "Added by {{name}} on {{date}}",
        "notOnAllowlist": "Sign-in not enabled yet",
        "remove": "Remove tenant",
        "add": "Tenant ID",
        "addButton": "Add",
        "notOnAllowlistHint": "The tenant is not listed in AZURE_AD_ALLOWED_TENANTS. Its users can only sign in once it is.",
        "lookup": {
          "checking": "Checking tenant …",
          "unknownName": "Name not available – the tenant can still be added.",
          "mappedHere": "Already mapped to this organisation.",
          "mappedElsewhere": "Already belongs to the organisation “{{name}}”."
        },
        "nameUnknown": "Name unknown"
      },
      "errors": {
        "seatLimitInvalid": "Please enter a whole number between 0 and {{max}} or leave the field empty.",
        "tenantInvalid": "The tenant ID must be a GUID.",
        "entryAppRequired": "Select at least webOS or cdbChat.",
        "themeRequired": "Automatic approval needs a default theme.",
        "waitingMessageTooLong": "The note may be at most {{max}} characters long.",
        "productEntryRequired": "The organisation needs at least webOS or cdbChat."
      },
      "toast": {
        "saved": "Settings saved",
        "saveFailed": "Saving failed",
        "tenantAdded": "Tenant mapped",
        "tenantAddFailed": "Tenant could not be mapped",
        "tenantRemoved": "Tenant removed",
        "tenantRemoveFailed": "Tenant could not be removed"
      },
      "pickOrganization": "Select an organisation to manage seats and tenants.",
      "applications": {
        "label": "Applications",
        "webos": "webOS (desktop)",
        "cdbChat": "cdbChat",
        "editor": "Editor",
        "composer": "Composer",
        "controlCenter": "Control Center"
      },
      "products": {
        "label": "Products of the organisation",
        "hint": "Only these products can be given to users of the organisation, by admins and supervisors.",
        "removedWarning": "On save, every user of the organisation loses: {{products}}."
      },
      "waitingMessage": {
        "label": "Note for people who wait",
        "placeholder": "e.g. Roles are assigned by IT, phone 0123 456789",
        "hint": "Shown on the sign-in screen to everyone who cannot get in yet: without a role, without a free seat or before approval. {{count}} / {{max}} characters."
      }
    },
    "ontologies": {
      "title": "Ontologies",
      "new": "New",
      "newTitle": "New ontology",
      "empty": "No ontologies yet.",
      "pick": "Pick an ontology on the left or create a new one.",
      "systemGroup": "System",
      "readOnly": "Read-only",
      "counts": "{{entities}} entity types · {{edges}} relationship types",
      "usedBy_one": "Used by {{count}} knowledge area",
      "usedBy_other": "Used by {{count}} knowledge areas",
      "unsaved": "Not saved",
      "formView": "Form",
      "jsonView": "JSON view",
      "jsonLabel": "Definition as JSON",
      "copyToClient": "Copy for a client",
      "importFile": "Import from file",
      "validate": "Check",
      "deleteInUse_one": "Cannot delete: {{count}} knowledge area uses this ontology.",
      "deleteInUse_other": "Cannot delete: {{count}} knowledge areas use this ontology.",
      "systemReadOnly": "System preset – cannot be changed. To adapt it, create a copy for a client.",
      "valid": "Valid: {{entities}} entity types, {{edges}} relationship types, {{pairs}} allowed connections.",
      "name": "Name",
      "client": "Client",
      "clientPlaceholder": "Choose a client",
      "description": "Description",
      "clientLocked": "The client is fixed while knowledge areas use the ontology.",
      "searchTypes": "Search types",
      "entityTypes": "Entity types",
      "edgeTypes": "Relationship types",
      "deleteTitle": "Delete ontology?",
      "deleteConfirm": "\"{{name}}\" will be deleted permanently.",
      "discardTitle": "Discard changes?",
      "discardDescription": "The ontology has unsaved changes.",
      "discard": "Discard",
      "copyTitle": "Copy for a client",
      "copyDescription": "\"{{name}}\" is created as an editable ontology of the chosen client.",
      "copyName": "{{name}} (copy)",
      "copyCreate": "Create copy",
      "columns": {
        "name": "Name",
        "description": "Description for the model",
        "fields": "Fields",
        "pairs": "Allowed from → to"
      },
      "anyEntity": "Any type",
      "unnamed": "Unnamed",
      "rowErrors_one": "{{count}} error",
      "rowErrors_other": "{{count}} errors",
      "noMatches": "No matches.",
      "noEntityTypes": "No entity types yet.",
      "noEdgeTypes": "No relationship types yet.",
      "removeType": "Remove \"{{name}}\"",
      "addEntityType": "Add entity type",
      "addEdgeType": "Add relationship type",
      "entityNamePlaceholder": "e.g. Product",
      "edgeNamePlaceholder": "e.g. BELONGS_TO",
      "descriptionPlaceholder": "When should the model use this type?",
      "noFields": "No fields.",
      "fieldName": "Field name",
      "fieldType": "Type",
      "fieldDescription": "Field description",
      "removeField": "Remove field",
      "addField": "Add field",
      "pairsHint": "Between which entity types may this relationship exist?",
      "pairSource": "From",
      "pairTarget": "To",
      "removePair": "Remove connection",
      "pairNeedsName": "Give it a name first.",
      "addPair": "Add connection",
      "importNotes": {
        "droppedEntity": "The empty type “Entity” was removed; Graphiti uses it for every entity anyway.",
        "edgesOpened_one": "{{count}} relationship type is now allowed between all entity types because it listed too many connections for extraction: {{names}}",
        "edgesOpened_other": "{{count}} relationship types are now allowed between all entity types because they listed too many connections for extraction: {{names}}"
      },
      "fieldTypes": {
        "text": "Text",
        "integer": "Number",
        "number": "Decimal",
        "boolean": "Yes/No",
        "text_list": "List of text",
        "integer_list": "List of numbers",
        "datetime": "Date/time",
        "date": "Date"
      },
      "errors": {
        "validate": "Check failed.",
        "save": "Saving failed.",
        "delete": "Deleting failed.",
        "import": "Import failed.",
        "importType": "Please choose a .py or .json file.",
        "importJson": "The file is not a valid ontology: {{reason}}",
        "json": "Invalid JSON: {{reason}}",
        "nameRequired": "Please enter a name.",
        "clientRequired": "Please choose a client.",
        "list": "Ontologies could not be loaded: {{reason}}",
        "load": "Ontology could not be loaded: {{reason}}"
      },
      "genericPairs": "Generic relationship {{edge}} (no definition of its own): {{pairs}}"
    }
  },
  "languages": {
    "de": "German",
    "en": "English"
  },
  "roleBasedApp": {
    "checkingAccessHelper": "One moment please.",
    "accessTo": "Access to {{app}}",
    "accessDenied": "Access denied",
    "noPermission": "You do not have permission to use this application.",
    "roleAdmin": "Administrator",
    "roleUser": "User",
    "active": "Active",
    "inactive": "Inactive",
    "user": "User: {{email}}",
    "contactAdmin": "Please contact an administrator if you require access to this feature."
  },
  "start": {
    "openAria": "Open start menu",
    "label": "Start",
    "loadingApps": "Loading apps..."
  },
  "auth": {
    "guest": "Guest",
    "email": "Email",
    "password": "Password",
    "name": "Name",
    "emailRequired": "Email address is required",
    "emailInvalid": "Please enter a valid email address",
    "passwordRequired": "Password is required",
    "nameRequired": "Name is required",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "signUp": "Sign Up",
    "signingUp": "Signing up...",
    "forgotPassword": "Forgot password?",
    "createAccount": "Create account",
    "backToLogin": "Back to login",
    "resetPassword": "Reset password",
    "loginTitle": "cdbOS - Login",
    "welcomeBack": "Welcome back",
    "welcome": "Welcome",
    "loginSuccess": "Successfully logged in",
    "loginFailed": "Login failed",
    "registerSuccess": "Registration successful",
    "registerFailed": "Registration failed",
    "logoutSuccess": "Logged out",
    "logoutMessage": "You have been successfully logged out.",
    "invalidCredentials": "Invalid credentials",
    "errorOccurred": "An error occurred",
    "resetNotAvailable": "Not available",
    "resetNotEnabled": "Password reset is not enabled in this demo.",
    "nameMinLength": "Name must be at least 2 characters long",
    "nameMaxLength": "Name cannot exceed 100 characters",
    "nameInvalidChars": "Name can only contain letters, spaces, hyphens and apostrophes",
    "passwordMinLength": "Password must be at least 8 characters long",
    "passwordMaxLength": "Password cannot exceed 50 characters",
    "passwordComplexity": "Password must contain at least one lowercase letter, one uppercase letter, one number and one special character",
    "passwordHint": "Password must be at least 8 characters long and contain uppercase, lowercase, numbers and special characters.",
    "message": "Message",
    "accessRequestSubmitted": "Access Request Submitted",
    "accessRequestSubmittedMessage": "Your request has been successfully submitted. An administrator will review it shortly.",
    "accessRequestMessagePlaceholder": "Optional: Describe why you need access...",
    "submitAccessRequest": "Request Access",
    "submittingRequest": "Submitting request...",
    "welcomeToCdbOS": "Welcome to cdbOS",
    "signInWithCredentials": "Sign in with your credentials",
    "requestAccess": "Request Access",
    "requestAccessDescription": "Request access to the system",
    "azureAdDescription": "Sign in with your Microsoft account",
    "signInWithMicrosoft": "Sign in with Microsoft",
    "switchAccount": "Sign in with a different account",
    "azureAdHint": "You will be redirected to Microsoft",
    "pendingApproval": "Access Pending",
    "pendingApprovalDescription": "Your account for {{email}} has been created and is awaiting administrator approval.",
    "pendingApprovalNotification": "You will be notified when your access has been activated.",
    "seatLimitReached": "No free seats",
    "seatLimitReachedDescription": "All seats of your organisation are taken. Your request for {{email}} was recorded – please contact your supervisor.",
    "noRoleAssigned": "Role pending",
    "noRoleAssignedDescription": "Your account for {{email}} is set up. You can use cdbOS once a role has been assigned to you.",
    "organisationMessage": "Note from your organisation",
    "loginPage": {
      "answerCaption": "Answer from your knowledge",
      "example": "Example",
      "searching": "Searching {{count}} sources …",
      "examples": {
        "pump": {
          "q": "Which tightening torque applies to the flange joint on pump P-200?",
          "a": "The P-200 flange joint takes 45 Nm, crosswise in two passes. Since revision C, a re-check after 24 operating hours is mandatory.",
          "s1": "Assembly manual P-200, rev. C",
          "s1Loc": "p. 14",
          "s2": "Service report 2026-118",
          "s2Loc": "sec. 3"
        },
        "leave": {
          "q": "How many vacation days can I carry over to next year?",
          "a": "You can carry over up to 10 days. They must be taken by 31 March; HR approves exceptions.",
          "s1": "Works agreement on leave 2026",
          "s1Loc": "§ 4",
          "s2": "HR FAQ",
          "s2Loc": "entry 12"
        },
        "supplier": {
          "q": "Which suppliers are approved for stainless steel 1.4404?",
          "a": "Three suppliers: Müller Stahl, Nordmetall and Ferro Süd. Nordmetall is only conditionally approved until June because its audit is still open.",
          "s1": "Purchasing supplier list",
          "s1Loc": "as of 09/2026",
          "s2": "Audit report Nordmetall",
          "s2Loc": "07/2026",
          "s3": "Material sheet 1.4404",
          "s3Loc": "p. 2"
        }
      },
      "claimLead": "Your knowledge.",
      "claimAccent": "Your potential.",
      "claimSub": "Ask your company knowledge directly and get a sourced answer in seconds.",
      "signIn": "Sign in with Microsoft",
      "redirecting": "Redirecting to Microsoft …",
      "hint": "You sign in with your work account at Microsoft.",
      "noAccount": "Not a customer yet?",
      "contactUs": "Contact us",
      "mailSubject": "Corporate Digital Brain inquiry",
      "tags": {
        "email": "Email",
        "documents": "Documents",
        "meeting": "Team meeting",
        "experts": "Expert knowledge",
        "databases": "Databases",
        "sharepoint": "SharePoint",
        "maintenance": "Maintenance report",
        "iot": "IoT sensors",
        "bot": "Knowledge bot",
        "configurators": "Configurators",
        "robotics": "Robotics",
        "avatars": "Audio & video avatars"
      },
      "siemens": {
        "eyebrow": "Knowledge Hub · powered by CDB",
        "claimLead": "Product knowledge.",
        "claimAccent": "Right at hand.",
        "claimSub": "Ask for commercial and technical data on your products. Every answer comes with its source from Graph Studio, data sheet or manual.",
        "signIn": "Sign in with Siemens account",
        "hint": "Sign-in via Microsoft Entra ID with your Siemens account.",
        "poweredBy": "powered by Corporate Digital Brain",
        "panelLine": "Product data from Graph Studio, data sheets and expert knowledge in one search.",
        "factPrimarySource": "Graph Studio as primary source",
        "factSources": "Answers with sources"
      }
    },
    "noWebOSAccess": "No access to webOS",
    "noWebOSAccessDescription": "Your account does not have access to this application. Please contact an administrator.",
    "sessionExpiringMessage": "Your session will expire in a few minutes.",
    "extendSession": "Extend session",
    "sessionExpiredTitle": "Session Expired",
    "sessionExpiredMessage": "Your session has expired. Please sign in again to continue.",
    "sessionExpiredButton": "Sign in again",
    "tenantNotAllowed": "No access",
    "tenantNotAllowedDescription": "Your organisation is not authorized to use this application. Signing in again will not change that — please contact your IT department.",
    "tenantNotAllowedAccount": "Signed in as {{email}}",
    "userStatus": {
      "title": "User status",
      "signedInAs": "Signed in as:",
      "email": "Email:",
      "id": "ID:",
      "registered": "Registered:",
      "dateUnavailable": "Date not available",
      "notSignedIn": "Not signed in"
    }
  },
  "apps": {
    "app-store": "App Store",
    "settings": "Settings",
    "widget-settings": "Widget Manager",
    "widget-store": "Widget Store",
    "cortex": "Cortex",
    "voice": "Voice Assistant",
    "multimedia": "Multimedia Player",
    "qa": "Q&A Creator",
    "pdf-viewer": "PDF Viewer",
    "file-preview": "File Preview",
    "prompt-library": "Prompt Library",
    "cdb-sessions": "CDB Sessions",
    "cdb-training": "CDB Training Hub",
    "notes": "Notes",
    "drive2": "cdbDrive",
    "drive2-description": "Browse and manage documents by Knowledge Area",
    "communicator2": "cdbChat",
    "collabora-editor": "Document Editor",
    "ai-knowledge-extractor": "CDB Knowledge Extractor",
    "knowledge-verifier": "CDB Knowledge Verifier",
    "document-editor": "Document Editor",
    "document-editor-description": "Create and edit documents online",
    "access": {
      "accessDeniedTitle": "Access Denied",
      "accessDeniedMessage": "You don't have access to this app. You can request access via the App Store."
    },
    "cortex-description": "Cortex — administration area for users, apps and configuration",
    "multimedia-description": "Audio and video playback",
    "pdf-viewer-description": "View PDF documents",
    "file-preview-description": "Preview PDF, Word, Excel, PowerPoint, text, JSON, XML, Markdown, and CSV files",
    "cdb-training-description": "Trainings and surveys in one app",
    "inDevelopment": "This app is still in development.",
    "wissenshaus": "Wissenshaus",
    "wissenshaus-description": "Your knowledge areas as a house: what happened in the brain",
    "harness": "cdbHARNESS",
    "cdb-control": "cdbControl",
    "harness-description": "Agent roles check a knowledge area, you approve (prototype)",
    "cdb-control-description": "Your client's tasks from recordings and added by hand",
    "fallbackTitle": "App {{id}}",
    "fallbackId": "App ID: {{id}}"
  },
  "sessions": {
    "sidebar": {
      "manage": "Manage",
      "play": "Session",
      "episodeLibrary": "Episode Library",
      "sessionCreator": "Session Creator",
      "sessions": "Knowledge Sessions"
    },
    "library": {
      "title": "My Sessions",
      "description": "Manage training sessions with episodes",
      "loading": "Loading sessions...",
      "empty": "No sessions yet",
      "createFirst": "Create first session",
      "createSession": "Create Session",
      "deleteConfirm": "Really delete this session?",
      "episodes": "Episodes",
      "questions": "Questions"
    },
    "episodes": {
      "title": "Episode Library",
      "description": "Manage reusable episodes",
      "libraryDescription": "All created episodes. Create new episodes in the Session Creator.",
      "createHint": "Use the Session Creator to create new episodes",
      "dragDropHint": "💡 Tip: Episodes can be added to the Session Creator via Drag & Drop",
      "loading": "Loading episodes...",
      "empty": "No episodes yet",
      "createFirst": "Create first question",
      "createQuestion": "Create Question",
      "createEpisode": "Create Episode",
      "editQuestion": "Edit Question",
      "editEpisode": "Edit Episode",
      "deleteConfirm": "Really delete this question?",
      "deleteTitle": "Delete Question",
      "deleteConfirmMessage": "Do you really want to delete the question \"{{question}}\"? This action cannot be undone.",
      "deleteSuccess": "Episode deleted",
      "deleteSuccessDescription": "The question has been successfully deleted",
      "deleteError": "Error deleting",
      "saveSuccess": "Episode saved",
      "saveSuccessDescription": "The question has been successfully saved",
      "saveError": "Error saving",
      "editorDescription": "Create or edit a question",
      "episodeText": "Episode Text",
      "episodeTextPlaceholder": "Enter your question...",
      "episodeType": "Episode Type",
      "answerOptions": "Answer Options",
      "option": "Option",
      "addOption": "Add Option",
      "tags": "Tags",
      "tagsPlaceholder": "Add tag...",
      "knowledgeArea": "Knowledge Area",
      "selectKnowledgeArea": "Select Knowledge Area",
      "knowledgeAreaHint": "Required for image upload",
      "images": "Images",
      "uploadImages": "Upload Images",
      "uploadHint": "Click to upload or drag & drop",
      "types": {
        "multipleChoice": "Multiple Choice",
        "singleChoice": "Single Choice",
        "freeText": "Free Text"
      },
      "visibility": {
        "label": "Visibility",
        "client": "Entire Client (all users in the client can use this question)",
        "sharedUsers": "Specific Users (only selected users can use this question)",
        "private": "Private (only I can use this question)",
        "selectUsers": "Select users:"
      },
      "filters": {
        "all": "All Questions",
        "own": "My Questions",
        "shared": "Shared Questions",
        "onlyMe": "Only me",
        "wholeClient": "Whole Client"
      },
      "table": {
        "type": "Type",
        "episode": "Episode",
        "answers": "Answers",
        "sharedWith": "Shared With",
        "actions": "Actions"
      },
      "episodeTextTooShort": "The episode text needs at least {{min}} characters.",
      "usersSelected_one": "1 user selected",
      "usersSelected_other": "{{count}} users selected",
      "selectAtLeastOneUser": "Select at least one user, otherwise the episode cannot be saved.",
      "invalidFileType": "Invalid file type",
      "notAnImage": "{{name}} is not an image",
      "imagesUploaded": "Images uploaded",
      "imagesUploadedDescription_one": "{{count}} image uploaded",
      "imagesUploadedDescription_other": "{{count}} images uploaded",
      "uploadFailed": "Upload failed",
      "imagesSelected": "Images selected",
      "imagesSelectedDescription_one": "{{count}} image will be uploaded after saving",
      "imagesSelectedDescription_other": "{{count}} images will be uploaded after saving",
      "imageDeleted": "Image deleted",
      "imageDeletedDescription": "The image was removed from the client bucket",
      "imageDeleteFailed": "Delete failed",
      "pendingUploadHint": "Images are uploaded automatically once the episode has been saved",
      "uploading": "Uploading...",
      "imageLoading": "Loading...",
      "userCount": "({{count}} users)",
      "loadingUsers": "Loading users...",
      "unknownUser": "Unknown user",
      "dragToCreator": "Drag this episode to the Session Creator"
    },
    "creator": {
      "title": "Session Creator",
      "description": "Create a new training session",
      "selectedQuestions": "Selected Questions",
      "noEpisodesYet": "No episodes added yet",
      "addQuestions": "Add Questions",
      "createNewQuestion": "Create New Question",
      "availableQuestions": "Add from Library (click to add)",
      "saveSession": "Save Session",
      "saveSuccess": "Session created",
      "saveSuccessDescription": "The session has been successfully created",
      "saveError": "Error creating",
      "sessionCreated": "Session created successfully!",
      "editTitle": "Edit Session",
      "createTitle": "Create Session",
      "steps": {
        "info": "Info",
        "episodes": "Episodes",
        "share": "Share"
      },
      "titleLabel": "Title",
      "titleRequired": "Minimum 3 characters required",
      "descriptionOptional": "Description (optional)",
      "descriptionPlaceholder": "Brief description of the session...",
      "shuffleLabel": "Shuffle episodes when playing",
      "newEpisode": "Create New Episode",
      "fromLibrary": "Select from Library",
      "dragDropHint": "Open the Episode Library and drag & drop episodes here",
      "selectedEpisodes": "Selected Episodes",
      "noEpisodesAdded": "No episodes added yet",
      "createOrSelectHint": "Create a new episode or select from the library",
      "imageCount_one": "{{count}} Image",
      "imageCount_other": "{{count}} Images",
      "shareHintAdmin": "Share this session with users from all clients. You can also do this later via the \"Share\" button.",
      "shareHintUser": "Share this session with other users. You can also do this later via the \"Share\" button.",
      "selectUsers": "Select users",
      "noUsersAdmin": "No users available",
      "noUsersClient": "No other users in the client available",
      "alreadyAssigned": "Already assigned",
      "client": "Client",
      "next": "Next",
      "back": "Back",
      "nextToShare": "Next to Share",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "saveAndShare": "Save & share with {{count}} user(s)",
      "assignmentsReset": "{{count}} assignment(s) have been reset.",
      "assignmentsUpdated": "{{added}} added, {{removed}} removed",
      "shareFailedHint": "Session was created, but sharing failed",
      "libraryWindowTitle": "Episode Library - Drag & Drop",
      "unknownClient": "Unknown"
    },
    "table": {
      "title": "Sessions",
      "description": "All created sessions",
      "empty": "No sessions yet",
      "createHint": "Use the Session Creator to create a session",
      "deleteTitle": "Delete Session",
      "deleteConfirmMessage": "Do you really want to delete the session \"{{session}}\"? This action cannot be undone.",
      "deleteSuccess": "Session deleted",
      "deleteSuccessDescription": "The session has been successfully deleted",
      "deleteError": "Error deleting",
      "columns": {
        "title": "Title",
        "creator": "Creator",
        "episodes": "Episodes",
        "created": "Created",
        "status": "Status",
        "actions": "Actions"
      },
      "status": {
        "completed": "Completed",
        "pending": "Open"
      },
      "filters": {
        "all": "All",
        "own": "Own",
        "assigned": "Assigned"
      },
      "actions": {
        "play": "Play",
        "edit": "Edit",
        "share": "Share",
        "delete": "Delete"
      }
    },
    "builder": {
      "createSession": "Create Session",
      "saveFailed": "The session could not be saved. Please try again.",
      "editSession": "Edit Session",
      "description": "Create or edit a session",
      "title": "Title",
      "titlePlaceholder": "Enter session title...",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Optional description...",
      "shuffleEpisodes": "Shuffle episodes when playing",
      "assignmentsReset": "Assignments Reset",
      "assignmentsResetDescription": "{{count}} assignment(s) have been reset to \"open\"."
    },
    "player": {
      "loading": "Loading session...",
      "error": "Error loading",
      "noEpisodes": "No episodes in this session",
      "previous": "Previous",
      "next": "Next",
      "episode": "Episode",
      "answerPlaceholder": "Your answer...",
      "keyboardHint": "Use ← → keys to navigate",
      "backToSessions": "Back to Sessions",
      "complete": "Complete Session",
      "alreadyCompleted": "Already Completed",
      "completedBanner": "Session Completed",
      "completedAt": "Added to knowledge on",
      "lastEpisodeHint": "Last episode - complete session",
      "lastSlideHint": "Last slide - complete session",
      "readOnlyHint": "This session has been completed (read-only)",
      "loadAnswerError": "Could not load the answer",
      "saveFailed": "Saving failed",
      "readOnly": "Read-only",
      "loadingImage": "Loading image...",
      "imageLoadError": "Image could not be loaded",
      "saving": "Saving...",
      "lastSaved": "Last saved: {{time}}"
    },
    "share": {
      "title": "Share Session",
      "description": "Assign this session to users with an optional deadline",
      "sharedWith": "Already shared with",
      "notSharedYet": "This session has not been shared yet",
      "deadline": "Deadline (optional)",
      "deadlineHint": "Users should complete the session by this date",
      "addUsers": "Add new users",
      "selectedCount": "{{count}} selected",
      "allClients": "All Clients",
      "noUsersAvailable": "No other users available",
      "allUsersAssigned": "All available users have already been assigned",
      "shareButton": "Share with {{count}} user(s)",
      "sharing": "Sharing...",
      "removeAssignment": "Remove assignment",
      "due": "Due",
      "unknown": "Unknown",
      "episodes": "Episode(s)",
      "pending": "pending",
      "removePending": "Remove pending assignment"
    },
    "toasts": {
      "sessionShared": "Session shared",
      "sessionSharedDescription": "Session shared with {{count}} user(s)",
      "shareError": "Could not share session",
      "usersLoadError": "Could not load users",
      "assignmentRemoved": "Assignment removed",
      "assignmentRemovedDescription": "The assignment has been successfully removed",
      "assignmentRemoveError": "Could not remove assignment",
      "sessionUpdated": "Session updated",
      "sessionUpdatedDescription": "Changes have been saved",
      "sessionCreatedAndShared": "Session created & shared",
      "sessionCreatedAndSharedDescription": "The session was created and shared with {{count}} user(s)",
      "sessionCreated": "Session created",
      "sessionCreatedDescription": "The session was saved successfully",
      "episodeAdded": "Episode added",
      "saveError": "Error saving"
    },
    "summary": {
      "title": "Session Overview & Export",
      "description": "Review your answers and add the session to the Knowledge Base.",
      "answerPlaceholder": "Your answer...",
      "documentTitle": "Document Title",
      "episodeCount": "{{count}} Episodes",
      "episodeCount_one": "{{count}} Episode",
      "answeredCount": "{{count}} answered",
      "noAnswer": "No answer",
      "save": "Save",
      "addToKnowledge": "Add to Knowledge",
      "noClientForArea": "The selected Knowledge Area has no client assigned.",
      "knowledgeArea": "Knowledge Area",
      "loadingKnowledgeAreas": "Loading Knowledge Areas...",
      "selectKnowledgeArea": "Select Knowledge Area",
      "editedCount": "{{count}} edited",
      "edited": "edited",
      "loadingAnswers": "Loading answers...",
      "errors": {
        "noEpisodes": "There are no episodes to upload",
        "noKnowledgeArea": "Please select a Knowledge Area",
        "noTitle": "Please enter a title",
        "noClient": "No client available"
      }
    }
  },
  "training": {
    "hub": {
      "permissionsFailedTitle": "Could not load your permissions",
      "permissionsFailedHint": "Please reload the page. If the problem persists, contact your admin.",
      "pickTitle": "What would you like to do?",
      "pickHint": "Pick an area. You can switch back at any time.",
      "schulungTitle": "Training",
      "schulungDescription": "Build trainings from materials, optionally with a quiz and a passing score at the end.",
      "umfrageTitle": "Survey",
      "umfrageDescription": "Create standalone surveys, distribute them and have them evaluated automatically.",
      "backToPicker": "Switch area",
      "noModuleTitle": "No area enabled",
      "noModuleHint": "Your role has neither trainings nor surveys enabled. Please contact your admin.",
      "title": "Training Hub",
      "areasLabel": "Areas",
      "clientLabel": "Client",
      "clientHint": "As an admin you see and edit the trainings, surveys, participants and materials of this client. The choice applies to every Training Hub window.",
      "areas": {
        "trainings": "Trainings",
        "surveys": "Surveys & quizzes",
        "participants": "Participants",
        "materials": "Material library"
      },
      "actions": {
        "trainings": "New training",
        "surveys": "Create new",
        "participants": "Add participant",
        "materials": "Upload"
      },
      "stats": {
        "active": "active",
        "drafts": "drafts",
        "overdue": "overdue",
        "myOpen": "open for you",
        "newAnswers": "new answers",
        "people": "people",
        "expiring": "access ending",
        "expired": "expired",
        "files": "files",
        "folders": "folders"
      },
      "foot": {
        "lastChanged": "Last changed {{when}} · {{title}}",
        "accessDays": "Access period: {{count}} days from first sign-in",
        "accessUnlimited": "Access without a time limit",
        "materialsChanged": "Last changed {{when}}",
        "materials": "Client library and personal space",
        "unavailable": "Numbers unavailable right now"
      }
    },
    "sidebar": {
      "manage": "Manage",
      "play": "Play",
      "materialLibrary": "Material Library",
      "trainingCreator": "Create Training",
      "trainings": "Trainings",
      "participants": "Participants"
    },
    "materials": {
      "title": "Material Library",
      "subtitle": "Videos, podcasts and documents for trainings",
      "upload": "Upload material",
      "uploadFirst": "Upload first material",
      "empty": "No materials available yet",
      "searchPlaceholder": "Search materials...",
      "allTypes": "All types",
      "deleteConfirm": "Really delete this material?",
      "deleteConfirmInline": "Delete this material?",
      "deleteWarning": "This action cannot be undone.",
      "deleted": "Material deleted",
      "deletedDescription": "The material was successfully deleted",
      "updated": "Material updated",
      "updatedDescription": "The material was successfully updated",
      "edit": "Edit material",
      "visibility": "Visibility",
      "visibilityOptions": {
        "private": "Private",
        "shared": "Shared",
        "client": "Entire client"
      },
      "filename": "Filename",
      "type": "Type",
      "types": {
        "video": "Video",
        "podcast": "Podcast",
        "document": "Document",
        "audio": "Audio",
        "pdf": "PDF",
        "image": "Image",
        "other": "Other",
        "docx": "Word",
        "xlsx": "Excel",
        "pptx": "PowerPoint"
      },
      "table": {
        "title": "Title",
        "filename": "Filename",
        "size": "Size",
        "uploaded": "Uploaded",
        "format": "Format"
      },
      "titleRequired": "The title must not be empty",
      "descriptionPlaceholder": "Description (optional)"
    },
    "materialLibrary": {
      "root": "Training library",
      "folders": "Folders",
      "expand": "Expand",
      "collapse": "Collapse",
      "newFolder": "New folder",
      "newFolderIn": "New folder in {{name}}",
      "renameFolder": "Rename folder",
      "create": "Create",
      "folderName": "Name",
      "folderNamePlaceholder": "e.g. Onboarding",
      "folderHint": "Folders organise the library. They carry no permissions of their own – every author in the client sees every folder.",
      "folderExists": "A folder with this name already exists here",
      "folderSaveFailed": "Could not save the folder",
      "folderDeleted": "Folder deleted",
      "folderNotEmpty": "The folder is not empty. Move or delete its contents first.",
      "folderDeleteFailed": "Could not delete the folder",
      "deleteFolderConfirm": "Delete folder “{{name}}”?",
      "move": "Move",
      "moveHere": "Move here",
      "moveHint": "Moving only changes where the file lives. Trainings that use it stay unchanged.",
      "moveFolder": "Move “{{name}}”",
      "moveMaterial": "Move “{{name}}”",
      "moved": "Moved",
      "moveFailed": "Could not move",
      "moveIntoSelf": "A folder cannot be moved into itself",
      "rename": "Rename",
      "renameFailed": "Could not rename",
      "searchAll": "Search the whole library …",
      "noSearchResults": "No file found.",
      "emptyFolder": "“{{name}}” is empty. Upload files or drag some here.",
      "loadFailed": "Could not load the library",
      "location": "Location",
      "changed": "Changed",
      "itemCount_one": "{{count}} item",
      "itemCount_other": "{{count}} items",
      "usedIn": "Used in",
      "usedInCount_one": "{{count}} training",
      "usedInCount_other": "{{count}} trainings",
      "notUsed": "Not used in any training yet.",
      "notUsedShort": "not used",
      "versions": "Versions",
      "versionLine": "{{size}} · version {{version}}",
      "versionCurrent": "Version {{version}} · current",
      "versionNumber": "Version {{version}}",
      "restore": "Restore this version",
      "restored": "Version {{version}} restored",
      "restoreFailed": "Could not restore",
      "replace": "Replace",
      "replaceTitle": "Replace “{{name}}”",
      "replaceDrop": "Drop the new file here or click",
      "replaceHint": "Becomes version {{version}}. Version {{previous}} stays restorable.",
      "replaceHintUsed": "Becomes version {{version}}. {{trainings}} shows the new file from now on. Version {{previous}} stays restorable.",
      "replaced": "Version {{version}} uploaded",
      "replaceFailed": "Could not replace the file",
      "deleteBlocked": "You can delete this file once no training uses it.",
      "deleteWarning": "The file and all its versions are deleted for good.",
      "deleteFailed": "Could not delete",
      "downloadFailed": "Download failed",
      "forbidden": "Only the uploader, a supervisor or an admin may do this.",
      "uploadTarget": "Goes to",
      "areaTab": "Knowledge area",
      "areaHintTitle": "Use documents from the Drive",
      "areaHintBody": "Assign a knowledge area to the training. You can then add documents from it as slides here – linked, so always up to date.",
      "areaHintChat": "Participants may then also ask that knowledge area in the training portal, so slides and chat share the same boundary.",
      "areaAssign": "Assign knowledge area",
      "areaSameField": "This is the same field as “Knowledge area for participants” in step 1.",
      "areaLinkedHint": "Documents from “{{name}}” are linked, not copied: changes in the Drive show up in the training right away. Word, PowerPoint and Excel are shown as PDF.",
      "areaSearch": "Search “{{name}}” …",
      "areaLoadFailed": "Could not load the knowledge area's documents.",
      "areaEmpty": "“{{name}}” has no documents yet.",
      "areaOtherHint": "A document from another knowledge area? Put it into “{{name}}” with “Sync with Brain” in the Drive – then the chat can cite it too – or upload a copy to the training library.",
      "notLinkable": "This format cannot be shown as a slide.",
      "notLinkableShort": "{{name}} · cannot be shown as a slide",
      "linkFailed": "Could not link the document.",
      "staleSlides_one": "One slide comes from a knowledge area the training no longer has. Remove it or assign that knowledge area again – until then the training cannot be saved.",
      "staleSlides_other": "{{count}} slides come from a knowledge area the training no longer has. Remove them or assign that knowledge area again – until then the training cannot be saved.",
      "fromDrive": "From the Drive",
      "linkedEntry": "Linked from knowledge areas",
      "linkedEntryHint": "Drive documents are picked in the training wizard, from the training's knowledge area.",
      "linkedViewHint": "These documents live in the Drive and are maintained there. Trainings always show the current file. Links no training uses any more can be removed here.",
      "linkedEmpty": "No training uses a document from a knowledge area yet.",
      "linkedLocation": "Drive › {{name}}",
      "linkedHint": "Linked from “{{name}}”. Renaming, replacing and deleting happens in the Drive.",
      "unknownArea": "Knowledge area",
      "unlink": "Remove link",
      "unlinkWarning": "Only the link is removed. The document in the Drive stays as it is.",
      "driveImport": "Copy from my Drive",
      "driveImportTitle": "Copy from my Drive",
      "driveImportHint": "The selected files are copied into the training library and then belong to the client. Your original stays in the Drive; later changes to it do not carry over.",
      "driveSearch": "Search my documents …",
      "driveEmpty": "Nothing found in “My documents”.",
      "driveMore": "Load more",
      "driveImportButton_one": "Copy {{count}} file",
      "driveImportButton_other": "Copy {{count}} files",
      "driveImported_one": "{{count}} file copied",
      "driveImported_other": "{{count}} files copied",
      "driveImportPartial_one": "{{count}} file could not be copied",
      "driveImportPartial_other": "{{count}} files could not be copied",
      "driveImportFailed": "The copy failed.",
      "unlinkConfirm": "Remove the link to “{{name}}”?",
      "unlinked": "Link removed",
      "personalRoot": "Personal",
      "personalTab": "Personal",
      "libraryTab": "Library",
      "personalTreeHint": "Only you see these files and folders.",
      "movedToPersonal": "Moved to your personal space",
      "movedToClient": "Moved to the training library",
      "personalBlocked": "This file is used in a training and therefore cannot become personal – other authors of that training would lose sight of the slide.",
      "folderOtherSpace": "Folders stay in their space. Move the individual files instead.",
      "moveToClientHint": "The file moves to the training library and becomes visible to every author in the client.",
      "moveToPersonalHint": "The file becomes personal: afterwards only you see it.",
      "personalHint": "Personal file – only you see it.",
      "personalUsedHint": "Personal file used by a training. Other authors of that training do not see it in the library; move it to the training library so the training does not depend on you.",
      "share": "Share",
      "shareTitle": "Share “{{name}}”",
      "shareHint": "Colleagues you share with see the file under “Shared with me” and can use it in their own trainings. Only you can still change, replace or delete it.",
      "shareSearch": "Search colleagues …",
      "shareNoUsers": "No colleagues found.",
      "shareNobody": "Not shared – only you see the file.",
      "shareCount_one": "Shared with {{count}} person",
      "shareCount_other": "Shared with {{count}} people",
      "shareInUse": "Access cannot be removed while these trainings use the file: {{trainings}}.",
      "shareFailed": "Could not save the sharing.",
      "shareSave": "Save",
      "sharedWithCount_one": "Shared with {{count}} person",
      "sharedWithCount_other": "Shared with {{count}} people",
      "notShared": "Not shared",
      "sharedToast_one": "Shared with {{count}} person",
      "sharedToast_other": "Shared with {{count}} people",
      "unsharedToast": "Sharing removed – only you see the file",
      "sharedEntry": "Shared with me",
      "sharedViewHint": "Colleagues shared these files with you. You can view them and use them in your own trainings; only the uploader can change them.",
      "sharedEmpty": "Nobody has shared a file with you yet.",
      "sharedLocation": "Shared by {{name}}",
      "sharedByHint": "Shared by {{name}}. You can use the file in your own trainings but not change it.",
      "personalSharedHint_one": "Personal file – you and {{count}} person see it.",
      "personalSharedHint_other": "Personal file – you and {{count}} people see it.",
      "driveImportHintPersonal": "The selected files are copied into your personal space – only you see them. Your original stays in the Drive; later changes to it do not carry over."
    },
    "upload": {
      "title": "Upload Material",
      "materialType": "Material type",
      "file": "File",
      "dropzone": "Drop file here or click to select",
      "titleLabel": "Title",
      "titlePlaceholder": "Title of the material",
      "description": "Description",
      "descriptionPlaceholder": "Optional description...",
      "uploading": "Uploading...",
      "uploadButton": "Upload",
      "success": "Upload successful",
      "successDescription": "The material was successfully uploaded",
      "missingFields": "Please fill in all required fields",
      "invalidFileType": "Invalid file type",
      "client": "Client",
      "selectClient": "Select client...",
      "clientHint": "As admin, you can select the target client for upload",
      "visibility": "Visibility",
      "visibilityClient": "Entire client (all users in the client can see the material)",
      "visibilitySharedUsers": "Specific users (only selected users can see the material)",
      "visibilityPrivate": "Private (only I can see the material)",
      "selectUsers": "Select users:",
      "usersSelected": "{{count}} users selected",
      "loadingUsers": "Loading users...",
      "dropzoneMulti": "Drop files here or click to select",
      "multiErrorDescription": "Some files could not be uploaded",
      "multiSuccessDescription": "All files were uploaded successfully",
      "selectedFiles": "Selected files",
      "uploadMultiButton": "Upload all"
    },
    "visibility": {
      "label": "Visibility",
      "client": "Entire client",
      "sharedUsers": "Specific users",
      "private": "Private",
      "onlyMe": "Only me",
      "wholeClient": "Entire client"
    },
    "library": {
      "title": "Trainings",
      "subtitle": "All available trainings",
      "filterAll": "All",
      "filterOwn": "My trainings",
      "filterAssigned": "Assigned to me",
      "empty": "No trainings available yet",
      "emptyAssigned": "No trainings assigned to you yet",
      "emptyCompleted": "You haven't completed any trainings yet",
      "name": "Name",
      "creator": "Creator",
      "materials": "Materials",
      "created": "Created",
      "status": "Status",
      "completed": "Completed",
      "alreadyCompleted": "Already completed",
      "pending": "Pending",
      "play": "Start",
      "preview": "Preview",
      "share": "Share",
      "deleteConfirm": "Really delete this training?",
      "deleteConfirmInline": "Delete this training?",
      "deleteWarning": "This action cannot be undone.",
      "deleted": "Training deleted",
      "deletedDescription": "The training was successfully deleted",
      "noMaterials": "No materials in this training",
      "noActions": "No actions available",
      "assignedTo": "Assigned to",
      "assign": "Assign",
      "users": "users",
      "tabs": {
        "all": "All trainings",
        "mine": "My trainings",
        "assigned": "Assigned to me",
        "completed": "Completed"
      }
    },
    "creator": {
      "portalHeroTitle": "Portal presentation",
      "portalHeroHint": "In the training portal the course replaces the landing page. These texts sit above the player there; look and colours come from the portal builder. Leave blank to fall back to the training's title and description.",
      "portalHeroHeadline": "Headline",
      "portalHeroHeadlinePlaceholder": "Training title",
      "portalHeroSubtitle": "Subtitle",
      "portalHeroDescription": "Description",
      "slideTextPlaceholder": "Text for this slide (Markdown supported) — optional",
      "chapterTitlePlaceholder": "Start a new chapter here (optional)",
      "preview": "Preview",
      "previewTitle": "Preview",
      "previewEmpty": "No materials selected yet.",
      "title": "Create Training",
      "editTitle": "Edit Training",
      "step": "Step {{current}} of {{total}}",
      "stepInfo": "Information",
      "stepMaterials": "Materials",
      "titleLabel": "Title",
      "titlePlaceholder": "Title of the training",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Optional description of the training...",
      "next": "Next",
      "create": "Create training",
      "availableMaterials": "Available materials",
      "selectedMaterials": "Selected materials (order)",
      "noMaterials": "No materials available",
      "noMaterialsSelected": "No materials selected",
      "created": "Training created",
      "createdDescription": "The training was successfully created",
      "updated": "Training updated",
      "updatedDescription": "The training was successfully updated",
      "visibility": "Visibility",
      "visibilityClient": "Entire client (all users in the client can see the training)",
      "visibilitySharedUsers": "Specific users (only selected users can see the training)",
      "visibilityPrivate": "Private (only I can see the training)",
      "selectUsers": "Select users:",
      "usersSelected": "{{count}} users selected",
      "loadingUsers": "Loading users...",
      "knowledgeArea": "Knowledge area for participants",
      "knowledgeAreaHint": "Participants of this training may query exactly this knowledge area in the training portal. Without a selection the Brain Session has no knowledge scope.",
      "knowledgeAreaNone": "No knowledge area",
      "knowledgeAreaPlaceholder": "Choose a knowledge area…",
      "knowledgeAreaLoading": "Loading knowledge areas…",
      "stepQuiz": "Quiz/Survey",
      "attachQuizTitle": "Attach quiz or survey (optional)",
      "attachQuizHint": "Link an existing quiz or survey to this training. Manage them under Quizzes and Surveys.",
      "attachQuizFooterHint": "Tip: you can change or remove this link at any time later.",
      "noQuiz": "No quiz attached",
      "noQuizHint": "Plain training without assessment.",
      "noQuizzesYet": "No quizzes or surveys yet — create one in the Quizzes and Surveys tab.",
      "availableQuizzes": "Available quizzes and surveys"
    },
    "share": {
      "title": "Assign Training",
      "currentAssignments": "Current assignments",
      "noAssignments": "No assignments yet",
      "selectUsers": "Select participants",
      "searchUsers": "Search participants...",
      "noUsers": "No participants available",
      "alreadyAssigned": "Already assigned",
      "deadline": "Deadline",
      "deadlineHint": "optional, applies to the next assignments",
      "shareButton": "Assign",
      "removed": "Assignment removed",
      "assigned": "Participant assigned",
      "success": "Training assigned",
      "successDescription": "Training assigned to {{count}} participant(s)",
      "addUser": "Add participant",
      "searchPlaceholder": "Search name or email...",
      "noUsersFound": "No participants found",
      "allUsersAssigned": "All participants already assigned",
      "assignViaCsv": "Assign via CSV",
      "uploadCsvAssign": "Upload CSV & assign",
      "csvHint": "Format: semicolon-separated (NOT comma), UTF-8, columns nachname/vorname/e-mail. Duplicate emails are skipped.",
      "csvTemplate": "Template",
      "csvTemplateHint": "Download a sample CSV in the correct format",
      "csvExample": "nachname;vorname;e-mail\nMustermann;Max;max@example.com",
      "csvAssigned": "Participants assigned via CSV",
      "csvAssignedCount": "{{count}} participants assigned",
      "removeAll": "Remove all",
      "allRemoved": "All assignments removed",
      "tabs": {
        "internal": "Internal",
        "external": "External"
      },
      "internalHint": "Members of your team. They see the assignment in the \"Assigned to me\" tab and fill it out directly in the app.",
      "externalHint": "External participants without a system account. Import via CSV or pick from existing guests — they receive a link.",
      "deadlineShort": "until {{date}}",
      "assignmentCompleted": "This person has completed the training. The assignment is their proof and cannot be removed.",
      "removeFailed": "The assignment could not be removed"
    },
    "player": {
      "slide": "Slide {{current}} of {{total}}",
      "materialsCompleted": "completed",
      "previewMode": "Preview",
      "notFound": "Training not found",
      "noMaterials": "This training contains no materials",
      "loadingMaterial": "Loading material...",
      "previous": "Previous",
      "next": "Next",
      "finishTraining": "Finish training",
      "closePreview": "Close preview",
      "completed": "Training completed",
      "completedDescription": "You have successfully completed the training",
      "documentPreview": "Preview not available for this document type",
      "openInNewTab": "Open in new tab",
      "download": "Download",
      "markAsRead": "Mark as read",
      "openSlides_one": "{{count}} slide still open – taking you there.",
      "openSlides_other": "{{count}} slides still open – taking you to the first.",
      "previewUnavailable": "The preview is not available right now. You can open or download the file."
    },
    "participants": {
      "title": "Title",
      "subtitle": "Overview of all participants and their assigned trainings",
      "searchPlaceholder": "Search participants...",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "assignedTrainings": "Assigned Trainings",
      "assignedTrainingsCol": "Trainings",
      "assignedQuizzesCol": "Quizzes & Surveys",
      "trainings": "trainings",
      "trainingsCount_one": "{{count}} training",
      "trainingsCount_other": "{{count}} trainings",
      "quizzesCount_one": "{{count}} quiz",
      "quizzesCount_other": "{{count}} quizzes",
      "completed": "completed",
      "noAssignments": "No assignments",
      "noUsers": "No participants available. Upload a CSV to import participants.",
      "noUsersFound": "No participants found",
      "assign": "Assign",
      "assigned": "Training assigned",
      "assignTraining": "Assign Training",
      "assignTo": "Assign to",
      "selectTraining": "Select training",
      "searchTrainings": "Search trainings...",
      "noTrainingsFound": "No trainings found",
      "allTrainingsAssigned": "All trainings already assigned",
      "uploadCsv": "Upload CSV",
      "uploadSuccess": "Participants imported",
      "importedCount": "{{count}} participants imported",
      "duplicatesSkipped": "{{count}} duplicates skipped",
      "deleted": "Participant deleted",
      "addManually": "Add participant",
      "createTitle": "Create new participant",
      "created": "Participant created",
      "access": {
        "column": "Access",
        "notStarted": "not started yet",
        "expired": "expired",
        "daysLeft_one": "{{count}} day left",
        "daysLeft_other": "{{count}} days left",
        "extend": "Extend access",
        "extendTitle": "Extend access",
        "extendHintActive": "The days are added to the current end of every training {{name}} has started.",
        "extendHintExpired": "Access of {{name}} has expired. The days count from today; the person can sign in again right away.",
        "extendBy": "Extend by",
        "days": "days",
        "extended": "Access for {{name}} now lasts until {{date}}",
        "settingsButton": "Access period",
        "settingsTitle": "Access period in the training portal",
        "settingsHint": "Applies to all external participants of this client. Every training has its own window from its first opening; once the last one closes the portal is locked, certificates included.",
        "limit": "Limit access in time",
        "duration": "Duration",
        "durationHint": "Participants see the days left in the portal's sidebar.",
        "settingsSaved": "Access period saved",
        "nothingToExtend": "{{name}} has not opened a training yet – there is no window to extend."
      },
      "certificate": {
        "title": "Certificate",
        "hint": "A Word template with placeholders per client. Without one the generic certificate is used.",
        "upload": "Upload template (.docx)",
        "replace": "Replace template",
        "remove": "Remove template",
        "uploaded": "Template “{{name}}” saved",
        "removed": "Template removed – the generic certificate applies again",
        "placeholders": "Placeholders in the template:",
        "place": "Place of issue"
      },
      "titleSuffix": "Title suffix"
    },
    "consumer": {
      "startTraining": "Start training",
      "startShort": "Start",
      "noContent": "This training has no materials or questions."
    },
    "fileKind": {
      "pdf": "PDF",
      "video": "Video",
      "audio": "Audio",
      "image": "Image",
      "other": "File"
    },
    "overview": {
      "subtitle": "Manage your client's trainings",
      "loadFailed": "Trainings could not be loaded",
      "allTrainings": "All trainings",
      "clearFigure": "Clear filter",
      "searchPlaceholder": "Search trainings …",
      "allAreas": "All knowledge areas",
      "noArea": "No knowledge area",
      "mineOnly": "Mine",
      "emptyFiltered": "No training matches these filters",
      "resetFilters": "Reset filters",
      "slides_one": "{{count}} slide",
      "slides_other": "{{count}} slides",
      "chapters_one": "{{count}} chapter",
      "chapters_other": "{{count}} chapters",
      "doneOf": "{{done}} of {{total}} done",
      "lateCount_one": "{{count}} overdue",
      "lateCount_other": "{{count}} overdue",
      "onTrack": "on track",
      "notAssigned": "Not assigned to anyone yet",
      "changed": "Changed {{when}} · {{who}}",
      "someone": "Unknown",
      "status": {
        "all": "All",
        "draft": "Draft",
        "active": "Active",
        "archived": "Archived"
      },
      "kpi": {
        "active": {
          "label": "Active trainings",
          "hint": "assigned to at least one person",
          "section": "Active trainings"
        },
        "open": {
          "label": "Open assignments",
          "hint": "participants not done yet",
          "section": "Trainings with open assignments"
        },
        "late": {
          "label": "Overdue",
          "hint": "deadline missed",
          "section": "Trainings with overdue participants"
        },
        "stale": {
          "label": "Stale drafts",
          "hint": "unchanged for more than 14 days",
          "section": "Stale drafts"
        }
      },
      "todo": {
        "title": "To do",
        "hint": "Assigned to you",
        "dueIn_one": "due tomorrow",
        "dueIn_other": "due in {{count}} days",
        "dueToday": "due today",
        "overdue_one": "{{count}} day overdue",
        "overdue_other": "{{count}} days overdue",
        "slidesLeft_one": "{{count}} slide left",
        "slidesLeft_other": "{{count}} slides left",
        "resume": "Resume"
      },
      "layout": {
        "grid": "Tiles",
        "list": "List"
      },
      "list": {
        "training": "Training",
        "status": "Status",
        "people": "Participants"
      },
      "actions": {
        "more": "More actions",
        "details": "Open details",
        "duplicate": "Duplicate",
        "archive": "Archive",
        "restore": "Restore",
        "preview": "Preview",
        "assign": "Assign",
        "deleteBlocked": "Has participants – it can only be archived."
      },
      "toast": {
        "duplicated": "\"{{title}}\" created as a draft",
        "archived": "\"{{title}}\" archived",
        "restored": "\"{{title}}\" restored"
      },
      "panel": {
        "label": "Details of {{title}}",
        "tabs": {
          "overview": "Overview",
          "outline": "Outline",
          "people": "Participants {{count}}",
          "portal": "Portal"
        },
        "area": "Knowledge area",
        "noAreaHint": "none – participants cannot ask anything in the portal",
        "content": "Content",
        "changed": "Changed",
        "progress": "Progress",
        "legendDone": "{{count}} done",
        "legendLate": "{{count}} overdue",
        "legendOpen": "{{count}} open",
        "noSlides": "No slides yet.",
        "linked": "linked",
        "archivedNoAssign": "Archived – no new assignments possible.",
        "noPeople": "No participants yet.",
        "doneOn": "completed on {{date}}",
        "certificateDownloaded": "certificate downloaded on {{date}}",
        "certificateNotDownloaded": "certificate not downloaded yet",
        "dueOn": "deadline {{date}}",
        "missedOn": "missed deadline {{date}}",
        "assignedOn": "assigned on {{date}}",
        "person": {
          "done": "Done",
          "late": "Overdue",
          "open": "Open"
        },
        "portalEyebrow": "How the training appears in the training portal",
        "portalHint": "Heading, subline and description come from \"Portal display\" in the wizard; empty means the training's title and description.",
        "resume": "Resume",
        "reopen": "Open again",
        "outlineVersion": "Published version {{version}}",
        "outlineDraft": "Draft – not published yet"
      },
      "new": {
        "button": "New training",
        "title": "New training",
        "step": {
          "choose": "How do you want to start?",
          "folder": "Pick a folder – its files become slides, subfolders become chapters.",
          "area": "Pick a knowledge area – the wizard opens its documents.",
          "duplicate": "Pick a training as template – the copy is a draft without participants."
        },
        "empty": "Start empty",
        "emptyHint": "Enter a title, pick slides from the library.",
        "folder": "From a folder",
        "folderHint": "All files of a library folder become slides, subfolders chapters.",
        "area": "From a knowledge area",
        "areaHint": "Link documents of a knowledge area; the area is assigned right away.",
        "duplicate": "Duplicate existing",
        "duplicateHint": "Take a training as a template and adapt it.",
        "folderEmpty": "This folder has no files.",
        "noFolders": "The library has no folders yet.",
        "continue": "Continue"
      }
    },
    "people": {
      "title": "Participants",
      "subtitle": "Who gets trainings and surveys – and how far they are",
      "kindLabel": "Where the person learns",
      "kind": {
        "internal": "webOS",
        "external": "Training portal"
      },
      "searchPlaceholder": "Search person …",
      "searchUsers": "Search users …",
      "onlyAssigned": "With assignments only",
      "noneFound": "Nobody matches the search",
      "assignButton": "Assign",
      "overdue_one": "{{count}} overdue",
      "overdue_other": "{{count}} overdue",
      "internalNote": "Internal users come from the client's user management. Whoever is missing here has no webOS account yet.",
      "columns": {
        "person": "Person",
        "trainings": "Trainings",
        "surveys": "Surveys",
        "role": "Role",
        "lastActive": "Last active"
      },
      "module": {
        "schulung": "Training",
        "umfrage": "Survey",
        "quiz": "Quiz"
      },
      "empty": {
        "internal": "No internal users",
        "external": "No external participants yet"
      },
      "emptyHint": {
        "internal": "Internal users come from the client's user management.",
        "external": "Create external participants or upload them as CSV."
      },
      "assign": {
        "title": "Assign",
        "hint": "Pick people and trainings – every combination becomes an assignment.",
        "loadFailed": "The selection could not be loaded.",
        "forPerson": "Pick trainings and surveys for {{name}}.",
        "forTraining": "Pick people for “{{title}}”.",
        "persons": "People",
        "items": "Trainings & surveys",
        "alreadyAssigned": "already assigned",
        "onlyAssigned": "Show only people already assigned ({{count}})",
        "noneAssignedHere": "Nobody in this area is assigned yet.",
        "deadlineHint": "optional, applies to all – in the training portal access ends on this day instead of after the access period",
        "submit_one": "Create {{count}} assignment",
        "submit_other": "Create {{count}} assignments",
        "created_one": "{{count}} assignment created",
        "created_other": "{{count}} assignments created",
        "skipped_one": "{{count}} already existed and was skipped.",
        "skipped_other": "{{count}} already existed and were skipped.",
        "deadline": "Deadline",
        "summary": {
          "both": "{{count}} assignments: {{portal}} in the training portal, {{webos}} in webOS",
          "portal_one": "{{count}} assignment in the training portal",
          "portal_other": "{{count}} assignments in the training portal",
          "webos_one": "{{count}} assignment in webOS",
          "webos_other": "{{count}} assignments in webOS"
        },
        "pickedInTab": "{{count}} selected",
        "surveyNotInPortal_one": "{{count}} selected survey does not appear in the training portal – the portal shows trainings only. External people reach surveys through the invitation link.",
        "surveyNotInPortal_other": "{{count}} selected surveys do not appear in the training portal – the portal shows trainings only. External people reach surveys through the invitation link."
      },
      "create": {
        "title": "Create external participant",
        "hint": "The person signs in to the training portal with this e-mail address; the account links itself on the first sign-in.",
        "assignNow": "Assign trainings right away",
        "submit": "Create",
        "submitAssign": "Create and assign",
        "created": "{{name}} created"
      },
      "panel": {
        "externalBadge": "External · participant",
        "internalBadge": "Internal · {{role}}",
        "accessTitle": "Access to the training portal",
        "firstLogin": "First sign-in {{date}}",
        "noLogin": "No sign-in yet",
        "accessDays_one": "Access {{count}} day per training",
        "accessDays_other": "Access {{count}} days per training",
        "accessRule": "Every training has its own window, starting when it is first opened. The portal stays open while any of them is running.",
        "doneOf": "{{done}} of {{total}} done",
        "assignments": "Assignments",
        "nothingAssigned": "Nothing assigned yet.",
        "answered": "Answered",
        "noDeadline": "No deadline",
        "slides": "{{done}} of {{total}} slides",
        "windowNotStarted": "not opened yet",
        "windowExpired": "access expired",
        "plus30": "+30 days",
        "remove": "Remove assignment",
        "removed": "Assignment “{{title}}” removed",
        "delete": "Delete participant",
        "deleteTitle": "Delete “{{name}}”?",
        "deleteBody_one": "Their assignment, learning progress, survey and quiz answers and portal chats are deleted with them. This cannot be undone. Their portal sign-in account remains; they will no longer see any training there.",
        "deleteBody_other": "Their {{count}} assignments, learning progress, survey and quiz answers and portal chats are deleted with them. This cannot be undone. Their portal sign-in account remains; they will no longer see any training there.",
        "deleteConfirm": "Delete permanently",
        "deleteBlocked": "This person has completed a training. The completion is their proof, so they cannot be deleted.",
        "erase": "Erase on the person’s request (GDPR)",
        "eraseHint": "Also deletes completed trainings and certificates.",
        "eraseTitle": "Erase “{{name}}” on request?",
        "eraseBody": "All assignments, learning progress, completed trainings with their certificates, survey and quiz answers (also those given through public links under their email address), portal chats and, if no other client still enrols them, their sign-in history are deleted. No completion can be proven afterwards. This cannot be undone.",
        "eraseTypeLabel": "To confirm, type the name: {{name}}",
        "eraseConfirm": "Erase permanently",
        "erasedTitle": "Data erased",
        "erasedSummary": "Deleted: {{completions}} completions, {{certificates}} certificates, {{answers}} answers given through public links.",
        "erasedCertificatesFailed": "{{count}} certificate files could not be deleted. Please contact support.",
        "erasedAccountManual": "The person’s portal sign-in account still exists. BIK has to delete it in the “CDB Learning” tenant. Object ID: {{id}}",
        "erasedAccountElsewhere": "The portal sign-in account remains because another client still enrols the person.",
        "erasedAccountNone": "The person never signed in to the portal, so there is no sign-in account to delete.",
        "extendedOne": "“{{title}}” is now open until {{date}}",
        "sessionsTitle": "Portal sign-ins",
        "sessionsSummary": "{{logins}} sign-ins · {{devices}} devices",
        "noSessions": "No portal sign-in yet.",
        "sessionActive": "signed in now",
        "sessionEnd": {
          "superseded": "replaced by another device",
          "logout": "signed out",
          "expired": "expired"
        }
      },
      "where": {
        "external": "Sign in to the training portal with a one-time code and see their trainings there.",
        "externalLimit_one": "Sign in to the training portal with a one-time code and see their trainings there. Access {{count}} day per training from the first opening.",
        "externalLimit_other": "Sign in to the training portal with a one-time code and see their trainings there. Access {{count}} days per training from the first opening.",
        "internal": "Colleagues with a webOS account. They see their trainings in the Training Hub under “For me” – no training portal, no access period."
      }
    },
    "course": {
      "untitled": "New training",
      "untitledChapter": "Untitled chapter",
      "header": {
        "kind": "Training",
        "titlePlaceholder": "Title of the training",
        "draft": "Draft",
        "active": "Active",
        "version": "Version {{version}}",
        "draftOf": "Version {{version}} · draft",
        "saved": "Saved {{time}}",
        "autosave": "Saves automatically",
        "preview": "Preview",
        "assign": "Assign",
        "publish": "Publish",
        "publishVersion": "Publish version {{version}}"
      },
      "banner": {
        "frozenTitle": "Version {{version}} is published. Assigned: {{assigned}}, of whom {{started}} have started.",
        "frozenHint": "You can change the title and description at any time. Changing chapters, items or material versions creates version {{next}}. People who have started keep working on their version.",
        "newVersion": "Edit as version {{version}}",
        "draftHint": "You are editing version {{version}} as a draft. Until you publish it, everyone keeps seeing version {{published}}. When you publish, you can move assignments that have not started yet ({{unstarted}}) to the new version. People who have started ({{started}}) stay on version {{published}} unless you explicitly move them too.",
        "discardDraft": "Discard draft",
        "pinnedHint": "They see nothing added since, such as a new questionnaire.",
        "liftPinned": "Move to version {{version}}",
        "liftConfirmHint": "Slides already viewed stay marked as done. If the new version contains a newer edition of a questionnaire, it is answered again. People who have already completed the course stay on their version; their certificate names that version.",
        "pinnedTitle_one": "One person is still on an older version.",
        "pinnedTitle_other": "{{count}} people are still on an older version.",
        "liftConfirmTitle_one": "Move one person to version {{version}}?",
        "liftConfirmTitle_other": "Move {{count}} people to version {{version}}?"
      },
      "structure": {
        "title": "Structure",
        "emptyChapter": "No item yet – choose “Material” or “Questionnaire” below.",
        "questions_one": "{{count}} question",
        "questions_other": "{{count}} questions",
        "required": "Required",
        "addChapter": "Chapter",
        "addMaterial": "Material",
        "addQuestionnaire": "Questionnaire",
        "aiQuiz": "Generate quiz"
      },
      "panel": {
        "pick": "Pick a chapter or an item on the left.",
        "item": "Item",
        "chapter": "Chapter {{n}}",
        "material": "Material",
        "chapterTitle": "Chapter title",
        "chapterDescription": "Description",
        "chapterDescriptionPlaceholder": "What is learned here? Shown in the portal at the start of the chapter.",
        "inPortal": "In the portal",
        "inPortalHint": "Chapter {{n}} appears in the chapter navigation; the progress ring counts its {{count}} items.",
        "up": "Move up",
        "down": "Move down",
        "removeChapter": "Delete chapter",
        "removeItem": "Remove from course",
        "replace": "Replace"
      },
      "material": {
        "pinned": "Pinned version",
        "pinnedHint": "The course shows version {{version}} of this material, even if the library has a newer one.",
        "newerAvailable": "The library holds version {{version}}.",
        "adoptHint": "Adopting swaps the slides in this draft.",
        "adoptNeedsDraft": "Adopting is possible in the next course version.",
        "adopt": "Adopt version {{version}}",
        "text": "Slide text",
        "textPlaceholder": "Text beside the material in the portal (Markdown allowed) – optional",
        "countsAlways": "Counts towards completion",
        "always": "always",
        "seenHint": "Seen = left with “Next”; jumping does not count.",
        "mediaHint": "Counts as seen when played to the end or left with “Next”.",
        "quizGateHint": "The training has a required quiz – the quiz is the proof, the slides are free.",
        "free": "free"
      },
      "questionnaire": {
        "passMark": "Pass mark {{percent}} %",
        "from": "From Surveys & Quizzes",
        "fromHint": "Questions, pass mark and display settings are maintained there.",
        "openEditor": "Open in quiz editor",
        "required": "Required for completion",
        "requiredHintOn": "Must be passed (≥ {{percent}} %), otherwise the training stays open.",
        "requiredHintOff": "Practice – the result is stored, nothing is blocked.",
        "requiredSurvey": "Must be filled in",
        "requiredSurveyHint": "A survey can be required to fill in, never to pass.",
        "retry": "Retries allowed",
        "retryHint": "A failed quiz can be attempted again.",
        "retryOn": "until passed",
        "draftHint": "The questionnaire is still a draft. It is published together with the training – internally, without an open link.",
        "newerQuiz": "The course scores with version {{pinned}} of the quiz (pass mark {{pinnedMark}} %). The current version is {{current}} (pass mark {{currentMark}} %). Learners keep taking version {{pinned}} and are scored on it.",
        "newerSurvey": "The course uses version {{pinned}} of the survey. The current version is {{current}}.",
        "newerNeedsVersion": "To make the course use the current version, create and publish a new course version. You can then move people who have already started to the new course version.",
        "newerOnPublish": "When you publish this course version, it uses the current version.",
        "newerDot": "Newer version {{version}} available – the course still uses the older one",
        "requiredHintNoMark": "Must be passed – the quiz has no pass mark yet; without one any submission counts."
      },
      "settings": {
        "title": "Settings",
        "description": "Description",
        "descriptionPlaceholder": "What is it about, for whom, how long?",
        "certificate": "Certificate",
        "certificateWithResult": "Person, training, course version, date, quiz result – the required quiz is the proof",
        "certificateParticipation": "Certificate of participation: person, training, course version, date",
        "certificateOff": "No proof after completion",
        "certificateNoQuizHint": "Without a required quiz the certificate only confirms participation. Set a quiz to “required” for a knowledge check.",
        "certificatePoints": "Points",
        "certificateCategory": "Kind of training",
        "certificateCategoryPlaceholder": "General continuing education",
        "certificateCredits": "Continuing-education points",
        "certificateCreditAdd": "Add a kind of continuing education",
        "certificateCreditRemove": "Remove row",
        "certificatePointsHint": "Fills «fortbildung» in the certificate template: every kind in one sentence, e.g. \"2,50 Punkten (Allgemeine Fortbildung) und 1,00 Punkten (Ingenieurtechnische Fortbildung)\". Without an entry the sentence is left off the certificate.",
        "certificatePointsInvalid": "Each row needs a kind and points with at most two decimals, e.g. 2,50. Nothing is saved until then.",
        "knowledgeArea": "Questions in the portal",
        "knowledgeAreaHint": "Knowledge area the chat beside the slide draws on.",
        "noKnowledgeArea": "Slide texts only",
        "access": "Access period",
        "accessDays": "{{days}} days from first opening (client setting)",
        "accessUnlimited": "Unlimited (client setting)",
        "accessWhere": "Client default, change it under Participants › Training portal › Access period. A fixed end date is set when assigning (“Deadline”).",
        "visibility": "Visible to",
        "portal": "Portal start page",
        "heroTitle": "Headline",
        "heroSubtitle": "Subline",
        "heroDescription": "Description",
        "scope": "Scope",
        "scopeChapters": "{{chapters}} chapters · {{items}} items",
        "scopeSlides": "{{slides}} slides · {{videos}} media",
        "scopeQuiz": "{{quizzes}} quizzes ({{required}} required) · {{surveys}} surveys",
        "scopeMinutes": "approx. {{minutes}} minutes",
        "certificateCategoryGeneral": "General continuing education",
        "certificateCategoryEngineering": "Engineering continuing education"
      },
      "picker": {
        "title": "Add item",
        "replaceTitle": "Replace item",
        "hint": "Goes to the end of chapter “{{chapter}}”. Nothing is copied – the course points at the library.",
        "replaceHint": "The slot stays, the reference changes.",
        "materialTab": "Material library",
        "questionnaireTab": "Surveys & Quizzes",
        "nothing": "Nothing found",
        "inCourse": "in course",
        "materialFooter": "Something missing? Upload it in the material library.",
        "questionnaireFooter": "New quiz? Create it in Surveys & Quizzes or here with AI."
      },
      "ai": {
        "title": "Generate a quiz from the material",
        "hint": "The question assistant reads this training's slide texts and creates a quiz in Surveys & Quizzes. It lands as a draft in chapter “{{chapter}}” and is checked there.",
        "quizTitle": "Quiz title",
        "defaultTitle": "Knowledge check {{title}}",
        "count": "Number of questions",
        "levelLabel": "Difficulty",
        "level": {
          "mixed": "mixed",
          "easy": "easy",
          "hard": "demanding",
          "mixedInstruction": "Mix easy comprehension questions with more demanding application questions.",
          "easyInstruction": "Ask easy comprehension questions about the key statements.",
          "hardInstruction": "Ask demanding application and transfer questions."
        },
        "focus": "Focus",
        "focusPlaceholder": "e.g. provider obligations and exceptions – optional",
        "focusInstruction": "Focus: {{focus}}.",
        "source": "Source: this training's slide texts ({{slides}} items). Intermediate model, tracked as “question assistant”.",
        "run": "Generate {{count}} questions",
        "running": "Generating …",
        "done": "{{count}} questions generated – “{{title}}” is a draft in Surveys & Quizzes and hangs here as practice."
      },
      "publish": {
        "title": "Publish version {{version}}",
        "hintFirst": "Publishing fixes version 1: its order, items, material versions and questionnaire versions can no longer be changed. Later changes to them create version 2.",
        "hintNext": "Publishing fixes version {{version}}. People who have started the previous version ({{started}}) stay on it. You can move assignments that have not started yet ({{unstarted}}) to the new version.",
        "rowTitle": "Title",
        "rowChapters": "Chapters filled",
        "rowRule": "Completion rule",
        "ruleWithQuiz": "{{quizzes}} required quiz passed – the {{slides}} slides are free",
        "ruleNoQuiz": "{{slides}} slides seen – no required quiz",
        "rowQuestionnaires": "Questionnaires",
        "draftQuizzes_one": "{{count}} questionnaire still a draft – published along (internally, no open link)",
        "draftQuizzes_other": "{{count}} questionnaires still drafts – published along (internally, no open link)",
        "allPublished": "all published",
        "lift": "Move assignments that have not started",
        "liftHint": "These assignments get version {{version}} ({{unstarted}}). People who have started ({{started}}) stay on their version.",
        "go": "Publish",
        "goAssign": "Publish and assign",
        "problemTitle": "The training needs a title",
        "problemNoItems": "The training has no item yet",
        "problemEmptyChapter": "Chapter {{n}} “{{title}}” has no item",
        "problemNoPassMark": "Required quiz “{{title}}” has no pass mark",
        "liftStarted": "Also move people who have started",
        "liftStartedHint": "Then people who have started version {{published}} ({{started}}) and up to {{older}} people on older versions also get version {{version}}. Slides already viewed stay marked as done. People who have completed the course stay on their version."
      },
      "toast": {
        "itemRemoved": "Removed from the course – it stays in the library",
        "lastChapter": "The last chapter stays",
        "adopted": "“{{title}}” now shows version {{version}}",
        "published": "Version {{version}} published",
        "newVersion": "Version {{version}} opened as draft",
        "draftDiscarded": "Draft discarded",
        "assigned": "Assigned",
        "passMarkSet": "“{{title}}”: pass mark set to {{percent}} % – adjustable in the quiz editor",
        "passMarkLocked": "“{{title}}” is published. Change the pass mark in the quiz editor via “Edit as new version”. The course cannot be published without a pass mark.",
        "lifted_one": "Moved one person to version {{version}}",
        "lifted_other": "Moved {{count}} people to version {{version}}"
      },
      "quiz": {
        "previewNoSubmit": "Preview: nothing is submitted",
        "requiredPass": "Required: pass from {{percent}} %",
        "requiredFill": "Required: fill in",
        "optional": "Practice",
        "missing_one": "{{count}} required question missing",
        "missing_other": "{{count}} required questions missing",
        "passMarkHint": "Pass mark {{percent}} %",
        "resultHidden": "This quiz does not show the result.",
        "retry": "Try again",
        "correctAnswers": "Correct answers",
        "yourChoice": "your choice"
      },
      "player": {
        "chapters": "Chapters",
        "openItems_one": "{{count}} item still open",
        "openItems_other": "{{count}} items still open",
        "requiredOpen": "A required quiz is not passed yet",
        "certificate": "Download certificate",
        "certificateFailed": "The certificate could not be created",
        "completed": "Completed on {{date}}",
        "versionNote": "Version {{version}}"
      }
    }
  },
  "pdfViewer": {
    "percent": "{{value}}%",
    "zoomMenu": "Zoom {{value}}, options",
    "fitWholePage": "Show whole page",
    "fitWholeSlide": "Show whole slide",
    "fitWholeSheet": "Show whole sheet",
    "actualSize": "Actual size",
    "zoomHint": "Ctrl/⌘ + scroll wheel or pinch · Ctrl/⌘ + 0 = 100%",
    "slide": "Slide",
    "ofTotal": "of {{total}}",
    "slideCounter": "Slide {{current}} of {{total}}",
    "previousSlide": "Previous slide",
    "nextSlide": "Next slide",
    "sheetTabs": "Sheets",
    "title": "PDF Viewer",
    "currentDocument": "Current Document",
    "documentName": "Document Name",
    "fileName": "File Name",
    "fileSize": "File Size",
    "totalPages": "Total Pages",
    "pages": "Pages",
    "noPdfSelected": "No PDF selected",
    "openFromDrive": "Open PDFs via cdbDrive",
    "openFromDriveHint": "This viewer only displays PDFs opened from other apps (e.g., cdbDrive).",
    "pdfLoading": "Loading PDF...",
    "errorLoadingPdf": "Error loading PDF",
    "pdfNoLongerAvailable": "PDF is no longer available. Please open the file again via cdbDrive.",
    "retry": "Retry",
    "pageCounter": "Page {{current}} of {{total}}",
    "previousPage": "Previous Page",
    "nextPage": "Next Page",
    "fitToWidth": "Fit to Width",
    "fitToPage": "Fit to Page",
    "width": "Width",
    "page": "Page",
    "zoomOut": "Zoom Out",
    "zoomIn": "Zoom In",
    "dragToPan": "Drag to Pan",
    "scrollToZoom": "Scroll to Zoom",
    "closeTab": "Close Tab",
    "maxTabsReached": "Maximum of {{max}} tabs reached"
  },
  "filePreview": {
    "title": "File Preview",
    "noFileSelected": "No file selected",
    "openFromDrive": "Open files via cdbDrive",
    "errorLoading": "Error loading file",
    "temporaryUrlExpired": "The file is no longer available after reloading. Please open the file again via cdbDrive.",
    "tryAgain": "Please try again",
    "invalidJson": "Invalid JSON format",
    "fileInfo": "File Information",
    "fileName": "File Name",
    "fileSize": "File Size",
    "fileType": "File Type",
    "knowledgeArea": "Knowledge Area",
    "unknownSize": "Unknown",
    "viewOptions": "View Options",
    "lineNumbers": "Line Numbers",
    "wordWrap": "Word Wrap",
    "htmlPage": "Page",
    "htmlSource": "Source",
    "actions": "Actions",
    "download": "Download",
    "csvOptions": "CSV Options",
    "csvDelimiter": "Delimiter",
    "csvHasHeader": "First Row as Header",
    "loadingPresentation": "Loading presentation...",
    "emptyPresentation": "No slides found",
    "fullscreen": "Fullscreen",
    "exitFullscreen": "Exit fullscreen (Esc)",
    "search": {
      "placeholder": "Search in document...",
      "position": "{{position}} of {{total}}",
      "noHits": "No hits",
      "previous": "Previous hit (Shift+Enter)",
      "next": "Next hit (Enter)"
    },
    "sheetTruncated": "Not shown: {{parts}}. Download the file or open it in Collabora to see everything.",
    "sheetEmpty": "This sheet is empty.",
    "sheetTruncatedRows": "{{count}} more rows",
    "sheetTruncatedCols": "{{count}} more columns",
    "noPreviewTitle": "No preview available",
    "noPreviewDescription": "There is no preview for this file type. You can download the file instead."
  },
  "promptLibrary": {
    "newPrompt": "New Prompt",
    "editPrompt": "Edit Prompt",
    "deleteConfirm": "Do you really want to delete the prompt \"{{title}}\"?",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Code Review Prompt",
    "descriptionLabel": "Description (optional)",
    "descriptionPlaceholder": "A brief description of the prompt",
    "promptTextLabel": "Prompt Text",
    "promptTextPlaceholder": "Enter your prompt here...",
    "editorHint": "Create a new prompt for your collection.",
    "createSuccess": "Prompt created successfully",
    "updateSuccess": "Prompt updated successfully",
    "deleteSuccess": "Prompt deleted successfully",
    "errors": {
      "saveFailed": "Failed to save prompt",
      "deleteFailed": "Failed to delete prompt",
      "reorderFailed": "Failed to save prompt order"
    },
    "share": {
      "title": "Share Prompt",
      "description": "Share this prompt with other users. An independent copy will be created for each recipient.",
      "selectUsers": "Select users",
      "noUsersAvailable": "No users available for sharing.",
      "shareButton": "Share with {{count}} user(s)",
      "sharing": "Sharing...",
      "shareSuccess": "Prompt shared with {{count}} user(s) successfully.",
      "shareError": "Failed to share prompt. Please try again.",
      "loadUsersError": "Failed to load users."
    }
  },
  "drive2": {
    "filter": {
      "media": "Audio and video"
    },
    "pickForChat": {
      "title": "Select files for the chat",
      "selectedCount": "{{count}} selected",
      "attach": "Attach to chat"
    },
    "sidebar": {
      "title": "cdbDrive",
      "personal": "My Documents",
      "corporate": "Corporate",
      "corporateKnowledgeAreas": "Knowledge Areas",
      "allAreas": "All Areas",
      "expand": "Expand sidebar",
      "collapse": "Collapse sidebar",
      "legendPersonal": "Personal",
      "legendCorporate": "Corporate",
      "personalComingSoon": "Coming soon",
      "general": "General"
    },
    "badge": {
      "personal": "Personal",
      "corporate": "Corporate"
    },
    "header": {
      "allAreas": "All Areas",
      "documents": "Documents"
    },
    "search": {
      "placeholder": "Search documents..."
    },
    "table": {
      "name": "Name",
      "format": "Format",
      "knowledgeArea": "Knowledge Area",
      "memoryStatus": "Searchable",
      "modified": "Modified",
      "size": "Size",
      "versionsTitle": "{{count}} versions — view/restore earlier versions"
    },
    "actions": {
      "open": "Open",
      "download": "Download",
      "downloading": "Downloading...",
      "upload": "Upload",
      "delete": "Delete",
      "deleteConfirm": "Really delete this file?",
      "useInChat": "Use in cdbChat",
      "ingest": "Make searchable",
      "copyLink": "Copy link",
      "copyLinkDone": "Link copied",
      "copyLinkFailed": "Could not copy the link",
      "shareLink": "Share link",
      "rename": "Rename"
    },
    "memory": {
      "ingested": "Searchable",
      "noText": "No text",
      "none": "Not searchable"
    },
    "empty": {
      "noFilesTitle": "No Documents",
      "noFilesDescription": "There are no documents in this area yet.",
      "noSearchResultsTitle": "No Results",
      "noSearchResultsDescription": "No documents found for your search.",
      "personalEmptyTitle": "No personal documents",
      "personalEmptyDescription": "Upload documents via cdbChat to see them here."
    },
    "loading": "Loading documents...",
    "loadingMore": "Loading more...",
    "loadMore": "{{loaded}} of {{total}} loaded — Load more",
    "loadMoreMedia": "{{found}} — Load more",
    "mediaFound_one": "{{count}} audio/video file in {{loaded}} of {{total}} loaded documents",
    "mediaFound_other": "{{count}} audio/video files in {{loaded}} of {{total}} loaded documents",
    "errorLoadingFiles": "Could not load documents.",
    "footer": {
      "of": "of",
      "files": "documents"
    },
    "subtitle": {
      "loading": "Loading...",
      "allAreas": "All Areas"
    },
    "preview": {
      "close": "Close preview",
      "loadError": "The file could not be loaded.",
      "retry": "Try again",
      "splitter": "Resize preview pane"
    },
    "editor": {
      "collabora": {
        "openCta": "Edit in Collabora",
        "title": "Office editor: {{name}}",
        "subtitle": "Collabora Online · Word · Excel · PowerPoint",
        "loading": "Loading editor…",
        "saveNow": "Save now",
        "saving": "Saving…",
        "saved": "Saved",
        "unsaved": "Unsaved",
        "close": "Close editor",
        "popOut": "Open in its own window",
        "unavailable": "The Office editor is currently unavailable.",
        "unsupported": "This file type cannot be edited in Collabora.",
        "error": "Editor could not be loaded."
      }
    },
    "bpmn": {
      "openCta": "Open in the BPMN editor",
      "title": "Edit BPMN — {{name}}",
      "subtitle": "Changes are saved as a new version",
      "loading": "Loading diagram …",
      "renderError": "The diagram could not be rendered.",
      "save": "Save",
      "saving": "Saving …",
      "saved": "Saved",
      "saveFailed": "Saving failed",
      "saveError": "The new version could not be saved.",
      "unsaved": "Unsaved changes",
      "manualSave": "Save with Ctrl/Cmd+S",
      "discardConfirm": "You have unsaved changes. Close the editor anyway?",
      "discard": "Discard",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "fit": "Fit to view",
      "close": "Close editor"
    },
    "html": {
      "loadFailed": "The page could not be loaded.",
      "openCta": "Open in the editor",
      "editTitle": "Edit HTML — {{name}}",
      "editSubtitle": "Changes are saved as a new version",
      "save": "Save",
      "saving": "Saving …",
      "saved": "Saved",
      "saveFailed": "Saving failed",
      "saveError": "The new version could not be saved.",
      "unsaved": "Unsaved changes",
      "discardConfirm": "You have unsaved changes. Close the editor anyway?",
      "discard": "Discard",
      "close": "Close editor",
      "showPreview": "Show preview",
      "hidePreview": "Hide preview",
      "refreshPreview": "Refresh preview",
      "lineCount_one": "{{count}} line",
      "lineCount_other": "{{count}} lines",
      "link": {
        "request": "This page wants to open:",
        "open": "Open",
        "cancel": "Cancel"
      }
    },
    "exportPdf": {
      "cta": "Save as PDF",
      "running": "Creating PDF …",
      "doneTitle": "PDF saved",
      "doneBody": "“{{name}}” is now in your files.",
      "doneIncomplete": "“{{name}}” is now in your files. Anything the page works out in the browser — charts, for instance — is missing from it.",
      "failedTitle": "Export failed",
      "failedBody": "The page could not be saved as a PDF.",
      "tooLargeBody": "The page is too large to export as a PDF.",
      "unavailableBody": "PDF export is not available in this environment."
    },
    "details": {
      "title": "Details",
      "knowledgeSection": "Knowledge",
      "openPreview": "Open preview"
    },
    "multiselect": {
      "selectAll": "Select all",
      "selectedCount": "{{count}} selected",
      "deleteSelected": "Delete",
      "clearSelection": "Clear selection",
      "deleteConfirm": "Really delete {{count}} document(s)?",
      "syncToBrain": "Sync with Brain"
    },
    "brainSync": {
      "title": "Sync with Brain",
      "successTitle": "Handed to the Brain – processing",
      "successDescription": "{{count}} file(s) accepted. The Drive shows the processing state on each file.",
      "noneAccepted": "No file was accepted.",
      "precheckSummary": "{{count}} of {{total}} file(s) can be added.",
      "filesHeading": "Selection",
      "checkingFormats": "Checking supported formats…",
      "willSend": "Will be added",
      "willSkip": "Skipped",
      "confirmCount": "Sync {{count}}",
      "progress": "File {{current}} of {{total}}: {{name}}",
      "rateLimitWait": "Upload limit reached – retrying in {{seconds}} s",
      "stop": "Stop",
      "problemsHint": "{{count}} file(s) were not added. Files worth retrying stay selected.",
      "resultsHeading": "Result",
      "result": {
        "accepted": "Handed over – processing",
        "acceptedUnlinked": "Handed over – the status cannot be tracked in the Drive",
        "duplicate": "Already in {{knowledgeArea}} ({{status}})",
        "duplicateUnknown": "Identical content already exists",
        "reprocess": "Reprocess",
        "reprocessStarted": "Restarted",
        "reprocessFailed": "Reprocessing failed.",
        "rateLimited": "Upload limit reached – please try again later",
        "cancelled": "Not sent (stopped)",
        "failed": "Failed: {{message}}"
      },
      "reason": {
        "convertToJpeg": "{{extension}} is not processed – convert it to JPEG first",
        "excelImport": "Add spreadsheets ({{extension}}) through the Excel import in the Knowledge Extractor",
        "exportPdf": "Export HTML pages as PDF first",
        "imagesDisabled": "Images are currently not processed in Knowledge Areas",
        "tooLarge": "Larger than {{maxMb}} MB",
        "format": "File type {{extension}} cannot be processed",
        "noExtension": "Files without an extension cannot be processed",
        "driveVideoTooLarge": "Videos over {{maxMb}} MB cannot be sent from Drive yet – please upload them in the Knowledge Extractor"
      }
    },
    "linkedDocument": {
      "errorTitle": "Could not open the document",
      "errorMessage": "The shared link points to a document that cannot be loaded right now."
    },
    "shareLink": {
      "title": "Share this file by link",
      "description": "Anyone who opens this link can view “{{filename}}” — always its current version. The file is not copied.",
      "create": "Create link",
      "copy": "Copy link",
      "notDisplayable": "This file has a valid link, but it can no longer be displayed. Revoke it and create a new one.",
      "createdOn": "Created on {{date}}",
      "viewers": "Viewed by: {{count}}",
      "noViews": "Nobody has opened the file yet",
      "unknownUser": "Unknown",
      "revoke": "Revoke",
      "revoked": "Link revoked",
      "revokeFailed": "The link could not be revoked",
      "copyFailed": "The link could not be copied",
      "createFailed": "The link could not be created",
      "loadFailed": "The link could not be loaded",
      "copyNote": "There is exactly one link per file — copy it as often as you like. Revoking takes effect at once, including for someone who has the file open."
    },
    "delete": {
      "failedTitle": "Delete failed",
      "failedBody": "The file could not be deleted and is still there. Please try again.",
      "bulkFailedBody_one": "{{count}} of {{total}} files could not be deleted and is still there. Please try again.",
      "bulkFailedBody_other": "{{count}} of {{total}} files could not be deleted and are still there. Please try again."
    },
    "rename": {
      "title": "Rename file",
      "description": "The file extension stays as it is — it decides how the file is displayed and edited.",
      "failedTitle": "Rename failed",
      "failedBody": "The name could not be changed. Please try again."
    },
    "brainStatus": {
      "label": "Brain",
      "section": "Brain (Knowledge Area)",
      "queued": "Queued",
      "processing": "Processing",
      "completed": "Processed",
      "failed": "Failed",
      "unsupported": "Not supported",
      "notSynced": "Not synced",
      "outdated": "older version",
      "outdatedHint": "An older version of this file was synced.",
      "processedAt": "Processed on {{when}}"
    }
  },
  "changelog": {
    "title": "Changelog",
    "version": "Version",
    "latest": "Latest",
    "types": {
      "feature": "New",
      "improvement": "Improved",
      "fix": "Fixed"
    },
    "howTo": "How to",
    "loading": "Loading what's new …",
    "loadError": "What's new could not be loaded.",
    "empty": "Nothing new yet.",
    "loadMore": "Show older",
    "loadingMore": "Loading older entries …",
    "loadMoreError": "Older entries could not be loaded.",
    "dontShowAgain": "Don't show on startup",
    "confirm": "Got it!",
    "settingsHint": "You can always find the changelog in the taskbar",
    "footer": "Press ESC or click outside to close"
  },
  "commandPalette": {
    "title": "Quick Access",
    "spotlightPlaceholder": "Spotlight Search",
    "taskbarLabel": "Quick Access ({{shortcut}})",
    "groups": {
      "app": "Apps",
      "document": "Documents",
      "personalDocument": "My Documents"
    },
    "hintNavigate": "Navigate",
    "hintOpen": "Open"
  },
  "upload": {
    "fileTooLarge": "Files must not exceed {{max}} MB",
    "tooManyFiles": "Too many files selected"
  },
  "taskbar": {
    "aria": "Taskbar",
    "timeBerlin": "Time in Berlin",
    "openTour": "Start desktop tour",
    "stopTour": "End desktop tour",
    "preview": {
      "windowCount_one": "{{count}} Window",
      "windowCount_other": "{{count}} Windows",
      "active": "Active",
      "minimized": "Minimized",
      "restore": "Restore",
      "minimize": "Minimize",
      "close": "Close"
    },
    "voiceAgentActive": "Voice Agent Active",
    "voiceAgentSession": "Voice Agent session running",
    "toggleWidgetArea": "Toggle widget area"
  },
  "bugReport": {
    "myReports": {
      "title": "My tickets",
      "description": "Follow the progress of your reports and feature requests and answer questions from the team.",
      "createTicket": "Create ticket",
      "groups": {
        "label": "Filter tickets",
        "active": "Active ({{count}})",
        "done": "Done ({{count}})"
      },
      "groupEmpty": {
        "active": "No open tickets.",
        "done": "No completed tickets yet."
      },
      "listLabel": "Your tickets",
      "empty": "You have not submitted any tickets yet.",
      "emptyHint": "If you notice an error, report it via “Create ticket”. The team can reply to you right here.",
      "loadError": "Your tickets could not be loaded.",
      "retry": "Try again",
      "notFound": "This ticket was not found.",
      "selectHint": "Select a ticket to see its history.",
      "unread_one": "{{count}} new reply",
      "unread_other": "{{count}} new replies",
      "submittedOn": "submitted on {{date}}",
      "showReport": "View my report",
      "hideReport": "Hide report",
      "attachments": "Attachments of the report",
      "back": "Back to the list",
      "progressLabel": "Progress",
      "steps": {
        "submitted": "Submitted",
        "inProgress": "In progress",
        "question": "Question",
        "resolved": "Resolved",
        "closed": "Closed",
        "planned": "Planned"
      },
      "questionBanner": {
        "title": "The team has a question.",
        "body": "Please reply so we can continue."
      },
      "resolvedHint": "The team marked this ticket as resolved. If the problem persists, reply within 14 days – the ticket will be reopened, otherwise it is closed automatically."
    },
    "category": {
      "ui": "UI / Design",
      "functionality": "Functionality",
      "performance": "Performance",
      "data_loss": "Data Loss",
      "new_feature": "New feature",
      "improvement": "Improvement",
      "ui_ux": "UI / UX",
      "workflow": "Workflow & productivity",
      "integration": "Integration",
      "other": "Other"
    },
    "system": {
      "portal": "Portal",
      "webos": "webOS",
      "document_editor": "Document Editor",
      "pdb": "PDB",
      "chat": "Chat"
    },
    "form": {
      "titleLabel": "Title",
      "titlePlaceholder": "Short bug title",
      "categoryLabel": "Category",
      "systemLabel": "System",
      "systemPlaceholder": "Select system",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "What happened? How can the issue be reproduced?",
      "attachmentsLabel": "Attachments (optional)",
      "attachmentsHint": "Up to {{max}} files, each max {{maxMb}} MB (PNG, JPG, GIF, WEBP, MP4, WEBM).",
      "removeAttachment": "Remove attachment",
      "attachmentsSummary": "{{used}} of {{max}} attachments used"
    },
    "dialog": {
      "title": "Report a bug",
      "description": "Describe the issue as precisely as possible. Screenshots or short videos help with triage.",
      "replyNotice": "The team can reply to you about this report.",
      "submit": "Send bug report",
      "submitting": "Sending...",
      "successTitle": "Bug report submitted",
      "successDescription": "Thanks for your feedback. The admin team will review the report.",
      "errorTitle": "Bug report failed",
      "errorDescription": "The bug report could not be saved. Please try again later."
    },
    "validation": {
      "titleRequiredTitle": "Title required",
      "titleRequired": "Please enter a title.",
      "descriptionRequiredTitle": "Description required",
      "descriptionRequired": "Please enter a description.",
      "systemRequiredTitle": "System required",
      "systemRequired": "Please select a system.",
      "tooManyFilesTitle": "Too many files",
      "tooManyFiles": "A maximum of {{max}} files is allowed.",
      "fileTooLargeTitle": "File too large",
      "fileTooLarge": "{{name}} exceeds {{max}} MB.",
      "invalidTypeTitle": "Invalid file type",
      "invalidType": "{{name}} has an unsupported file type."
    },
    "errors": {
      "BUG_REPORT_MAX_FILES_EXCEEDED": "A maximum of 6 attachments is allowed.",
      "BUG_REPORT_FILE_TOO_LARGE": "At least one file is larger than 10 MB.",
      "BUG_REPORT_INVALID_FILE_TYPE": "At least one file has an invalid type.",
      "BUG_REPORT_SYSTEM_REQUIRED": "Please select a system.",
      "BUG_REPORT_NOT_AUTHENTICATED": "You are not signed in. Please sign in again.",
      "BUG_REPORT_UPLOAD_FAILED": "Attachments could not be uploaded.",
      "BUG_REPORT_CLOSE_REASON_REQUIRED": "Please choose a reason for closing."
    },
    "status": {
      "open": "Open",
      "in_progress": "In Progress",
      "waiting_for_reporter": "Waiting for reporter",
      "planned": "Planned",
      "resolved": "Resolved",
      "closed": "Closed"
    },
    "closeReason": {
      "done": "Done / implemented",
      "declined": "Declined",
      "duplicate": "Duplicate",
      "not_a_bug": "Not a bug",
      "no_response": "No response",
      "suggested": "Suggested"
    },
    "type": {
      "bug": "Bug",
      "feature": "Feature request"
    },
    "admin": {
      "description": "Bugs and feature requests from all clients. Drag a card to change its status; the reporter is notified.",
      "empty": "No tickets found",
      "unknownUser": "Unknown user",
      "filters": {
        "all": "All",
        "noClient": "Unassigned",
        "allClients": "All organisations",
        "search": "Search tickets",
        "searchPlaceholder": "Search: title, ID, reporter",
        "allSystems": "All systems",
        "allCategories": "All categories",
        "onlyUnread": "Only with new replies ({{count}})",
        "button": "Filter",
        "activeCount_one": "{{count}} filter active",
        "activeCount_other": "{{count}} filters active",
        "reset": "Reset filters",
        "client": "Organisation",
        "system": "System",
        "category": "Category",
        "status": "Status"
      },
      "table": {
        "status": "Status",
        "category": "Category",
        "system": "System",
        "title": "Title",
        "reporter": "Reported by",
        "attachments": "Attachments",
        "actions": "Actions",
        "client": "Organisation",
        "noReporter": "—",
        "lastActivity": "Last activity",
        "unread": "New",
        "type": "Type"
      },
      "details": {
        "noAttachments": "No attachments available.",
        "screenshots": "Screenshots",
        "recordings": "Screen recordings",
        "documents": "Documents",
        "preview": "Preview",
        "previewLoading": "Loading preview …",
        "previewError": "The preview could not be loaded. Download the file to open it.",
        "download": "Download",
        "downloadErrorTitle": "Download failed",
        "downloadErrorDescription": "\"{{name}}\" could not be downloaded.",
        "status": "Status"
      },
      "loadErrorTitle": "Could not load tickets",
      "loadErrorDescription": "Please try again.",
      "saveErrorClosed": "The ticket is closed. Reopen it to add a note.",
      "emptyFiltered": "No tickets match these filters.",
      "board": {
        "viewLabel": "View",
        "viewBoard": "Board",
        "viewList": "List",
        "columnLabel": "{{status}} ({{count}})",
        "collapse": "Collapse",
        "expand": "Show",
        "hint": {
          "open": "just in",
          "in_progress": "being worked on",
          "waiting_for_reporter": "waiting for reporter",
          "resolved": "fix rolled out",
          "closed": "done",
          "planned": "feature requests only"
        },
        "emptyColumn": "Drop here",
        "closedHint": "Collapsed. Drop here to close.",
        "dragHandle": "Move \"{{title}}\"",
        "unreadPrefix": "New replies:",
        "unread_one": "{{count}} new reply",
        "unread_other": "{{count}} new replies",
        "moveErrorTitle": "Status not changed",
        "moveErrorDescription": "\"{{title}}\" stays at \"{{status}}\". Please try again.",
        "moveRefusedTitle": "“{{status}}” not possible",
        "plannedNotAllowed": "“Planned” exists for feature requests only. Classify the bug as a feature request in the ticket first.",
        "dropReason": {
          "label": "Reason for closing “{{title}}”",
          "heading": "Close as …",
          "cancelHint": "Esc cancels, the card stays where it was."
        }
      },
      "drawer": {
        "copyLink": "Copy link",
        "linkCopied": "Link copied",
        "linkCopyFailed": "Could not copy the link",
        "reportedBy": "reported by {{name}}",
        "noReporter": "no reporter",
        "attachments": "Attachments ({{count}})",
        "history": "History",
        "submitted": "Submitted",
        "visibility": "Visibility: the reporter sees the description, attachments, status and all replies. Internal notes are visible to the BIK team only.",
        "loadErrorTitle": "Conversation could not be loaded",
        "loadErrorDescription": "Please try again.",
        "notFound": "This ticket was not found.",
        "showDetails": "Show details",
        "hideDetails": "Hide details",
        "type": "Type",
        "closeAs": "Closed as …",
        "reopenFirst": "reopen first",
        "typeChanged": "Classified as {{type}}",
        "typeErrorTitle": "Type not changed",
        "typeErrorDescription": "The type could not be changed. Please try again."
      },
      "github": {
        "button": "Create in GitHub",
        "chip": "GitHub #{{number}}",
        "chipTitle": "Open issue {{ref}} in GitHub",
        "dialogTitle": "Create a GitHub issue",
        "privacyNote": "A draft following our issue rules is written from the report and its conversation; you review it before anything is created. The reporter's name, e-mail address and ID are not sent; attachments stay in the ticket, which the issue links to.",
        "repo": "Repository",
        "repoPlaceholder": "Choose a repository",
        "includeNotes": "Include internal notes",
        "draft": "Create draft",
        "redraft": "Draft again",
        "drafting": "Creating draft …",
        "draftingHint": "This takes a few seconds.",
        "typeLabel": "Type",
        "type": {
          "bug": "Bug",
          "feature": "Feature",
          "chore": "Chore",
          "intent": "Intent (needs a spec)"
        },
        "titleLabel": "Title",
        "bodyLabel": "Body (Markdown)",
        "edit": "Edit",
        "preview": "Preview",
        "labels": "Labels",
        "addLabel": "Add label",
        "removeLabel": "Remove label {{label}}",
        "labelUnknown": "Not in this repository",
        "labelUnknownHint": "The selected repository has no such label. It will not be set.",
        "labelUnknownNote": "Struck-through labels do not exist in {{repo}} and will not be set.",
        "dismissUnknownLabel": "Dismiss the note on “{{label}}”",
        "unknownLabelsError": "Some labels do not exist in this repository. They were removed – please create the issue again.",
        "create": "Create issue",
        "creating": "Creating issue …",
        "successText": "Issue {{ref}} was created and linked to this ticket.",
        "openIssue": "Open in GitHub",
        "unavailable": "The GitHub connection is not set up in this environment. Please contact the platform team.",
        "configError": "The GitHub settings could not be loaded. Please try again.",
        "draftError": "The draft could not be created. Please try again.",
        "createError": "The issue could not be created. Please try again.",
        "exists": "This ticket already has an issue."
      },
      "typeFilter": {
        "label": "Type",
        "all": "All",
        "bug": "Bugs",
        "feature": "Features",
        "count": "{{label}} ({{count}})"
      }
    },
    "stepper": {
      "details": "Details",
      "screenshot": "Screenshot",
      "recording": "Recording",
      "documents": "Attachments"
    },
    "documents": {
      "hint": "Optionally attach documents that led to the problem — for example the file whose upload failed. PDF, Word and Excel files are allowed.",
      "selectLabel": "Select documents"
    },
    "screenshot": {
      "hint": "Optionally capture a screenshot. You can crop the area afterwards.",
      "capture": "Take screenshot",
      "retake": "Retake",
      "remove": "Remove",
      "crop": "Crop",
      "cropHint": "Drag a rectangle over the area you want to keep.",
      "cropApply": "Apply crop",
      "cropReset": "Reset",
      "cropError": "Crop failed",
      "capturing": "Starting capture...",
      "manualLabel": "Or upload a screenshot file",
      "readyToCapture": "Ready to capture",
      "captureNow": "Take screenshot now",
      "streamingHint": "Navigate to the desired view and click \"Take screenshot now\"."
    },
    "recording": {
      "hint": "Optionally record a short screen recording (max. 30 seconds).",
      "start": "Start recording",
      "stop": "Stop recording",
      "retake": "Retake",
      "remove": "Remove",
      "recording": "Recording in progress",
      "maxDuration": "Maximum duration: {{seconds}} seconds",
      "manualLabel": "Or upload a video recording",
      "inProgressHint": "Recording is running in the background. Use the floating bar to stop."
    },
    "navigation": {
      "next": "Next",
      "back": "Back",
      "submit": "Send bug report",
      "skipToSubmit": "Send now"
    },
    "thread": {
      "label": "Conversation",
      "empty": "No messages yet.",
      "newDivider": "New",
      "event": "{{name}}: {{from}} → {{to}}",
      "system": "System",
      "reporter": "Reporter",
      "team": "BIK team",
      "internal": "Internal",
      "internalNoteBy": "Internal note by {{name}}",
      "messageBy": "Message from {{name}}",
      "downloadAttachment": "Download {{name}}",
      "typeEvent": "{{name}}: classified as {{to}} (was {{from}})"
    },
    "composer": {
      "label": "Write a message",
      "modeLabel": "Message type",
      "modeReply": "Reply to reporter",
      "modeNote": "Internal note",
      "noReporter": "No reporter – internal notes only.",
      "replyHint": "{{name}} will be notified in the notification center.",
      "noteHint": "Visible to the BIK team only, nobody is notified.",
      "messageLabel": "Message",
      "replyPlaceholder": "Write a reply …",
      "notePlaceholder": "Write an internal note …",
      "attachments": "Attachments",
      "removeAttachment": "Remove {{name}}",
      "attach": "Attach file",
      "statusAfter": "Status afterwards:",
      "statusUnchanged": "Unchanged",
      "send": "Send",
      "closedAdmin": "This ticket is closed. Reopen it to reply.",
      "closedReporter": "This ticket is closed.",
      "sendErrorTitle": "Message not sent",
      "sendErrorDescription": "The message could not be sent. Your draft has been kept.",
      "closeReason": "Reason:",
      "closeReasonPlaceholder": "Choose a reason",
      "closeReasonMissing": "Please choose a reason for closing.",
      "sendAndClose": "Send and close"
    },
    "context": {
      "title": "Context",
      "system": "System",
      "app": "App",
      "window": "Window",
      "route": "Page",
      "app_version": "Version",
      "browser": "Browser",
      "os": "Operating system",
      "client_name": "Organisation",
      "captured_at": "Captured"
    }
  },
  "ticketPanel": {
    "title": "Create ticket",
    "entry": {
      "feature": "Suggest an improvement"
    },
    "type": {
      "label": "Ticket type",
      "bug": "Report a bug",
      "feature": "Suggest an improvement"
    },
    "form": {
      "titleLabel": {
        "bug": "What happened?",
        "feature": "What do you suggest?"
      },
      "titlePlaceholder": {
        "bug": "In short, e.g. “PDF preview stays blank”",
        "feature": "In short, e.g. “Sort delivery notes by date”"
      },
      "descriptionLabel": "Description",
      "descriptionPlaceholder": {
        "bug": "What did you do, what happened and what did you expect?",
        "feature": "Which problem would this solve, and how do you work today?"
      },
      "categoryLabel": "Category",
      "optional": "optional",
      "categoryNone": "Not specified"
    },
    "validation": {
      "title": "Please enter a title.",
      "description": "Please describe your request."
    },
    "attachments": {
      "label": "Attachments",
      "count": "{{used}} of {{max}}",
      "screenshot": "Screenshot",
      "recording": "Recording",
      "file": "File",
      "kind": {
        "screenshot": "Screenshot",
        "screenshotMarked": "Screenshot with markings",
        "recording": "Screen recording"
      },
      "capturedHint": "captured without this panel",
      "mark": "Mark",
      "remove": "Remove {{name}}"
    },
    "capture": {
      "ready": "Choose the view you want to show.",
      "now": "Capture now",
      "recording": "Recording",
      "secondsLeft": "{{seconds}} s left",
      "stop": "Stop",
      "unsupported": "Your browser does not support screen capture. You can attach a file instead.",
      "failed": "The capture failed. Please try again."
    },
    "markup": {
      "title": "Mark the screenshot",
      "toolsLabel": "Tool",
      "tool": {
        "rect": "Rectangle",
        "arrow": "Arrow"
      },
      "undo": "Remove last marking",
      "hint": "Drag on the image to mark a spot.",
      "canvasLabel_one": "Screenshot with {{count}} marking",
      "canvasLabel_other": "Screenshot with {{count}} markings",
      "failed": "The screenshot could not be loaded.",
      "apply": "Apply"
    },
    "context": {
      "title": "Captured automatically",
      "attach": "attach",
      "version": "Version {{version}}",
      "excluded": "These details will not be sent."
    },
    "footer": {
      "replyNotice": "The team can reply to you.",
      "submit": "Send ticket",
      "submitting": "Sending …"
    },
    "success": {
      "title": "Thank you – your ticket has been received.",
      "text": "You will find the team's replies under “My tickets”. You will be notified as soon as there is news.",
      "open": "Open my tickets",
      "another": "Create another ticket"
    },
    "errors": {
      "submitTitle": "The ticket could not be sent",
      "submit": "Please try again. Your input is kept.",
      "typeDisabled": {
        "bug": "Bug reports are not enabled for your role. Please contact your administrator.",
        "feature": "Improvement suggestions are not enabled for your role. Please contact your administrator."
      }
    },
    "similar": {
      "title": "Similar tickets found",
      "own": "reported by you",
      "noClient": "unassigned",
      "open": "Open",
      "openLabel": "Open “{{title}}”",
      "append": "Add to it",
      "appendLabel": "Add to “{{title}}”"
    },
    "append": {
      "title": "Add to an existing ticket",
      "hint": "Your description and attachments are sent as a reply to this ticket – no new ticket is created.",
      "cancel": "New ticket instead",
      "descriptionLabel": "Your addition",
      "descriptionPlaceholder": "What is new or happened in addition?",
      "submit": "Send addition",
      "successTitle": "Thank you – your addition has been received.",
      "successText": "You will find it in the ticket under “My tickets”. The team is notified.",
      "successOpen": "Open ticket",
      "errorTitle": "Addition could not be sent",
      "closed": "The ticket has been closed in the meantime. You can send your request as a new ticket – your input is kept."
    },
    "suggestion": {
      "type": {
        "bug": "Sounds more like a bug",
        "feature": "Sounds more like a feature request",
        "bugWithCategory": "Sounds more like a bug ({{category}})",
        "featureWithCategory": "Sounds more like a feature request ({{category}})"
      },
      "category": "Suggested category: {{category}}",
      "apply": "apply",
      "dismiss": "Hide suggestion"
    }
  },
  "settings": {
    "title": "Settings",
    "description": "Customize your cdb-webOS",
    "saving": "Saving settings...",
    "desktopIcons": "Desktop Icons",
    "showIcons": "Show icons",
    "showIconsDesc": "Show or hide desktop icons",
    "showLabels": "Labels",
    "showLabelsDesc": "Show text under icons",
    "taskbarDisplayMode": "Taskbar display",
    "iconAndName": "Icon and name",
    "iconOnly": "Icon only",
    "nameOnly": "Name only",
    "sections": {
      "theme": "Theme & Language",
      "desktop": "Desktop Icons",
      "taskbar": "Taskbar",
      "claude": "Connect Claude"
    },
    "theme": {
      "label": "Theme",
      "description": "Choose a theme for your cdb-webOS",
      "automaticSettings": "Automatic Settings",
      "iconColor": "Icon Color",
      "textColor": "Text Color"
    },
    "language": {
      "label": "Language",
      "description": "Change the user interface language"
    },
    "desktop": {
      "visibility": "Visibility",
      "showIcons": "Show Icons",
      "showIconsDescription": "Show or hide desktop icons",
      "showLabels": "Show Icon Labels",
      "showLabelsDescription": "Show text under icons"
    },
    "taskbar": {
      "displayMode": "Display Mode",
      "displayModeDescription": "Choose how apps are displayed in the taskbar",
      "displayBoth": "Icon and Name",
      "displayIconOnly": "Icon only",
      "displayNameOnly": "Name only"
    },
    "reset": {
      "title": "Reset",
      "description": "Reset all settings to default values",
      "button": "Reset Settings",
      "confirmMessage": "Are you sure you want to reset all settings? This action cannot be undone.",
      "confirm": "Yes, reset",
      "cancel": "Cancel"
    },
    "selectLanguage": "Select language",
    "selectDisplayMode": "Select display mode",
    "selectTheme": "Select Theme",
    "claude": {
      "description": "Connect Claude (claude.ai, Claude Desktop, Claude Code) to cdbOS. Claude can then search the knowledge areas you have access to here – read only.",
      "url": "Server URL",
      "clientId": "OAuth client ID",
      "copy": "Copy",
      "steps": {
        "add": "In Claude: Settings → Connectors → Add custom connector and enter the server URL.",
        "clientId": "Under “OAuth client”, choose “Use your own OAuth client”, enter the client ID and leave the secret field empty.",
        "signIn": "Connect and sign in with your cdbOS account in the browser."
      },
      "disconnect": "To disconnect, remove the connector in Claude again.",
      "noSecret": "No client secret is needed – leave that field empty."
    }
  },
  "appstore": {
    "title": "App Store",
    "subtitle": "Browse and manage your apps",
    "searchPlaceholder": "Search apps...",
    "searchAria": "App search",
    "count": "{{count}} apps",
    "countAria": "{{count}} results",
    "installed": "Installed",
    "available": "Available",
    "install": "Install",
    "reinstall": "Re-install",
    "uninstall": "Uninstall",
    "installNotImplemented": "Installation is not implemented in this version yet.",
    "systemApp": "System App",
    "notRemovable": "This app is required by the system and cannot be uninstalled.",
    "defaultDescription": "App for cdb-webOS.",
    "addToDesktop": "Add to Desktop",
    "removeFromDesktop": "Remove from Desktop",
    "category": "Category",
    "description": "Description",
    "filters": {
      "all": "All Apps",
      "assigned": "Assigned Apps"
    },
    "categories": {
      "title": "Categories",
      "system": "System",
      "multimedia": "Multimedia",
      "productivity": "Productivity",
      "admin": "Administration",
      "other": "Other",
      "clear": "Reset filter"
    },
    "descriptions": {
      "app-store": "Browse all available apps by category, add them to your desktop or request access to restricted applications.",
      "settings": "Customise theme, language, desktop icons and taskbar display to match your preferences.",
      "cortex": "Manage users, roles, app assignments, access requests, knowledge areas, clients and themes from Cortex, the central administration panel.",
      "voice": "Voice assistant (placeholder).",
      "multimedia": "Play audio and video files from your knowledge areas — with playback controls, volume adjustment and fullscreen mode.",
      "qa": "Create Q&A content (placeholder).",
      "notes": "This app is under development and will be available in a future update.",
      "pdf-viewer": "Open PDF documents in-window with page navigation, smooth zoom, drag-to-pan and keyboard controls.",
      "file-preview": "Universal file viewer for PDF (with zoom, pan, page navigation), Word (.docx), Excel (.xlsx with sheet tabs), and text-based files (code, JSON, CSV, Markdown, XML).",
      "cdb-sessions": "Create interactive quiz sessions with multiple choice, single choice and free-text questions from the episode library and play them as learning units.",
      "cdb-training": "Two areas in one app: trainings built from materials (videos, documents, podcasts) with an optional quiz — and standalone surveys with automatic evaluation.",
      "communicator2": "Next-generation conversational assistant with persistent memory — ask follow-up questions and the assistant remembers the context of your conversation.",
      "ai-knowledge-extractor": "Upload documents to a knowledge area and let the AI automatically extract Q&A pairs, facts and entities.",
      "knowledge-verifier": "Review and verify extracted Q&A pairs, facts and entities for a knowledge area and manage the knowledge graph.",
      "document-editor": "Create and edit documents directly in the browser — opens in a new tab.",
      "wissenshaus": "Your knowledge areas as a 3D house to walk into: each area is a room, and you see what happened in the brain today, this week or this month.",
      "harness": "Prototype: a checker and an editor go through open facts of a knowledge area and propose confirmations or corrections with sources. Only your approval changes the brain.",
      "cdb-control": "All tasks of your client in one place: as a list or kanban board, with assignee and deadline. Tasks from recordings in the Knowledge Extractor keep their source. Admins only for now."
    },
    "access": {
      "noAccess": "No Access",
      "noAccessButton": "No Access"
    },
    "openViaDrive": "Open files via cdbDrive"
  },
  "communicator2": {
    "usage": {
      "cost": "Cost",
      "unlimited": "Unlimited",
      "overLimit": "Limit exceeded",
      "budget": "Usage",
      "ofBudget": "of monthly budget"
    },
    "warnings": {
      "limitExceeded": {
        "title": "Limit reached",
        "description": "Your token or cost limit for this period has been reached. Please contact your administrator."
      }
    },
    "welcome": {
      "title": "cdbChat"
    },
    "subtitle": {
      "idle": "Ready",
      "active": "Conversation"
    },
    "input": {
      "placeholder": "Type a message…",
      "hint": "Enter to send · Shift+Enter for a new line",
      "disclaimer": "AI can make mistakes — please verify important information.",
      "charsLeft_one": "{{count}} character left",
      "charsLeft_other": "{{count}} characters left",
      "tooLong_one": "{{count}} character too long — shorten it or attach it as a file",
      "tooLong_other": "{{count}} characters too long — shorten it or attach it as a file",
      "pastedAsFile": "The pasted text was too long for a message and was attached as a file."
    },
    "models": {
      "button": "Models",
      "languageSection": "Language model",
      "auto": {
        "label": "Automatic",
        "desc": "Our default: the most thorough model, with sources."
      },
      "vendor": {
        "openai": "OpenAI",
        "google": "Google",
        "anthropic": "Anthropic"
      },
      "vendorHint": "All models run through our EU data zone — the vendor name says nothing about where your data goes.",
      "vendorCount": "{{count}} models"
    },
    "websearchDepth": {
      "button": "Web search",
      "section": "Search depth",
      "auto": "Automatic",
      "autoDesc": "The model picks the search depth to match the question.",
      "quick": "Quick",
      "quickDesc": "First reliable sources, fastest answer — for simple factual questions.",
      "deep": "Thorough",
      "deepDesc": "Broad research across multiple sources — takes longer."
    },
    "deepResearch": {
      "label": "Research",
      "hint": "Multi-step research: decomposes the question, queries every connected source and cites the result. Takes longer."
    },
    "imageModels": {
      "section": "Image model",
      "nanoBanana": {
        "label": "Nano Banana 2",
        "desc": "Google's image model (Gemini, EU) — default."
      },
      "gptImage": {
        "label": "GPT Image",
        "desc": "Azure OpenAI image model."
      }
    },
    "actions": {
      "send": "Send",
      "stop": "Stop",
      "copy": "Copy answer",
      "copied": "Copied",
      "regenerate": "Regenerate answer",
      "readFromStart": "Read answer from the top",
      "clear": "Clear conversation"
    },
    "memory": {
      "button": "Memory",
      "pageTitle": "Memory",
      "empty": "Memory builds up over your conversations.",
      "deleteConclusion": "Delete insight",
      "reset": "Reset memory",
      "resetConfirm": "All insights and the summary will be deleted. This cannot be undone.",
      "resetConfirmAction": "Reset",
      "cancel": "Cancel",
      "back": "Back to chat",
      "brainTitle": "Your Brain",
      "brainSubtitle": "Cross-session knowledge your Personal Digital Brain has derived from your conversations.",
      "profileTitle": "Brain profile",
      "profileEmpty": "No brain profile yet. It is created automatically after a few conversations.",
      "insightsTitle": "Brain insights",
      "reload": "Reload",
      "rebuild": "Build profile",
      "rebuilding": "Building …",
      "rebuildHint": "Build the brain profile now from the insights",
      "rebuildNoResult": "No profile could be built yet — it needs a few personal details from chat (e.g. name, role, preferences). Purely factual questions aren't enough on their own.",
      "rebuildUnavailable": "Your personal memory is temporarily unavailable. Please try again later.",
      "editProfile": "Edit",
      "doneEditing": "Done",
      "editEmpty": "No facts yet. Add some below.",
      "addFact": "Add",
      "factPlaceholder": "Enter a new fact …",
      "removeFact": "Remove fact",
      "sourceChat": "from “{{title}}”",
      "sourceChatFallback": "Chat",
      "sourceDrive": "from uploaded files",
      "sourceInferred": "inferred from several insights",
      "factFromChat": "from “{{title}}” on {{date}}",
      "factFromChats": "from {{count}} chats",
      "factFromChatsHide": "show less",
      "factByUser": "added by you",
      "factFromDeletedChat": "from a deleted chat",
      "sessionsTitle": "Your sessions",
      "sessionsSubtitle": "The chats your memory learns from. Click opens the chat; deleting removes the session and its history.",
      "sessionsEmpty": "No sessions yet.",
      "sessionOpen": "Open chat",
      "sessionDelete": "Delete session",
      "sessionDeleteTitle": "Delete session?",
      "sessionDeleteHint": "Permanently removes the session and its history. Saved attachments stay in My Documents.",
      "projects": {
        "title": "Project memory",
        "hint": "What you say in a project stays in that project. Only chats there know these facts.",
        "factCount_one": "{{count}} fact",
        "factCount_other": "{{count}} facts",
        "nothingYet": "nothing learned yet",
        "empty": "Nothing has been learned from this project's chats yet.",
        "factPlaceholder": "Add a fact about the project …",
        "clear": "Delete all",
        "open": "Project memory"
      }
    },
    "sidebar": {
      "newChat": "New chat",
      "discover": "Discover"
    },
    "create": {
      "title": "Create new",
      "word": "Word document",
      "presentation": "Presentation",
      "spreadsheet": "Excel spreadsheet",
      "bpmn": "BPMN diagram",
      "html": "HTML page",
      "image": "Image",
      "error": "Could not create the document"
    },
    "preview": {
      "open": "Open preview",
      "close": "Close preview",
      "openTab": "Open in new tab",
      "loading": "Loading preview…",
      "failed": "The preview could not be loaded.",
      "notAvailable": "No preview is available for this file yet.",
      "firstOpenHint": "The first preview of a file can take a few seconds (conversion) — afterwards it opens instantly.",
      "textFallback": "Original preview unavailable — showing the extracted text.",
      "driveDeleted": "The file was deleted in the Drive – showing the copy from the chat.",
      "openInCollabora": "Open in Collabora (full view)",
      "versions": {
        "title": "Versions",
        "label": "V{{n}}",
        "active": "active",
        "setActive": "Restore as the current version"
      },
      "openInBpmnEditor": "Open in the BPMN editor",
      "openInHtmlEditor": "Open in the HTML editor"
    },
    "attach": {
      "dropTitle": "Drop files here",
      "dropHint": "They will be attached to your message.",
      "dropRejected_one": "This file type is not supported: {{files}}",
      "dropRejected_other": "These file types are not supported: {{files}}",
      "button": "Attach file",
      "remove": "Remove",
      "uploading": "Uploading…",
      "extracting": "Reading text…",
      "uploadNew": "Upload a new file",
      "fromDrive": "Attach from Drive",
      "drivePickerTitle": "Pick a file from the Drive",
      "failed": "Upload failed",
      "dismiss": "Dismiss"
    },
    "sessions": {
      "title": "Conversations",
      "collapse": "Collapse sidebar",
      "expand": "Expand sidebar",
      "empty": "No conversations yet. Ask your first question.",
      "untitled": "New conversation",
      "rename": "Rename",
      "delete": "Delete",
      "renameTitle": "Rename conversation",
      "titleLabel": "Title",
      "titlePlaceholder": "Conversation title",
      "cancel": "Cancel",
      "save": "Save",
      "working": "Currently answering"
    },
    "projects": {
      "title": "Projects",
      "create": "New project",
      "createTitle": "New project",
      "renameTitle": "Rename project",
      "rename": "Rename",
      "delete": "Delete",
      "deleteTitle": "Delete project",
      "deleteConfirm": "Really delete project \"{{name}}\"? Its chats are kept and reappear without a project.",
      "nameLabel": "Project name",
      "namePlaceholder": "e.g. Marketing Q3",
      "empty": "No projects yet. Create one to group your chats.",
      "dropHint": "Drag a chat here",
      "allGrouped": "Every chat belongs to a project.",
      "newChatIn": "New chat in this project",
      "dragHandle": "Drag chat into a project"
    },
    "filter": {
      "label": "Knowledge areas"
    },
    "sources": {
      "title": "Select sources",
      "corporate": "Corporate",
      "websearch": "Web search",
      "router": "External systems",
      "corporateHint": "Search corporate knowledge (documents, graph, facts)",
      "websearchHint": "Search the web (sources cited inline in the answer)",
      "routerHint": "Search connected external systems (Router sources)",
      "unavailable": {
        "corporate": "You have no knowledge areas assigned."
      },
      "skillsBucket": "Tools",
      "toolboxSection": "Tools",
      "corporateSourcesLabel": "Corporate sources",
      "web": "Web",
      "graphFact": "Graph fact",
      "sourcesCount": "Sources · {{count}}",
      "sourcesToggleHint": "Show / hide source details",
      "openHint": "Open source",
      "usedLabel": "Sources used",
      "graphPreviewError": "Could not load the graph preview."
    },
    "corporate": {
      "title": "Internal knowledge",
      "strategy": {
        "vector": "Search documents",
        "graph": "Query the knowledge graph",
        "facts": "Check verified facts",
        "structured": "Search structured data"
      },
      "refCount": "{{count}} hits",
      "refCount_one": "{{count}} hit",
      "refCount_other": "{{count}} hits"
    },
    "memoryToggle": {
      "label": "Personal memory",
      "hint": "Off: the assistant no longer remembers across conversations and learns nothing new about you. Existing insights stay viewable and deletable."
    },
    "memoryIngest": {
      "label": "Save attached files to My Documents",
      "hint": "Attached files stay in My Documents after the chat and can be found again by their content later. Off: the file belongs to this chat only."
    },
    "settings": {
      "button": "Settings",
      "title": "cdbChat settings",
      "saved": "Saved.",
      "saveError": "Saving failed.",
      "loadError": "Could not load settings.",
      "back": "Back",
      "saving": "Saving…",
      "personal": {
        "title": "Personal settings",
        "hint": "Changes are saved automatically."
      },
      "name": {
        "label": "What should I call you?",
        "hint": "Leave empty to use no fixed name."
      },
      "address": {
        "label": "Address form",
        "auto": "Automatic",
        "du": "Informal",
        "Sie": "Formal"
      },
      "tone": {
        "label": "Tone",
        "neutral": "Neutral",
        "locker": "Casual",
        "formell": "Formal",
        "direkt": "Direct"
      },
      "connectors": {
        "title": "Connected accounts",
        "hint": "Accounts cdbChat may work with on your behalf.",
        "connect": "Connect",
        "disconnect": "Disconnect",
        "connectedSince": "Connected since {{date}}",
        "connectedStatus": "Connected",
        "limits": "Sends nothing without your confirmation. Other mailboxes only when you add them yourself and Microsoft 365 grants you access; calendars only when they are shared with you",
        "permissions": {
          "mail": {
            "read": "Search and read your e-mails",
            "draft": "Create drafts in your mailbox",
            "shared": {
              "read": "Search and read shared mailboxes you add",
              "draft": "Create drafts in a shared mailbox, after your confirmation"
            }
          },
          "calendar": {
            "read": "Read appointments and find free time, also with colleagues",
            "write": "Manage your own appointments and answer invitations"
          },
          "people": {
            "read": "Find people in your frequent contacts, contacts and your organisation's directory"
          }
        },
        "items": {
          "outlook": {
            "description": "cdbChat can search and read the e-mails in your Outlook mailbox and create reply drafts for you."
          },
          "microsoft365": {
            "description": "cdbChat works with your Microsoft 365 account: with the areas you switch on."
          }
        },
        "confirmConnect": {
          "title": "Connect {{name}}?",
          "revocable": "You can disconnect at any time.",
          "pickAreas": "Choose what cdbChat may work with."
        },
        "confirmDisconnect": {
          "title": "Disconnect {{name}}?",
          "body": "cdbChat will no longer be able to access your {{name}} account. You can connect it again at any time."
        },
        "connected": "{{name}} is connected.",
        "disconnected": "{{name}} has been disconnected.",
        "connectError": "{{name}} could not be connected. Please try again later.",
        "consentRefused": "Microsoft did not grant access. {{name}} can be connected once your IT approves the app.",
        "disconnectError": "{{name}} could not be disconnected. Please try again later.",
        "details": "Details",
        "areas": {
          "mail": {
            "name": "Email",
            "description": "Search your mailbox, read mails and attachments, create drafts."
          },
          "calendar": {
            "name": "Calendar",
            "description": "Read appointments, find free time also with colleagues, manage your own and shared calendars, answer invitations."
          },
          "shared_mailboxes": {
            "name": "Shared mailboxes",
            "description": "Mailboxes like info@ or sales@ that you may open in Outlook. You add each one yourself; Microsoft 365 checks your access."
          },
          "people": {
            "name": "People & contacts",
            "description": "Find addresses for names: frequent contacts, Outlook contacts and your organisation's directory. Nothing is stored."
          }
        },
        "editAreas": "Change areas",
        "save": "Save",
        "areasSaved": "Areas of {{name}} saved.",
        "confirmAreas": {
          "title": "Areas of {{name}}"
        },
        "mailboxes": {
          "title": "Shared mailboxes",
          "hint": "Add a mailbox you may open in Outlook. Microsoft 365 checks your access before it appears here.",
          "placeholder": "e.g. info@company.com",
          "add": "Add",
          "remove": "Remove {{address}}",
          "recheck": "Check again",
          "statusVerified": "Verified",
          "statusNoAccess": "No access",
          "verified": "{{address}} is verified and connected.",
          "errors": {
            "invalid_address": "Please enter a valid e-mail address.",
            "own_mailbox": "That is your own mailbox – it is already connected.",
            "too_many_mailboxes": "At most 20 mailboxes can be connected.",
            "mailbox_access_denied": "You have no access to this mailbox in Microsoft 365.",
            "mailbox_not_found": "This mailbox does not exist in your organisation, or you have no access to it.",
            "area_inactive": "Please switch on the area “Shared mailboxes” first.",
            "consent_required": "Your IT has to approve access to shared mailboxes first.",
            "generic": "The mailbox could not be checked right now. Please try again later."
          }
        }
      }
    },
    "allSources": {
      "label": "All sources",
      "hint": "The assistant picks which knowledge sources to search per question. Off: only the selected sources are searched. Tools such as Word or images are always available.",
      "pillsAllAllowed": "All sources are allowed. Turn \"All sources\" off to limit the search to individual sources.",
      "chip": "Auto",
      "chipScoped": "Sources",
      "chipNoTools": "Answered without sources",
      "freeQuery": "Free query",
      "freeQueryHint": "The prepared queries found nothing. This answer rests on a query the model wrote itself — check it with more care."
    },
    "feedback": {
      "up": "Helpful",
      "down": "Not helpful",
      "reasonTitle": "Reason (optional)",
      "noReason": "No reason",
      "reasons": {
        "wrong_route": "Wrong route/source",
        "incomplete": "Incomplete",
        "incorrect": "Incorrect",
        "too_slow": "Too slow",
        "other": "Other"
      }
    },
    "meta": {
      "steps": "{{count}} steps",
      "toolsHint": "Show tool steps",
      "memory": "Memory",
      "memoryHint": "Show the memory context used",
      "toolsDone": "{{count}} tools · done",
      "filesDone": "{{count}} files",
      "research": "Research · {{count}} sub-question",
      "research_other": "Research · {{count}} sub-questions",
      "researchHint": "This turn ran as research: the question was decomposed and each part looked up in the sources. Click to see the sub-questions."
    },
    "activity": {
      "working": "Working …",
      "summary": "Activity · {{count}} steps",
      "toolsTitle": "Tools",
      "failed_one": "1 step failed",
      "failed_other": "{{count}} steps failed"
    },
    "widget": {
      "table": {
        "title": "Table",
        "rowCount_one": "{{count}} row",
        "rowCount_other": "{{count}} rows",
        "export": "Download as Excel",
        "exportShort": "Excel",
        "exportFailed": "The Excel file could not be created. Please try again.",
        "exportIncomplete": "The file holds {{count}} rows and the source has more, so it is incomplete.",
        "loadMore": "Load more",
        "loadMoreFailed": "More rows could not be loaded. Please try again.",
        "rowCount": "{{count}} rows",
        "rowsShown": "{{shown}} of {{count}} rows",
        "truncated": "Incomplete: the source has more than these {{count}} rows.",
        "truncatedWithExport": "Incomplete: this holds {{count}} rows and the source has more. Get the whole list through “Excel”."
      },
      "fileRef": {
        "title": "Files",
        "count_one": "{{count}} file",
        "count_other": "{{count}} files",
        "corporate": "Corporate",
        "personal": "Personal",
        "open": "Open preview",
        "count": "{{count}} files"
      },
      "confirm": {
        "title": "Please confirm",
        "submit": "Confirm",
        "sent": "Confirmed – being applied",
        "superseded": "Superseded by a newer proposal.",
        "message": "Fields confirmed."
      },
      "outlookAttachment": {
        "fromOutlook": "from Outlook",
        "attachedMail": "attached e-mail",
        "open": "Open preview",
        "fromMailbox": "from {{mailbox}}"
      },
      "interactive": {
        "title": "Interactive view",
        "loading": "Loading view …",
        "missing": "The interactive view is no longer available.",
        "loadFailed": "The interactive view could not be loaded.",
        "retry": "Try again",
        "expand": "Enlarge",
        "collapse": "Shrink",
        "aiHint": "AI-generated interactive view – check contents and calculations.",
        "promptRequest": "This page wants to send a message:",
        "send": "Send",
        "discard": "Discard",
        "busy": "You can send once the current answer is complete.",
        "wait": "Please wait a moment and send again.",
        "navigated": "The page tried to reload itself or navigate away — stopped.",
        "fromPage": "from interactive page",
        "openBeside": "Open beside chat",
        "openedBeside": "Opened beside the chat —",
        "showHere": "Show here",
        "showInChat": "Show in chat",
        "closePanel": "Close (back into the chat)",
        "versionOf": "Version {{version}} of {{latest}}",
        "versionShort": "v{{version}}",
        "prevVersion": "Previous version",
        "nextVersion": "Next version",
        "olderVersion": "Older version",
        "showLatest": "Show latest",
        "newerAvailable": "Newer version available (v{{version}})",
        "show": "show",
        "history": "History",
        "historyLoading": "Loading history …",
        "historyFailed": "The history could not be loaded.",
        "restoredFrom": "restored from v{{version}}",
        "latestLabel": "latest",
        "current": "shown",
        "view": "View",
        "restore": "Restore",
        "restoreFailed": "Restore failed.",
        "edit": "Edit",
        "editing": "Being edited",
        "editChip": "Editing:",
        "editChipClear": "Stop editing"
      },
      "productImages": {
        "title": "Images",
        "count_one": "{{count}} image",
        "count_other": "{{count}} images",
        "image": "Image",
        "enlarge": "Enlarge",
        "notPublic": "Not public",
        "unavailable": "Not available",
        "more_one": "{{count}} more image not shown",
        "more_other": "{{count}} more images not shown"
      }
    },
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "sendFailed": "Failed to send the message. Please try again.",
      "empty": "No answer arrived. Please try again.",
      "cancelled": "Answer stopped.",
      "historyFailed": "The conversation could not be loaded. Please try again."
    },
    "uploadErrors": {
      "generic": "No reason was given. Please try again.",
      "gateway_timeout": "Processing took too long. Please try a smaller file.",
      "too_many_files": "This conversation has reached its maximum of {{limit}} files. Remove one before attaching the next.",
      "file_too_large": "That file is too large. The limit is {{max_mb}} MB.",
      "file_empty": "That file is empty.",
      "filename_too_long": "That file name is too long. The limit is {{max_chars}} characters.",
      "unsupported_format": "That file format is not supported. You can attach PDF, Word, PowerPoint, Excel, email, audio, images (PNG, JPG, WEBP, GIF, SVG) and text formats.",
      "extraction_timeout": "Reading the file took too long. Please try again.",
      "extraction_failed_file": "The file could not be read. Please check whether it is intact.",
      "extraction_failed_server": "The file could not be processed. Please try again — if it fails again, it is not your file.",
      "audio_too_long": "That recording is too long. The limit is {{max_minutes}} minutes per file.",
      "audio_failed": "The recording could not be transcribed.",
      "image_failed": "The image could not be interpreted. Try again, or check the file.",
      "storage_unavailable": "File storage is unreachable right now. Please try again.",
      "personal_file_not_found": "That file is no longer in your Drive. It was probably deleted in the meantime.",
      "limit_exceeded": "Your token or cost limit for this period has been reached. Please contact your administrator."
    },
    "files": {
      "indexed": "Indexed",
      "version": "v{{version}}",
      "versionTitle": "Version {{version}} of this file in the Drive",
      "download": "Download",
      "editInCollabora": "Edit in Collabora",
      "openBpmnEditor": "Open in the BPMN editor",
      "openHtmlEditor": "Open in the HTML editor",
      "exportPdf": "Save as PDF",
      "collaboraComingSoon": "The Collabora editor for Office documents is coming soon.",
      "pending": "Being created …",
      "failed": "Could not be created.",
      "unknownNumbers": "Contains numbers that do not come from the workflow: {{numbers}} — please check."
    },
    "activeFile": {
      "use": "Use this file",
      "label": "Active file:",
      "clear": "Clear active file",
      "editHint": "Changes are saved as a new version of this file."
    },
    "resizePanel": "Drag to resize width",
    "resizeSidebar": "Resize the chat list",
    "resizePanelHint": "Drag to resize · double-click to reset",
    "stackedPane": {
      "label": "Show chat or preview",
      "chat": "Chat",
      "panel": "Preview"
    },
    "focusView": {
      "button": "Focus view"
    },
    "collaboraWindow": {
      "missing": "No document specified to open."
    },
    "templates": {
      "upload": "Upload template",
      "uploadHint": "Allowed: .docx and .pptx files (max 20 MB).",
      "nameLabel": "Name",
      "namePlaceholder": "e.g. Offer letter template",
      "selectFile": "Choose file",
      "preview": "Preview",
      "previewFailed": "Could not load the preview.",
      "layouts": "Layouts",
      "styles": "Styles",
      "fonts": "Fonts",
      "layoutOn": "On",
      "layoutOff": "Off",
      "fontsUpload": "Upload font",
      "fontsUploaded": "Font(s) uploaded.",
      "fontsUploadFailed": "Failed to upload font.",
      "fontsDeleteFailed": "Failed to delete font.",
      "fontCovered": "Available (uploaded)",
      "fontMissing": "Missing — upload as .ttf/.otf",
      "enrich": {
        "pending": "Analyzing template …",
        "done": "Analyzed",
        "failed": "Analysis failed",
        "none": "Not analyzed yet",
        "timedOut": "Analysis is taking unusually long",
        "retry": "Re-analyze"
      },
      "toast": {
        "patchFailed": "Failed to save change.",
        "reenrichFailed": "Could not start the analysis."
      },
      "prepared": {
        "title": "Prepared for documents",
        "status": {
          "review": "Prepared – documents still use the uploaded file until this version is released.",
          "approved": "Released {{date}} – documents use the prepared version.",
          "not_needed": "The template already carries the fields and is used as it is.",
          "failed": "The template could not be prepared. Documents use the uploaded file."
        },
        "cover": "Cover",
        "coverImage": "Cover image",
        "coverImageSlot": "slot for a picture of your own",
        "back": "Back page",
        "running": "Header and footer",
        "lists": "Lists",
        "listCreated": "created",
        "table": "Table style",
        "kinds": "Special formats",
        "removed": "Removed",
        "removedValue": "{{blocks}} sample paragraphs, {{footnotes}} sample footnotes",
        "found": "found",
        "notFound": "not found",
        "none": "none",
        "field": {
          "topline": "Topline",
          "title": "Title",
          "subtitle": "Subtitle",
          "author": "Author",
          "date": "Date",
          "meta": "Author | date",
          "classification": "Classification",
          "year": "Year"
        },
        "kind": {
          "callout": "Callout",
          "quote": "Quote",
          "topline": "Topline",
          "margin_note": "Margin note",
          "caption": "Caption",
          "wide": "full width"
        },
        "unrecognized": "Placeholders not mapped: {{items}}. They stay as text.",
        "warning": {
          "no_cover": "No cover found: documents start with the content.",
          "no_title_field": "No field for the title found: the title appears as the first heading."
        },
        "release": "Release",
        "withdraw": "Withdraw release",
        "releaseHint": "Check the sample document. Once released, new documents use this version.",
        "withdrawHint": "New documents then use the uploaded file again.",
        "releaseFailed": "The release could not be saved.",
        "preview": {
          "template": "Template",
          "sample": "Sample document"
        }
      }
    },
    "brandKits": {
      "button": "Brand kits",
      "pageTitle": "Brand kits",
      "description": "A brand kit holds everything that makes output yours: colours, fonts, logos and templates. It applies without a template too — to Word, PowerPoint, Excel, HTML pages and images.",
      "pickerTitle": "Brand kit",
      "pickerNone": "No brand kit",
      "source": {
        "thread": "Chosen for this chat",
        "preference": "Your pre-selection",
        "organisation": "Your organisation's default",
        "none": "No brand kit"
      },
      "scope": {
        "user": "Only me",
        "client": "My organisation",
        "global": "Everyone"
      },
      "create": "New brand kit",
      "createTitle": "New brand kit",
      "nameLabel": "Name",
      "namePlaceholder": "e.g. Corporate",
      "descriptionLabel": "Description",
      "scopeLabel": "Visibility",
      "empty": "No brand kit yet.",
      "emptyHint": "Create one – from a template or put together yourself.",
      "defaultBadge": "Default",
      "disabledBadge": "Disabled",
      "assembledBadge": "Assembled automatically",
      "makeDefault": "Pre-select for everyone",
      "clearDefault": "Stop pre-selecting it",
      "colors": "Colours",
      "fonts": "Fonts",
      "logos": "Logos",
      "noColors": "No colours set yet.",
      "colorIncomplete": "Incomplete: {{roles}}. A colour needs 3 or 6 digits — otherwise the role is not saved.",
      "noLogos": "No logo yet.",
      "role": {
        "ink": "Text",
        "surface": "Background",
        "primary": "Primary",
        "secondary": "Secondary",
        "accent": "Accent",
        "display": "Headings",
        "body": "Body"
      },
      "assetKind": {
        "logo_light": "Logo (light background)",
        "logo_dark": "Logo (dark background)",
        "logo_mono": "Logo (single colour)",
        "mark": "Picture mark"
      },
      "uploadTemplate": "Upload template",
      "downloadTemplate": "Download template",
      "publish": "Publish",
      "publishTitle": "Publish brand kit",
      "publishHint": "Who should be able to use this brand kit?",
      "duplicate": "Duplicate",
      "copySuffix": "{{name}} (copy)",
      "delete": "Delete brand kit",
      "deleteConfirm": "\"{{name}}\" will be deleted. Its colours, fonts and logos go with it.",
      "deleteBlocked": "This brand kit still holds templates. Move or delete them first.",
      "divergenceTitle": "Differs from the template",
      "divergenceHint": "This template carries different values than the kit. The file stays the source of truth for Word and PowerPoint — nothing is changed here automatically.",
      "blocked": {
        "current": "Already this visibility.",
        "uploaderOnly": "Only the person who created the kit can withdraw it."
      },
      "replaceTemplate": "Replace template",
      "slotEmpty": {
        "docx": "No Word template yet",
        "pptx": "No PowerPoint template yet"
      },
      "slotHint": "A kit holds one template per format. Uploading replaces the current one.",
      "edit": "Edit",
      "editTitle": "Edit brand kit",
      "editHint": "Name, description and whether the kit can be used. Visibility is changed under \"Publish\".",
      "enabledLabel": "Usable",
      "enabledHint": "A disabled kit appears for nobody in the chat but is kept here.",
      "fontHint": "These font files are embedded in the document.",
      "deleteTemplate": "Remove template",
      "deleteTemplateConfirm": "Remove this template? The file is deleted — download it first if you still need it.",
      "disableTemplate": "Disable template",
      "moveTemplate": "Move to another kit",
      "moveTemplateTitle": "Move “{{name}}”",
      "moveTemplateHint": "Pick the kit the template should move into. Kits whose slot for this format is taken cannot be picked.",
      "enableTemplate": "Enable template",
      "disabledHint": "A disabled template is kept but no longer used. Documents of that format are then produced with the kit colours alone.",
      "imageStyle": "Image style",
      "imageStylePlaceholder": "e.g. flat vector illustration, generous whitespace, no gradients",
      "imageStyleHint": "Appended to every image request along with the kit's colours. A request that names its own style takes precedence.",
      "deleteTitle": "Delete brand kit",
      "deleteBlocked_one": "This kit still holds one template. Move or delete it first — deleting the kit would leave its file orphaned in storage.",
      "deleteBlocked_other": "This kit still holds {{count}} templates. Move or delete them first — deleting the kit would leave their files orphaned in storage.",
      "htmlStyle": "Page style",
      "htmlStylePlaceholder": "e.g. generous whitespace, no drop shadows, quiet typography",
      "htmlStyleHint": "Given to the model for generated HTML pages. Colours and fonts land in the page regardless — this is the part a palette cannot express.",
      "saving": "Saving …",
      "saved": "Saved",
      "notSaved": "Not saved – please check your input.",
      "createHint": "Where does your brand come from? Take it from a template or put it together yourself – both can be changed afterwards.",
      "createMode": {
        "template": {
          "title": "Take it from a template",
          "hint": "Upload a PowerPoint or Word template. Colours, fonts and logo are read from it."
        },
        "compose": {
          "title": "Put it together yourself",
          "hint": "Pick a colour palette, fonts and style from suggestions. Takes a minute."
        }
      },
      "createFromTemplateHint": ".pptx, .potx, .docx or .dotx. The template is then used for that format.",
      "palette": {
        "navyOrange": "Navy & orange",
        "petrol": "Petrol",
        "forest": "Forest green",
        "signal": "Signal red",
        "violet": "Violet",
        "graphite": "Graphite"
      },
      "roleHint": {
        "ink": "Text, dark slides",
        "surface": "light areas",
        "primary": "Accents, charts",
        "secondary": "second chart series",
        "accent": "Highlights"
      },
      "contrast": {
        "good": "Reads well: primary on background {{ratio}} : 1. On dark slides the accent is lightened automatically where needed.",
        "primary": "Primary is weak on a light background ({{ratio}} : 1). For text it is darkened automatically – areas stay as chosen.",
        "text": "Text and background are too close ({{ratio}} : 1). Documents then use neutral text and background colours."
      },
      "fontPair": {
        "clear": "Clear",
        "office": "Office default",
        "serious": "Serious",
        "classic": "Classic",
        "technical": "Technical",
        "elegant": "Elegant",
        "own": "From the template"
      },
      "fontPairHint": "Only fonts that come with Microsoft Office – so the document looks the same on every computer.",
      "imagePreset": {
        "photo": {
          "name": "Photo, realistic",
          "text": "Realistic photography, natural light, real people and places, calm composition"
        },
        "flat": {
          "name": "Flat illustration",
          "text": "Flat vector illustration, clean shapes, plenty of white space, no gradients"
        },
        "isometric": {
          "name": "Isometric 3D",
          "text": "Isometric 3D illustration, soft lighting, clean edges, reduced detail"
        },
        "line": {
          "name": "Line art",
          "text": "Fine line drawing, single-colour strokes on a light background, sparing accents"
        },
        "abstract": {
          "name": "Abstract",
          "text": "Abstract geometric shapes, areas of colour, no text in the image"
        }
      },
      "pagePreset": {
        "airy": {
          "name": "Calm & airy",
          "hint": "plenty of white space, little colour",
          "text": "Plenty of white space, calm typography, colour only as an accent, no drop shadows"
        },
        "bold": {
          "name": "Bold & colourful",
          "hint": "large titles, colour blocks",
          "text": "Large, bold headings, coloured areas and sections, strong contrast"
        },
        "compact": {
          "name": "Compact & factual",
          "hint": "denser, for reports",
          "text": "Compact, factual layout, dense information, tables and a clear structure"
        }
      },
      "ownText": "Own text – editable under “Advanced”.",
      "logo": "Logo",
      "advanced": "Advanced",
      "exactColors": "Exact colour values",
      "imageStyleText": "Image style as text",
      "htmlStyleText": "Page style as text",
      "logoVariants": "More logo variants",
      "fontFiles": "Font files",
      "preview": {
        "heading": "Preview",
        "eyebrow": "Portfolio 2026",
        "title": "Our key message at a glance",
        "section": "Results",
        "contentTitle": "What has changed",
        "kpi": "shorter lead time",
        "withTemplate": "PowerPoint uses the uploaded template. The preview shows the kit colours for everything else.",
        "withoutTemplate": "This is how decks look without their own template: CDB example slides in your colours, fonts and logo."
      },
      "templatesOptional": "Templates (optional)",
      "templatesHint": "Without a template, Word and PowerPoint still come out in the kit's colours, fonts and logo.",
      "target": {
        "noKits": "There is no kit you can edit yet. Create a brand kit first.",
        "loadingKits": "Checking kits …",
        "slotTaken": "Already has a {{format}} template."
      },
      "createQuestion": "Where does your brand come from?",
      "createLead": "A brand kit makes Word, PowerPoint, Excel, HTML pages and images yours. You can change everything later – start wherever is quickest.",
      "createDrop": "Drop a .pptx, .potx, .docx or .dotx here",
      "createDropPick": "or choose a file",
      "createDropReplace": "Choose another file",
      "createDropRejected": "This file is not a PowerPoint or Word template (.pptx, .potx, .docx, .dotx).",
      "createRecommended": "Recommended if there is a company template",
      "createSameEditor": "Both ways end in the same editor. Whatever the template already provides – colours, fonts, logo – is filled in there.",
      "releasePending": "Release pending",
      "sampleWorkbook": {
        "title": "Excel",
        "hint": "Workbooks from the chat take the kit's colours, fonts and logo – no template needed. The logo sits beside the overview's title and in the print header.",
        "show": "Show sample workbook",
        "hide": "Hide sample workbook",
        "download": "Download sample workbook",
        "failed": "The sample workbook could not be created.",
        "headerLogoHint": "Only Excel shows the logo in the print header, not this preview."
      }
    },
    "routines": {
      "button": "Routines",
      "title": "Routines",
      "new": "New routine",
      "empty": "Routines run recurring prompts automatically on a schedule.",
      "createFirst": "Create your first routine",
      "active": "Active",
      "paused": "Paused",
      "pause": "Pause routine",
      "resume": "Activate routine",
      "nextRun": "next run",
      "runNow": "Run now",
      "runStarted": "Routine is running …",
      "openConversation": "Open conversation",
      "edit": "Edit",
      "delete": "Delete",
      "history": "History",
      "noRuns": "No runs yet.",
      "deleteConfirmTitle": "Delete routine?",
      "deleteConfirm": "Really delete {{name}}? Its history will be lost.",
      "status": {
        "running": "running",
        "completed": "completed",
        "failed": "failed"
      },
      "trigger": {
        "cron": "scheduled",
        "manual": "manual"
      },
      "errors": {
        "saveFailed": "Could not save the routine.",
        "runFailed": "Could not start the routine.",
        "deleteFailed": "Could not delete the routine.",
        "loadFailed": "Could not load routines."
      },
      "picker": {
        "title": "New routine",
        "blank": "From scratch",
        "blankHint": "Empty form – you build the routine yourself."
      },
      "form": {
        "createTitle": "New routine",
        "editTitle": "Edit routine",
        "name": "Name",
        "namePlaceholder": "e.g. Daily summary",
        "description": "Description",
        "descriptionPlaceholder": "What is this routine for?",
        "prompt": "Instruction",
        "promptPlaceholder": "What should the routine do on each run?",
        "promptHint": "Placeholders like {date}, {weekday_en} or {week_en} are filled in on each run.",
        "promptCounter": "{{chars}} / {{max}} characters",
        "promptTooLong": "{{over}} characters over the limit of {{max}}. Shorten the instruction before saving.",
        "schedule": "Schedule",
        "sources": "Sources",
        "model": "Model",
        "enabled": "Enabled",
        "cancel": "Cancel",
        "save": "Save"
      },
      "schedule": {
        "freq": {
          "manual": "Manual",
          "hourly": "Hourly",
          "daily": "Daily",
          "weekly": "Weekly",
          "monthly": "Monthly",
          "custom": "Custom"
        },
        "hour": "Hour",
        "minute": "Minute",
        "dayOfMonth": "Day of month",
        "berlinTime": "Berlin time",
        "weekday": {
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat",
          "sun": "Sun"
        },
        "customEmpty": "Please enter a cron expression."
      },
      "retry": "Retry",
      "wizard": {
        "basics": "Basics",
        "task": "Task",
        "schedule": "Schedule",
        "options": "Options",
        "back": "Back",
        "next": "Next",
        "create": "Create routine",
        "summarySchedule": "Runs automatically on schedule.",
        "summaryManual": "No schedule — manual start only."
      }
    },
    "timeline": {
      "understand": "Understand the request",
      "compose": "Composing the answer",
      "composeDone": "Answer composed",
      "detailsHint": "Show details",
      "tool": {
        "graph": "Query the knowledge graph",
        "facts": "Check verified facts",
        "script": "Run a script",
        "image": "Generate an image",
        "document": "Create a document",
        "search": "Search knowledge",
        "searchDocuments": "Search documents",
        "getDocumentContent": "Read document content",
        "findFiles": "Find files",
        "queryStructured": "Query structured data",
        "editDocument": "Edit the document",
        "createHtml": "Create an HTML page",
        "editHtml": "Edit the HTML page",
        "createBpmn": "Create a BPMN diagram",
        "editBpmn": "Edit the BPMN diagram",
        "editImage": "Edit the image",
        "readAttachment": "Read the attachment",
        "readChatFile": "Read the chat file",
        "enrichExcel": "Enrich Excel data",
        "ingestDocument": "Ingest a document",
        "ingestFromUrl": "Ingest content from a URL",
        "ingestResult": "Check the ingest",
        "listClients": "List organisations",
        "listKnowledgeAreas": "List knowledge areas",
        "readDocument": "Read the document",
        "renameDocument": "Rename the file",
        "dataSource": "Query a data source",
        "dataSourceNamed": "Query {{source}}",
        "generic": "Run a tool",
        "outlookSearch": "Search Outlook",
        "outlookRead": "Read e-mail",
        "outlookDraft": "Create Outlook draft",
        "outlookReadAttachment": "Read Outlook attachment",
        "outlookSaveAttachment": "Save attachment to My Documents",
        "calendarList": "Check calendar",
        "calendarRead": "Read appointment",
        "calendarFreeTime": "Find free time",
        "calendarCreate": "Create appointment",
        "calendarUpdate": "Change appointment",
        "calendarCancel": "Cancel appointment",
        "calendarCalendars": "List calendars",
        "calendarRespond": "Answer invitation",
        "peopleFind": "Find person",
        "peopleRead": "Look up person",
        "documentDocx": "Create a Word document",
        "documentPptx": "Create a presentation",
        "documentXlsx": "Create an Excel spreadsheet",
        "createInteractive": "Create an interactive view",
        "editInteractive": "Edit the interactive view"
      },
      "toolRunning": {
        "document": "Creating the document",
        "documentDocx": "Creating the Word document",
        "documentPptx": "Creating the presentation",
        "documentXlsx": "Creating the Excel spreadsheet",
        "editDocument": "Editing the document",
        "createHtml": "Creating the HTML page",
        "editHtml": "Editing the HTML page",
        "createInteractive": "Creating the interactive view",
        "editInteractive": "Editing the interactive view",
        "createBpmn": "Creating the BPMN diagram",
        "editBpmn": "Editing the BPMN diagram",
        "image": "Generating the image",
        "editImage": "Editing the image"
      },
      "workflow": {
        "run": "Run workflow",
        "runNamed": "Workflow “{{name}}”",
        "paused": "Workflow waits for your confirmation",
        "pausedNamed": "Workflow “{{name}}” waits for your confirmation",
        "needsConnection": "Workflow needs Microsoft 365",
        "needsConnectionNamed": "Workflow “{{name}}” needs Microsoft 365",
        "stepStatus": {
          "ok": "done",
          "skipped": "skipped",
          "warning": "with a notice",
          "failed": "failed",
          "asked": "question"
        },
        "write": {
          "simulated": "{{label}}: simulated in the test, nothing created",
          "created": "{{label}}{{key}} created",
          "createdLines": "{{label}}{{key}} created, {{n}} lines",
          "partial": "{{label}}{{key}} created, {{done}} of {{n}} lines – the rest not created",
          "lineUnknown": "{{label}}{{key}} created, {{done}} of {{n}} lines – unclear whether one line was created",
          "appended": "{{label}}{{key}}: {{done}} lines appended",
          "appendedPartial": "{{label}}{{key}}: {{done}} of {{n}} lines appended – the rest not created",
          "appendedUnknown": "{{label}}{{key}}: {{done}} of {{n}} lines appended – unclear whether one line was created",
          "unknown": "{{label}}: unclear whether created – check the source",
          "asked": "{{label}}: waiting for confirmation",
          "skipped": "{{label}}: skipped",
          "notCreated": "{{label}}: not created"
        }
      }
    },
    "research": {
      "save": "Save as document",
      "saveHint": "File this research run, with its source list, as a Markdown document in your Drive",
      "saved": "Research saved",
      "saveError": "Could not save the research document"
    },
    "quota": {
      "request": "Request more quota",
      "submit": "Send request",
      "messagePlaceholder": "What do you need the quota for? (optional)",
      "pending": "Your request was sent and is waiting for approval.",
      "pendingEscalated": "Your request is with the admins — the client budget needs raising.",
      "clientBlocked": "Your organisation's budget is exhausted. The request goes to the admins."
    },
    "voice": {
      "dictate": "Dictate — the text lands in the input field",
      "speakAndSend": "Speak and send straight away"
    },
    "clarification": {
      "pick": "Pick an answer:",
      "reply": "I mean: {{label}}",
      "replyMany": "I mean: {{labels}}",
      "sendAnswers": "Send answers ({{n}}/{{total}})",
      "allow": "Yes, go ahead.",
      "deny": "No, please don't."
    },
    "workflows": {
      "button": "Workflows",
      "title": "Workflows",
      "subtitle": "Fixed step chains over connected systems – one tool each in the chat.",
      "new": "New workflow",
      "empty": "No workflows yet. A workflow looks up customers, checks rules and builds a proposal from them – deterministically, as one tool in the chat.",
      "createFirst": "Create the first workflow",
      "edit": "Edit",
      "view": "View",
      "publish": "Publish",
      "startInChat": "Start in chat",
      "startSentence": "Start the workflow \"{{name}}\": ",
      "confirmDelete": "Really delete workflow \"{{name}}\"?",
      "readOnly": "read-only",
      "disabled": "disabled",
      "scope": {
        "user": "Only me",
        "client": "My organisation",
        "global": "All organisations"
      },
      "status": {
        "draft": "Draft",
        "active": "Active"
      },
      "types": {
        "lookup": "Lookup",
        "check": "Check",
        "map": "Mapping",
        "ask": "Question",
        "present": "Present",
        "compute": "Calculation",
        "route": "Decision",
        "each": "For each position",
        "retrieve": "Retrieve knowledge",
        "artifact": "Create document",
        "connector": "Microsoft 365",
        "write": "Create in source"
      },
      "severity": {
        "hard": "hard",
        "soft": "soft"
      },
      "ops": {
        "eq": "equals",
        "ne": "differs from",
        "in": "is in",
        "not_in": "is not in",
        "gt": ">",
        "gte": "≥",
        "lt": "<",
        "lte": "≤",
        "contains": "contains",
        "not_contains": "does not contain",
        "starts_with": "starts with",
        "ends_with": "ends with",
        "matches": "matches pattern",
        "empty": "is empty",
        "not_empty": "is not empty",
        "truthy": "is true",
        "falsy": "is false"
      },
      "toasts": {
        "saved": "Saved",
        "createFailed": "Create failed",
        "deleteFailed": "Delete failed",
        "moved": "Visibility changed",
        "moveFailed": "Visibility could not be changed"
      },
      "versions": {
        "hint": "Every saved change to the steps or inputs is a version. Restoring creates the old state as a new version – nothing is lost.",
        "dirtyHint": "Save or discard your changes first, then restore.",
        "empty": "No versions stored yet.",
        "current": "current",
        "steps": "{{count}} steps",
        "view": "View",
        "restore": "Restore",
        "restoredFrom": "Restored from version {{version}}",
        "confirmRestore": "Restore version {{version}}? It is created as a new version; the current one stays in the list.",
        "restored": "Version {{version}} restored – now v{{now}}.",
        "restoreFailed": "Restore failed",
        "loadFailed": "Versions could not be loaded."
      },
      "builder": {
        "tabBuilder": "Builder",
        "tabTest": "Test",
        "tabRuns": "Runs",
        "whenPrefix": "when",
        "patternPlaceholder": "regular expression, e.g. ^MAGDOS",
        "listPlaceholder": "list, e.g. [\"A\", \"B\"]",
        "pickVariable": "Insert variable",
        "variablesInputs": "Inputs",
        "variablesNow": "Time",
        "variablesNone": "No variables before this step.",
        "variablesRowAny": "any column – name the columns in “columns” and they show up here",
        "inputs": "Inputs",
        "noInputs": "no inputs declared",
        "inputsHint": "What the model has to supply from the user's request. Becomes the tool's parameter schema.",
        "inputDescription": "Description for the model",
        "required": "Required",
        "addInput": "Add input",
        "conditional": "conditional",
        "unsaved": "unsaved",
        "addStep": "Add step",
        "addAfter": "Insert after the selected step",
        "emptyInspector": "Select a step on the canvas to edit it.",
        "emptyInspectorHint": "The start node holds the inputs. The order of the chain is the order of execution.",
        "stepId": "Step id",
        "stepIdHint": "Used in expressions: steps.<id>.row.<field>",
        "label": "Label",
        "title": "Section title",
        "when": "Run only if (condition)",
        "valuePlaceholder": "Value",
        "source": "Source",
        "sourceHint": "Name of the router source",
        "operation": "Operation",
        "table": "Table",
        "term": "Search term",
        "filters": "Filters",
        "addFilter": "Add filter",
        "columns": "Columns",
        "attempts": "Search paths",
        "attemptsHint": "The first search path that finds rows counts – later steps read the same row.",
        "eachBlock": "for each position · {{label}}",
        "eachItems": "List",
        "eachItemsHint": "Path to the list, e.g. inputs.positionen.",
        "eachAs": "Element name",
        "eachAsHint": "Referenced in the block as pos.field.",
        "eachSteps": "Steps in the block",
        "eachStepsHint": "That many steps directly below run per position – lookup, check, map and compute are allowed.",
        "eachItemLabel": "Position name",
        "eachItemLabelHint": "How a position is named in questions and in the table.",
        "eachMax": "At most positions",
        "arrayFields": "Fields per element (pos.<field> in the block):",
        "routeHint": "The first branch whose condition holds runs; the others are skipped. Each branch consists of the next steps below, branch by branch, “otherwise” last.",
        "branchLabel": "Branch",
        "branchId": "ID",
        "branchSteps": "Steps",
        "branchWhen": "When",
        "addBranch": "Add branch",
        "defaultLabel": "Otherwise",
        "defaultHint": "Runs when no branch holds.",
        "defaultPlaceholder": "otherwise",
        "tabVersions": "Versions",
        "columnsHint": "Comma-separated. Without them the source returns only default columns – checks on missing columns abort.",
        "limit": "Row limit",
        "expect": "Expectation",
        "expectOne": "exactly one row",
        "expectMany": "list",
        "onMany": "On several matches",
        "onManyAsk": "ask the user",
        "onManyFirst": "take the first (note)",
        "onManyFail": "abort",
        "key": "Key column",
        "keyHint": "Value of a question option",
        "display": "Display columns",
        "askPrompt": "Question text (optional)",
        "optional": "Optional",
        "optionalHint": "No match or a source error is then not an abort.",
        "assert": "Condition that must hold",
        "severityLabel": "Severity",
        "message": "Message on violation",
        "messageHint": "Template, e.g. Customer {{steps.debitor.row.name}} is blocked.",
        "fields": "Fields",
        "addField": "Add field",
        "literal": "fixed value",
        "origin": "Origin",
        "note": "Note",
        "prompt": "Question to the user",
        "optionsFrom": "Options from (expression)",
        "optionsFromHint": "e.g. steps.artikel.rows – empty = free text",
        "optionValue": "Value column",
        "optionLabel": "Display columns",
        "sections": "Sections (mappings)",
        "noMapSteps": "No mapping in the chain yet.",
        "summary": "Summary",
        "summaryHint": "First sentence of the result; template with {{…}}.",
        "moveUp": "move up",
        "moveDown": "move down",
        "testUnsaved": "The test runs with the saved state – save first.",
        "invalidJson": "Not valid JSON with definition.steps.",
        "applyJson": "Apply JSON",
        "applyJsonHint": "Applies to the builder; remember to save.",
        "expression": "Calculation",
        "expressionHint": "Paths and numbers with + − × / and parentheses, e.g. inputs.minutes * inputs.devices / 60. ?? supplies a fallback: inputs.rate ?? steps.bench.row.rate_eur. The result is available as steps.<id>.value.",
        "round": "Decimal places",
        "roundHint": "Empty = unrounded, 0 = whole number.",
        "knowledgeAreas": "Knowledge areas",
        "knowledgeAreasHint": "Each area is searched on its own, with the permissions of whoever uses the workflow. Someone who cannot read an area gets a notice, never a search in other areas.",
        "addKnowledgeArea": "Add area",
        "strategies": "Searches",
        "strategiesHint": "Run in every area. The graph returns automatically extracted, unreviewed entries; the fact search only verified ones.",
        "strategy": {
          "vector": "Documents",
          "graph": "Knowledge graph (all entries)",
          "facts": "Verified facts"
        },
        "query": "Search query",
        "queryHint": "Fix what is always searched for; an optional input lets the user's request steer part of it, e.g. {{inputs.focus ?? \"\"}}. Whether \"nothing found\" aborts the run is decided by a check on steps.<id>.count.",
        "topK": "Passages",
        "topKHint": "Per search and area.",
        "maxChars": "Characters per passage",
        "instructions": "Writing instruction",
        "instructionsHint": "How the model turns the result into text (e.g. the fields of a card). Replaces the default \"two or three sentences, then ask\"; the model is still told the tables are already shown.",
        "triggers": "Trigger phrases",
        "triggersHint": "One phrase per line, e.g. \"Pain Card\". When a message contains one, the model is told this workflow is likely relevant. A hint, not a forced start — that stays with \"Start in chat\".",
        "triggersPlaceholder": "Pain Card\nCost of inaction",
        "userStated": "Only as stated by the user",
        "userStatedHint": "If the model fills in a number or a date here that does not occur in the user's messages, the value is dropped and the stored assumption applies. Other text is not checked.",
        "requestKey": "Identifies the request",
        "requestKeyHint": "For example the customer. If a follow-up message names another value here, a new proposal starts. If it changes other details, confirmed and corrected values are kept. Without a mark, any change to a detail already given starts over.",
        "artifactFormat": "Format",
        "artifactFormats": {
          "docx": "Word (docx)",
          "pptx": "PowerPoint (pptx)",
          "xlsx": "Excel (xlsx)"
        },
        "artifactModel": "Model",
        "artifactModelHint": "Empty = the chat's model.",
        "artifactFilename": "File name",
        "artifactFilenameHint": "Without extension. When the workflow runs again in the same chat, this file gets a new version.",
        "artifactInstructions": "What goes into the document",
        "artifactInstructionsHint": "Content and structure. The model writes the document in the chat from this instruction and the chosen results while the answer is already streaming. It takes numbers from the results; a number that does not occur there is shown below the file.",
        "artifactContext": "Results for the document",
        "artifactContextHint": "No selection = all results before this step.",
        "artifactNoContext": "There are no results before this step yet.",
        "artifactOutline": "Outline (optional)",
        "artifactOutlineHint": "One heading, slide or sheet per line, in this order. Empty = the model decides.",
        "assistant": "AI assistant",
        "addStepShort": "Step",
        "drop": {
          "mainChain": "Main chain",
          "intoBlock": "into “{{name}}”",
          "intoBranch": "into branch “{{name}}”",
          "refusal": {
            "block_type": "A “For each position” block holds only lookup, check, mapping and computation.",
            "branch_type": "A branch holds lookup, check, mapping, computation, question and knowledge retrieval.",
            "artifact_order": "A document step has to come after the steps it reads."
          }
        },
        "zoomToSelection": "Zoom to selection",
        "confirm": "Confirmed by the user",
        "confirmHint": "The computed value is only a suggestion; the user confirms or changes it in the chat before the proposal is done.",
        "confirmOptions": "Choices",
        "confirmFreeText": "Free text (no list)",
        "confirmValueColumn": "Column holding the value",
        "confirmLabelColumns": "Display columns, comma-separated",
        "confirmNoLists": "A list comes from a lookup step that returns several rows (result: many).",
        "confirmWhen": "Only ask for confirmation when",
        "toAttempts": "Add another search path",
        "fromAttempts": "Keep only the first search path",
        "addAttempt": "Add search path",
        "attemptWhen": "Only try when",
        "attemptLabelPlaceholder": "Label, e.g. item number",
        "orderBy": "Sort order",
        "orderAsc": "ascending",
        "orderDesc": "descending",
        "addOrder": "Add sort order",
        "addElementField": "Add field",
        "tabSettings": "Settings",
        "writeField": "Write to the source",
        "writeFieldHint": "A write step sends this field to the source; empty values are left out.",
        "writeHint": "Creates a record (POST), only after the person clicked “Allow” in the chat. It sends the fields of the map that are set to “Write to the source”.",
        "writeOperation": "Operation (create)",
        "writeOperationHint": "The source’s POST endpoint; every field sent must be declared there as a body parameter.",
        "writeMap": "Record from map",
        "writeMapHint": "A map outside a positions block, before this step.",
        "writeKey": "Key field of the answer",
        "writeKeyHint": "The field naming the created record, e.g. “No” – readable as steps.<id>.key. It must be in the endpoint’s response whitelist.",
        "writeLines": "With lines",
        "writeLinesHint": "One line per position of a positions block, created after the header.",
        "writeLinesEach": "Positions block",
        "writeLinesMap": "Line from map",
        "writeLinkField": "Line link field",
        "writeLinkFieldHint": "Gets the header’s key, e.g. “Document_No”.",
        "writeLinkFrom": "from header field",
        "writeLinkFromHint": "The field of the header’s answer holding the key, e.g. “No”."
      },
      "assist": {
        "title": "AI assistant",
        "subtitle": "Ask, explain, propose changes",
        "intro": "Ask me about this workflow – what a step does, why a test fails, what could be improved. I look things up in the workflow's sources when needed. I only change something when you want me to: you get a proposal and decide.",
        "ephemeral": "The conversation is not stored and ends when you close the builder.",
        "suggestExplain": "Explain the workflow",
        "suggestLastRun": "Why did the last test turn out like that?",
        "suggestImprove": "What could be improved?",
        "placeholder": "Question or change request …",
        "hint": "Enter sends, Shift+Enter adds a line.",
        "withRun": "The last test from the Test tab is included.",
        "send": "Send",
        "stop": "Stop",
        "reset": "New conversation",
        "proposing": "Preparing a proposal – this can take a minute …",
        "lookingUp": "Looking it up ({{tool}}) …",
        "unavailable": "The assistant is not available on this server yet.",
        "proposal": "Proposal",
        "apply": "Apply",
        "applyAnyway": "Apply anyway",
        "discard": "Discard",
        "applied": "Applied – not saved yet.",
        "discarded": "Discarded.",
        "stale": "You changed the workflow since the proposal was requested. Applying overwrites those changes.",
        "kind": {
          "added": "new",
          "changed": "changed",
          "removed": "removed"
        },
        "fields": "fields: {{fields}}",
        "moved": "moved from {{from}} to {{to}}",
        "mainChain": "main chain",
        "inputsAdded": "new {{names}}",
        "inputsRemoved": "removed {{names}}",
        "inputsChanged": "changed {{names}}",
        "triggers": "Triggers",
        "order": "Order of the steps",
        "identity": "Name/description ({{fields}})",
        "unrequested": "Not asked for – please check before applying:"
      },
      "connector": {
        "area": "Area",
        "action": "Action",
        "tools": {
          "outlook": "Mail",
          "calendar": "Calendar",
          "people": "People"
        },
        "actions": {
          "outlook": {
            "search": "Search mail",
            "read": "Read mail",
            "create_draft": "Create draft"
          },
          "calendar": {
            "list": "List appointments",
            "free_time": "Find free time",
            "create": "Create appointment"
          },
          "people": {
            "find": "Find person"
          }
        },
        "confirmBadge": "Confirmation in chat",
        "confirmHint": "Before this step creates anything, the chat asks “Allow / Don't allow”. In a test run it is only simulated.",
        "unknownAction": "This action does not exist (any more). Pick another one.",
        "mailbox": "Mailbox",
        "mailboxMode": {
          "own": "Own mailbox",
          "address": "Fixed address",
          "variable": "From a variable"
        },
        "mailboxHint": {
          "own": "The mailbox of the person who starts the workflow.",
          "address": "A shared mailbox. Whoever uses the workflow must have added it under “Connected accounts”.",
          "variable": "For example an input; empty or “me” means the own mailbox."
        },
        "args": {
          "query": "Search text",
          "sender": "Sender",
          "since": "Since (YYYY-MM-DD)",
          "until": "Until (YYYY-MM-DD)",
          "unread_only": "Unread only",
          "folder": "Folder",
          "limit": "At most",
          "thread_id": "Conversation",
          "message_id": "Mail id",
          "body": "Text",
          "mode": "Kind",
          "reply_to_id": "Reply to (mail id)",
          "to": "To",
          "cc": "Cc",
          "subject": "Subject",
          "start": "Start",
          "end": "End",
          "minutes": "Duration (minutes)",
          "working_hours_only": "Working hours only",
          "attendees": "Attendees",
          "calendar_id": "Calendar",
          "location": "Location",
          "show_as": "Show as",
          "online_meeting": "Teams meeting",
          "all_day": "All day"
        },
        "default": "Default",
        "listPlaceholder": "a@company.com, b@company.com or {{…}}",
        "optional": "Errors only as a notice",
        "optionalHint": "If Microsoft 365 is not connected or does not answer, the workflow goes on with an empty result.",
        "simulated": "Simulated",
        "simulatedHint": "Writing Microsoft 365 steps are only simulated in a test run: no draft and no appointment is created. Reading steps run with your own account."
      },
      "connection": {
        "connectTo": "Connect {{what}} in Microsoft 365 to use this workflow.",
        "and": " and ",
        "mailbox": "the shared mailbox {{address}}",
        "notEnabled": "This workflow uses Microsoft 365, which is not enabled for your organisation.",
        "generic": "This workflow needs a connection to Microsoft 365.",
        "open": "Open connected accounts",
        "listHint": "Connect {{what}} to use this workflow"
      }
    },
    "roomQuestion": {
      "seed": "Question for the room “{{room}}”:"
    },
    "writeRecords": {
      "title": "Create “{{label}}” in {{source}}",
      "appendTitle": "Append to “{{label}}” {{record}} in {{source}}",
      "appendNote": "{{record}} already exists – only the missing lines are sent.",
      "lines_one": "{{count}} line",
      "lines_other": "{{count}} lines",
      "more_one": "… and {{count}} more line",
      "more_other": "… and {{count}} more lines"
    }
  },
  "sharedChat": {
    "extractedImage": "Extracted image from document",
    "openDocument": "Open document",
    "filter": {
      "loading": "Loading knowledge areas...",
      "noAreas": "No knowledge areas",
      "noAreasAvailable": "No knowledge areas available",
      "selectArea": "Select knowledge area",
      "selectMultiple": "Select knowledge areas"
    },
    "sources": {
      "aiGenerated": "AI-written",
      "aiGeneratedHint": "This document was written by the system (e.g. a saved research run) and is not a primary source.",
      "graph": {
        "documentsHeading": "Documents",
        "entitiesHeading": "Entities",
        "entityFallback": "Entity",
        "factFallback": "Graph fact",
        "factsHeading": "Facts",
        "heading": "Graph sources",
        "relevanceTooltip": "Relevance"
      },
      "image": "Image",
      "status": {
        "open": "open",
        "rejected": "rejected",
        "updated": "updated",
        "verified": "verified",
        "outdated": "outdated"
      },
      "untitled": "Untitled source",
      "relevance": "{{value}}% relevance",
      "chunk": "Chunk {{index}}",
      "loadingFullText": "Loading full text…",
      "chunkUnavailable": "The chunk content could not be loaded.",
      "chunkLoadError": "Error loading the full text.",
      "summaryLabel": "AI key statement",
      "summaryHint": "Derived from the image by AI, not verbatim in the image.",
      "review": {
        "corrected": "corrected",
        "automatic": "confirmed automatically",
        "automaticHint": "Marked as confirmed automatically on upload, not checked by a person."
      },
      "derivation": {
        "ocr": "Text recognition (scan)",
        "transcript": "Machine transcript",
        "image": "Image AI-described",
        "video": "Machine-made from video",
        "hint": "This text was made by a machine, not written by a person."
      },
      "olderVersion": "Older version",
      "olderVersionHint": "This passage comes from an older version of the document.",
      "contested": "Open contradiction",
      "contestedHint": "A statement of this document contradicts a checked one; the review is still open.",
      "sourceFlagged": "Marked as wrong",
      "sourceFlaggedHint": "Experts marked a statement of this document as wrong.",
      "archivedVersion": "Archived version",
      "archivedVersionHint": "This passage comes from a version of the document that has since been archived.",
      "openHint": "Open source"
    },
    "externalImage": "External image “{{name}}” not loaded"
  },
  "multimedia": {
    "checkingAccess": "Checking permissions...",
    "checkingAccessHint": "One moment please.",
    "title": "Multimedia Player",
    "mediaType": "Media Type",
    "all": "All",
    "audio": "Audio",
    "video": "Video",
    "playlist": "Playlist",
    "items": "files",
    "play": "Play",
    "pause": "Pause",
    "playing": "Playing",
    "selected": "Selected",
    "loading": "Loading...",
    "noMediaSelected": "No file selected",
    "selectFromPlaylist": "Select a file from the playlist",
    "noMediaFound": "No media files found",
    "errorLoadingMediaList": "Error loading media list",
    "errorLoadingMedia": "Error loading media",
    "errorPlaying": "Error playing media"
  },
  "knowledgeExtractor": {
    "title": "Knowledge Hub",
    "entityInfoReadonly": "Entity Info (read-only)",
    "previousNotes": "Previous notes:",
    "metadata": "Metadata",
    "created": "Created:",
    "updated": "Updated:",
    "noOutgoingRelations": "No outgoing relationships",
    "noIncomingRelations": "No incoming relationships",
    "noConnectedDocuments": "No connected documents",
    "knowledgeArea": "Knowledge Area:",
    "noKnowledgeArea": "No knowledge area selected",
    "openFromHub": "Please open this app via the Knowledge Hub.",
    "errorLoadingDocuments": "Error loading documents",
    "loading": "Loading...",
    "loaded": "Loaded",
    "noAccessibleAreas": "No accessible knowledge areas",
    "selectArea": "Select knowledge area",
    "document": "Document",
    "documents": "Documents",
    "searchPlaceholder": "Search by title or filename...",
    "uploadDocument": "Upload File",
    "filterAll": "All Status",
    "filterAllAreas": "All Areas",
    "filterCompleted": "Completed",
    "filterMine": "My uploads",
    "qaBrowserComingSoon": "Q&A Browser",
    "qaBrowserDescription": "This feature will be available soon.",
    "tabs": {
      "documentExtractor": "Document Extractor",
      "verifier": "Knowledge Verifier"
    },
    "verifier": {
      "title": "Knowledge Verifier",
      "description": "Verify and review extracted knowledge",
      "selectView": "Select view",
      "preview": {
        "toggle": "Show preview",
        "error": "Preview could not be loaded.",
        "show": "Show document",
        "hide": "Hide document"
      },
      "docFilter": {
        "all": "All",
        "empty": "No documents",
        "searchPlaceholder": "Search documents...",
        "selected": "Selected"
      },
      "documentOverview": {
        "title": "Documents for verification",
        "empty": "No documents for verification",
        "emptyDescription": "Once documents have been extracted, they will appear here with their verification progress.",
        "clickHint": "Click a document to review its concepts and statements.",
        "factsColumn": "Statements",
        "nodesColumn": "Concepts",
        "progressColumn": "Progress",
        "uploadDate": "Uploaded"
      },
      "nodeDetail": {
        "properties": "Properties",
        "nameLabel": "Concept",
        "summaryLabel": "Description"
      },
      "actions": {
        "verify": "Verify",
        "reject": "Reject",
        "edit": "Edit",
        "backToOverview": "Overview",
        "saveCorrection": "Save correction"
      },
      "facts": {
        "title": "Statements",
        "statusLabel": "Statements",
        "empty": "No statements for this concept.",
        "emptyFiltered": "No statements with this status.",
        "outgoing": "outgoing",
        "incoming": "incoming",
        "countsSummary": "{{v}} verified, {{r}} rejected, {{o}} to review",
        "jumpToNode": "Jump to this concept",
        "sourceDocument": "Source: {{title}}",
        "sourceUnavailable": "Source not available in this knowledge area",
        "toggleNode": "Expand concept",
        "linkedCount": "+{{count}} from other documents",
        "mentionedCount_one": "named in {{count}} statement",
        "mentionedCount_other": "named in {{count}} statements",
        "mentionedInStatements_one": "Named in {{count}} statement in this document.",
        "mentionedInStatements_other": "Named in {{count}} statements in this document.",
        "noneFromThisDocument": "Nothing said about this in this document.",
        "emptyConceptFilter": "No concept with this status.",
        "shownCounts": "{{concepts}} concepts · {{statements}} statements"
      },
      "views": {
        "qa": "Q&A",
        "facts": "Statements",
        "nodes": "Concepts",
        "blocks": "Blocks"
      },
      "status": {
        "editedMarker": "edited"
      },
      "overview": {
        "title": "To review",
        "summary": "{{open}} of {{total}} documents open",
        "done": "done",
        "back": "Overview",
        "columnDocument": "Document",
        "columnUploaded": "Uploaded"
      },
      "document": {
        "progress": "reviewed",
        "noStatements": "Nothing was extracted from this document."
      },
      "searchDocuments": "Search documents...",
      "searchStatements": "Search statements...",
      "graph": {
        "title": "Knowledge Graph",
        "toggle": "Show graph",
        "noNeighbors": "No connected concepts",
        "spacing": "Spacing",
        "usedHint": "Highlighted = used for the answer",
        "detail": {
          "centre": "Centre in graph"
        },
        "ownEdge": "from this document",
        "linkedEdge": "from another one",
        "fit": "Fit to view",
        "spacingPreset": {
          "compact": "Tight",
          "normal": "Medium",
          "spacious": "Wide"
        },
        "labelHint": "{{count}} concepts from other documents — names appear on zoom or hover",
        "hideOutside": "This document only",
        "showOutside": "Show {{count}} concepts outside",
        "budgetNote": "Too many concepts for a network view — showing the {{shown}} most connected of {{total}}."
      },
      "documents": {
        "empty": "No documents to review.",
        "emptySearch": "No document matches \"{{term}}\"."
      },
      "leftMode": {
        "document": "Document",
        "connections": "Connections",
        "review": "Step through"
      },
      "conceptStatusLabel": "Concepts",
      "review": {
        "empty": "Nothing to step through.",
        "done": "{{done}} of {{total}} reviewed",
        "aboutConcept": "About the concept",
        "findInDocument": "Find in document",
        "agenda": "Concepts",
        "kindConcept": "Concept",
        "kindStatement": "Statement",
        "keysStep": "move",
        "keysChapter": "change concept",
        "keysDecide": "verify · edit · reject",
        "back": "Back to the run",
        "cameFromHere": "Your spot",
        "cameFromHereTitle": "This is where you left the run"
      },
      "assignment": {
        "column": "Responsible",
        "unassigned": "Nobody assigned",
        "unknownUser": "Unknown person",
        "change": "Change who is responsible",
        "noCandidates": "Nobody has access to this knowledge area",
        "myTasks": "My tasks"
      },
      "tasks": {
        "title": "Suggestions ({{count}})",
        "kind": {
          "sameStatement": "Same statement?",
          "drift": "Number changed",
          "contested": "Contested",
          "missingInVersion": "Missing in new version",
          "sourcesConflict": "Conflict between sources",
          "passageConflict": "Conflicting passages",
          "other": "Suggestion"
        },
        "similarity": "{{value}} % similar",
        "later": "Later",
        "new": "New",
        "reviewed": "Reviewed",
        "incoming": "Newly extracted",
        "sameStatement": "Same statement",
        "verifyNew": "Verify new",
        "rejectNew": "Reject new",
        "laterAction": "Later",
        "dismiss": "No action needed",
        "onlyWithSuggestions": "With suggestions",
        "badge": "{{count}} suggestions",
        "contestedHint": "Another document states a different number.",
        "hint": {
          "sameStatement": "Newly extracted and similar to a reviewed statement. Is it the same one?",
          "drift": "This document now states a different value than the reviewed statement.",
          "contested": "Another document states a different value than the reviewed statement.",
          "missingInVersion": "This statement was reviewed and is no longer in the new version of the document. Does it still hold?",
          "sourcesConflict": "Two documents state different values and neither statement is reviewed. Which value holds?",
          "passageConflict": "Two documents state different values in these passages. Which one holds?",
          "other": "A case this view does not know yet. Please look again later."
        },
        "reviewedIn": "Reviewed · from {{document}}",
        "newApplies": "New value applies",
        "newAppliesHint": "The new statement is verified, the reviewed one is marked as outdated.",
        "oldApplies": "Previous value applies",
        "oldAppliesHint": "The new statement is rejected and its source marked as wrong.",
        "bothApply": "Both are true",
        "bothApplyHint": "Both are true, e.g. different variants or periods. The new statement is verified.",
        "suggested": "See suggestion",
        "suggestedHint": "There is a suggestion about this statement above.",
        "stillValid": "Still valid",
        "stillValidHint": "The statement stays reviewed, even without the new version as its source.",
        "markOutdated": "Outdated",
        "markOutdatedHint": "The statement held once and no longer does; it leaves the answers.",
        "markWrong": "Wrong",
        "markWrongHint": "The statement was never right; it is rejected.",
        "fromDocument": "From {{document}}",
        "unknownDocument": "document",
        "valueApplies": "Value from {{document}} holds",
        "valueAppliesHint": "This statement is verified, the other one rejected and its source marked as wrong.",
        "bothApplySourcesHint": "Both hold, e.g. different variants or periods. Both statements are verified.",
        "aiReason": "AI assessment: {{reason}}",
        "valueAppliesPassageHint": "The other passage is marked as wrong. Answers drawing on its document point this out.",
        "bothApplyPassageHint": "Both hold, e.g. different variants or conditions. Nothing is marked."
      },
      "sourceDeleted": {
        "open": "Source deleted",
        "title": "Reviewed, source deleted",
        "hint": "These statements were reviewed and kept when their document was deleted. They still feed answers, without a source. Reject one to stop it from counting.",
        "empty": "No statements without a source."
      },
      "reason": {
        "sourceWrongCorrection": "The source itself is wrong or outdated",
        "rejectSourceWrong": "Reject: source wrong or outdated"
      },
      "sourceArchived": {
        "open": "Source archived",
        "title": "Reviewed, source archived",
        "hint": "These statements were confirmed after their document's version was archived. They still go into answers; the archived version stays downloadable. Reject one to stop it counting.",
        "empty": "No confirmed statements from archived versions."
      },
      "readOnly": {
        "label": "Read only",
        "hint": "You can view the content but not verify it. An admin or supervisor grants the right to verify through your role."
      }
    },
    "status": {
      "completed": "Completed",
      "processing": "Processing",
      "failed": "Failed",
      "pending": "Pending",
      "queued": "Queued",
      "converting": "Converting",
      "cleaning": "Cleaning",
      "chunking": "Chunking",
      "graph": "Graph",
      "vector": "Vector",
      "uploaded": "Uploaded",
      "markdown_ready": "Processing"
    },
    "table": {
      "filename": "Filename",
      "knowledgeArea": "Knowledge Area",
      "status": "Status",
      "verificationStatus": "Verification Status",
      "verificationFacts": "Facts",
      "verificationNodes": "Nodes",
      "groupVerification": "Verification",
      "groupExtraction": "Extraction",
      "verificationTooltip": "Open: {{open}} · Verified: {{verified}} · Updated: {{updated}} · Rejected: {{rejected}} · Outdated: {{outdated}}",
      "verificationError": "Verification status unavailable: {{message}}",
      "chunks": "Chunks",
      "knowledgeGraph": "Knowledge Graph",
      "created": "Created",
      "noDocuments": "No documents found",
      "nodes": "{{count}} nodes",
      "edges": "{{count}} edges",
      "autoVerifyTl1": "Auto-Verify TL1"
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "reprocess": "Reprocess",
      "openDocument": "Open Document",
      "delete": "Delete"
    },
    "upload": {
      "title": "Upload Documents",
      "description": "Upload PDF, Office, text or email files.",
      "fileLabel": "File(s)",
      "fileSelected": "file selected",
      "filesSelected": "files selected",
      "prefixLabel": "Title Prefix (optional)",
      "prefixPlaceholder": "e.g. SENTRON",
      "prefixHint": "Optional: Prefix will be added before each filename",
      "clientLabel": "Client (for Storage)",
      "noClientsAvailable": "No clients available",
      "knowledgeAreaLabel": "Knowledge Area",
      "noKnowledgeAreasAvailable": "No knowledge areas available",
      "selectKnowledgeArea": "Select knowledge area",
      "knowledgeAreaHint": "Document will be assigned to this knowledge area",
      "noKnowledgeArea": "No area selected",
      "uploading": "Uploading...",
      "uploadFiles": "Upload {{count}} file(s)",
      "upload": "Upload",
      "extractorLimitExceeded": "Monthly extractor token limit reached",
      "extractorLimitExceededDescription": "Document uploads are blocked because your monthly extractor token limit has been exceeded. Contact your administrator to increase the limit.",
      "extractorLimitWarning": "Extractor token usage at {{percentage}}%",
      "extractorLimitWarningDescription": "You are approaching your monthly extractor token limit. Uploads may be blocked soon.",
      "chunkLimitExceeded": "Chunk limit reached",
      "chunkLimitExceededDescription": "Delete existing documents or increase the limit.",
      "chunkLimitWarning": "Chunk limit almost reached ({{percentage}}%)",
      "chunkLimitUsage": "{{current}} / {{maximum}} chunks",
      "noClientAssigned": "No client assigned",
      "noKnowledgeAreaSelected": "No knowledge area selected",
      "partialErrorTitle": "Partial upload error",
      "selectKnowledgeAreaFirst": "Please select a knowledge area first",
      "successTitle": "Upload successful",
      "successDescription": "The document was uploaded successfully",
      "selectFiles": "Select files",
      "selectFolder": "Select folder",
      "folderFiltered": "{{supported}} of {{total}} files supported ({{filtered}} filtered)",
      "noSupportedFilesInFolder": "No supported files in folder",
      "emptyFolder": "Folder is empty",
      "tooManyFiles": "Maximum {{max}} files per upload allowed",
      "tooManyExcelFiles": "Maximum {{max}} Excel files per upload allowed",
      "fileTooLarge": "Files must not exceed {{max}} MB",
      "duplicateToastTitle": "{{count}} file(s) already exist in the system",
      "duplicateToastDescription": "The content is identical to documents that were already uploaded. The affected files are highlighted in the list.",
      "duplicateBadge": "Already exists in the system",
      "duplicateIn": "Already exists in “{{knowledgeArea}}” as “{{title}}”",
      "rateLimitedToastTitle": "{{count}} file(s) deferred due to the server upload limit",
      "rateLimitedToastDescription": "The server upload limit has been reached. The files stay in the list — just click \"Upload\" again in a few minutes.",
      "rateLimitedBadge": "Server upload limit — click \"Upload\" again later",
      "rateLimitWaiting": "Server upload limit reached — the upload will resume automatically. You can also cancel and retry later.",
      "cancelUpload": "Cancel upload",
      "reasonRateLimited": "server upload limit",
      "reasonDuplicate": "already exists",
      "andMoreFiles": " and {{count}} more",
      "largeSelectionTitle": "Large selection — upload runs in stages",
      "largeSelectionDescription": "The server accepts {{window}} files per {{minutes}} minutes. Just keep the dialog open — the upload resumes automatically until everything is uploaded.",
      "uploadProgress": "{{done}} of {{total}} file(s) uploaded",
      "uploadingProgress": "Uploading… ({{done}}/{{total}})",
      "recentPrefixes": "Recent:",
      "summaryComplete": "All {{total}} file(s) are in the knowledge area.",
      "summaryIncomplete": "{{open}} of {{total}} file(s) are still missing — they are marked below.",
      "summaryDetail": "{{uploaded}} uploaded · {{duplicates}} already present · {{open}} open",
      "versions": {
        "title_one": "New version ({{count}})",
        "title_other": "New versions ({{count}})",
        "hint": "These files are named like documents already in the knowledge area and go up as their new version. Untick to upload one as a separate document.",
        "asVersion": "New version of “{{title}}” (v{{from}} → v{{to}})",
        "asSeparate": "Uploaded as a separate document, “{{title}}” stays as it is",
        "error": {
          "default": "Could not be uploaded as a new version.",
          "identical_to_current_version": "Identical to the current version (v{{version}}) – nothing to do.",
          "version_conflict": "The document changed in the meantime. Please select the file again.",
          "version_target_not_current": "The document has a newer version by now. Please select the file again.",
          "version_target_not_found": "The document no longer exists.",
          "version_target_other_area": "A new version has to be in the same knowledge area as the document.",
          "document_versions_disabled": "Versions are not enabled for this organisation."
        }
      }
    },
    "edit": {
      "title": "Edit Document",
      "description": "Change the document metadata.",
      "titleLabel": "Title",
      "titlePlaceholder": "Document title",
      "filenameLabel": "Filename",
      "knowledgeAreaLabel": "Knowledge Area",
      "knowledgeAreaHint": "The knowledge area cannot be changed.",
      "updating": "Saving...",
      "save": "Save"
    },
    "delete": {
      "title": "Delete Document",
      "description": "Do you really want to delete the following document?",
      "warning": "This action cannot be undone. All chunks and vectors will also be deleted.",
      "deleting": "Deleting...",
      "confirm": "Delete",
      "verdicts": {
        "summary": "This document carries {{statements}} reviewed statements and {{concepts}} reviewed concepts.",
        "openVerifier": "View in the Verifier",
        "deleteToo": "Delete the reviewed knowledge too",
        "keep": "Keep it as reviewed knowledge without a source",
        "keepHint": "The statements stay in answers, marked \"source deleted\", and are listed in the Verifier under \"Source deleted\"."
      }
    },
    "view": {
      "title": "View Document",
      "processingInfo": "Processing Information",
      "noContent": "No content available",
      "noRawMarkdown": "No raw markdown available",
      "noCleanedMarkdown": "No cleaned markdown available",
      "noChunks": "No chunks available",
      "documentNotFound": "Document not found",
      "tabs": {
        "details": "Details",
        "content": "Content",
        "rawMarkdown": "Raw Markdown",
        "cleanedMarkdown": "Cleaned MD",
        "chunks": "Chunks"
      },
      "chunks": {
        "showFullContent": "Show full content",
        "title": "Chunk #{{index}}",
        "characters": "{{count}} characters",
        "embedded": "✓ Embedded"
      },
      "fields": {
        "status": "Status",
        "knowledgeArea": "Knowledge Area",
        "chunks": "Chunks",
        "created": "Created At",
        "processed": "Processed At",
        "documentId": "Document ID"
      },
      "knowledgeGraph": {
        "title": "Knowledge Graph",
        "nodes": "Graph Nodes",
        "edges": "Graph Edges"
      }
    },
    "factsBrowser": {
      "loading": "Loading facts...",
      "noResults": "No facts found",
      "resultsCount": "Showing {{count}} of {{total}} facts",
      "factsLabel": "Facts",
      "total": "Total",
      "today": "Today",
      "yesterday": "Yesterday",
      "daysAgo": "{{count}} days ago",
      "search": {
        "placeholder": "Search facts, entities, or relationships..."
      },
      "table": {
        "fact": "Fact",
        "entities": "Entities",
        "relationship": "Relationship",
        "knowledgeArea": "Knowledge Area",
        "status": "Status",
        "updated": "Updated",
        "actions": "Actions"
      },
      "filter": {
        "allStatus": "All Status",
        "allAreas": "All Areas",
        "selectStatus": "Select status",
        "selectKnowledgeArea": "Select knowledge area"
      },
      "status": {
        "open": "Open",
        "verified": "Verified",
        "updated": "Updated",
        "rejected": "Rejected",
        "outdated": "Outdated"
      },
      "relationshipType": "Relationship Type",
      "knowledgeArea": "Knowledge Area",
      "createdAt": "Created At",
      "updatedAt": "Updated At",
      "reviewNotes": "Review Notes",
      "originalFact": "Original",
      "actions": {
        "verify": "Verify",
        "reject": "Reject",
        "edit": "Edit"
      },
      "loadMore": {
        "button": "Load {{amount}} more",
        "loading": "Loading more...",
        "remaining": "remaining"
      },
      "empty": {
        "title": "No facts available",
        "description": "No facts have been extracted for this knowledge area yet. Try a different filter or search term."
      },
      "editDialog": {
        "title": "Edit Fact",
        "description": "Change the status or content of this fact.",
        "entities": "Entities (Read-only)",
        "factText": "Fact Text",
        "original": "Original",
        "characters": "characters",
        "status": "Status",
        "statusOpen": "🟡 Open - Not yet reviewed",
        "statusVerified": "🟢 Verified - Confirmed and correct",
        "statusUpdated": "🔵 Updated - Fact text was modified",
        "statusRejected": "🔴 Rejected - Fact is incorrect/not usable",
        "reviewNotes": "Review Notes (optional)",
        "reviewNotesPlaceholder": "Optional notes about this change...",
        "cancel": "Cancel",
        "save": "Save Changes",
        "saving": "Saving..."
      }
    },
    "nodesBrowser": {
      "title": "Nodes Browser",
      "loading": "Loading entities...",
      "entitiesLabel": "Entities",
      "statusCounts": "{{open}} open, {{verified}} verified, {{updated}} updated, {{rejected}} rejected",
      "noAccessibleAreas": "No knowledge areas assigned",
      "empty": {
        "title": "No entities found",
        "description": "No entities available or all have been filtered out."
      },
      "status": {
        "open": "to review",
        "verified": "verified",
        "updated": "verified",
        "rejected": "rejected",
        "outdated": "outdated"
      },
      "filters": {
        "search": "Search name or summary...",
        "clearFilters": "Clear filters",
        "status": {
          "all": "All Status",
          "placeholder": "Status"
        },
        "knowledgeArea": {
          "all": "All Areas",
          "placeholder": "Knowledge Area"
        },
        "entityType": {
          "all": "All Types",
          "placeholder": "Entity Type"
        }
      },
      "table": {
        "name": "Name",
        "type": "Type",
        "summary": "Summary",
        "area": "Area",
        "status": "Status",
        "updated": "Last updated",
        "actions": "Actions",
        "noEntities": "No entities found",
        "noSummary": "No summary",
        "reviewedBy": "by {{reviewer}}"
      },
      "actions": {
        "verify": "Verify",
        "reject": "Reject",
        "edit": "Edit"
      },
      "dialog": {
        "title": "Edit Entity",
        "originalName": "Original Name",
        "entityName": "Entity Name",
        "namePlaceholder": "Entity name...",
        "originalSummary": "Original Summary",
        "entitySummary": "Entity Summary",
        "summaryPlaceholder": "Entity summary...",
        "contentChangedWarning": "Name or summary has been changed. Status will automatically be set to \"Updated\". The original will be saved in original_name and original_summary.",
        "status": "Status",
        "notes": "Review Notes (optional)",
        "outgoingRelationships": "Outgoing Relationships",
        "incomingRelationships": "Incoming Relationships",
        "relatedQA": "Related Q&A Pairs",
        "relatedDocs": "Related Documents",
        "cancel": "Cancel",
        "save": "Save Changes",
        "saving": "Saving...",
        "type": "Type",
        "targetType": "Target type",
        "sourceType": "Source type",
        "characters": "{{count}} characters",
        "statusOpen": "🟡 Open – not reviewed yet",
        "statusVerified": "🟢 Verified – confirmed and correct",
        "statusUpdated": "🔵 Updated – name/summary was adjusted",
        "statusUpdatedHint": "(only available when name or summary was changed)",
        "statusRejected": "🔴 Rejected – entity is not correct/usable",
        "notesPlaceholder": "Optional notes on the change...",
        "moreItems": "... and {{count}} more",
        "unknownDocument": "Unknown document"
      }
    },
    "viewers": {
      "pdfViewer": "PDF Viewer",
      "multimedia": "Multimedia Player",
      "filePreview": "File Preview",
      "download": "Download",
      "noViewer": "No viewer available"
    },
    "blocksBrowser": {
      "search": {
        "placeholder": "Search Q&A or Entities..."
      },
      "knowledgeBlock": "Knowledge Block",
      "knowledgeBlocksList": "Knowledge Blocks",
      "blocks": "Blocks",
      "noBlocks": "No Knowledge Blocks found",
      "noBlocksHint": "Adjust filters or process documents",
      "noSelection": "No Knowledge Block selected",
      "selectBlock": "Select a Knowledge Block from the list to view details",
      "loadingBlocks": "Loading Knowledge Blocks...",
      "loadingBlock": "Loading Knowledge Block...",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "facts": "Facts",
      "entities": "Entities",
      "verified": "verified",
      "totalProgress": "Total Progress",
      "expand": "Show {{count}} Entities",
      "qaPair": "Q&A Pair",
      "viewFile": "View file",
      "edit": "Edit",
      "verify": "Verify",
      "reject": "Reject",
      "question": "Question",
      "answer": "Answer",
      "document": "Document",
      "chunk": "Chunk",
      "fact": "Fact"
    },
    "allAreas": "All Areas",
    "entityCount": "{{count}} Entity",
    "entityCount_plural": "{{count}} Entities",
    "errors": {
      "loadFacts": "Failed to load facts",
      "verifyFact": "Failed to verify fact",
      "rejectFact": "Failed to reject fact",
      "updateFact": "Failed to update fact",
      "loadEntities": "Failed to load entities",
      "verifyEntity": "Failed to verify entity",
      "rejectEntity": "Failed to reject entity",
      "updateEntity": "Failed to update entity"
    },
    "excel": {
      "wizard": {
        "title": "Excel Import Configuration",
        "subtitle": "Configure how the Excel data should be imported into the Knowledge Graph.",
        "steps": {
          "mapping": "Mapping",
          "sheets": "Sheets",
          "relationships": "Relationships",
          "description": "Description",
          "review": "Review"
        }
      },
      "mappingStep": {
        "title": "Select Mapping",
        "description": "Choose an existing mapping or create a new one.",
        "newMapping": "Create new mapping",
        "existingMapping": "Use existing mapping",
        "selectMapping": "Select mapping...",
        "noMappingsAvailable": "No mappings available for this knowledge area.",
        "headerRow": "Header Row",
        "headerRowHint": "Row index of column headers (0 = first row)",
        "deleteConfirm": "Really delete mapping \"{{name}}\"?"
      },
      "sheetStep": {
        "title": "Configure Sheets",
        "description": "Configure each sheet that should be imported.",
        "enableSheet": "Import sheet",
        "disabledSheet": "Disabled",
        "entityType": "Entity Type",
        "entityTypeHint": "Name of the node label in Neo4j",
        "primaryKey": "Primary Key Columns",
        "primaryKeyHint": "Column(s) that uniquely identify each record. Multiple columns for composite key.",
        "selectPrimaryKeyColumns": "Select primary key column(s)...",
        "nameTemplate": "Name Template",
        "nameTemplateHint": "Template for the node name, e.g. {Nr}: {Description}",
        "nameTemplatePlaceholder": "{Column1}: {Column2}",
        "groupId": "Knowledge Area",
        "groupIdHint": "Knowledge Area the data will be assigned to",
        "selectKnowledgeArea": "Select Knowledge Area...",
        "generateEmbeddings": "Generate Embeddings",
        "generateEmbeddingsHint": "Create vector embeddings for semantic search",
        "sampleData": "Sample Data",
        "hideSampleData": "Hide sample data",
        "rowCount": "{{count}} rows",
        "columns": "{{count}} columns",
        "noSheetsEnabled": "At least one sheet must be enabled.",
        "searchColumn": "Search column..."
      },
      "relationshipStep": {
        "title": "Define Relationships",
        "description": "Define relationships between sheets or to external entities.",
        "addRelationship": "Add relationship",
        "editRelationship": "Edit relationship",
        "deleteRelationship": "Delete relationship",
        "sourceSheet": "Source Sheet",
        "sourceColumn": "FK Column",
        "sourceColumnHint": "Column containing the foreign key",
        "targetSheet": "Target Sheet",
        "externalReference": "External Reference",
        "externalType": "External Entity Type",
        "externalTypeHint": "Entity type that exists in another import",
        "targetColumn": "PK Column",
        "targetColumnHint": "Primary key column in target",
        "relationshipType": "Relationship Type",
        "relationshipTypeHint": "Name of the relationship in Neo4j, e.g. HAS_MATERIAL",
        "noRelationships": "No relationships defined.",
        "noRelationshipsHint": "Relationships are optional. You can skip this step.",
        "crossExcelNote": "This relationship references an external entity type.",
        "externalTypePlaceholder": "e.g. Material",
        "targetColumnPlaceholder": "e.g. Code",
        "relationshipTypePlaceholder": "HAS_MATERIAL"
      },
      "descriptionStep": {
        "title": "Dataset Description",
        "description": "Optional: Provide a description for this upload. It will be embedded as an attribute in every created node."
      },
      "reviewStep": {
        "title": "Review Configuration",
        "description": "Review your configuration and start the import.",
        "sheetsTab": "Sheets ({{count}})",
        "relationshipsTab": "Relationships ({{count}})",
        "configTab": "JSON Configuration",
        "saveMapping": "Save mapping for future uploads",
        "mappingName": "Mapping Name",
        "mappingNamePlaceholder": "e.g. Product Catalog Mapping",
        "mappingNameRequired": "Mapping name is required when saving.",
        "mappingDescription": "Description (optional)",
        "mappingDescriptionPlaceholder": "Brief description of the mapping",
        "uploadDescription": "Dataset Description",
        "uploadDescriptionPlaceholder": "e.g. High-pressure centrifugal pumps from product catalog 2024",
        "uploadDescriptionHint": "Will be embedded as attribute in every created node (optional, max 1000 chars)",
        "generateEmbeddings": "Generate embeddings for TL 3 vector search",
        "generateEmbeddingsDescription": "Enables semantic search in Excel data via TL 3",
        "summary": {
          "title": "Summary",
          "sheets": "{{count}} sheet(s) will be imported",
          "relationships": "{{count}} relationship(s) will be created",
          "embeddings": "Embeddings: {{status}}",
          "embeddingsEnabled": "Yes ({{count}} entity types)",
          "embeddingsDisabled": "No",
          "embeddingsAuto": "TL3 embeddings: enabled automatically for all sheets"
        }
      },
      "actions": {
        "back": "Back",
        "next": "Next",
        "process": "Process Excel",
        "cancel": "Cancel",
        "save": "Save",
        "loadMapping": "Load mapping"
      },
      "validation": {
        "primaryKeyRequired": "Primary key column is required.",
        "entityTypeRequired": "Entity type is required.",
        "atLeastOneSheet": "At least one sheet must be enabled.",
        "relationshipIncomplete": "All fields of a relationship must be filled.",
        "mappingNameRequired": "Mapping name is required.",
        "invalidEntityType": "Entity type may only contain letters, numbers, and underscores."
      },
      "process": {
        "starting": "Starting import...",
        "success": "Excel import started",
        "successDescription": "The import is running in the background. You can track progress in the job overview.",
        "completed": "Excel import completed",
        "error": "Error starting import",
        "errorDescription": "Please try again or contact support.",
        "completedDescription": "{{nodes}} nodes, {{relationships}} relationships",
        "queuedDescription": "Import job {{job}}... has been queued.",
        "mappingCreated": "Mapping created",
        "mappingCreatedDescription": "Mapping \"{{name}}\" was created successfully.",
        "mappingDeleted": "Mapping deleted",
        "mappingDeletedDescription": "The mapping was deleted successfully."
      },
      "preview": {
        "loading": "Analyzing Excel file...",
        "error": "Error reading Excel file",
        "fileInfo": "{{sheets}} sheets, {{size}}"
      },
      "fileDetected": {
        "title": "Excel/CSV file detected",
        "description": "The selected file is an Excel or CSV file. Would you like to start the import wizard?",
        "startWizard": "Start Import Wizard",
        "cancel": "Cancel"
      }
    },
    "qaBrowser": {
      "status": {
        "open": "Open"
      }
    },
    "loadMore": "Load {{amount}} more",
    "pageSizeLabel": "Documents per page",
    "pageSizeValue": "{{amount}} per page",
    "shell": {
      "navLabel": "Knowledge Extractor sections",
      "nav": {
        "start": "Start",
        "contents": "Contents in the brain",
        "drafts": "Drafts",
        "addGroup": "Add",
        "upload": "Upload files",
        "record": "Record audio"
      },
      "start": {
        "title": "What would you like to turn into knowledge today?",
        "subtitle": "Pick a source. The CDB extracts statements from it, which you then review in the Knowledge Verifier.",
        "uploadTitle": "Upload files",
        "uploadBody": "Documents, spreadsheets, images and videos. Audio files are transcribed as drafts. Several files or whole folders; large files upload in blocks.",
        "uploadAction": "Choose files",
        "recordTitle": "Record audio",
        "recordBody": "Expert interview, meeting or dictation. The recording is transcribed; you review the transcript and file it in the brain.",
        "recordAction": "Prepare a recording",
        "status": "Status",
        "inProgress": "In processing",
        "draftsReady": "Drafts ready to file",
        "failed": "Failed",
        "recent": "Recently added",
        "showAll": "Show all contents",
        "docStatus": {
          "pending": "Pending",
          "uploaded": "Uploaded",
          "processing": "In processing",
          "markdown_ready": "In processing",
          "completed": "Done",
          "failed": "Failed"
        },
        "eyebrow": "Knowledge Extractor"
      },
      "expand": "Expand sidebar",
      "collapse": "Collapse sidebar",
      "quota": "Extractor quota",
      "quotaValue": "{{percent}} % this month"
    },
    "drafts": {
      "count": "Drafts ({{count}})",
      "inControl_one": "{{count}} task in cdbControl",
      "inControl_other": "{{count}} tasks in cdbControl",
      "emptyTitle": "No drafts",
      "emptyBody": "All recordings are in the brain. New recordings show up here until you file them.",
      "step": {
        "recorded": "Recorded",
        "transcribed": "Transcribed",
        "edited": "Edited",
        "inBrain": "In the brain"
      },
      "subtitle": "Your recordings that are not in the brain yet; only you see them. Once filed, everyone with access to the knowledge area finds them under \"Contents in the brain\".",
      "newRecording": "New recording",
      "privateHint": "Only visible to you until you file the draft in the brain",
      "stand": "Status",
      "stepDone": "(done)",
      "stepCurrent": "(current)",
      "excerpt": "Transcript (excerpt)",
      "waitingBody": "The transcript shows up here once transcription is done. You can close the window.",
      "failedBody": "Transcription failed. The recording itself is saved.",
      "recordedBody": "No transcript yet. Start the transcription to review the text and file it.",
      "fileTitle": "File in the brain",
      "fileArea": "Knowledge area",
      "fileDocTitle": "Document title",
      "fileAction": "File in the brain",
      "editTranscript": "Edit transcript",
      "deriveTasks": "Derive tasks"
    },
    "record": {
      "showDrafts": "Go to drafts",
      "fileHint": "Already have the recording as a file?"
    },
    "contents": {
      "count": "{{shown}} of {{total}}",
      "draftsHintBefore": "Recordings that are not filed yet are under",
      "draftsHintAfter": ".",
      "statements_one": "{{count}} statement",
      "statements_other": "{{count}} statements",
      "column": {
        "title": "Title",
        "type": "Type",
        "area": "Knowledge area",
        "status": "Status",
        "date": "Date"
      },
      "kind": {
        "pdf": "PDF",
        "word": "Word",
        "powerpoint": "PowerPoint",
        "excel": "Excel",
        "image": "Image",
        "audio": "Audio",
        "video": "Video",
        "web": "Web page",
        "text": "Text",
        "other": "File"
      },
      "review": "Review",
      "retry": "Process again",
      "typeFilter": {
        "label": "Type",
        "all": "All",
        "document": "Documents",
        "image": "Images",
        "video": "Videos"
      }
    },
    "uploadPage": {
      "dropTitle": "Drag files here",
      "formats": "Documents (PDF, Word, PowerPoint, HTML, text), spreadsheets, images and videos. Audio files (MP3, M4A, WAV …) become drafts and are transcribed. Videos and files over 95 MB upload in blocks.",
      "nextTitle": "What happens next",
      "next": {
        "convert": "The CDB turns every file into text. Audio and video are transcribed, videos also with stills.",
        "extract": "Statements and links in the knowledge area are drawn from it.",
        "review": "You review the statements in the Knowledge Verifier."
      },
      "selected_one": "{{count}} file selected",
      "selected_other": "{{count}} files selected",
      "audioGroup_one": "{{count}} audio file: becomes a draft",
      "audioGroup_other": "{{count}} audio files: become drafts",
      "audioHint": "becomes a draft and is transcribed",
      "audioRemove": "Remove {{name}}",
      "audioNoClient": "Your account has no client, so audio files cannot be added.",
      "audioDone_one": "The audio file is under Drafts and is being transcribed.",
      "audioDone_other": "{{count}} audio files are under Drafts and are being transcribed.",
      "audioFailed_one": "One audio file could not be uploaded. It is still in the list.",
      "audioFailed_other": "{{count}} audio files could not be uploaded. They are still in the list."
    },
    "editor": {
      "aiBadge": "AI",
      "back": "Back",
      "backToDrafts": "Back to drafts",
      "cancel": "Cancel",
      "retry": "Try again",
      "loading": "Loading draft …",
      "noTranscript": "No transcript yet. Start the transcription under “Drafts”.",
      "private": "visible only to you",
      "recordedOn": "Recorded on {{date}}",
      "speakers_one": "{{count}} speaker",
      "speakers_other": "{{count}} speakers",
      "saved": "Saved",
      "savedVersion": "Saved · version {{version}}",
      "saving": "Saving …",
      "unsaved": "Unsaved changes",
      "saveFailed": "The changes could not be saved.",
      "conflict": {
        "changedElsewhere": "The transcript was changed in another window. \"Reload\" discards your latest changes here, \"Keep my version\" makes them the new version. The other state stays in the history.",
        "inBrain": "Already in the Brain. Changes here are no longer saved.",
        "reload": "Reload",
        "keepMine": "Keep my version",
        "summaryChanged": "The summary was changed in another window. You now see the new state here. Please check it and file again.",
        "reloadFailed": "The transcript could not be reloaded."
      },
      "saveFailedRetry": "Saving failed · try again",
      "versionN": "version {{version}}",
      "currentVersion": "current version",
      "trackKnowledge": "Knowledge",
      "trackTasks": "Tasks",
      "tools": "Tools",
      "tab": {
        "tasks": "Tasks",
        "assist": "Assistant"
      },
      "player": {
        "play": "Play",
        "pause": "Pause",
        "position": "Position in the recording",
        "speed": "Speed {{speed}}×",
        "failed": "The recording could not be loaded."
      },
      "transcript": {
        "jumpTo": "Play from {{time}}",
        "editPassage": "Edit passage",
        "clickToEdit": "Click to edit",
        "taskChip": "Task {{number}}",
        "hint": "Edit the text directly · a timestamp plays the recording from there · changes save themselves",
        "hintNoTimes": "Edit the text directly · changes save themselves · this older transcript has no timestamps"
      },
      "tasks": {
        "intro": "Proposed from the conversation. Each task points to its passage; you decide which ones stay.",
        "extracting": "Reading tasks from the conversation …",
        "none": "No tasks were found in the conversation.",
        "failed": "Tasks could not be proposed. Please try again.",
        "loadFailed": "The tasks could not be loaded.",
        "saveFailed": "The task could not be saved.",
        "state": {
          "proposed": "Proposal",
          "accepted": "Accepted",
          "dropped": "Dropped"
        },
        "source": "Source",
        "due": "Due",
        "noDue": "No date mentioned",
        "dueFrom": "{{date}} (from “{{hint}}”)",
        "manual": "Added by you",
        "noSource": "No timestamp",
        "accept": "Accept",
        "edit": "Edit",
        "drop": "Drop",
        "undo": "Undo",
        "save": "Save",
        "titleLabel": "Task",
        "dueLabel": "Due on",
        "add": "Add a task yourself",
        "again": "Propose again",
        "send_one": "Send {{count}} task to cdbControl",
        "send_other": "Send {{count}} tasks to cdbControl",
        "sendHint": "Sends the accepted tasks that are not in cdbControl yet. There the whole client sees them; from then on they are changed in cdbControl.",
        "stayHint": "Accepted tasks stay with the recording.",
        "sent_one": "{{count}} task sent to cdbControl",
        "sent_other": "{{count}} tasks sent to cdbControl",
        "sendFailed_one": "{{count}} task could not be sent. Please try again.",
        "sendFailed_other": "{{count}} tasks could not be sent. Please try again.",
        "inControl": "In cdbControl",
        "openInControl": "Open in cdbControl",
        "assignee": "Assignee",
        "unassigned": "Nobody assigned",
        "countProposed": "{{count}} proposed",
        "countAccepted": "{{count}} accepted"
      },
      "file": {
        "title": "Add to the brain",
        "savedState": "The saved state is filed ({{version}}). Unsaved changes are saved first.",
        "summaryHeading": "Summary",
        "transcriptHeading": "Transcript",
        "summarizing": "Creating the summary …",
        "summaryFailed": "The summary could not be created.",
        "summarySaveFailed": "The summary could not be saved.",
        "regenerate": "Create the summary again",
        "goes": "Goes into the brain",
        "stays": "Stays here",
        "goesSummary": "Summary (AI, checked by you)",
        "goesTranscript": "Transcript with speakers and timestamps, including your edits",
        "staysTranscript": "The transcript (stays with the draft, only for you)",
        "staysTasks": "Tasks",
        "staysSuggestions": "Suggestions you did not accept",
        "staysAudio": "The audio file",
        "chooseArea": "Choose a knowledge area",
        "areaAudience": "Afterwards everyone with access to “{{area}}” can see it.",
        "areaRequired": "Choose a knowledge area to file the conversation.",
        "docTitle": "Title in the brain",
        "afterHint": "Afterwards the conversation is under “Contents in the brain”.",
        "outdated": "The summary comes from an older state of the transcript and lacks newer changes. File it anyway?",
        "action": "Add",
        "actionAnyway": "File anyway",
        "filed": "Added to the brain: {{area}}",
        "titleWithChoice": "Add to the brain · {{choice}}",
        "choice": {
          "summary": "summary only",
          "transcript": "transcript only",
          "both": "summary + transcript",
          "none": "nothing selected"
        },
        "bothOneDocument": "Both as one document. Change the choice on the blocks on the left.",
        "changeChoice": "Change the choice on the blocks on the left.",
        "nothingChosen": "Nothing selected: tick the summary, the transcript or both on the left."
      },
      "toBrain": "To the brain",
      "summary": {
        "current": "matches the transcript",
        "currentVersion": "matches the transcript (version {{version}})",
        "updating": "update pending",
        "updatingHint": "Updating to the changed transcript …",
        "failed": "not updated",
        "edited": "edited by you",
        "stale": "The transcript changed since the summary was edited. “Create again” replaces your version.",
        "regenerate": "Create again",
        "keep": "Keep it",
        "back": "Back",
        "backHint": "Back to your edited version",
        "backFailed": "Your version could not be brought back.",
        "collapse": "Collapse summary",
        "expand": "Expand summary"
      },
      "proposal": {
        "badge": "AI proposal",
        "apply": "Apply",
        "before": "Before",
        "after": "After",
        "view": "Proposal view",
        "onlyChanged": "Changed passages only",
        "transcriptDetail": "{{action}} · {{changes}} changes in {{passages}} of {{total}} passages",
        "hidden": "{{count}} unchanged passages hidden",
        "dropped": "The text has changed. The proposal no longer fits, so create it again if you need it."
      }
    },
    "filterInProgress": "In progress",
    "filterFailed": "Failed"
  },
  "tokenUsage": {
    "dashboard": {
      "period": "Period",
      "lastDays": "{{n}}d",
      "removeFilter": "Remove filter",
      "clearAll": "Clear all",
      "exportCsv": "Export CSV",
      "custom": "Custom",
      "fromDate": "From",
      "toDate": "To",
      "pivotTitle": "Model × Client",
      "filters": "Filters",
      "noFilters": "None — click a slice to filter",
      "loadError": "Could not load data.",
      "retry": "Retry",
      "metricTokens": "Tokens",
      "metricCost": "Cost",
      "other": "Other"
    },
    "dimensions": {
      "model": "Model",
      "provider": "Provider",
      "source": "Source",
      "client_id": "Client",
      "user_id": "User",
      "knowledge_area": "Knowledge Area",
      "call_type": "Activity",
      "day": "Day"
    },
    "title": "Token Usage",
    "subtitle": "LLM Token Usage & Costs",
    "period": "Period",
    "days7": "7 Days",
    "days30": "30 Days",
    "days90": "90 Days",
    "currentMonth": "Current Month",
    "allClients": "All Clients",
    "lastUpdated": "Updated {{minutes}} min ago",
    "justUpdated": "Just updated",
    "refresh": "Refresh",
    "pricing": {
      "refreshPrices": "Refresh prices",
      "refreshed": "Prices updated: {{updated}}, skipped: {{skipped}}",
      "refreshFailed": "Price refresh failed"
    },
    "refreshing": "Refreshing...",
    "tabs": {
      "overview": "Overview",
      "byUser": "Client Usage",
      "clients": "Clients",
      "user": "User",
      "limits": "Limits",
      "backendLimits": "Backend Limits",
      "apiLimits": "Client API Limits",
      "quotaRequests": "Requests"
    },
    "month": {
      "prev": "Previous month",
      "next": "Next month",
      "pick": "Pick month"
    },
    "mode": {
      "frontend": "Frontend",
      "backend": "Backend"
    },
    "my": {
      "chatTitle": "My chat tokens (this month)",
      "backendTitle": "My document tokens (this month)",
      "limitLabel": "Limit",
      "noLimit": "No limit",
      "overLimit": "Over limit",
      "requests": "Requests",
      "requestsLabel": "API Calls",
      "requests_one": "{{count}} request",
      "requests_other": "{{count}} requests",
      "errorTitle": "Could not load your token usage",
      "errorMessage": "We couldn't reach the token-usage service. Please try again."
    },
    "summary": {
      "totalTokens": "Total Tokens",
      "totalCost": "Cost (USD)",
      "totalRequests": "API Calls",
      "topModel": "Top Model"
    },
    "charts": {
      "trendByModel": "Usage over time by model",
      "perModel": "Per model",
      "perClient": "Per client",
      "perKnowledgeArea": "Per knowledge area",
      "topConsumers": "Top {{dim}}",
      "usage": "Usage",
      "noData": "No data for this period",
      "heatmapHint": "Colour intensity = share of the busiest cell.",
      "dailyTrend": "Daily Trend",
      "byModel": "By Model",
      "byCallType": "By Call Type",
      "bySource": "By Source",
      "byActivity": "By Activity",
      "tokens": "Tokens",
      "cost": "Cost",
      "requests": "Requests",
      "clientUsageBySource": "Client Usage: Chat vs Backend",
      "userUsageBySource": "User Usage: Chat vs Backend",
      "perCallType": "Per activity"
    },
    "tables": {
      "byClient": "By Client",
      "byKnowledgeArea": "By Knowledge Area",
      "byUser": "User Token Consumption",
      "combinedClientUsage": "Combined Client Usage (All Call Types)",
      "tokenLimits": "Token Limits",
      "clientLimits": "Chat Client Limits",
      "backendClientLimits": "Backend Client Limits",
      "client": "Client",
      "user": "User",
      "knowledgeArea": "Knowledge Area",
      "tokens": "Tokens",
      "cost": "Cost (USD)",
      "requests": "Requests",
      "knowledgeAreas": "Knowledge Areas",
      "noData": "No data for the selected period.",
      "role": "Role",
      "limit": "Monthly Limit",
      "used": "Used This Month",
      "remaining": "Remaining",
      "usage": "Usage %",
      "status": "Status",
      "percentage": "% of Client"
    },
    "byUser": {
      "period": "Current month",
      "totalUsers": "{{count}} of {{total}} users",
      "searchPlaceholder": "Search users...",
      "allRoles": "All Roles",
      "admins": "Admins",
      "supervisors": "Supervisors",
      "users": "Users"
    },
    "limits": {
      "exceeded": "Exceeded",
      "warning": "Warning",
      "normal": "Normal",
      "unlimited": "Unlimited",
      "actions": "Actions",
      "setLimit": "Set Limit",
      "setCostLimit": "Cost Limit",
      "warningThreshold": "Warning Threshold",
      "active": "Active",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "remove": "Remove",
      "userLimits": "Per-User Limits",
      "noUserLimits": "No users found.",
      "setUserLimit": "Set User Limit",
      "clientLimitApplies": "Client limit: {{limit}}",
      "userLimitRemoveConfirm": "Remove chat token limit for {{user}}? Client chat limit will still apply.",
      "inheritsClientLimit": "Inherits client limit",
      "noExplicitLimit": "No limit set",
      "searchUsers": "Search users...",
      "showingUsers": "{{shown}} of {{total}} users",
      "assigned": "Total Limit",
      "remaining": "Remaining",
      "allocatedToUsers": "Allocated to Users",
      "unallocated": "Unallocated",
      "limitSaved": "Limit saved",
      "saveFailed": "Failed to save limit",
      "limitRemoved": "Limit removed",
      "removeFailed": "Failed to remove limit",
      "noLimitsConfigured": "No chat token limits configured yet.",
      "infoTitle": "Chat Call Types",
      "infoDescription": "Chat limits apply to interactive AI operations: chat streaming, vector search, GraphRAG, web search, voice sessions, and query processing.",
      "grantedThisMonth": "Additionally granted for this month"
    },
    "backendLimits": {
      "userLimits": "Per-User Backend Limits",
      "noLimitsConfigured": "No backend token limits configured yet.",
      "infoTitle": "Backend Call Types",
      "infoDescription": "Backend limits apply to all backend ingestion and processing operations: document embedding (batch & single), knowledge graph extraction (Graphiti), RAG pipeline & DB ingestion, QA pair generation, Neo4j QA generation, and audio transcription (standard & chunked). These cover the full document lifecycle — upload, chunking, embedding, KG extraction, QA creation, and indexing.",
      "callTypes": "Included call types",
      "removeConfirm": "Are you sure you want to remove the backend token limit for {{client}}?",
      "userLimitRemoveConfirm": "Remove backend token limit for {{user}}? Client backend limit will still apply."
    },
    "apiLimits": {
      "chatLimits": "API Chat Limits",
      "backendLimits": "API Extractor Limits",
      "noLimitsConfigured": "No API token limits configured yet.",
      "infoDescription": "API token limits are separate from user/chat limits. They apply to chat requests made via API keys and are configured per client.",
      "removeConfirm": "Are you sure you want to remove the API token limit for {{client}}?"
    },
    "callTypes": {
      "tw4_streaming": "TW4 Streaming",
      "tw3_vector_answer": "TW3 Vector Answer",
      "tw2_harmonization": "TW2 Harmonization",
      "tw2_graph_rag": "TW2 Graph-RAG",
      "tw1_verified_rag": "TW1 Verified",
      "websearch": "Web Search",
      "embedding": "Embedding",
      "embedding_batch": "Embedding (Batch)",
      "transcription": "Transcription",
      "transcription_chunked": "Transcription (Chunks)",
      "summary_streaming": "Summary",
      "rag_pipeline": "RAG Pipeline",
      "structured_retrieval": "Struct. Retrieval",
      "realtime_session": "Realtime Session",
      "graphiti_kg": "Knowledge Graph (Graphiti)",
      "qa_generation": "QA Generation (Chunks)",
      "qa_neo4j_generation": "QA Generation (Neo4j)",
      "training_question_assist": "Question assistant",
      "activity_import": "Questionnaire import (Markdown)",
      "activity_summary": "Survey summary",
      "activity_sentiment": "Survey sentiment",
      "activity_themes": "Free-text themes (survey)"
    },
    "sources": {
      "extractor": "Backend / Extractor",
      "other": "Other",
      "training": "Training Hub"
    },
    "quota": {
      "title": "Open quota requests",
      "empty": "No open requests.",
      "approve": "Approve",
      "decline": "Decline",
      "grant": "Grant quota",
      "escalate": "Ask admins for client budget",
      "escalated": "Passed on to the admins",
      "approved": "Quota granted",
      "declined": "Request declined",
      "actionFailed": "Action failed",
      "amountRequired": "Set a token or cost amount",
      "bonusTokens": "Additional tokens",
      "bonusCost": "Additional budget (USD)",
      "consumed": "Consumed: {{tokens}} tokens · {{cost}}",
      "clientRequest": "Client budget: {{client}}",
      "clientBudgetBlocks": "The client budget is exhausted — personal quota will not lift the block.",
      "adminOnly": "Only admins can raise the client budget.",
      "statusEscalated": "With admins",
      "dimension": {
        "tokens": "Token limit",
        "cost": "Cost limit",
        "both": "Token and cost limit"
      },
      "linkedHint": "Tokens and budget are linked — converted using this person’s consumption so far. Either field can be overwritten.",
      "focus": {
        "approved": "The request from {{name}} was already approved on {{date}}.",
        "declined": "The request from {{name}} was already declined on {{date}}.",
        "resolved": "The request from {{name}} is settled: the client budget was raised on {{date}}.",
        "decided": "The request from {{name}} is no longer open.",
        "missing": "This request is no longer available."
      }
    }
  },
  "realtime": {
    "title": "Voice Assistant",
    "openWidget": "Open Voice Assistant",
    "restoreWidget": "Restore Voice Assistant",
    "minimize": "Minimize",
    "close": "Close",
    "user": "You",
    "assistant": "Assistant",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "mute": "Mute",
    "unmute": "Unmute",
    "clearTranscript": "Clear",
    "insertToSession": "Insert to Session",
    "typeMessage": "Type a message...",
    "sendMessage": "Send message",
    "error": "Error",
    "functionCall": "Function Call",
    "connectTooltip": "Start voice conversation with AI assistant",
    "disconnectTooltip": "End voice conversation",
    "clearTranscriptTooltip": "Clear conversation history",
    "insertToSessionTooltip": "Insert conversation into current Brain Session",
    "noTranscript": "No conversation yet",
    "noTranscriptHint": "Start speaking to create a conversation",
    "insertedToSession": "Inserted to Brain Session",
    "insertedToSessionHint": "The conversation has been added to your current session",
    "connected": "Connected",
    "status": {
      "disconnected": "Disconnected",
      "connecting": "Connecting...",
      "connected": "Connected",
      "listening": "Listening...",
      "speaking": "Speaking...",
      "processing": "Processing..."
    },
    "waveform": {
      "idle": "Idle",
      "ready": "Ready",
      "listening": "Listening",
      "speaking": "AI Speaking",
      "connectToStart": "Connect to start conversation"
    },
    "transcript": {
      "empty": {
        "disconnected": "No conversation yet",
        "connected": "Start speaking",
        "disconnectedHint": "Connect to start a voice conversation",
        "connectedHint": "The AI is listening and will respond to your voice"
      }
    },
    "modal": {
      "title": "Save Conversation?",
      "description": "Would you like to transfer this conversation to your Brain Session before disconnecting?",
      "transfer": "Transfer",
      "discard": "Discard"
    }
  },
  "tour": {
    "controls": {
      "next": "Next",
      "prev": "Previous",
      "done": "Done",
      "progress": "Step {{current}} of {{total}}"
    },
    "desktopIntro": {
      "startMenu": {
        "title": "Start menu",
        "description": "Open apps and settings from the start menu. A single click on the grid reveals every installed application."
      },
      "desktop": {
        "title": "Desktop apps",
        "description": "Launch an app with a single click on its desktop icon.",
        "detailButton": "Explain each app"
      },
      "taskbar": {
        "title": "Taskbar",
        "description": "The taskbar lists every open window. Click once to focus a window, click again to minimize it, hover over a window button to see the different instances of the same app."
      },
      "widgets": {
        "title": "Clock & widgets",
        "description": "The clock opens the widget area with customizable widgets like calendar, clock, notifications, and more."
      },
      "commandPalette": {
        "title": "Quick access",
        "description": "Press ⌘K (or Ctrl K) to open Quick Access — search apps, documents, and chats. It's also where you'll find bug reports, feature requests and the changelog."
      },
      "notificationBell": {
        "title": "Notifications",
        "description": "See all system notifications here, for example when an app is assigned to you or a session is shared with you."
      },
      "helpButton": {
        "title": "Tour help",
        "description": "Use this help button to replay or end the tour at any time."
      },
      "cdbChat": {
        "title": "Questions about the interface?",
        "description": "If you have questions about how to use cdb-webOS, open cdbChat. The \"cdbOS Guide\" knowledge area is available to all users and can answer your questions about the interface."
      }
    },
    "desktopAppsDetail": {
      "title": "{{app}} overview",
      "defaultDescription": "Need {{app}}? Click once to open the app window. Right-click for more desktop actions.",
      "next": "Next",
      "prev": "Previous",
      "done": "Finish",
      "progressText": "App {{current}} of {{total}}",
      "knowledgeHubDetailButton": "to app",
      "descriptions": {
        "app-store": "Browse all available apps by category and add them to your desktop.",
        "settings": "Customise theme, language, desktop icons and taskbar display to match your preferences.",
        "cortex": "Manage users, roles, app permissions, knowledge areas, clients and themes from Cortex, the central administration panel.",
        "ai-knowledge-extractor": "Upload documents to a knowledge area and let the AI automatically extract Q&A pairs, facts and entities.",
        "knowledge-verifier": "Review and verify extracted Q&A pairs, facts and entities for a knowledge area and manage the knowledge graph.",
        "notes": "This app is under development and will be available in a future update.",
        "pdf-viewer": "Open PDF documents in-window with page navigation, smooth zoom, drag-to-pan and keyboard controls.",
        "multimedia": "Play audio and video files from your knowledge areas — with playback controls, volume adjustment and fullscreen mode.",
        "cdb-sessions": "Create interactive quiz sessions with multiple choice, single choice and free-text questions and play them as learning units.",
        "cdb-training": "Two areas in one app: trainings built from materials with an optional quiz — and standalone surveys with automatic evaluation.",
        "wissenshaus": "Knowledge areas as a 3D house with everything that happened in the brain",
        "harness": "Agent roles check facts, you approve",
        "cdb-control": "Your client's tasks from recordings and added by hand"
      }
    }
  },
  "widgets": {
    "categories": {
      "system": "System",
      "apps": "Apps",
      "productivity": "Productivity",
      "admin": "Administration"
    },
    "overview": {
      "title": "Quick Widgets"
    },
    "calendar": {
      "title": "Calendar",
      "description": "Today's events and upcoming meetings"
    },
    "clock": {
      "title": "Clock",
      "description": "Current time in your timezone"
    },
    "notifications": {
      "title": "Notifications",
      "description": "Latest system and app notifications",
      "justNow": "Just now",
      "minsAgo": "{{mins}} min ago",
      "hoursAgo": "{{hours}} hours ago",
      "daysAgo": "{{days}} day(s) ago",
      "noNotifications": "No new notifications",
      "clickForAll": "Click for all"
    },
    "voice-agent": {
      "title": "Voice Agent",
      "description": "Launch the voice agent for hands-free assistance"
    },
    "app-store": {
      "title": "App Store",
      "description": "Discover recommended and new apps"
    },
    "appStore": {
      "title": "App Store",
      "description": "Discover recommended and new apps",
      "noApps": "No apps available"
    },
    "url-linked": {
      "title": "Quick Links",
      "description": "Quick access to your favorite websites",
      "noLinks": "No links added yet",
      "addLinksHint": "Open widget settings to add links",
      "links": "Links",
      "addLink": "Add Link",
      "titlePlaceholder": "Link Title",
      "urlRequired": "URL is required",
      "httpsOnly": "Only HTTPS URLs are allowed",
      "invalidUrl": "Invalid URL format",
      "titleRequired": "Title is required",
      "maxLinksReached": "Maximum 5 links allowed",
      "displayMode": "Display Mode",
      "listMode": "List",
      "compactMode": "Compact",
      "manageLinks": "Manage links",
      "noLinksConfigured": "No links configured",
      "limitReached": "Limit reached"
    },
    "settings": {
      "title": "Settings",
      "description": "Quick access to important settings",
      "darkMode": "Dark Mode",
      "lightMode": "Light Mode",
      "language": "Language",
      "currentTheme": "Theme",
      "themeLight": "Light",
      "themeCdbLight": "CDB Light",
      "themeDark": "Dark",
      "themeCdbDark": "CDB Dark",
      "themeAqua": "Aqua",
      "themeForest": "Forest",
      "themeOcean": "Ocean"
    },
    "knowledgeHub": {
      "title": "Knowledge Hub",
      "description": "Current knowledge areas and documents",
      "noAreas": "No knowledge areas",
      "allAreas": "All areas",
      "documents": "Documents",
      "apps": "Knowledge Apps"
    },
    "aiChat": {
      "title": "AI Chat",
      "description": "Recent conversations and new chat",
      "newChat": "New Chat",
      "noChats": "No chats"
    },
    "promptLibrary": {
      "title": "Prompt Library",
      "description": "Favorite and recently used prompts",
      "noPrompts": "No prompts"
    },
    "pdf-viewer": {
      "title": "PDF Viewer",
      "description": "Recently opened PDF documents",
      "noPDFs": "No PDFs",
      "pages": "Pages"
    },
    "pdfViewer": {
      "title": "PDF Viewer",
      "description": "Recently opened PDF documents",
      "noPDFs": "No PDFs",
      "pages": "Pages"
    },
    "multimedia": {
      "title": "Multimedia",
      "description": "Currently/recently played media",
      "noMedia": "No media"
    },
    "admin": {
      "title": "Cortex",
      "description": "System status and statistics",
      "status": "Status",
      "healthy": "Healthy",
      "warning": "Warning",
      "error": "Error",
      "unknown": "Unknown",
      "users": "Users",
      "uptime": "Uptime"
    },
    "cdb-sessions": {
      "title": "CDB Sessions",
      "description": "Training sessions with episodes",
      "noSessions": "No sessions"
    },
    "desktop": {
      "removeFromDesktop": "Remove from desktop",
      "folder": "Folder",
      "folderAppCount": "{{count}} Apps",
      "createFolder": "Folder created",
      "deleteFolder": "Delete Folder",
      "renameFolder": "Rename Folder",
      "emptyFolder": "This folder is empty",
      "unpackFolder": "Unpack folder?",
      "unpackFolderHint": "Only 1 app remaining in folder. Would you like to unpack the folder?"
    }
  },
  "widgetBar": {
    "prompts": {
      "copy": "Copy {{title}}",
      "share": "Share",
      "expand": "Expand prompts",
      "collapse": "Close detail view",
      "panelLabel": "Prompts, detail view",
      "new": "New prompt",
      "search": "Search prompts",
      "noHits": "No results",
      "empty": "No prompts yet.",
      "loadFailed": "The prompts could not be loaded.",
      "retry": "Try again",
      "toChat": "Add to chat",
      "taken": "Prompt added. Please check it, complete it and then send.",
      "count_one": "prompt",
      "count_other": "prompts"
    },
    "voice": {
      "name": "Voice assistant",
      "idleHint": "Ask questions or open apps and documents by voice.",
      "start": "Start voice assistant",
      "connecting": "Connecting",
      "cancel": "Cancel",
      "listening": "Listening",
      "processing": "Processing",
      "processingShort": "One moment",
      "speaking": "Answering",
      "muted": "Muted",
      "mutedShort": "Muted",
      "mutedText": "The microphone is off. The assistant hears nothing.",
      "listeningHint": "Just start talking.",
      "mute": "Mute",
      "unmute": "Turn on microphone",
      "end": "End conversation",
      "errorMicTitle": "No access to the microphone",
      "errorMicText": "Please allow the microphone in your browser.",
      "errorNetTitle": "Connection lost",
      "errorNetText": "The conversation ended. Please try again.",
      "retry": "Try again"
    },
    "calendar": {
      "title": "Appointments",
      "next": "Next appointment",
      "free": "No more appointments today",
      "tomorrow": "Tomorrow, {{time}}",
      "allDay": "All day",
      "now": "Now · {{minutes}} min left",
      "connectHint": "Show appointments here",
      "connect": "Connect",
      "expired": "Appointments unavailable",
      "renew": "Renew",
      "failed": "Appointments unreachable right now",
      "retry": "Try again",
      "monthLabel": "Month view {{month}}, today is the {{day}}."
    },
    "title": "Widgets",
    "edit": "Edit",
    "editing": "Edit widgets",
    "done": "Done",
    "add": "Add widget",
    "addToBar": "Add to bar",
    "inBar": "in the bar",
    "search": "Search widgets",
    "noResults": "No widgets found",
    "close": "Close",
    "empty": "No widgets in the bar yet.",
    "remove": "Remove {{name}}",
    "moved": "Size",
    "names": {
      "clock": "Date & time",
      "calendar": "Calendar",
      "voice-agent": "Voice assistant",
      "prompt-library": "Prompts"
    },
    "descriptions": {
      "clock": "The time and today's date, digital or analog.",
      "calendar": "Your next appointments when Microsoft 365 is connected, otherwise the month.",
      "voice-agent": "Ask questions or open apps and documents by voice.",
      "prompt-library": "Your prompts, in the chat with one click."
    },
    "variants": {
      "small": "Small",
      "medium": "Wide",
      "smallDigital": "Small, digital",
      "smallAnalog": "Small, analog"
    }
  },
  "widgetStore": {
    "title": "Widget Store",
    "subtitle": "Manage your widgets",
    "openSettings": "Open widget settings",
    "editDesktopIcons": "Edit Desktop Icons",
    "editModeActive": "Edit Mode Active",
    "search": "Search widgets...",
    "allCategories": "All Categories",
    "noResults": "No widgets found",
    "noWidgets": "No widgets available",
    "loading": "Loading widgets...",
    "manageHint": "Use the settings icon to enable widgets",
    "resetToDefaults": "Reset to defaults",
    "reset": "Reset",
    "pin": "Pin",
    "unpin": "Unpin",
    "size": "Size",
    "sizes": {
      "small": "Small (1x1)",
      "medium": "Wide (1x2)",
      "tall": "Tall (2x1)",
      "large": "Large (2x2)"
    },
    "customSettings": "Widget Settings",
    "stats": "{{enabled}} of {{total}} widgets active",
    "hint": "Changes are saved automatically",
    "editWidgets": "Edit Widgets...",
    "enabledLabel": "Enabled",
    "disabledLabel": "Disabled",
    "dragToEnable": "Drag to Desktop or Sidebar to enable",
    "dragToDisable": "Drag into the Widget Store to disable",
    "previewUnavailable": "Preview is not available for this widget",
    "maxItems": "Maximum items",
    "filterArea": "Filter by area",
    "filterAreaHint": "Filter will be set within the widget",
    "showFavoritesOnly": "Show favorites only",
    "cycleClockStyle": "Change clock style",
    "clockStyle": "Clock style",
    "clockStyles": {
      "analog": "Analog",
      "digital": "Digital",
      "minimal": "Minimal"
    },
    "cycleCalendarStyle": "Change calendar style",
    "calendarStyle": "Calendar style",
    "calendarStyles": {
      "day": "Day view",
      "month": "Month view"
    },
    "calendarMonthViewDisabled": "Only available in large size"
  },
  "voiceAgent": {
    "widget": {
      "title": "Voice Agent",
      "clickToStart": "Click to start"
    },
    "greetingFallbackCDB": "Greet the user briefly in English as Corporate Digital Brain and ask how you can help.",
    "greetingFallback": "Greet the user briefly in English and ask how you can help.",
    "azureGreetingWrapper": "Please greet me with exactly the following text, without any variation or interpretation:\n\"{{greetingText}}\"",
    "greetingSessionInstruction": "IMPORTANT - FIRST MESSAGE:\nIf this is your very first message in this session, you must say EXACTLY the following text, without any variation or interpretation:\n\"{{greetingText}}\"\n\nSay this text verbatim as your first response. After this greeting, continue responding EXCLUSIVELY in English for the rest of the session."
  },
  "notificationCenter": {
    "title": "Notifications",
    "unreadBadge": "{{count}} new",
    "bellLabelUnread_one": "Notifications, {{count}} new",
    "bellLabelUnread_other": "Notifications, {{count}} new",
    "markAllAsRead": "Mark all as read",
    "deleteRead": "Delete read",
    "filterLabel": "Filter by category",
    "onlyUnread": "Only new",
    "maximize": "Enlarge",
    "restore": "Reduce",
    "loading": "Loading notifications …",
    "loadError": "Notifications could not be loaded or changed. Please try again later.",
    "unreadPrefix": "New:",
    "markRead": "Mark as read",
    "markBundleRead": "Mark all as read",
    "markUnread": "Mark as unread",
    "markBundleUnread": "Mark all as unread",
    "moreActions": "More actions",
    "delete": "Delete",
    "deleteBundle": "Delete all",
    "chips": {
      "all": "All",
      "bug_reports": "Tickets",
      "documents": "Documents",
      "routines": "Routines",
      "requests": "Requests",
      "shared": "Shared with me"
    },
    "meta": {
      "bug_reports": "Ticket",
      "documents": "Documents",
      "routines": "Routine",
      "requests": "Request",
      "shared": "Shared with you"
    },
    "days": {
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "older": "Older"
    },
    "when": {
      "justNow": "Now",
      "minutes": "{{count}} min",
      "hours": "{{count}} h"
    },
    "actions": {
      "open": "Open",
      "review": "Review",
      "reply": "Reply"
    },
    "bundle": {
      "newReplies_one": "{{count}} new reply to {{subject}}",
      "newReplies_other": "{{count}} new replies to {{subject}}",
      "replies_one": "{{count}} reply to {{subject}}",
      "replies_other": "{{count}} replies to {{subject}}",
      "newUpdates_one": "{{count}} new notification about {{subject}}",
      "newUpdates_other": "{{count}} new notifications about {{subject}}",
      "updates_one": "{{count}} notification about {{subject}}",
      "updates_other": "{{count}} notifications about {{subject}}",
      "expand_one": "Show {{count}}",
      "expand_other": "Show all {{count}}",
      "collapse": "Hide",
      "quoted": "“{{text}}”"
    },
    "empty": {
      "title": "No notifications yet",
      "text": "Replies, status changes and finished processing runs will appear here."
    },
    "emptyFiltered": {
      "title": "All caught up",
      "text": "No new notifications."
    },
    "toast": {
      "region": "New notifications",
      "dismiss": "Dismiss"
    },
    "listLabel": "Notification list",
    "settings": {
      "open": "Notification settings",
      "back": "Back to notifications",
      "title": "Settings",
      "categoriesTitle": "Notifications by category",
      "intro": "Choose where you are told about new notifications. The setting applies on all your devices.",
      "category": "Category",
      "channels": {
        "inApp": "In-app",
        "toast": "Toast"
      },
      "hints": {
        "bug_reports": "Replies, questions, status",
        "documents": "Processing finished or failed",
        "routines": "Run finished or failed",
        "requests": "Quota, access, approvals",
        "shared": "Prompts, sessions"
      },
      "switchLabel": {
        "inApp": "Show {{category}} in the list",
        "toast": "Show {{category}} as a toast"
      },
      "explain": {
        "inApp": "The notification appears in this list and counts towards the number on the bell. Turned off, it is still stored but not shown.",
        "toast": "A short note at the bottom right as soon as a new notification arrives. Turned off, it is only listed."
      },
      "saveError": "The setting could not be saved. Please try again.",
      "notLoaded": "Your settings are still loading. You can change them once they have loaded.",
      "cleanupTitle": "Clean up",
      "retention": "Read notifications are deleted automatically after 90 days, unread ones after 180 days."
    }
  },
  "recordingConsent": {
    "title": "Recording consent",
    "startRecording": "Start recording",
    "tableConsent": "Consent",
    "globalStatusHint": "Audio recording in progress — click to switch to the recording window",
    "noRecord": "no record",
    "noRecordHint": "No consent record exists for this recording (created before this feature or imported file).",
    "microphone": {
      "description": "This feature records audio (microphone; in future possibly computer audio as well). Recording without the knowledge and consent of all participants is not permitted. Your confirmation is documented with the recording.",
      "statement": "I confirm that I have informed all participants about the recording and that all of them have consented."
    },
    "systemAudio": {
      "description": "This recording captures all audio from this computer, including every voice in an ongoing conference. The conferencing system shows the other participants no recording notice — informing them is up to you. Your confirmation is documented with the recording.",
      "statement": "I confirm that I have informed all participants about this recording and that all of them have consented. I am aware that no recording notice is shown to them in the conferencing system and that I am responsible for using this recording lawfully."
    }
  },
  "audioRecorder": {
    "title": "Audio Recorder",
    "uploadStalledError": "Audio upload has stalled — no segment was uploaded for over a minute. Please stop and finalize now to save what was recorded so far.",
    "chunkUploadFailedWarning": "A recording segment failed to upload. Some audio may be missing from the final recording.",
    "recorderError": "The recorder encountered a problem. Please check the recording and consider stopping and finalizing to avoid losing audio.",
    "recordingSaved": "Recording saved",
    "recordingSavedDescription": "The recording was saved successfully ({{duration}} seconds).",
    "interruptedSessionFound": "Interrupted recording found",
    "segmentsCount": "{{count}} segments ({{duration}})",
    "resume": "Resume",
    "finalize": "Finalize",
    "discard": "Discard",
    "recordingNameLabel": "Recording name (optional)",
    "recordingNamePlaceholder": "e.g. Interview with Expert XY",
    "segmentStatus": "Segment {{current}} • {{uploaded}} uploaded",
    "startRecording": "Record",
    "pause": "Pause",
    "stop": "Stop",
    "continue": "Continue",
    "finalizing": "Finalizing...",
    "uploading": "Uploading...",
    "recordings": "Recordings",
    "recordingsCount": "Recordings ({{count}})",
    "tableDate": "Date",
    "deleteConfirm": "Do you really want to delete \"{{title}}\"?",
    "deleteWarning": "This action cannot be undone",
    "editName": "Edit name",
    "error": "Error",
    "saved": "Saved",
    "playRecording": "Play",
    "downloadRecording": "Download",
    "transcribe": "Transcribe",
    "deleteRecording": "Delete",
    "deleteFailed": "The recording could not be deleted. Please try again.",
    "transcript": "Transcript",
    "stepEdit": "Edit",
    "stepAddToKnowledge": "Add to Knowledge",
    "tabEdit": "Edit",
    "tabPreview": "Preview",
    "editTranscript": "Edit transcript:",
    "transcriptPlaceholder": "Transcript...",
    "charactersCount": "{{count}} characters",
    "selectKnowledgeArea": "Select Knowledge Area:",
    "selectKnowledgeAreaPlaceholder": "Choose Knowledge Area...",
    "knowledgeAreasAvailable": "{{count}} Knowledge Areas available",
    "documentTitle": "Document Title:",
    "documentTitlePlaceholder": "e.g. Interview Summary",
    "documentPreview": "Document preview:",
    "source": "Source",
    "duration": "Duration",
    "seconds": "seconds",
    "copyToClipboard": "Copy to clipboard",
    "copied": "Copied",
    "saveChanges": "Save changes",
    "clickToConfirm": "Click again to confirm",
    "retranscribe": "Re-transcribe",
    "nextToKnowledge": "Continue to Knowledge →",
    "back": "← Back",
    "uploadingDocument": "Uploading...",
    "addToKnowledge": "Add to Knowledge",
    "errorSavingTranscript": "Error saving transcript",
    "errorAddingToKnowledge": "Error adding to Knowledge Area",
    "knowledgeAreaNoClient": "Knowledge Area has no assigned client",
    "uploadAudio": "Upload",
    "uploadingFile": "Uploading...",
    "uploadFailed": "Upload failed",
    "noClientId": "No client assigned",
    "aiAssistant": {
      "title": "AI assistant",
      "layerQuestion": "What should I work on?",
      "layer": {
        "summary": "Summary",
        "transcript": "Transcript"
      },
      "layerHint": {
        "summary": "Rewords the summary. The transcript stays as it is.",
        "transcript": "Corrects the wording only: what was said stays said. No shortening or rewriting here."
      },
      "noSummary": "No summary yet. It appears above the transcript as soon as there is one.",
      "shorten": "Shorter",
      "expand": "More detail",
      "formal": "More formal",
      "byTopic": "Group by topic",
      "cleanup": "Clean up",
      "fixTerms": "Fix technical terms",
      "speakers": "Name speakers",
      "speakerFrom": "Speaker",
      "speakerChoose": "Choose speaker",
      "speakerTo": "New name",
      "speakerToPlaceholder": "e.g. Customer",
      "rename": "Rename",
      "processing": "Processing …",
      "progressParts": "Part {{done}} of {{total}}",
      "discard": "Discard",
      "placeholder": "Choose an action or write your own instruction.",
      "customPrompt": {
        "summary": "Own instruction for the summary",
        "transcript": "Own instruction for the transcript"
      },
      "customPromptPlaceholder": {
        "summary": "e.g. name costs and funding first",
        "transcript": "e.g. “Maier” instead of “Meier”"
      },
      "error": "Processing failed. Please try again.",
      "truncatedWarning": "The result is much shorter than the text and was probably cut off. Check the end before applying it: applying replaces the whole text.",
      "applyAnyway": "Apply anyway",
      "emptyResult": "The AI answered but returned no text, usually because its budget ran out. Please try again.",
      "truncatedWarningMeasured": "The AI reported that its output budget ran out, so the result ends mid-text. Check the end before applying it: applying replaces the whole text.",
      "customAction": "Own instruction",
      "proposalWhere": {
        "summary": "The proposal is on the left, in the summary",
        "transcript": "The proposal is on the left, in the transcript"
      },
      "proposalWhereHint": "Check the marked places. “Apply” and “Discard” cover the whole proposal.",
      "renamed": "Renamed: {{from}} → {{to}}. Undo via the version history."
    },
    "versionHistory": {
      "title": "Version History",
      "version": "Version {{number}}",
      "sourceOriginal": "Original",
      "sourceManualEdit": "Manual Edit",
      "sourceAiRefine": "AI Refined",
      "sourceRetranscribe": "Re-transcribed",
      "sourceRestore": "Restored",
      "preview": "Preview",
      "restore": "Restore",
      "restored": "Version restored",
      "words": "words",
      "noVersions": "No version history available",
      "loading": "Loading versions...",
      "chars": "{{count}} chars",
      "current": "Current",
      "close": "Close"
    },
    "window": {
      "loading": "Loading transcript …",
      "notFoundTitle": "Recording not found",
      "notFoundBody": "This recording no longer exists, or it belongs to another account. Close the window and open the recording again from the list.",
      "loadErrorTitle": "Transcript could not be loaded",
      "loadErrorBody": "The connection to the server failed. The recording is not lost — it just cannot be reached right now. Close the window and try again.",
      "stepRecorded": "Recorded",
      "unsaved": "Unsaved changes",
      "uploadSuccess": "Added to the brain, in knowledge area “{{area}}”. The recording stays here.",
      "openDocument": "Open document"
    },
    "overview": {
      "searchPlaceholder": "Search recordings …",
      "sortNewest": "Newest first",
      "sortOldest": "Oldest first",
      "sortLongest": "Longest first",
      "sortTitle": "By title",
      "stageRecorded": "Recorded",
      "stageTranscribing": "Transcribing",
      "stageFailed": "Failed",
      "stageTranscribed": "Transcribed",
      "stageEdited": "Edited",
      "actionTranscribe": "Transcribe",
      "actionRetry": "Try again",
      "actionRunning": "Running …",
      "actionOpen": "Open transcript",
      "emptyTitle": "No recordings yet",
      "emptyBody": "Start a recording above or upload an existing audio file. Transcript and brain follow in the same flow.",
      "noMatchTitle": "No recording found",
      "noMatchBody": "Nothing matches “{{query}}”.",
      "clearSearch": "Clear search",
      "errorTitle": "Recordings could not be loaded",
      "errorBody": "The connection to the server failed. Your recordings are not lost — they just cannot be reached right now.",
      "reload": "Reload"
    },
    "sourceLostNotice": "The audio source ended. The recording up to that point has been saved.",
    "sourceLabel": "Recording source",
    "sourceMicrophone": "Microphone",
    "sourceMicrophoneSystem": "Microphone + system",
    "sourceSystemHint": "Also records this computer’s audio, including the other participants in a conference. In the share dialog choose \"Entire screen\" and tick \"Share system audio\". Please use headphones — over speakers the microphone records the conference audio a second time.",
    "systemAudioMissing": "The share carried no audio. Tick \"Share system audio\" in the share dialog — or your browser cannot share the computer’s audio. Without it only the microphone is recorded.",
    "tryAgain": "Try again",
    "narrowSurfaceWarning": "You shared a single window or a browser tab. Only its audio is recorded, not the whole computer — for a conference choose \"Entire screen\".",
    "resumeWith": "Resume with:",
    "stateIdle": "Ready to record",
    "stateIdleHint": "Microphone and source can be chosen before you start.",
    "stateRecording": "Recording",
    "stateRecordingHint": "Saved continuously in segments — a crash costs the last few seconds at most.",
    "statePaused": "Paused",
    "statePausedHint": "The recording is on hold. What you have so far is saved.",
    "stateSaving": "Saving",
    "stateSavingHint": "The last segment is being uploaded. Please keep the window open.",
    "jobStage": {
      "queued": "Queued …",
      "downloading": "Loading",
      "converting": "Converting",
      "transcribing": "Transcribing",
      "saving": "Saving",
      "done": "Done"
    },
    "jobError": {
      "generic": "Transcription failed. Please try again.",
      "tooLong": "The recording is too long to be transcribed.",
      "unreadable": "The audio file could not be read.",
      "noSpeech": "No speech was detected in the recording.",
      "busy": "Transcription could not be started right now. Please try again in a few minutes.",
      "timeout": "Transcription was interrupted. Please try again.",
      "notFound": "The recording was not found. Please reload the list.",
      "limitExceeded": "Your token or cost limit for this period has been reached. Please contact your administrator."
    }
  },
  "window": {
    "restore": "Restore",
    "minimize": "Minimize",
    "maximize": "Maximize",
    "close": "Close",
    "resize": {
      "right": "Resize window width from right",
      "left": "Resize window width from left",
      "bottom": "Resize window height from bottom",
      "top": "Resize window height from top",
      "bottomRight": "Resize window from bottom right",
      "bottomLeft": "Resize window from bottom left",
      "topRight": "Resize window from top right",
      "topLeft": "Resize window from top left"
    },
    "closeGuard": {
      "title": "Unsaved changes",
      "description": "This window has changes that have not been saved. Closing it discards them.",
      "descriptionAll": "{{count}} windows have changes that have not been saved. Closing them discards those changes.",
      "descriptionAll_one": "One window has changes that have not been saved. Closing it discards them.",
      "keepOpen": "Keep open",
      "discard": "Discard and close"
    },
    "resizeSnapped": "Resize the docked windows"
  },
  "selectionTranslation": {
    "title": "Translation",
    "translateToDe": "Deutsch",
    "translateToEn": "English",
    "translating": "Translating...",
    "copyTranslation": "Copy",
    "copied": "Copied!",
    "error": "Translation failed",
    "retry": "Retry",
    "close": "Close"
  },
  "agentToolbox": {
    "communicator2": {
      "subtabs": {
        "trace": "Per-turn trace",
        "session": "Session trace",
        "feedback": "Ratings"
      },
      "map": {
        "placeholder": "Capability map — coming (Phase D-4).",
        "intro": "What the LLM sees for this caller per turn — grouped by routing role. \"Collapsed\" = a source/corporate as one tool, \"hidden\" = internal primitives. Role = relevance, not access.",
        "loadError": "Could not load the capability map.",
        "empty": "No tools visible for this caller type.",
        "collapsed": "collapsed",
        "hidden": "hidden",
        "hiddenHint": "Hidden from the LLM — invoked only internally by skills.",
        "editRights": "Rights",
        "editRightsAll": "Rights (all {{count}})",
        "underlyingToggle": "Show {{count}} endpoints",
        "servesSource": "Serves the source {{name}}"
      },
      "trace": {
        "placeholder": "Per-turn trace — coming (Phase D-3).",
        "empty": "No turns yet — every cdbChat turn shows up here.",
        "loadError": "Could not load the trace.",
        "turnCount": "{{count}} turns",
        "noneDirection": "Smalltalk / no tool",
        "skipped": "skipped",
        "curationOff": "off",
        "curationPruned": "{{count}} pruned",
        "curationHinted": "{{count}} hint",
        "curationTriggered": "Trigger",
        "showInvocations": "Show invocations",
        "table": {
          "time": "Time",
          "status": "Status",
          "directions": "Layer-1 directions",
          "calls": "Layer-2 calls",
          "curation": "Curation",
          "sources": "Sources",
          "tools": "Tools",
          "rating": "Rating",
          "total": "Total",
          "ttf": "First token"
        }
      },
      "session": {
        "pickerTitle": "Conversations",
        "turnsLabel": "{{count}} turns",
        "errorsLabel": "{{count}} errors",
        "loadError": "Could not load conversations.",
        "empty": "No conversations yet — every cdbChat conversation shows up here.",
        "selectHint": "Pick a conversation on the left to see its trace.",
        "traceEmpty": "No turns for this conversation."
      },
      "feedback": {
        "lastDays": "{{count}} days",
        "loadError": "Could not load ratings.",
        "empty": "No ratings yet — 👍/👎 from the chat show up here aggregated.",
        "table": {
          "direction": "Layer-1 direction",
          "ratings": "👎 / total",
          "negativeRate": "👎 rate",
          "topReason": "Top reason"
        }
      }
    },
    "capabilityRole": {
      "label": "Routing role",
      "hint": "Coarse direction for the layered router (Layer 1). \"Automatic\" derives it from category/type.",
      "auto": "Automatic (from category/type)",
      "internal_knowledge": "Internal knowledge",
      "public": "Public / web",
      "structured_connector": "Structured connector",
      "action": "Action",
      "none": "Exclude from routing"
    },
    "tabs": {
      "label": "Agent Toolbox Tabs",
      "skills": "Skills",
      "manifest": "Tool manifest",
      "history": "Invocations",
      "performance": "Performance",
      "routing": "Routing strategy"
    },
    "info": {
      "skills": "Curated TQS endpoints exposed as agent tools. Permissions, visibility and returned fields control what the agent may call and what comes back.",
      "manifest": "Table of every live agent tool with its permissions. Per tool: assign clients first, then roles from those clients. Empty = admin-only.",
      "history": "Audit trail of every tool invocation — who called what when, with which status. Skills + connected systems combined.",
      "performance": "cdbChat latency baseline — p50/p95 per day and per source combination, measured server-side. Foundation for the smart-routing comparison.",
      "routing": "Manifest curator configuration: hint and pruning thresholds for automatic source selection. Changes apply without a deploy."
    },
    "performance": {
      "windowDays": "{{count}} days",
      "stable": "Stable",
      "regressionFlag": "today's p95 > {{factor}}× window p95",
      "loadError": "Telemetry could not be loaded.",
      "empty": "No turns in this window yet — every cdbChat turn feeds the baseline.",
      "chartTitle": "Total duration per day (p50/p95)",
      "comboTitle": "Latency by active sources",
      "kpi": {
        "turns": "Turns",
        "errorRate": "{{rate}} % errors",
        "ttf": "Time to first token",
        "total": "Total duration",
        "tokens": "Tokens",
        "cacheShare": "{{share}} % from cache"
      },
      "table": {
        "sources": "Sources",
        "noSources": "memory only",
        "ttfP50": "First token p50",
        "ttfP95": "First token p95",
        "totalP50": "Total p50",
        "totalP95": "Total p95"
      }
    },
    "routing": {
      "intro": "Before every auto-routing turn the curator scores all manifest tools against the question. High scores become advisory hints for the assistant; low scores are only removed once the manifest exceeds the minimum size. Changes apply to the next turn without a deploy.",
      "enabled": "Curator active",
      "enabledHint": "Off = the LLM sees the unfiltered manifest without hints.",
      "tHigh": "Hint threshold (t_high)",
      "tHighHint": "At or above this score a tool earns a \"likely relevant\" hint in the prompt.",
      "tLow": "Pruning threshold (t_low)",
      "tLowHint": "Below this score a tool is removed from the manifest — only for large manifests, never for system skills.",
      "minTools": "Minimum manifest size for pruning",
      "minToolsHint": "Pruning only activates when the manifest holds more tools than this value.",
      "maxHints": "Maximum hints per turn",
      "maxHintsHint": "Upper bound for tool hints in the system prompt.",
      "invalidThresholds": "The pruning threshold must not exceed the hint threshold.",
      "saved": "Saved",
      "loadError": "Routing configuration could not be loaded."
    },
    "lifecycle": {
      "draft": "Draft",
      "testing": "Testing",
      "active": "Live"
    },
    "permissions": {
      "editTitle": "Permissions for {{name}}",
      "clientsLabel": "Clients",
      "clientsHint": "Which clients may use this tool. Empty = all clients (open, provided no role is set either).",
      "rolesLabel": "Roles",
      "rolesHintNoClient": "Without a client selection only global roles are shown. Pick clients above to surface their roles. Empty = open (provided no clients are set either).",
      "rolesHintOwner": "Roles of the owner client + global roles. Empty = every user of the owner client may use the tool.",
      "ownerInherited": "Client: {{name}} — inherited from the source (owner client). Only callers of this client reach this tool; refine the roles within the client here if needed.",
      "rolesHintFiltered": "Shows global roles + roles of the chosen clients. Empty = no role filter; admin-only is set explicitly via the admin role.",
      "noClients": "No clients available.",
      "noRoles": "No matching roles available.",
      "global": "global",
      "cascadeHint": "This selection is written to all {{count}} underlying tools, overwriting their individual rights."
    },
    "skills": {
      "title": "Skills",
      "subtitle": "Curated TQS endpoints as agent tools — permissions, visibility, response projection.",
      "totalCount": "{{count}} skills",
      "loading": "Loading skills...",
      "errorTitle": "Failed to load skills",
      "empty": "No skills registered yet. Coming soon: \"Create skill from endpoint\" wizard.",
      "createBtn": "New skill",
      "active": "active",
      "inactive": "inactive",
      "ratePerMin": "{{count}}/min",
      "cols": {
        "name": "Name",
        "target": "Endpoint",
        "visibility": "Visibility",
        "role": "Role",
        "params": "Params",
        "rateLimit": "Rate limit",
        "status": "Status"
      },
      "fields": {
        "name": "Name (must have tqs__ prefix)",
        "description": "Description (for the agent)",
        "descriptionPlaceholder": "What does this skill do? When should the agent use it?",
        "visibility": "Visibility",
        "rateLimit": "Rate limit (per minute)",
        "status": "Status",
        "publicHint": "⚠ Backend currently rejects visibility=public until ALLOW_PUBLIC_SKILLS=true (see #316).",
        "nameInvalid": "Must match: tqs__[a-z][a-z0-9_]* (backend CHECK constraint).",
        "publicSubmitBlocked": "visibility=public is currently blocked by the backend (#316). Switch to internal or set ALLOW_PUBLIC_SKILLS=true.",
        "visibilityPublicM2m": "public (M2M)"
      },
      "create": {
        "title": "Create new skill",
        "step1": "Step 1/3 — pick the TQS endpoint to wrap.",
        "step2": "Step 2/3 — name, description, visibility, rate limit.",
        "step3": "Step 3/3 — configure parameters (free / preset / context_binding).",
        "loadingEndpoints": "Loading available endpoints...",
        "searchEndpoints": "Search — path, summary, tag…",
        "endpointHint": "{{count}} skill-eligible endpoints (canonical dependency set: only routes with AuthContext).",
        "noParams": "This endpoint has no parameters.",
        "paramsHint": "Mode determines where the value comes from: free = agent input, preset = DB-fixed, context_binding = pulled from AuthContext.",
        "submit": "Create skill",
        "invalidJson": "Invalid JSON format",
        "alreadyWrapped": "already wrapped"
      },
      "edit": {
        "title": "Edit skill",
        "partialSaveError": "Skill metadata saved, but updating the permissions failed: {{message}}. Please save again."
      },
      "permissions": {
        "title": "Access permissions",
        "hint": "Empty = no filter. Otherwise: caller needs a matching role AND a matching client (OR within each column).",
        "roles": "Allowed roles",
        "clients": "Allowed clients",
        "noRoles": "No roles available.",
        "noClients": "No clients available."
      },
      "delete": {
        "title": "Delete skill?",
        "confirm": "Skill {{name}} will be permanently deleted. Audit rows in tool_invocations are preserved."
      },
      "test": {
        "title": "Test call (admin-only)",
        "run": "Run skill",
        "noFreeParams": "Skill has no free parameters — test call runs without args.",
        "result": "Result (projected):"
      },
      "detail": {
        "target": "Target endpoint",
        "category": "Category",
        "visibility": "Visibility & status",
        "parameters": "Parameters ({{count}})",
        "noParams": "No parameters configured.",
        "permission": "Permission gate",
        "requiredRole": "Required role",
        "requiredKAs": "Required KAs",
        "requiredTwLevels": "Required TW levels",
        "noGate": "No gate configured — all internal users may call.",
        "assignments": "Assignments ({{count}})",
        "projection": "Response projection",
        "noProjection": "No projection — skill can only be called via test_mode (admin).",
        "meta": "Metadata",
        "created": "Created",
        "updated": "Updated",
        "handler": "Capability handler",
        "presetLabel": "Preset",
        "bindingLabel": "Binding"
      },
      "handler": {
        "configLabel": "Handler configuration",
        "createBtn": "Create",
        "createBtnShort": "Handler skill",
        "createSubtitle": "Wraps a server-side capability as one tool. Pick a handler type from the catalog.",
        "createTitle": "Create handler skill",
        "descLabel": "Description",
        "invalidJson": "Invalid JSON in field \"{{field}}\".",
        "loadingCatalog": "Loading handler catalog...",
        "nameHint": "Must match the pattern ^tqs__[a-z][a-z0-9_]*$.",
        "nameLabel": "Tool name",
        "noConfig": "This handler has no configuration.",
        "projectionHint": "Required before calling — without a projection the backend rejects the invocation.",
        "projectionLabel": "Response projection (one JSONPath per line)",
        "rateLabel": "Rate limit / min",
        "typeLabel": "Handler type",
        "visibilityLabel": "Visibility"
      },
      "modes": {
        "free": "free (agent input)",
        "preset": "preset (fixed in DB)",
        "context_binding": "from context (auth)"
      },
      "params": {
        "mode": "Mode",
        "presetValue": "Preset value (JSON)",
        "contextSource": "Context source"
      }
    },
    "system": {
      "schema": {
        "autoGenerateHintOData": "Creates the three tools query / find_rows / describe_tables in draft. Every call is rendered server-side as an OData request — filters over several columns, no joins or aggregation yet. Idempotent — existing operation_ids are skipped.",
        "unreadableSets": "{{count}} entity set(s) not readable with the stored credentials — left out:",
        "unreadableSetsHint": "This is the list for the system's operator: extend the read permissions, then apply again.",
        "browser": {
          "title": "Tables & fields",
          "titleClasses": "Classes & properties",
          "filterPlaceholder": "Filter by name or description …",
          "hint": "The model reads descriptions through describe_tables; the display column is what find_rows searches and returns as the label. Both survive a re-apply.",
          "noMatches": "No match for “{{query}}”.",
          "noDescription": "No description",
          "editDescription": "Edit description",
          "entityDescriptionLabel": "Table description (for the model)",
          "saveFailed": "Saving failed.",
          "loadingAttributes": "Loading fields …",
          "displayColumn": "Display column",
          "displayColumnHeuristic": "(pick automatically)",
          "attributesCount": "{{count}} fields",
          "primaryKey": "Primary key",
          "columns": {
            "name": "Field",
            "type": "Type",
            "values": "Values",
            "description": "Description"
          },
          "writeEndpoint": {
            "open": "Create write endpoint",
            "hint": "Creates a draft “POST /{{table}}” that workflows use to create records after confirmation in the chat. Only the checked fields may be written – the router refuses everything else.",
            "all": "All",
            "none": "None",
            "count": "{{count}} of {{total}} fields",
            "key": "Key field",
            "keyHint": "Key fields always go into the response so the new record’s number comes back. Better uncheck fields the source assigns itself (e.g. the document number).",
            "create_one": "Create draft with {{count}} field",
            "create_other": "Create draft with {{count}} fields",
            "created": "Draft “{{operation}}” created. Review and activate it in the “Tools” tab.",
            "exists": "This table already has a write endpoint.",
            "failed": "The endpoint could not be created."
          }
        },
        "persistedTools": "Persisted: {{count}} tools",
        "toolsTitle": "Tools of this source",
        "toolParams": "Parameters",
        "toolFixed": "Fixed",
        "toolExists": "Endpoint exists",
        "counts": "Counts from MCP",
        "countsBtn": "Pull counts",
        "countsHint": "Fetches instance and property counts from the analytics tool of a connected MCP source and writes them onto the schema. Reads only; no profiling. Takes about 30 seconds on large graphmarts.",
        "countsNoMcp": "No active MCP system connected — without one there is no analytics tool to count.",
        "countsSource": "MCP system",
        "countsResult": "{{entities}} classes and {{attributes}} properties updated ({{measured}} counted, as of {{time}}).",
        "countsStatements": "Statements in the graphmart: {{count}}",
        "countsEmpty": "Without instances: {{names}}",
        "countsUnmatched": "Counted but not in the schema: {{names}}",
        "apply": "Apply schema",
        "applyConfirmAction": "Apply schema",
        "applyConfirmBody": "Entities and attributes are persisted (full replace). Entities that disappeared are deleted together with their attributes; active endpoints referencing removed fields are flipped to \"broken\" and removed from the LLM manifest.",
        "applyConfirmTitle": "Apply schema?",
        "autoGenConfirmAction": "Generate",
        "autoGenConfirmBody": "Up to {{max}} templates are created in draft. Existing operation_ids are skipped — the call is idempotent. Activation happens manually per endpoint.",
        "autoGenConfirmRegenerate": "Generate + regenerate",
        "autoGenConfirmTitle": "Generate templates?",
        "autoGenerate": "Generate tools from schema",
        "autoGenerateBtn": "Auto-generate templates",
        "autoGenerateHint": "Creates list/get/count/search templates per entity in draft. Idempotent — existing operation_ids are skipped.",
        "connectionProbeFailed": "Connection probe failed (HTTP {{status}}). Check the DSN, network reachability or the read-only user grants.",
        "diff": {
          "added": "Added",
          "drift": "Schema drift detected ({{time}}):",
          "endpointsBroken_one": "{{count}} endpoint flipped to broken — missing refs.",
          "endpointsBroken_other": "{{count}} endpoints flipped to broken — missing refs.",
          "endpointsHealthy_one": "{{count}} endpoint recovered.",
          "endpointsHealthy_other": "{{count}} endpoints recovered.",
          "firstRun_one": "Initial introspect: {{count}} entry captured ({{time}}).",
          "firstRun_other": "Initial introspect: {{count}} entries captured ({{time}}).",
          "noDrift_one": "No drift — {{count}} entry unchanged ({{time}}).",
          "noDrift_other": "No drift — {{count}} entries unchanged ({{time}}).",
          "removed": "Removed",
          "unchanged": "Unchanged",
          "relationsAdded": "+ {{count}} relations",
          "relationsRemoved": "− {{count}} relations"
        },
        "hint": "Preview = read-only diff. Apply = persists the schema + drift recheck of all endpoints.",
        "introspect": "Schema introspect",
        "persistedClasses_one": "Persisted: {{count}} class",
        "persistedClasses_other": "Persisted: {{count}} classes",
        "persistedTables_one": "Persisted: {{count}} table",
        "persistedTables_other": "Persisted: {{count}} tables",
        "preview": "Preview schema",
        "regenerateHint": "Existing endpoints with auto_generated=true AND hand_modified=false are rolled in place to the current template default. Endpoint IDs, activation status and admin permissions are kept. Hand-edited tools are skipped.",
        "regenerateLabel": "Regenerate existing auto-generated tools",
        "title": "Schema",
        "unsupported": "Introspect is not available for this connector type — endpoints have to be created manually in the Tools tab."
      },
      "activity": {
        "cols": {
          "tool": "Tool"
        },
        "empty": "No invocations for this system with the current filters.",
        "filterEndpoint": "Tool",
        "openGlobal": "Open in global history",
        "resetFilters": "Reset filters",
        "title": "Activity"
      },
      "back": "Back",
      "backToList": "Back to overview",
      "connection": {
        "auth": "Authentication",
        "authNote": "Credentials are Fernet-encrypted (ROUTER_AUTH_ENCRYPTION_KEY). In an emergency: rotate the password in the external system + update the source via the API.",
        "defaultPerms": "Default permissions for new tools",
        "defaultPermsEmpty": "None — new tools start admin-only.",
        "defaultPermsHint": "Copied as permission rows to every new endpoint (auto-generated and manual). Change them via \"Edit\" above.",
        "deleteBody": "System \"{{name}}\" and all its tools will be deleted permanently. Audit rows in tool_invocations are kept.",
        "deleteTitle": "Delete system?",
        "metadata": "Connection metadata",
        "noMetadata": "No non-secret fields stored.",
        "rotateBody": "Auth config (token / password / DSN) is read-only here. Rotation currently goes through the API directly — a dedicated workflow is planned as a follow-up.",
        "rotateTitle": "Credential rotation not in the UI yet",
        "title": "Connection & auth"
      },
      "notFound": "System not found — it may have been deleted.",
      "overview": {
        "activeTools": "Live",
        "activityTitle": "Activity (last 50)",
        "brokenTools": "Broken",
        "createdAt": "Created",
        "draftTools": "Drafts",
        "lastHealthCheck": "Last health check",
        "meta": "Metadata",
        "notes": "Operational notes",
        "successInvocations": "Successful",
        "successRate": "Success rate",
        "testingTools": "In testing",
        "toolsTitle": "Tools",
        "totalInvocations": "Calls",
        "totalTools": "Total",
        "updatedAt": "Updated",
        "viewActivity": "Open activity",
        "viewTools": "Open tools"
      },
      "review": {
        "bulkPartialError": "Status change failed: {{message}}",
        "bulkSetTo": "Set to:",
        "created": "created",
        "empty": "No auto-generated tools yet. Run the auto-generate button above, then continue here.",
        "failed": "failed",
        "failedEntities": "Entities with errors: {{names}}",
        "lastRunTitle": "Last auto-generate run",
        "lifecycleNote": "Lifecycle: draft → test → live. The backend only allows forward transitions, so both steps are separate bulk actions.",
        "noMatches": "No tools match the current filter.",
        "openDetails": "Details",
        "regenerated": "regenerated",
        "skipped": "skipped",
        "title": "Auto-generated tools",
        "generalGroup": "General"
      },
      "tools": {
        "bulkDelete": "Delete",
        "bulkDeleteBody": "The selected tools will be deleted permanently. Their call history is kept.",
        "bulkDeleteTitle_one": "Delete {{count}} tool?",
        "bulkDeleteTitle_other": "Delete {{count}} tools?",
        "bulkSelected": "{{count}} selected",
        "bulkSetTo": "Set status:",
        "cols": {
          "health": "Health",
          "lastInvoked": "Last call",
          "operation": "Operation",
          "status": "Status"
        },
        "create": "New tool",
        "createManual": "Create manually",
        "emptyHint": "Fastest way: switch to the Schema tab and use auto-generate — it creates list/get/count/search templates for every class or table.",
        "emptyTitle": "No tools for this system yet",
        "noMatches": "No matches for the current filters.",
        "search": "Search (operation ID / description)…",
        "title": "Tools",
        "selectAll": "Select all",
        "selectTool": "Select tool {{name}}"
      },
      "tabs": {
        "overview": "Overview",
        "tools": "Tools",
        "schema": "Schema",
        "connection": "Connection & auth",
        "activity": "Activity"
      }
    },
    "router": {
      "title": "Connected systems",
      "subtitle": "External data sources (REST, Postgres, SPARQL). Credentials are encrypted; raw responses never reach the agent.",
      "clientScope": {
        "label": "Client",
        "own": "Own client",
        "hint": "Shows this client's systems and the shared systems every client sees."
      },
      "ownerBadgeHint": "Owner client — only callers of this client see and use this source's tools.",
      "sharedBadge": "shared",
      "sharedBadgeHint": "No owner client set — the source is usable by ALL clients with router access. Set an owner in the edit dialog.",
      "active": "active",
      "inactive": "inactive",
      "introspect": "introspect",
      "longRunning": "long-running",
      "connectorTypesTitle": "Connector types",
      "connectorTypesHint": "Click a connector type to connect a new system of that kind.",
      "sourcesTitle": "Connected systems",
      "sourcesCount": "{{count}} system(s)",
      "empty": "No systems connected yet. Pick a connector type above to start the wizard.",
      "cols": {
        "name": "Name",
        "type": "Type",
        "auth": "Auth",
        "health": "Health",
        "status": "Status"
      },
      "fields": {
        "name": "Name (slug, lowercase, _, min. 2 chars)",
        "nameInvalid": "Must match ^[a-z][a-z0-9_]*$ (backend CHECK constraint).",
        "nameHint": "Used as prefix in tool names: {name}__{operation}.",
        "displayName": "Display name",
        "description": "Description / Operational notes",
        "descriptionPlaceholder": "Owner, vault path for credentials, doc link, use case…",
        "descriptionHint": "Tip: jot down PW recovery via \"Owner: …\" + \"Credentials in 1Password / Vault X\".",
        "authMode": "Auth mode",
        "authModeFixed": "Auth mode",
        "status": "Status",
        "statusHint": "Inactive sources don't expose endpoints in the tool manifest.",
        "communicatorLabel": "cdbChat label",
        "communicatorLabelHint": "Shown in cdbChat as a badge next to every tool call from this source and as a source tag under each answer. Empty = falls back to the display name.",
        "turnBudget": "Steps per answer",
        "turnMaxIterations": "Rounds",
        "turnMaxToolCalls": "Tool calls",
        "turnBudgetHint": "For systems whose queries need many steps (e.g. rankings over a graph). Applies from the first call of this system in an answer and only raises the limit. Empty = default ({{defaultIterations}} rounds, {{defaultToolCalls}} calls), at most {{maxIterations}} and {{maxToolCalls}}.",
        "turnBudgetInvalid": "Steps per answer: a whole number from 1 to {{maxIterations}} (rounds) or {{maxToolCalls}} (calls), or leave it empty.",
        "communicatorColor": "Badge color",
        "communicatorPreview": "Preview:",
        "ownerClient": "Owner client",
        "ownerClientShared": "— shared (all clients) —",
        "ownerClientHint": "Hard boundary: with an owner set, ONLY callers of that client see and use this source's tools — including future endpoints. Without an owner the source is cross-client.",
        "ownerClientFixedHint": "The owner is set when the system is connected and cannot change afterwards — the system is stored in its client's database. For another owner, connect the system again."
      },
      "create": {
        "title": "New source — {{type}}",
        "step1": "Step 1/2 — name, description, connection metadata.",
        "step2": "Step 2/2 — auth mode + credentials. Stored Fernet-encrypted.",
        "connectionSection": "Connection metadata",
        "authSection": "Credentials (stored encrypted)",
        "noAuthFields": "Auth mode {{mode}} needs no fields.",
        "submit": "Create source",
        "successHint": "Source created. Tip: for Postgres sources, click \"Re-Introspect\" in the detail drawer to capture schema + verify connection."
      },
      "edit": {
        "title": "Edit source",
        "authNote": "Auth config and connection config are not editable here — credential rotation is a separate workflow.",
        "connectionHint": "Note: changes take effect immediately. If e.g. the ontology namespace changes, existing slot IRIs become invalid — check existing tools again afterwards.",
        "connectionSection": "Connection metadata",
        "extraKeysHint": "Connector-specific fields (not declared in the catalog schema, read by the backend by convention):"
      },
      "delete": {
        "title": "Delete source?",
        "confirm": "Source \"{{name}}\" and all its endpoints will be permanently deleted. Audit rows in tool_invocations are kept."
      },
      "detail": {
        "status": "Status",
        "lastHealthCheck": "Last health check",
        "connection": "Connection metadata",
        "noConnectionConfig": "No non-secret connection fields stored.",
        "auth": "Authentication",
        "authNote": "Credentials are Fernet-encrypted (ROUTER_AUTH_ENCRYPTION_KEY). In emergencies: rotate the PW in the external system + update the source via PUT /sources/{id}.",
        "notes": "Operational notes",
        "introspect": "Schema introspect",
        "previewSchema": "Preview Schema",
        "applySchema": "Apply Schema",
        "introspectHint": "Preview = read-only diff. Apply = persists schema + drift-rechecks every endpoint.",
        "introspectOk": "OK — {{count}} tables discovered ({{time}})",
        "introspectFirstRun": "Initial introspect: {{count}} tables captured ({{time}}).",
        "introspectFirstRunClasses": "Initial introspect: {{count}} classes captured ({{time}}).",
        "introspectNoDrift": "No drift — {{count}} tables unchanged ({{time}}).",
        "introspectNoDriftClasses": "No drift — {{count}} classes unchanged ({{time}}).",
        "relationsAdded": "{{count}} relations added",
        "relationsRemoved": "{{count}} relations removed",
        "introspectDrift": "Schema drift detected ({{time}}):",
        "previewNote": "Preview — nothing was saved. Click \"Apply Schema\" to commit.",
        "appliedNote": "Schema persisted. Active endpoints were rechecked against the new schema.",
        "endpointsNowBroken": "{{count}} endpoint(s) flipped to broken — missing slot or JOIN refs.",
        "endpointsNowHealthy": "{{count}} endpoint(s) recovered — refs resolve again.",
        "autoGenerateHintStructured": "Creates the three server-rendered tools query / find_rows / describe_tables in draft (or, optionally, the per-table set). Idempotent — existing operation_ids are skipped.",
        "familyStructured": "Structured tools (default)",
        "familyStructuredHint": "query, find_rows, describe_tables — filters over several columns, joins along the relations with filters on either side, aggregation. The statement is rendered server-side against the schema on every call.",
        "familyLegacy": "Per-table templates",
        "familyLegacyHint": "list / get_by_id / count / aggregate / search per table plus one join template per relation — one filter per call, slots in the manifest.",
        "autoGenerateTemplates": "Auto-Generate Templates",
        "autoGenerateHint": "Creates list/get_by_id/count/aggregate/search per entity in draft. Idempotent.",
        "autoGenerateResult": "{{created}} templates created, {{skipped}} skipped ({{time}}).",
        "applyConfirmTitle": "Apply schema?",
        "applyConfirmBody": "Tables + columns are persisted (full replace). Tables no longer in the live DB are deleted including their attributes; active endpoints with slot or JOIN refs against removed fields flip to \"broken\" and leave the LLM manifest.",
        "applyConfirmHint": "Tip: click \"Preview Schema\" first to inspect the diff before committing.",
        "applyConfirmAction": "Apply schema",
        "autoGenConfirmTitle": "Generate templates?",
        "autoGenConfirmBody": "Up to {{max}} templates will be created in draft ({{entities}} entities × up to 5 templates per entity depending on schema shape). Existing operation_ids are skipped — the call is idempotent. Activation is manual per endpoint in the detail drawer.",
        "autoGenConfirmBodySparql": "Up to {{max}} SPARQL templates will be created in draft ({{entities}} classes × list/get_by_uri/count/search, plus relations_<class> when the class has outgoing object-properties). Existing operation_ids are skipped — the call is idempotent. Activation is manual per endpoint in the detail drawer.",
        "autoGenConfirmAction": "Generate",
        "currentSchema": "Currently persisted: {{count}} tables.",
        "added": "Added",
        "removed": "Removed",
        "unchanged": "Unchanged",
        "endpoints": "Endpoints ({{count}})",
        "noEndpoints": "No endpoints yet. Click \"New endpoint\" to start the wizard.",
        "addEndpoint": "New endpoint",
        "meta": "Metadata",
        "createdBy": "Created by",
        "createdAt": "Created",
        "updatedAt": "Updated"
      },
      "endpointCreate": {
        "title": "New endpoint — {{source}}",
        "step1": "Step 1 — operation ID + description.",
        "step2": {
          "postgres": "Step 2 — SQL template.",
          "rest": "Step 2 — HTTP method + path (+ optional body template).",
          "sparql": "Step 2 — SPARQL query (POST is set automatically)."
        },
        "step3": {
          "slots": "Step 3 — whitelist definition for every {{...}} placeholder in the template."
        },
        "execSection": "Execution",
        "projectionSection": "Response projection (JSONPath whitelist)",
        "submit": "Create endpoint (status: draft)",
        "placeholdersBlock": "{{...}} placeholders ({{names}}) in template/path/body — remove them, create the endpoint, then wire slots in the detail drawer. Backend would otherwise reject the save with \"missing slot_definitions\".",
        "step4": {
          "returns": "Step 4 — optional: result entity + cardinality as a hint."
        },
        "step5": {
          "execution": "Step 5 — execution config + visible fields."
        }
      },
      "endpointFields": {
        "operationId": "Operation ID (slug, lowercase, _, min. 2 chars)",
        "operationIdInvalid": "Must match ^[a-z][a-z0-9_]*$ (backend CHECK constraint).",
        "operationIdHint": "Tool name in manifest: {{src}}__{{op}}",
        "description": "Description (for the agent — what it does, when to use)",
        "descriptionPlaceholder": "e.g. \"Lists active users per client. Use when asked about user statistics.\"",
        "method": "Method",
        "path": "Path",
        "pathHint": "Mark path params as {placeholder} — wired up later in endpoint params.",
        "sqlTemplate": "SQL template",
        "sqlHint": "Only SELECT/WITH at statement start — backend rejects otherwise. Named params via :name, wired up later in endpoint params.",
        "sqlNotReadOnly": "⚠ Statement doesn't start with SELECT/WITH — backend will reject this.",
        "bodyTemplate": "Body template (optional)",
        "bodyTemplateHint": "JSON string with {{slot}} placeholders for admin-controlled identifiers (Cypher label, Mongo $match column, …). Caller body params are deep-merged.",
        "bodyTemplateMethodMismatch": "⚠ Method {{method}} typically sends no body — template will be ignored.",
        "bodyTemplateInvalidJson": "⚠ Not valid JSON after slot substitution: {{error}}",
        "timeoutSeconds": "Timeout (seconds, max 600)",
        "rateLimit": "Rate limit (/min)",
        "resultRowCap": "Result row cap",
        "resultRowCapHint": "Hard cap — extra rows are dropped + truncated marker set.",
        "longRunning": "Long-running (ARQ async)",
        "requiresCatalogValidation": "Catalog validation (properties[])",
        "requiresCatalogValidationHint": "Free properties[] payloads are validated against the property catalog before the SPARQL build — misses become a clarification instead of hallucinated paths.",
        "projectionHint": "Empty = nothing exposed to LLM (opt-in). Examples: $.id, $.results[*].name, $[*].user_count",
        "projectionEmpty": "⚠ No projection defined — endpoint only callable via /test (admin-only).",
        "mcpTool": "Tool on the MCP server",
        "mcpToolHint": "Exact name on the server (camelCase allowed) — not the operation id the model sees.",
        "mcpFixedArguments": "Fixed arguments (JSON object, optional)",
        "mcpFixedArgumentsHint": "Whatever stands here is fixed by the source — the model cannot override it and never sees it as a parameter.",
        "isFallback": "Free-query fallback",
        "isFallbackHint": "This endpoint appears in chat only after a call to the source it backs came back empty in the same turn. Answers using it are marked. One per backed source.",
        "fallbackForSource": "Backs the templates of",
        "fallbackForOwnSource": "Own source",
        "fallbackForSourceHint": "The connector belongs to the source. A graph source's free query therefore lives on the MCP system and backs the graph source here: it appears when that source's templates found nothing.",
        "callableFrom": "Callable from",
        "callableFromChat": "Chat and workflows",
        "callableFromWorkflows": "Workflows only",
        "callableFromHint": "Workflows only: the chat does not offer the endpoint; a workflow step still calls it.",
        "callableFromLocked": "This endpoint writes to the source. It runs only as a workflow step a person confirms.",
        "sparqlHint": "SELECT / CONSTRUCT / ASK / DESCRIBE. Method=POST is set automatically. Slot whitelists via {{name}} (e.g. {{cls}} for class IRIs) — defined in the next step.",
        "sparqlNotStandard": "⚠ Query does not start with PREFIX/SELECT/CONSTRUCT/ASK/DESCRIBE.",
        "sparqlPath": "Path override (optional)",
        "sparqlPathHint": "Leave empty to use the path configured on the system. Set it here if this tool should query a different dataset.",
        "sparqlQuery": "SPARQL query"
      },
      "endpointEdit": {
        "title": "Edit endpoint",
        "returnsHint": "Both fields are optional. They are used for grouping in the auto-generate review tab.",
        "returnsSection": "Returns (hint)"
      },
      "endpointDelete": {
        "title": "Delete endpoint?",
        "confirm": "Endpoint \"{{op}}\" will be permanently deleted. Audit rows in tool_invocations are kept."
      },
      "endpointDetail": {
        "queryBuilderHint": "Server-rendered: the statement is built per call from the model's structured payload and the introspected schema (tables, columns, relations, known values). No template, no slots — the rendered SQL shows in the test result and in the trace.",
        "renderedSql": "Rendered SQL:",
        "renderedRequest": "Rendered request:",
        "joinPath": "Join path:",
        "description": "Description",
        "shape": "Shape",
        "bodyTemplate": "Body template (slot-substituted, deep-merged with caller body):",
        "execution": "Execution config",
        "slots": "Slots ({{count}})",
        "params": "Parameters",
        "permissions": "Access permissions",
        "projection": "Response projection",
        "healthBroken": "broken",
        "autoGenerated": "auto-generated",
        "brokenTitle": "Endpoint is broken — excluded from the manifest",
        "brokenFallback": "Schema drift since the last apply. Check slot definitions or JOIN refs.",
        "lifecycle": "Lifecycle",
        "currentStatus": "Current status:",
        "transitionTo": "→ {{target}}",
        "atActive": "Endpoint is active in the manifest.",
        "lifecycleHint": "draft → testing → active (backwards blocked). Only active appears in the tool manifest.",
        "recentInvocations": "Recent invocations",
        "noInvocations": "No invocations for this endpoint yet.",
        "meta": "Metadata",
        "createdBy": "Created by",
        "createdAt": "Created",
        "updatedAt": "Updated"
      },
      "errors": {
        "connectionProbeFailed": "Connection probe failed (HTTP {{status}}). Check DSN, network reachability, and RO-user grants — server logs have details.",
        "authFieldRequired": "Auth field \"{{label}}\" is required.",
        "unknownAuthMode": "Unknown auth mode: {{mode}}",
        "paramDeleteFailed": "Failed to delete param: {{message}}"
      },
      "params": {
        "empty": "No params defined. If the template has :placeholder or {placeholder}, wire them up here.",
        "addBtn": "Add param",
        "nameRequired": "Name is required.",
        "fields": {
          "name": "Name",
          "location": "Location",
          "description": "Description (for the agent)",
          "descriptionPlaceholder": "What should the agent put here?",
          "required": "Required",
          "attribute": "Source attribute (optional)",
          "attributeInheritsType": "Data type is taken from the attribute ({{type}}).",
          "attributeNone": "(none)",
          "dataType": "Data type",
          "dataTypeNone": "(not set)",
          "defaultValue": "Default value (JSON, optional)",
          "defaultValueHint": "JSON literal. Strings in quotes. Empty = no default — the agent must then supply the value."
        }
      },
      "slots": {
        "empty": "No slots defined. If the template or path contains {{placeholder}}, wire them up here.",
        "missing": "Template references {{...}} without slot definition: {{names}}. Add the slot or remove the placeholder.",
        "orphan": "Slots not referenced as {{name}} in the template: {{names}}. Delete the slot or extend the template.",
        "addBtn": "Add slot",
        "whitelistCount": "{{count}} values",
        "wizardHintTitle": "Slot whitelists still missing",
        "wizardHintBody": "Detected: {{names}}. After create, set the whitelist per placeholder in the endpoint detail drawer's Slots section — otherwise the backend validator rejects the save.",
        "types": {
          "column": "Column",
          "table": "Table",
          "enum": "Enum (free literals)",
          "class": "Class (SPARQL class IRI)",
          "predicate": "Predicate (SPARQL property IRI)"
        },
        "fields": {
          "name": "Name",
          "type": "Type",
          "description": "Description (for the agent)",
          "descriptionPlaceholder": "What does the agent pick here? e.g. \"Filter column\"",
          "required": "Required",
          "entity": "Entity (table)",
          "pickEntity": "— pick —",
          "allowedColumns": "Whitelisted columns",
          "allowedEntities": "Whitelisted entities",
          "allowedValues": "Allowed values (comma-separated)",
          "allowedClassIris": "Whitelisted classes (full IRIs)",
          "classIrisHint": "The connector auto-wraps the IRI in <…> — templates write {{cls}} instead of <{{cls}}>.",
          "noEntitiesYet": "No classes persisted yet — run \"Apply Schema\" on the source first.",
          "allowedPredicateIris": "Whitelisted predicates (full IRIs)",
          "predicateIrisHint": "The connector auto-wraps the IRI in <…> — templates write {{pred}} instead of <{{pred}}>.",
          "noRelationsYet": "No object-properties persisted — apply the source schema or the source has no relations."
        },
        "errors": {
          "nameRequired": "Name is required.",
          "nameFormat": "Name must start with a lowercase letter and contain only a-z, 0-9, _.",
          "duplicateName": "A slot with this name already exists.",
          "entityRequired": "Pick the entity this slot is scoped to.",
          "columnsRequired": "At least one column must be in the whitelist.",
          "entitiesRequired": "At least one entity must be in the whitelist.",
          "valuesRequired": "Enter at least one comma-separated value (e.g. ASC, DESC).",
          "enumValueShape": "Values must be identifier-shaped (a-zA-Z_, then a-zA-Z0-9_) — no spaces or special characters. Invalid: {{names}}",
          "classIrisRequired": "At least one class must be in the whitelist.",
          "predicateIrisRequired": "At least one predicate must be in the whitelist."
        },
        "allowed": "Allowed values",
        "description": "Description",
        "descriptionPlaceholder": "Optional explanation for the agent",
        "detectedInQuery": "Detected placeholders: {{names}} — whitelists are set in the next step.",
        "entity": "Entity",
        "required": "Required",
        "stepHint": "Every {{...}} placeholder in the template needs a whitelist. Separate values with line breaks.",
        "type": "Type",
        "entityNotPicked": "(not picked yet)"
      },
      "defaultPerms": {
        "title": "Default permissions for new endpoints",
        "hint": "Copied as permission rows into every new endpoint (auto-generated and admin-manual). Empty = admin-only.",
        "empty": "None — new endpoints are initially admin-only.",
        "addBtn": "Add permission",
        "kind": "Type",
        "role": "Role",
        "client": "Client",
        "accessType": "Access"
      },
      "endpointPerms": {
        "hint": "Which roles and clients can see + use this endpoint. Empty = admin-only. Multiple entries = OR (one match is enough).",
        "empty": "No permissions — this endpoint is currently visible to admins only.",
        "addBtn": "Add permission",
        "kind": "Type",
        "role": "Role",
        "client": "Client",
        "accessType": "Access"
      },
      "colors": {
        "default": "Default",
        "blue": "Blue",
        "green": "Green",
        "red": "Red",
        "amber": "Amber",
        "violet": "Violet",
        "pink": "Pink",
        "cyan": "Cyan"
      },
      "connectBtn": "Connect system",
      "connectFirst": "Connect your first system",
      "connectorPicker": {
        "subtitle": "Choose the type of system to connect. The next step configures name, connection details and auth.",
        "title": "Connect a new system"
      },
      "emptyHint": "Connect your first external system (REST API, Postgres, SPARQL). Once connected, you can auto-generate tools or create them manually.",
      "emptyTitle": "No systems connected yet",
      "returns": {
        "cardinality": "Cardinality",
        "cardinalityNone": "(unknown)",
        "entity": "Result entity",
        "entityHint": "Which entity / class does this tool return? Leave empty for aggregates (count_*).",
        "entityNone": "(unknown)",
        "hint": "Optional — helps grouping in the auto-generate review and schema hinting for the agent. Both fields may stay empty.",
        "many": "Many rows (many)",
        "one": "One row (1)"
      },
      "stats": {
        "active": "Active",
        "connectorTypes": "Connector types",
        "healthy": "Healthy",
        "neverProbed": "Not checked yet",
        "systems": "Systems"
      },
      "systemCard": {
        "auth": "Auth",
        "brokenTools_one": "{{count}} broken tool",
        "brokenTools_other": "{{count}} broken tools",
        "open": "Open system {{name}}",
        "tools": "Tools"
      },
      "test": {
        "hint": "Admin-only · bypasses status & rate-limit · audited as mode=test",
        "noInputs": "No parameters or slots — start right away with \"Run test\".",
        "openInHistory": "Open in history",
        "params": "Parameters",
        "projected": "Projected (agent view)",
        "raw": "Raw (audit row)",
        "run": "Run test",
        "slots": "Slots",
        "title": "Test it"
      },
      "requiredBadge": "required",
      "deleteItem": "Delete",
      "removePermission": "Remove permission",
      "authFields": {
        "token": "Bearer token",
        "header": "Header name",
        "key": "API key",
        "username": "Username",
        "password": "Password",
        "tokenUrl": "Token URL",
        "clientId": "Client ID",
        "clientSecret": "Client secret",
        "scope": "Scope (optional)",
        "dsn": "Connection string (DSN)"
      }
    },
    "manifest": {
      "title": "Tool Manifest",
      "subtitle": "Preview of what a caller would see at /agent/tools. Skills + Router unified, vendor-formatted.",
      "subtitleEditable": "Table of every active agent tool with its permissions. Per tool: assign clients first, then roles. Empty = open to every authenticated user; admin-only is set explicitly via the admin role.",
      "simulateCaller": "Simulate caller type (admin preview)",
      "useMyContext": "— my own context —",
      "filterClient": "Filter: client",
      "allClients": "— all clients —",
      "externalM2mHint": "External M2M sees ONLY visibility=public skills and NO router tools (hard rule, credential-hijack prevention).",
      "empty": "No tools visible for this caller type.",
      "toolCount": "{{count}} tools in manifest",
      "toolCountFiltered": "{{shown}} of {{total}} tools (filter active)",
      "params": "Parameters (what the agent sees):",
      "noParams": "No parameters (agent calls without arguments).",
      "cols": {
        "tool": "Tool",
        "kind": "Type",
        "clients": "Clients",
        "roles": "Roles"
      },
      "noFilterPublic": "No filter set — public for everyone",
      "public": "public",
      "editPermissions": "Edit permissions"
    },
    "history": {
      "title": "Invocation History",
      "subtitle": "Audit trail of every tool call — skills + router. Caller, parameters, projected response, status.",
      "clientScopeHint": "Calls are kept with the calling person's client.",
      "filterSource": "Source type",
      "filterStatus": "Status",
      "empty": "No invocations matching current filters — either nothing called or filters too narrow.",
      "cols": {
        "time": "Time",
        "source": "Source",
        "mode": "Mode",
        "status": "Status",
        "duration": "Duration",
        "caller": "Caller"
      },
      "detail": {
        "title": "Invocation details",
        "summary": "Summary",
        "caller": "Caller",
        "params": "Params (input)",
        "response": "Response (post-projection)",
        "workflowRun": "Workflow run",
        "error": "Error",
        "source": "Source",
        "mode": "Mode",
        "status": "Status",
        "duration": "Duration",
        "time": "Time",
        "userId": "User ID",
        "apiKeyId": "API Key ID",
        "client": "Client",
        "ka": "KA",
        "arqJob": "Background job (ARQ)"
      },
      "drillDown": {
        "label": "Filtered to tool",
        "clear": "Clear filter"
      },
      "sessionFilter": {
        "label": "Filtered to session",
        "turnLabel": "Turn",
        "turnPending": "Turn-exact filtering arrives with the tqs update — currently session-wide.",
        "back": "Back to session trace"
      },
      "emptySession": "No invocations for this session — either no tool calls ran or the entries have already been deleted by the retention policy.",
      "sourceTypes": {
        "routerRest": "System (REST/SPARQL)",
        "routerPostgres": "System (Postgres)",
        "workflow": "Workflow",
        "builtin": "cdbChat (built-in)"
      },
      "filterMode": "Mode",
      "filterSince": "From (since)",
      "filterUntil": "Until",
      "clearExtraFilters": "Reset extra filters",
      "callerApiKey": "API key",
      "callerSystem": "System"
    },
    "chat": {
      "running": "Running…",
      "completed": "Done",
      "failed": "Failed",
      "skipped": "Skipped",
      "argsLabel": "Arguments",
      "resultLabel": "Result",
      "durationMs": "{{ms}} ms",
      "truncatedHint": "Result truncated server-side to {{bytes}} bytes",
      "truncatedHintNoBytes": "Result truncated server-side",
      "manifestTruncated": "Showing {{shown}} of {{total}} available tools",
      "progress": "Planning next steps… (iteration {{iteration}} / {{budget}}, {{completed}} tools done)",
      "loopExceeded": {
        "max_tool_calls": "Maximum tool calls per turn reached ({{cap}})",
        "max_iterations": "Maximum loop iterations reached ({{cap}})"
      },
      "errorCodes": {
        "permission_denied": "Permission denied",
        "rate_limited": "Rate limit exceeded",
        "validation_error": "Invalid arguments",
        "tool_not_found": "Tool not found",
        "internal_error": "Internal error",
        "client_error": "Client error",
        "invalid_args_json": "Arguments were not valid JSON",
        "async_not_supported": "Background tools are not yet supported in chat",
        "unknown_tool": "Tool not in manifest",
        "loop_ended": "Loop ended — tool did not complete",
        "limit_exceeded": "Token or cost limit reached"
      },
      "empty": "No tool calls in this turn",
      "sourceTypes": {
        "skill": "Skill",
        "router_rest": "Router (REST)",
        "router_postgres": "Router (Postgres)",
        "builtin": "cdbChat (built-in)"
      }
    },
    "propertyCatalog": {
      "sectionTitle": "Property Catalog ({{count}})",
      "reviewQueue": "{{count}} to review",
      "add": "Entry",
      "hint": "The catalog maps user terms (\"Price Group\") deterministically to property IRIs + paths. Auto-derived entries are learned by the schema-walk LLM and should be reviewed.",
      "empty": "No entries match this filter. Click \"Entry\" to add one manually.",
      "filterAll": "All entries",
      "filterReviewQueue": "Review queue (auto + validated)",
      "filterAutoDerived": "Only auto-discovered",
      "filterAutoValidated": "Only system-validated",
      "filterManual": "Manual",
      "filterProfileDerived": "From profiles",
      "filterSourceIntrospect": "From schema",
      "promote": "Confirm as \"manual\"",
      "aliasesLabel": "Aliases",
      "createTitle": "New catalog entry",
      "editTitle": "Edit catalog entry",
      "deleteTitle": "Delete catalog entry?",
      "deleteBody": "Entry \"{{label}}\" will be deleted. Skills referencing it as an override will fall back to catalog miss + discovery.",
      "fieldIri": "Property IRI (final value predicate)",
      "iriImmutable": "IRI is part of the signature and cannot be changed — delete the entry and create a new one.",
      "fieldLabelDe": "Label DE",
      "fieldLabelEn": "Label EN",
      "fieldAliases": "Aliases (comma-separated or one per line)",
      "aliasesHint": "Automatically lowercased + deduped. These terms make the resolver hit deterministic.",
      "fieldDefinitionDe": "Definition DE",
      "fieldDefinitionEn": "Definition EN",
      "definitionHint": "Comes from the ontology (rdfs:comment) and is shown to the user as an explanation on clarification questions. Not part of the tool manifest.",
      "fieldProvenance": "Provenance",
      "usePathForm": "Multi-hop path (for indirection via relations)",
      "fieldPathHops": "Path hops (bridge → final, in order)",
      "noHops": "No hops yet — click \"Hop\" to set the first bridge predicate.",
      "pathHint": "The last hop is the value predicate. Constraints + complex multi-hop are more convenient in the enrichment-profile editor.",
      "errIriRequired": "Property IRI is required.",
      "resolvePlaceholder": "Resolve test: terms comma-separated (e.g. \"Price Group, Milestone\")",
      "resolveMiss": "unknown",
      "resolveAmbiguous": "ambiguous",
      "suggestions": "Suggestions",
      "noSubjectScope": "— no subject scope —",
      "subjectScopeHint": "Optional: subject class for narrowing (#480). Empty = no narrowing, shows the raw candidate set.",
      "subjectScopeBadge": "Scope",
      "bulkSelectAll": "All reviewable ({{count}})",
      "bulkSelectAllAria": "Select all reviewable entries",
      "bulkSelectRowAria": "Select entry \"{{label}}\" for bulk-promote",
      "bulkPromote": "Confirm {{count}}",
      "paginationRange": "{{from}}–{{to}} of {{total}}",
      "pageOf": "{{current}} / {{total}}",
      "prevPage": "← Back",
      "nextPage": "Next →",
      "addHop": "Hop",
      "inverse": "inverse",
      "hopCount": "{{count}}-hop"
    },
    "enrichmentProfiles": {
      "sectionTitle": "Enrichment Profiles ({{count}})",
      "add": "New profile",
      "hint": "Profiles bundle property IRIs and column labels for bulk enrichment flows (e.g. Excel upload). Resolved by the `enrich_excel` skill at runtime.",
      "empty": "No profiles yet. Click \"New profile\" to create one.",
      "defaultBadge": "Default",
      "columnsCount": "{{count}} columns",
      "createTitle": "New enrichment profile",
      "editTitle": "Edit enrichment profile",
      "deleteTitle": "Delete profile?",
      "deleteBody": "Profile \"{{name}}\" will be permanently deleted. Skills that still explicitly reference it by ID will fall back to the default profile or fail.",
      "namePlaceholder": "e.g. sales_default",
      "fields": {
        "identifierLabel": "Identifier column name",
        "identifierLabelPlaceholder": "e.g. MLFB",
        "identifierLabelHint": "Persistent header for the identifier column of the produced Excel. Used when the chat omits a label — so it survives follow-up turns. Empty = generic \"Identifier\".",
        "subjectClass": "Subject class",
        "subjectClassHint": "The RDF class whose instances are being enriched (e.g. ProductVariant).",
        "matchPredicate": "Match predicate",
        "matchPredicateNone": "(none — subjects are URIs directly)",
        "matchPredicateHint": "Datatype property used to look subjects up by literal value (e.g. label, MLFB code, SKU). \"none\" means the values in the Excel are already URIs.",
        "directProperties": "Direct properties (datatype properties)",
        "directPropertiesHint": "Click to toggle. Value is read straight from the subject (`?subject <prop> ?value`).",
        "indirectProperties": "1-hop indirection (object properties)",
        "indirectPropertiesHint": "Click to add a relation whose value is fetched via a \"value-via\" predicate on the linked node (e.g. hasPriceAT → priceValue, hasProductCategory → rdfs:label). Default is rdfs:label, override per entry below.",
        "noAttributes": "No datatype properties persisted — run \"Apply Schema\" on the source first.",
        "noRelations": "No object properties persisted — run \"Apply Schema\" on the source first.",
        "outputColumns": "Output columns (order + label + value-via)",
        "labelPlaceholder": "Column header",
        "valueViaPlaceholder": "Value-via predicate (e.g. rdfs:label)",
        "directBadge": "direct",
        "isDefault": "Mark as default for this source",
        "addConstraintHint": "Add constraint (pin the intermediate node to a URI)",
        "addHop": "Add hop",
        "addMultiHop": "Add multi-hop property",
        "constraintPredicatePlaceholder": "Predicate IRI",
        "constraintPrefix": "↳ where",
        "constraintShort": "Constraint",
        "constraintValuePlaceholder": "Value IRI",
        "hopLabel": "Hop {{n}}",
        "hopPredicatePlaceholder": "Predicate IRI",
        "inverseHint": "Inverse: reverse the triple direction (?next <p> ?prev instead of ?prev <p> ?next)",
        "inverseLabel": "inverse",
        "lastHopBindsValue": "Last hop — its object term is the value of the Excel column.",
        "pathProperties": "Multi-hop / inverse / constraint (extended indirection)",
        "pathPropertiesHint": "For paths the simple direct/1-hop picker does not cover: 2+ hops, inverse direction (e.g. \"?qd isQualityDatumOf ?subject\"), or a filter on the intermediate node (e.g. \"only QualityDatums of class X\"). The last hop binds the value.",
        "removeHop": "Remove hop"
      },
      "errors": {
        "nameRequired": "Name is required.",
        "classRequired": "Subject class must be selected.",
        "atLeastOneProperty": "Select at least one property.",
        "emptyLabel": "All column labels must be filled (empty values are not allowed).",
        "duplicateEntry": "Duplicate property configuration ({{iri}}, value_via={{via}}). Only one entry per (property, value-via) pair is allowed.",
        "constraintIncomplete": "Entry #{{idx}}, hop #{{hop}}, constraint #{{c}}: predicate and value are both required.",
        "hopMissingPredicate": "Entry #{{idx}}, hop #{{hop}}: predicate IRI is required.",
        "pathEmpty": "Multi-hop entry #{{idx}} has no hop. At least one hop is required."
      }
    },
    "toolDetail": {
      "access": {
        "body": "Permissions for this tool are managed centrally in the Tool Manifest tab — there you can assign clients per tool and unlock roles from those clients.",
        "hint": "The default permissions for a system's new tools are set in the \"Connection & auth\" tab. They are copied as presets when a tool is created.",
        "openManifest": "Open in Tool Manifest",
        "title": "Access"
      },
      "activity": {
        "empty": "No calls for this tool yet.",
        "openGlobal": "Open in global history",
        "title": "Activity"
      },
      "agentView": {
        "hint": "JSON schema fragment from the live manifest — exactly what a tool-use call would receive. Only visible while the tool is live.",
        "missingFromManifest": "⚠ Tool is live but not found in the manifest — possibly due to visibility / permissions. Check access.",
        "notLive": "⚠ Tool is not live yet and does not appear in the manifest. Check the lifecycle in the overview.",
        "title": "What the agent sees"
      },
      "autoGeneratedTitle": "Auto-generated tool",
      "back": "Back",
      "backToTools": "Back to tools",
      "broken": "broken",
      "brokenFallback": "Schema drift since the last apply. Check slot or JOIN refs.",
      "brokenTitle": "Tool is broken — not delivered to the agent manifest",
      "definition": {
        "bodyTemplate": "Body template (slot-substituted, deep-merged with the caller body):",
        "execution": "Execution config",
        "projection": "Visible fields",
        "projectionEmpty": "⚠ No visible fields defined — the tool can only be called as an admin test.",
        "returns": "Returns",
        "returnsEmpty": "No returns hint set — add one via \"Edit\".",
        "shape": "Shape",
        "title": "Definition",
        "timeout": "Timeout",
        "rateLimit": "Rate limit",
        "rowCap": "Row cap",
        "longRunning": "Long-running"
      },
      "delete": {
        "body": "Tool \"{{op}}\" will be deleted permanently. Its call history is kept.",
        "title": "Delete tool?"
      },
      "description": "Description",
      "jumpAccess": "Check access",
      "jumpActivity": "Open activity",
      "jumpDefinition": "Open definition",
      "jumpSlots": "Open slots & parameters",
      "lifecycle": "Lifecycle",
      "lifecycleHint": "The status can be switched between draft, test and live at any time. Only live tools are delivered to the agent manifest — resetting to draft takes the tool down immediately.",
      "notFound": "Tool not found — it may have been deleted.",
      "params": {
        "title": "Parameters"
      },
      "slots": {
        "collapse": "Show less",
        "edit": "Edit slots",
        "editorTitle": "Edit slots",
        "empty": "No slots defined.",
        "entityId": "Entity scope: {{id}}",
        "missing_one": "{{count}} placeholder without slot definition: {{names}}",
        "missing_other": "{{count}} placeholders without slot definition: {{names}}",
        "noValues": "⚠ No values defined.",
        "orphan_one": "{{count}} slot without a placeholder in the template: {{names}}",
        "orphan_other": "{{count}} slots without a placeholder in the template: {{names}}",
        "showAll": "+ {{count}} more",
        "title": "Slots",
        "unusedTag": "orphan",
        "valueCount_one": "{{count}} value",
        "valueCount_other": "{{count}} values",
        "deleteSlot": "Delete slot"
      },
      "statusLabel": "Status:",
      "tools": "Tools",
      "tabs": {
        "overview": "Overview",
        "definition": "Definition",
        "slots": "Slots & parameters",
        "access": "Access",
        "activity": "Activity"
      },
      "longRunning": "long-running",
      "copy": "Copy"
    },
    "values": {
      "invocationStatus": {
        "success": "success",
        "error": "error",
        "timeout": "timeout",
        "permission_denied": "permission denied",
        "rate_limited": "rate limited",
        "validation_error": "validation error"
      },
      "invocationMode": {
        "sync": "sync",
        "async": "async",
        "test": "test"
      },
      "sourceType": {
        "skill": "Skill",
        "router_rest": "System (REST)",
        "router_postgres": "System (Postgres)",
        "router_sparql": "System (SPARQL)",
        "builtin": "cdbChat (built-in)",
        "workflow": "Workflow"
      },
      "visibility": {
        "internal": "internal",
        "public": "public"
      },
      "health": {
        "healthy": "healthy",
        "unhealthy": "unhealthy",
        "unknown": "unknown",
        "broken": "broken"
      },
      "turnStatus": {
        "ok": "OK",
        "error": "error",
        "empty": "empty"
      },
      "callerType": {
        "internal_user": "Internal user (JWT)",
        "internal_service": "Internal service (service principal)",
        "external_m2m": "External M2M (API key)"
      },
      "accessType": {
        "invoke": "invoke",
        "test": "test"
      },
      "provenance": {
        "manual": "manual",
        "auto_validated": "auto, validated",
        "auto_derived": "auto-derived",
        "profile_derived": "from profile",
        "source_introspect": "from introspect"
      },
      "assigneeKind": {
        "role": "role",
        "client": "client",
        "user": "user"
      }
    }
  },
  "activities": {
    "sidebarSection": "Activity",
    "sidebarEdit": "Edit",
    "sidebarAnalysis": "Analysis",
    "menu": {
      "editActivity": "Edit quiz/survey",
      "analyze": "View analysis",
      "downloadMarkdown": "Download as Markdown",
      "respond": "Fill out activity",
      "addActivity": "Add quiz/survey"
    },
    "notFound": "Activity not found",
    "loadFailed": "Failed to load activity",
    "saveFailed": "Save failed",
    "configSaved": "Configuration saved",
    "submitFailed": "Submission failed",
    "submitting": "Submitting …",
    "submit": "Submit",
    "yourAnswer": "Your answer",
    "yourDetails": "Your details",
    "name": "Name",
    "email": "Email",
    "respondentInfoRequired": "Please enter name and email",
    "requiredFieldsMissing": "Required field missing",
    "requiredHint": "* Required fields",
    "withdrawTitle": "Withdraw submission",
    "withdrawn": "Submission withdrawn — you can re-take the quiz",
    "withdrawFailed": "Withdraw failed",
    "maxSelectionsHint": "Please select at most {{max}} options",
    "otherTextLabel": "Other:",
    "otherTextPlaceholder": "Please specify …",
    "passedTitle": "Passed!",
    "failedTitle": "Not passed",
    "submittedTitle": "Thank you!",
    "thankYouMessage": "Your answers have been submitted.",
    "passingScoreHint": "Passing score: {{score}} %",
    "passingScoreUnit": "Percent of maximum (0–100).",
    "publicUnavailableTitle": "Activity unavailable",
    "publicUnavailableHint": "The link is invalid, expired, or the activity is closed.",
    "questionType": {
      "free_text": "Free text",
      "single_choice": "Single choice",
      "multiple_choice": "Multiple choice",
      "rating": "Rating",
      "section_header": "Section"
    },
    "modeLabel": {
      "progress": "Training",
      "assessment": "Quiz / Test",
      "aggregate": "Survey"
    },
    "modeHint": {
      "progress": "Classic training — progress tracking only, no questions.",
      "assessment": "Quiz with correct/wrong answers and pass/fail per participant.",
      "aggregate": "Survey with aggregated statistics and AI-driven analysis."
    },
    "tracking": {
      "anonymous": "Answers are stored without a person – only who took part is known.",
      "perUser": "Answers are recorded and evaluated per participant."
    },
    "audienceType": "Audience",
    "audienceLabel": {
      "assigned_only": "Only assigned users",
      "all_client_users": "All client users",
      "knowledge_area_access": "Knowledge Area access",
      "public_link": "Public link"
    },
    "status": {
      "draft": "Draft",
      "active": "Active",
      "closed": "Closed"
    },
    "status_column": "Status",
    "analysisStatus": {
      "pending": "Pending",
      "running": "Running",
      "completed": "Completed",
      "failed": "Failed"
    },
    "questionText": "Question",
    "questionTextPlaceholder": "Enter question …",
    "points": "Points",
    "options": "Options",
    "addOption": "Add",
    "addOptionPlaceholder": "New option …",
    "maxSelections": "Max selections",
    "maxSelectionsUnlimited": "unlimited",
    "allowOtherText": "Allow free-text 'Other' option",
    "scaleMin": "Scale min",
    "scaleMax": "Scale max",
    "sectionTitle": "Section title",
    "sectionTitlePlaceholder": "e.g. Part 1: Expectations",
    "sectionDescription": "Description",
    "markCorrect": "Mark as correct",
    "unmarkCorrect": "Unmark",
    "toggleCorrect": "Toggle correct/wrong",
    "required": "Required",
    "configuration": "Configuration",
    "analysisMode": "Mode",
    "knowledgeArea": "Knowledge Area",
    "knowledgeAreaPlaceholder": "e.g. Marketing",
    "passingScore": "Passing score (points)",
    "deadline": "Deadline",
    "collectRespondentInfo": "Collect name & email",
    "saveConfig": "Save configuration",
    "questions": "Questions",
    "questionCount_one": "{{count}} question",
    "questionCount_other": "{{count}} questions",
    "questionCount": "{{count}} questions",
    "noQuestionsYet": "No questions yet — add one or import from markdown.",
    "addQuestion": "Add question",
    "saveQuestion": "Save question",
    "newQuestionDefault": "New question",
    "importMarkdown": "Import from markdown",
    "exportMarkdown": "Markdown export",
    "markdownImported": "Markdown imported",
    "markdownImportedDetail": "{{count}} questions detected ({{warnings}} warnings)",
    "markdownImportFailed": "Markdown import failed",
    "markdownExportFailed": "Markdown export failed",
    "addQuestionFailed": "Failed to add question",
    "updateQuestionFailed": "Failed to update question",
    "deleteQuestionFailed": "Failed to delete question",
    "activate": "Activate",
    "close": "Close",
    "activated": "Activated",
    "closed": "Closed",
    "activateFailed": "Activation failed",
    "closeFailed": "Close failed",
    "publicLinkLabel": "Public participant link",
    "publicShare": {
      "toggle": "Publicly shareable (link)",
      "toggleHint": "Generates a link to share with external participants. They enter their email — only invited addresses pass.",
      "dialogTitle": "Share publicly",
      "linkLabel": "Shareable link",
      "howItWorks": "External participants open the link, enter their email, and can submit only if they were invited via \"Assign\". Each email can submit only once.",
      "offTitle": "Public sharing is off",
      "offHint": "Enable it to generate a link. Activating publishes the quiz — editing questions is locked until you reset the quiz to draft.",
      "noQuestionsHint": "Add questions first — an empty quiz can't be activated.",
      "enable": "Make public",
      "disable": "Disable public sharing",
      "enabledToast": "Quiz is now publicly shareable",
      "disabledToast": "Public sharing disabled — link is no longer valid",
      "enableFailed": "Enable failed",
      "disableFailed": "Disable failed"
    },
    "publicGate": {
      "emailLabel": "Your email address",
      "emailPlaceholder": "name@company.com",
      "emailHint": "Use the address you were invited with.",
      "continue": "Continue",
      "errorNotAssigned": "This email was not invited. Contact the person who sent you the link.",
      "errorAlreadySubmitted": "You have already taken part. Taking part again is not possible.",
      "errorGeneric": "Email could not be verified. Please try again."
    },
    "editingLockedTitle": "Editing locked",
    "editingLockedHint": "This activity is active or closed. Use the button at the top right to move it back to draft.",
    "evaluation": "Analysis",
    "evaluationFromParent": "Analysis of the linked quiz — from training \"{{parent}}\"",
    "responseCount": "{{count}} responses",
    "completionRate": "{{rate}}% completed",
    "tabs": {
      "participants": "Participants",
      "statistics": "Statistics",
      "aiReport": "AI report",
      "mine": "Mine"
    },
    "noSubmissionsYet": "No submissions yet",
    "respondent": "Respondent",
    "score": "Score",
    "passed": "Passed",
    "passedYes": "Yes",
    "passedNo": "No",
    "completedAt": "Submitted",
    "authenticatedUser": "Authenticated user",
    "anonymous": "Anonymous",
    "completed": "Completed",
    "inProgress": "Started",
    "scoreDistribution": "Score distribution",
    "meanScore": "Mean score",
    "medianScore": "Median score",
    "passRate": "Pass rate",
    "mean": "Mean",
    "median": "Median",
    "range": "Range",
    "correctRate": "Correct rate: {{rate}}%",
    "otherTexts_one": "{{count}} free response",
    "otherTexts_other": "{{count}} free responses",
    "otherTexts": "{{count}} free responses",
    "word": "Word",
    "frequency": "Frequency",
    "noFreeTextAnswers": "No free-text answers",
    "lastAnalysis": "Last analysis",
    "lastUpdated": "updated {{time}}",
    "kpi": {
      "submissions": "Submissions",
      "completionRate": "Completion rate",
      "completedOf": "{{done}} of {{total}}",
      "passRate": "Pass rate",
      "avgScore": "Average score",
      "questions": "Questions",
      "uniqueRespondents": "Unique respondents"
    },
    "respondentSource": {
      "internal": "Internal",
      "external": "External",
      "anonymous": "Anonymous"
    },
    "noAnalysisYet": "No AI analysis yet — click Run analysis.",
    "runAnalysis": "Run analysis",
    "analyzing": "Analyzing …",
    "analysisFailed": "Analysis failed",
    "analysisCompleted": "Analysis completed",
    "analysisStartFailed": "Failed to start analysis",
    "summary": "Summary",
    "sentiment": "Sentiment",
    "sentimentError": "Sentiment analysis failed",
    "positive": "Positive",
    "neutral": "Neutral",
    "negative": "Negative",
    "fileTooLarge": "File too large (max {{max}} KB)",
    "copyFailed": "Copy failed",
    "copyManualHint": "Please copy the link manually from the field above.",
    "ratingAriaLabel": "Rating scale",
    "sentimentBarAriaLabel": "Sentiment distribution: {{positive}} positive, {{neutral}} neutral, {{negative}} negative",
    "sidebarSurveys": "Quizzes & Surveys",
    "surveyLibraryTitle": "Quizzes & Surveys",
    "surveyLibraryHint": "Standalone quizzes and surveys — no materials required.",
    "newSurvey": "New survey / quiz",
    "newSurveyTitle": "Create new survey or quiz",
    "noSurveysYet": "No surveys or quizzes yet — create one.",
    "emptyAssigned": "No quizzes or surveys assigned to you yet",
    "emptyCompleted": "You haven't completed any quizzes or surveys yet",
    "createFirstSurvey": "Create first survey",
    "createAndEdit": "Create & open",
    "createFailed": "Create failed",
    "noClientId": "No client assigned — check your profile",
    "deleteConfirmTitle": "Delete survey?",
    "deleteConfirmHint": "Drafts only. This action cannot be undone.",
    "deleted": "Deleted",
    "deleteFailed": "Delete failed",
    "titleColumn": "Title",
    "typeColumn": "Type",
    "descriptionColumn": "Description",
    "actions": "Actions",
    "surveyTitlePlaceholder": "e.g. Pre-workshop feedback",
    "surveyDescriptionPlaceholder": "Optional description for participants",
    "kindLabel": {
      "training": "Training",
      "training_with_quiz": "Training + Quiz",
      "quiz": "Quiz",
      "survey": "Survey"
    },
    "quizSurveyColumn": "Quiz/Survey",
    "autoSaving": "Saving …",
    "autoSaved": "Saved",
    "dragHandle": "Reorder (drag & drop)",
    "reorderFailed": "Failed to save the new order",
    "editOption": "Click to edit",
    "duplicateOptionTitle": "Duplicate option",
    "duplicateOption": "This answer option already exists",
    "activateBlockedIncomplete": "Please complete all questions first",
    "invalidReason": {
      "missingText": "Question text missing — will save once complete",
      "missingOptions": "Answer options missing — will save once complete",
      "correctNotInOptions": "Correct answer must be one of the options",
      "singleChoiceTooManyCorrect": "Single choice allows only one correct answer",
      "missingScale": "Scale bounds missing — will save once complete",
      "invalidScale": "Scale max must be greater than scale min",
      "maxSelectionsOnlyForMC": "Max selections is only valid for multiple choice",
      "sectionHeaderHasOptions": "Section header cannot have answer options",
      "sectionHeaderEmpty": "Section header needs a title or description"
    },
    "fromLibrary": "Insert from library",
    "libTitle": "Question library",
    "libSearchPlaceholder": "Search by title or text …",
    "libAllTypes": "All types",
    "libNoResults": "No matches.",
    "libEmpty": "Library is empty — save a question as template.",
    "libLoadFailed": "Failed to load library",
    "libDeleteConfirm": "Delete this template? Already-inserted questions remain unchanged.",
    "libDeleted": "Template deleted",
    "libDeleteFailed": "Failed to delete template",
    "libSaveAction": "Save as template",
    "libSaved": "Template saved to library",
    "libSaveFailed": "Failed to save template",
    "libInserted": "Question inserted from library",
    "lockedByAttachers_one": "Editing locked — this quiz is attached to 1 training:",
    "lockedByAttachers_other": "Editing locked — this quiz is attached to {{count}} trainings:",
    "lockedByAttachers": "Editing locked — attached to {{count}} training(s):",
    "unlock": "Allow editing",
    "unlocked": "Activity reset to draft",
    "unlockFailed": "Reset to draft failed",
    "fillOutShort": "Fill out",
    "done": "Done",
    "anonymousToggle": "Answer anonymously",
    "anonymousToggleHint": "Who took part is recorded – not who answered what. Answers show neither a name nor a time.",
    "anonymousFrozen": "Cannot change once someone has answered.",
    "anonymousRespondent": "Anonymous",
    "hub": {
      "title": "Surveys & quizzes",
      "subtitle": "Test knowledge or collect opinions – no material, your own questionnaire",
      "kindAll": "All",
      "statusAll": "All statuses",
      "kind": {
        "quiz": "Quiz",
        "survey": "Survey"
      },
      "status": {
        "draft": "Draft",
        "active": "Active",
        "closed": "Closed"
      },
      "view": {
        "manage": "Manage",
        "mine": "For me"
      },
      "kpi": {
        "active": "Active",
        "activeHint": "taking answers",
        "drafts": "Drafts",
        "draftsHint": "not published yet",
        "newAnswers": "New answers",
        "newAnswersHint": "in the last 7 days",
        "silent": "No response",
        "silentHint": "active, but under 3 answers"
      },
      "columns": {
        "answers": "Answers",
        "distribution": "Distribution",
        "lastActivity": "Last"
      },
      "searchPlaceholder": "Search title …",
      "noneFound": "Nothing matches the filter",
      "noneFoundHint": "Pick another kind or status.",
      "emptyHint": "Start the first questionnaire with “New” at the top right.",
      "newLabel": "new",
      "results": "Results",
      "share": "Share",
      "newVersion": "Edit as new version",
      "passedShort": "{{rate}} % passed",
      "passedOf": "Passed (mark {{mark}} %)",
      "responseRate": "Response of the assigned",
      "ofAssigned": "{{answers}} of {{assigned}}",
      "publishFirst": "Publish so the first one can come in.",
      "version": "Version {{number}}",
      "partOf": "Part of the training “{{title}}”",
      "versionNote": "Version {{number}}. Answers to earlier versions are kept and shown separately in the results.",
      "answered": "Answered",
      "dist": {
        "assigned": "{{count}} assigned",
        "emails": "{{count}} e-mails",
        "link": "Open link",
        "linkUntil": "Link until {{date}}",
        "none": "not distributed yet"
      },
      "new": {
        "title": "Create new",
        "hint": "What should it be? The kind decides the settings and cannot change later.",
        "kindLabel": "Kind",
        "submit": "Continue to editor",
        "quizHint": "Test knowledge. Answers are right or wrong.",
        "surveyHint": "Collect opinions. There is no right or wrong.",
        "quizPoint1": "Points per question, pass mark",
        "quizPoint2": "Result per person, pass rate",
        "quizPoint3": "Never anonymous",
        "surveyPoint1": "Optionally anonymous",
        "surveyPoint2": "Scales, free text, choice",
        "surveyPoint3": "Results as distribution",
        "quizPlaceholder": "e.g. Data protection – knowledge check",
        "surveyPlaceholder": "e.g. Workshop feedback"
      },
      "publish": {
        "title": "Publish",
        "shareTitle": "Share",
        "hint": "“{{title}}” – who should be able to answer? Several ways can run at once; each can be ended on its own.",
        "way": {
          "open": "Public link",
          "openHint": "Anyone with the link can answer – for events and QR codes. With expiry and maximum, revocable at any time.",
          "assigned_link": "Assigned people with a link",
          "assigned_linkHint": "For external participants without a cdbOS login: assign people and send them the link. Opening it asks for the e-mail address – only assigned people can answer, each once.",
          "assigned": "Assign without a link",
          "assignedHint": "Internal users find the survey in webOS under “For me”; every assignment has a status and an optional deadline. External participants reach surveys through “Assigned people with a link”.",
          "course": "Add to a training",
          "courseHint": "As a block at the end of a course’s last chapter – for a knowledge check or feedback inside a training. The course is published in the course editor."
        },
        "active": "active",
        "assignedCount_one": "{{count}} assigned",
        "assignedCount_other": "{{count}} assigned",
        "choosePeople": "Choose people",
        "createOpenLink": "Create open link",
        "expires": "Expires",
        "maxUses": "At most",
        "unlimited": "unlimited",
        "copy": "Copy link",
        "copied": "Link copied",
        "coursePick": "Choose a course",
        "courseAttach": "Add to course",
        "courseNone": "There is no course for this client yet.",
        "courseAlready": "This questionnaire is already part of “{{title}}”.",
        "courseAttached": "Added to the draft of “{{title}}”, at the end of “{{chapter}}”. Publish the course in the course editor so learners see it.",
        "openCourse": "Open course",
        "untitledChapter": "Chapter {{number}}",
        "linkCreated": "Link created",
        "revoke": "Revoke",
        "revoked": "Link revoked – existing answers stay",
        "emailCount_one": "{{count}} address",
        "emailCount_other": "{{count}} addresses",
        "uses": "{{uses}} of {{max}} uses",
        "until": "until {{date}}",
        "quizOpenHint": "A quiz over an open link asks for name and e-mail – no person, no result.",
        "liveNote": "Changes apply at once.",
        "freezeNote": "After that, the questions can only be changed by creating a new version.",
        "publishButton": "Publish",
        "createAssignedLink": "Create link for assigned people",
        "legacyEmailLists": "Earlier e-mail list links (still usable, can be ended):"
      },
      "editor": {
        "savedAt": "Saved {{time}}",
        "allSaved": "All saved",
        "empty": "Still empty. The first question gets it going.",
        "addQuestion": "Question",
        "addSection": "Section",
        "markdown": "Markdown",
        "newSection": "New section",
        "optionA": "Option 1",
        "optionB": "Option 2",
        "untitled": "No text",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "question": "Question",
        "questionN": "Question {{n}}",
        "duplicate": "Duplicate question",
        "firstQuestion": "Create the first question",
        "firstQuestionHint": "Choose “Question” on the left or ask the AI assistant – the type can change later.",
        "descriptionPlaceholder": "What is it about, how long does it take?",
        "passMark": "Pass mark",
        "showResult": "Show result",
        "showResultHint": "Learners see points and passed / not passed",
        "showCorrect": "Show correct answers",
        "showCorrectHint": "after submitting",
        "collectHint": "For answers over a link without an account",
        "deadlineHint": "optional – no answers after that",
        "shuffle": "Shuffle questions",
        "shuffleHint": "Random order per learner",
        "quizNote": "A quiz is never anonymous – the result belongs to the person and their certificate.",
        "surveyNote": "A survey gives no points. For right / wrong, create a quiz.",
        "frozenTitle_one": "Published, {{count}} answer received. The questions of this version can no longer be changed.",
        "frozenTitle_other": "Published, {{count}} answers received. The questions of this version can no longer be changed.",
        "frozenHint": "You can still change the title and description. Changing questions creates version {{next}}; the existing answers stay with version {{current}}. Until you publish version {{next}}, the questionnaire accepts no answers.",
        "newVersionOpened": "Version {{number}} created as a draft. The questions were copied."
      },
      "assistant": {
        "button": "AI assistant",
        "title": "AI assistant for questions",
        "quizHint": "Describe topic, audience and difficulty – you get quiz questions with correct answers and points to pick from.",
        "surveyHint": "Describe what you want to learn – you get survey questions (scales, choice, free text) to pick from.",
        "quizPlaceholder": "e.g. five questions on the duties for high-risk AI systems, medium difficulty, for non-experts",
        "surveyPlaceholder": "e.g. satisfaction with onboarding: preparation, contact person, material",
        "count": "Count",
        "context": "From training",
        "noContext": "no training",
        "ask": "Suggest",
        "askAgain": "Suggest again",
        "nothing": "The assistant proposed nothing usable – try another wording.",
        "failed": "Suggestions failed",
        "points_one": "{{count}} point",
        "points_other": "{{count}} points",
        "insert_one": "Take over {{count}}",
        "insert_other": "Take over {{count}}",
        "inserted_one": "{{count}} question added",
        "inserted_other": "{{count}} questions added",
        "footnote": "Runs on the intermediate model and counts towards token usage (activity “Question assistant”)."
      }
    },
    "results": {
      "versions": "Versions",
      "versionTab": "Version {{number}} · {{count}}",
      "versionLabel": "Version {{number}}",
      "download": "Download",
      "downloadPdf": "PDF report",
      "downloadPdfHint": "This view as a document – numbers, themes, report",
      "downloadXlsx": "Excel · raw data",
      "downloadXlsxHint": "One row per submission, with person",
      "downloadXlsxAnonHint": "One row per submission – anonymous, no person",
      "downloadMd": "Markdown · report",
      "downloadMdHint": "For wiki or e-mail",
      "downloadFailed": "Download failed",
      "kpiAnswers": "Answers",
      "kpiPassed": "Passed",
      "kpiCompletion": "Completed",
      "kpiResponseRate": "Response rate",
      "kpiScale": "Ø scale",
      "passHint": "Mark {{mark}} % · Ø {{mean}} points",
      "noTarget": "no target – link or without assignment",
      "scaleHint": "of {{max}} · median {{median}}",
      "newSince_one": "+{{count}} since the last analysis",
      "newSince_other": "+{{count}} since the last analysis",
      "allAnalysed": "all analysed",
      "notAnalysed": "no analysis yet",
      "analysedAt": "Analysis of {{date}}",
      "refreshAnalysis": "Refresh analysis",
      "startAnalysis": "Start analysis",
      "tabs": {
        "questions": "Questions",
        "report": "AI report",
        "participants": "Participants"
      },
      "correctShort": "{{rate}} % correct",
      "opinionNote": "opinion question, no right/wrong",
      "otherTexts_one": "{{count}} “other” entry",
      "otherTexts_other": "{{count}} “other” entries",
      "otherTextsHeading": "Free text for “Other”",
      "scaleLabel": "Scale {{min}}–{{max}}",
      "highShare": "{{share}} % in the upper half",
      "themes": "AI themes",
      "themesPending": "No themes yet – “Refresh analysis” reads all answers.",
      "themesFailed": "The theme analysis of this question failed – refresh again.",
      "themesAt": "Themes from the analysis of {{date}}",
      "themesStale_one": "{{count}} new answer not included yet",
      "themesStale_other": "{{count}} new answers not included yet",
      "themeFoot": "{{count}} answers on this theme · {{sentiment}}",
      "unassigned": "Single voices without a theme",
      "sentiment": {
        "positive": "positive",
        "neutral": "neutral",
        "negative": "critical"
      },
      "reportSource": "Report from numbers and themes",
      "reportAt": "Analysis of {{date}} over {{count}} answers",
      "reportNote": "The report quotes only values from the statistics and the themes of the free-text analysis – no invented numbers, no sample.",
      "noReport": "No report yet – “Start analysis” reads the free text and writes the report (intermediate model, counts towards token usage).",
      "participantsHint": "Quiz with person: points, passed, time.",
      "participantsAnon": "Anonymous survey: times only, no people – not in the export either."
    }
  },
  "desktop": {
    "loadingApps": "Loading desktop apps...",
    "loadAppsFailed": "Your desktop apps could not be loaded."
  },
  "voiceInput": {
    "partialLoss_one": "One part of the recording could not be recognised and is missing from the text.",
    "partialLoss_other": "{{count}} parts of the recording could not be recognised and are missing from the text.",
    "transcribing": "Transcribing …",
    "apply": "Apply",
    "cancel": "Discard",
    "start": "Start voice recording",
    "recording": "Recording …",
    "sendNow": "Send",
    "listening": "Just start speaking …"
  },
  "standalone": {
    "navAria": "App navigation",
    "toDesktop": "To desktop",
    "settingsDescription": "Language and appearance",
    "themeLight": "Light",
    "themeDark": "Dark",
    "settings": {
      "title": "Settings",
      "generalTitle": "General",
      "communicatorHint": "How the assistant addresses you and replies."
    }
  },
  "documentLink": {
    "loading": "Opening document …",
    "denied": {
      "title": "You cannot open this document",
      "message": "The link is valid, but your account has no access to this document. Ask the person who sent it to you."
    },
    "error": {
      "title": "Document unavailable right now",
      "message": "The link could not be resolved. Please try again later."
    },
    "noHost": {
      "title": "No suitable application enabled",
      "message": "Your account has neither the desktop nor the chat enabled. Without one of them the document cannot be shown."
    }
  },
  "sharedFile": {
    "loading": "Loading file …",
    "invalid": {
      "title": "This link is no longer valid",
      "message": "It was revoked, the file was deleted, or the link is incomplete. Ask the person who sent it for a new one."
    },
    "error": {
      "title": "That did not work just now",
      "message": "The file could not be loaded. Please try again in a moment."
    },
    "header": {
      "sharedBy": "Shared with you · {{size}}",
      "sharedByNamed": "Shared by {{name}} · {{size}}",
      "own": "Your own file · {{size}}"
    },
    "unsupported": "There is no preview for this file format. The link is fine — ask whoever shared it for a different format."
  },
  "video": {
    "player": {
      "region": "Video player",
      "regionNamed": "Video player: {{name}}",
      "play": "Play",
      "pause": "Pause",
      "mute": "Mute",
      "unmute": "Unmute",
      "fullscreen": "Fullscreen",
      "exitFullscreen": "Exit fullscreen",
      "seek": "Playback position",
      "volume": "Volume",
      "captions": "Captions",
      "loading": "Loading video …",
      "unplayable": "Your browser cannot play this video (e.g. HEVC). Processing is not affected – download the file to watch it.",
      "loadFailed": "The video could not be loaded.",
      "retry": "Try again",
      "download": "Download",
      "jumpTo": "Jump to {{time}} in the video",
      "tooLargeToPlay": "This video can only be played here by streaming, which the server does not offer yet. Above {{maxMb}} MB the browser does not load it as a whole – download it to watch it.",
      "downloadTooLarge": "This browser cannot save files above {{maxMb}} MB directly to disk. Please use Chrome or Edge for the download.",
      "downloadFailed": "The download failed."
    },
    "facts": {
      "heading": "About this video",
      "duration": "Duration {{time}}",
      "speakers_one": "{{count}} speaker",
      "speakers_other": "{{count}} speakers",
      "noAudio": "no audio",
      "provenance": "Transcript machine-generated · image descriptions AI-generated",
      "summaryLabel": "AI summary",
      "summaryHint": "Summarised by AI from the transcript and images – please check against the video.",
      "chapters": "Chapters (AI-generated)"
    },
    "sources": {
      "video": "Video",
      "transcriptMachine": "Machine transcript",
      "frameAi": "Image AI-described",
      "provenanceHint": "From a video: speech was transcribed by machine, images were described by AI."
    },
    "upload": {
      "hashing": "Calculating checksum … {{percent}}%",
      "uploading": "Uploading {{percent}}% ({{loaded}} of {{total}})",
      "completing": "Finishing …",
      "retrying": "Connection interrupted – retrying … {{percent}}%",
      "paused": "Paused at {{percent}}% – can be resumed",
      "pause": "Pause upload",
      "resume": "Resume upload",
      "abort": "Cancel upload",
      "tooLarge": "The file is too large (at most {{maxMb}} MB).",
      "unsupported": "The Knowledge Area cannot process this format ({{extension}}).",
      "videosDisabled": "Videos are not processed in this environment yet.",
      "tooLargeWithoutBlocks": "This server does not accept videos over {{maxMb}} MB yet – the resumable upload for large files is not active here.",
      "errors": {
        "knowledgeAreaNotFound": "The Knowledge Area was not found.",
        "clientNotFound": "The client of this Knowledge Area was not found.",
        "userContextRequired": "This upload needs a signed-in user.",
        "invalidRequest": "The server rejected the upload request as invalid.",
        "uploadClosed": "This upload has already ended.",
        "emptyFile": "The file is empty.",
        "generic": "The server refused the upload (status {{status}})."
      }
    },
    "progress": {
      "probe": "Checking video",
      "transcription": "Transcription",
      "frames": "Detecting images",
      "vision": "Describing images",
      "markdown": "Writing text",
      "other": "Processing video",
      "indexing": "Indexing for search",
      "withPercent": "{{label}} – {{percent}}%",
      "stage": {
        "probing": "Checking video",
        "extracting_audio": "Extracting audio",
        "transcribing": "Transcribing",
        "detecting_slides": "Detecting slides",
        "describing_frames": "Describing images",
        "building_markdown": "Writing text",
        "indexing": "Indexing for search"
      }
    },
    "brainStatus": {
      "uploading": "Uploading"
    },
    "verifier": {
      "hint": "Video · machine transcript · AI image descriptions · auto-verify off",
      "locate": "Find in video",
      "locating": "Searching the transcript …",
      "locateUnavailable": "Searching the video is not available on this server yet.",
      "locateNone": "No matching spot found.",
      "searchHits": "Search hits",
      "searchHitHint": "Found by searching the transcript – not necessarily where the statement was extracted from."
    }
  },
  "tickets": {
    "rail": {
      "label": "Tickets",
      "labelUnread_one": "Tickets – {{count}} with a new reply",
      "labelUnread_other": "Tickets – {{count}} with new replies"
    }
  },
  "harness": {
    "title": "cdbHARNESS · Prototype",
    "subtitle": "Prototype",
    "intro": "A team of agents works on your task in the chat: check knowledge or create files. Only your approval changes the brain.",
    "knowledgeArea": "Knowledge area",
    "pickArea": "Choose a knowledge area",
    "cancel": "Cancel",
    "export": "Export run",
    "phase": {
      "idle": "Ready",
      "loading": "Loading open facts …",
      "turn": "{{role}} is working · batch {{batch}} of {{batches}}",
      "done": "Run finished",
      "cancelled": "Run cancelled",
      "error": "Error: {{message}}",
      "working": "{{role}} is working"
    },
    "roles": {
      "pruefer": "Checker",
      "redakteur": "Editor",
      "rechercheur": "Researcher",
      "autor": "Author",
      "frei": "Free role"
    },
    "counts": "{{facts}} facts checked · {{ok}} confirmed · {{contra}} contradicted · {{none}} without evidence · {{proposals}} proposals",
    "quality": "{{format}} answers without a valid format · {{rejected}} entries discarded",
    "empty": {
      "idle": "Write the team a task below in your own words, for example “Check everything about E-47 on the FL-300”. With @name you ask one agent directly.",
      "noTeam": "No team yet. Create one in the Teams tab.",
      "noArea": "The team “{{team}}” has no knowledge area yet. Set it in the Teams tab.",
      "idleProject": "Write the team a task below, for example “Create a customer presentation about E-47 on the FL-300”. The researcher collects, the author builds the file. With @name you talk to one agent directly.",
      "idleChain": "The chain works in this order: {{steps}}. Write a task below; every agent gets it and the results of the agents before it. With @name you talk to one agent directly."
    },
    "actions": {
      "verify": "Confirm",
      "update": "Correct",
      "reject": "Reject"
    },
    "sources": "Sources",
    "approve": "Approve",
    "dismiss": "Discard",
    "decision": {
      "approved": "Approved, applied to the brain",
      "dismissed": "Discarded, nothing changed",
      "failed": "Approval failed: {{message}}"
    },
    "footer": "Prototype v0.5 · admins only · test with synthetic data on staging only. Knowledge maintenance at most 24 facts per task, chains at most 6 steps. The group chat is not stored; each agent's turns and files are in its own chat.",
    "byAgents": "written by {{editor}}, checked by {{checker}}, approval by you",
    "save": "Save",
    "delete": "Delete",
    "tabs": {
      "chat": "Group chat",
      "agents": "Agents",
      "teams": "Teams"
    },
    "models": {
      "gpt-6_1-sol": "gpt-6.1-sol (thinking)",
      "gpt-6-luna": "gpt-6-luna (volume)"
    },
    "chat": {
      "team": "Team",
      "checkerSummary": "Batch {{batch}} of {{batches}}: {{facts}} facts checked · {{ok}} confirmed · {{contra}} contradicted · {{none}} without evidence",
      "formatError": "The answer had no valid format and was not used.",
      "emptyAnswer": "No answer received.",
      "openInChat": "Open in chat",
      "askLabel": "Ask:",
      "placeholder": "Task for the team, e.g. “Check everything about E-47”, or @{{name}} with a question",
      "send": "Send",
      "mentionHint": "Address an agent of the team with @name, for example with the buttons above.",
      "noMatch": "No open facts found for “{{words}}” (of {{total}} open). Try other words.",
      "noOpenFacts": "This knowledge area has no open facts.",
      "handoff": "Handing over to {{name}}.",
      "runBusy": "The team is working on a task. Wait or cancel it; questions with @name work any time.",
      "queued": "{{name}} answers after the current turn.",
      "recheckSummary_one": "{{count}} fact checked again.",
      "recheckSummary_other": "{{count}} facts checked again.",
      "editorSummary_one": "{{count}} proposal written. Please review and approve.",
      "editorSummary_other": "{{count}} proposals written. Please review and approve.",
      "editorSummaryWithQuestions_one": "{{count}} proposal written. Questions to {{name}}: {{questions}}.",
      "editorSummaryWithQuestions_other": "{{count}} proposals written. Questions to {{name}}: {{questions}}.",
      "factsSelected_one": "{{count}} open fact matches the task (of {{total}}, search words: {{words}})",
      "factsSelected_other": "{{count}} open facts match the task (of {{total}}, search words: {{words}})",
      "factsLoaded_one": "{{count}} open fact loaded",
      "factsLoaded_other": "{{count}} open facts loaded",
      "noFile": "{{name}} created no file. Ask with @{{name}}, for example “as a Word document, please”.",
      "placeholderProject": "Task for the team, e.g. “Create a customer presentation about E-47”, or @{{name}} with a change",
      "placeholderChain": "Task for the chain, or @{{name}} with a message",
      "savedTasks": "Tasks:",
      "fillHint": "Replace the parts in {curly braces} and send.",
      "fillPlaceholders": "Please fill in: {{parts}}",
      "attach": "Attach a file to the task (at most {{max}})",
      "removeFile": "Remove {{name}}",
      "uploading": "Uploading …"
    },
    "agents": {
      "intro": "Every agent starts from a base role. The free role is defined entirely by its extra rules, for example “You are a sales assistant and write offers”. You set name, model, rules and features. Stored in your settings.",
      "baseRole": "Base role",
      "name": "Name",
      "model": "Model",
      "instructions": "Extra rules",
      "instructionsPlaceholder": "For example: pay special attention to numbers and deadlines.",
      "create": "Create agent",
      "usedBy": "In teams: {{teams}}. Replace it there first, then delete.",
      "features": "Features from the chat",
      "feature": {
        "corporate": "Team's knowledge area",
        "web": "Web search",
        "externalSystems": "External systems",
        "deepResearch": "Research mode",
        "microsoft365": "Mail and calendar (Microsoft 365)"
      },
      "webDepth": "Depth",
      "depth": {
        "auto": "automatic",
        "quick": "quick",
        "deep": "thorough"
      },
      "workflow": "Starts the workflow",
      "noWorkflow": "none",
      "noWorkflows": "No workflows are enabled for you.",
      "featuresNote": "The server enforces these switches. Every agent can create files (Word, PowerPoint, Excel, HTML, image, BPMN) like the chat; switching single tools off needs an agent profile in the TQS. In knowledge maintenance, checker and editor always check against the knowledge area only. Exception: mail and calendar come with your connected account; this switch only tells the agent whether it may use them.",
      "microsoft365": {
        "ready": "Reads mails and appointments and creates drafts, but never sends. The agent does not follow instructions found in mails.",
        "notConnected": "Your Microsoft 365 account is not connected. Connect it in cdbChat under Settings, Connected accounts (mail or calendar).",
        "unavailable": "Mail and calendar are not enabled for your organisation."
      }
    },
    "teams": {
      "intro": "A team has a type. Knowledge maintenance: a checker and an editor check open facts, you approve. Project: a researcher collects, an author builds the file, a checker may review it. Chain: any agents in a fixed order, each builds on the work before.",
      "name": "Name",
      "newPlaceholder": "New team",
      "create": "Create team",
      "approval": "Approval",
      "approvalYou": "always by you",
      "kind": "Team type",
      "kinds": {
        "wissenspflege": "Knowledge maintenance",
        "projekt": "Project",
        "kette": "Chain"
      },
      "optional": "optional",
      "none": "none",
      "step": "Step {{n}}",
      "up": "Move up",
      "down": "Move down",
      "removeStep": "Remove step",
      "addStep": "Add step (at most {{max}})",
      "brandKit": "Brand kit for files",
      "brandKitAsChat": "As in the chat (your pick, else organisation)",
      "brandKitNone": "No brand kit",
      "brandKitGone": "Picked kit no longer available",
      "tasks": "Saved tasks",
      "tasksHint": "Shown in the group chat as buttons above the input. Fill in parts in {curly braces} before sending, e.g. “Check everything about {product}”.",
      "taskTitle": "Title",
      "taskText": "Task",
      "taskTitlePlaceholder": "e.g. Weekly check",
      "taskTextPlaceholder": "e.g. Check everything about {product}",
      "addTask": "Add task",
      "removeTask": "Remove task",
      "seedTasks": {
        "check": "Check topic",
        "presentation": "Customer presentation"
      }
    },
    "projectCounts_one": "{{count}} file created",
    "projectCounts_other": "{{count}} files created",
    "conflict": {
      "title": "Contradiction · please decide",
      "intro": "{{checker}} and {{editor}} could not resolve this. What is right? Only your decision changes the brain.",
      "evidence": "Checker's evidence",
      "newText": "The fact as it should read",
      "correct": "Correct",
      "keep": "Confirm as it is",
      "reject": "Reject",
      "later": "Later",
      "open_one": "{{count}} contradiction to decide",
      "open_other": "{{count}} contradictions to decide",
      "decided": {
        "update": "Corrected, applied to the brain",
        "verify": "Confirmed, applied to the brain",
        "reject": "Rejected, applied to the brain",
        "later": "Put off, nothing changed"
      }
    }
  },
  "control": {
    "title": "cdbControl",
    "scope": "Every task belongs to the whole client.",
    "loading": "Loading tasks …",
    "loadError": "The tasks could not be loaded.",
    "retry": "Try again",
    "empty": "No tasks yet. Add the first one, or take tasks over from a recording in the Knowledge Extractor.",
    "noMatch": "No task matches the filters.",
    "notFound": "This task no longer exists.",
    "back": "Back to the overview",
    "noDue": "No deadline",
    "overdue": "overdue",
    "ai": "AI",
    "unknownPerson": "Unknown person",
    "visibleFor": "Visible to: everyone in the client",
    "moveTo": "Move to “{{status}}”",
    "nav": {
      "all": "All tasks",
      "new": "Add task",
      "later": "Later",
      "mine": "My tasks",
      "departments": "Departments",
      "documents": "From documents"
    },
    "view": {
      "list": "List",
      "board": "Kanban"
    },
    "tiles": {
      "overdue": "Overdue",
      "dueThisWeek": "Due this week",
      "unassigned": "Without assignee",
      "newFromRecordings": "New from recordings"
    },
    "filter": {
      "origin": "Origin",
      "origins": {
        "all": "All",
        "recording": "Recordings",
        "manual": "Manual"
      },
      "everyone": "Everyone",
      "unassigned": "Unassigned",
      "showDone": "Show done"
    },
    "fields": {
      "title": "Task",
      "description": "Description",
      "source": "Source",
      "assignee": "Assignee",
      "due": "Deadline",
      "status": "Status"
    },
    "status": {
      "open": "Open",
      "in_progress": "In progress",
      "done": "Done"
    },
    "origin": {
      "manual": "By hand",
      "recordingGone": "Recording deleted",
      "recordingUntitled": "Untitled recording"
    },
    "form": {
      "heading": "Add task",
      "titlePlaceholder": "What needs to be done?",
      "submit": "Add task",
      "cancel": "Cancel",
      "failed": "The task could not be added. Please try again.",
      "originHint": "Added by hand, without a source. Tasks from recordings are taken over in the Knowledge Extractor."
    },
    "detail": {
      "fromRecording": "Derived from the recording “{{title}}”",
      "passage": "passage {{at}}",
      "derivedFrom": "Derived from",
      "origin": "Origin",
      "recordedOn": "Recorded on {{date}}",
      "aiHint": "Proposed by the AI, taken over by {{name}}",
      "openRecording": "Open in Knowledge Extractor",
      "manual": "Added by hand by {{name}} on {{date}}, without a source.",
      "history": "History",
      "saveFailed": "The change could not be saved."
    },
    "history": {
      "created": "Task added",
      "filed": "Taken over from the recording",
      "status": "Status: {{to}}",
      "assignee": "Assignee: {{to}}",
      "due": "Deadline: {{to}}",
      "dueCleared": "Deadline removed",
      "title": "Title changed",
      "description": "Description changed"
    }
  },
  "wissenshaus": {
    "title": "What happened in the brain",
    "loading": "Building the house …",
    "organisation": "Organisation",
    "organisationHint": "Switch organisation (admins only; on production with staff elevation)",
    "ownOrganisation": "Own organisation",
    "rangeLabel": "Range",
    "range": {
      "heute": "Today",
      "woche": "Last 7 days",
      "monat": "Last 30 days"
    },
    "lead": {
      "heute_one": "Today {{count}} new document came in.",
      "heute_other": "Today {{count}} new documents came in.",
      "woche_one": "In the last 7 days {{count}} new document came in.",
      "woche_other": "In the last 7 days {{count}} new documents came in.",
      "monat_one": "In the last 30 days {{count}} new document came in.",
      "monat_other": "In the last 30 days {{count}} new documents came in."
    },
    "stand": "As of {{date}}",
    "houseCrumb": "{{name}} · whole house",
    "house": "Whole house",
    "aiSummary": "AI summary",
    "summaryPending": "The AI summary comes with the next step. Until then the house shows the figures from the documents.",
    "stats": {
      "newDocuments": "new documents",
      "newFacts": "new facts in the graph",
      "chat": "questions in chat",
      "activeRooms": "rooms with activity"
    },
    "connections": {
      "title": "Connections between rooms",
      "pruefen": "Please check",
      "zus": "Connection",
      "luecke": "Gap"
    },
    "moved": "What moved in the rooms",
    "docsShort_one": "+{{count}} doc",
    "docsShort_other": "+{{count}} docs",
    "noAccess": "no access",
    "lockedNotice": "You have no access to this room. Access is granted by the area administration.",
    "rightsNote": "The house shows only your organisation and the areas you may enter. With fewer rights you see less.",
    "nothingNew": "Nothing new came in during this range.",
    "topicsPending": "An area's topics come from the knowledge graph in the next step.",
    "hintHouse": "Drag to rotate · Click a room to step in · Click the tree, a crane or the info wall to learn what it means",
    "hintRoom": "Click a screen to open it in the panel · Esc goes back",
    "stageLabel": "Isometric house with the knowledge areas as rooms. Everything is also in the panel.",
    "day": {
      "today": "today",
      "yesterday": "yesterday",
      "ago_one": "{{count}} day ago",
      "ago_other": "{{count}} days ago"
    },
    "room": {
      "area": "Knowledge area",
      "forAll": "open to everyone",
      "documents_one": "{{count}} document",
      "documents_other": "{{count}} documents",
      "owner": "maintained by {{owner}}",
      "latest": "Newest documents",
      "topicsTitle": "What people are talking about here"
    },
    "screen": {
      "neu": "New arrivals",
      "themen": "Topics",
      "ai": "AI",
      "nothingNew": "Nothing new in this range",
      "noTopics": "Topics come from the knowledge graph in the next step.",
      "forAll": "for all",
      "digestFallback": "{{docs}} new documents, {{facts}} new facts. The AI summary follows.",
      "mentions_one": "{{count}} mention",
      "mentions_other": "{{count}} mentions",
      "sign": "Wissenshaus · {{open}} areas open · {{locked}} locked",
      "building": "Building {{letter}}",
      "flag": "Wissenshaus"
    },
    "tour": {
      "title": "Tour",
      "start": "Start tour",
      "hint": "all rooms with news one after another, good for a team meeting",
      "progress": "{{name}} · {{index}} of {{total}}",
      "pause": "Pause",
      "resume": "Resume",
      "stop": "End",
      "none": "There is no news in the selected range."
    },
    "view": {
      "title": "View",
      "motion": "Motion",
      "voll": "Full",
      "ruhig": "Calm",
      "aus": "Off",
      "light": "Light",
      "auto": "Now",
      "tag": "Day",
      "abend": "Evening",
      "note": "“Calm” saves computing power: rings and threads move, but people stand still, no documents, snow or leaves fall, clouds, cranes and wind turbines stop, and so does the flag. “Off” stops everything and only redraws when you do something. “Matching” uses your organisation’s house design. Wind turbines are decoration only.",
      "season": "Season",
      "seasons": {
        "fruehling": "Spring",
        "sommer": "Summer",
        "herbst": "Autumn",
        "winter": "Winter"
      },
      "design": "House design",
      "designs": {
        "auto": "Matching",
        "modern": "Modern",
        "backstein": "Brick",
        "holz": "Wood"
      },
      "wind": "Wind turbines",
      "windOptions": {
        "aus": "Off",
        "an": "On"
      }
    },
    "error": {
      "load": "The Wissenshaus could not be loaded.",
      "noOrganisation": "Your account belongs to no organisation. Without an organisation there is no Wissenshaus.",
      "forbidden": "You cannot open this organisation. Another organisation needs an active staff elevation.",
      "retry": "Try again",
      "webgl": "This browser cannot show the 3D view. Everything is also in the panel."
    },
    "askRoom": "Ask the room",
    "askRoomHint": "Opens cdbChat next to the house. The first question searches only this knowledge area.",
    "legend": {
      "title": "Legend",
      "heading": "What the signs mean",
      "ring": "Ring on the floor: new documents in the period, the bigger, the more",
      "screens": "Three screens on the back wall: summary, newly arrived and topics. The strip below glows orange when there is something new",
      "threads": "Thread of light: a connection between rooms, red means please check. A click shows what it is about",
      "locked": "Closed grey room: no access, only the name is shown",
      "lamps": "In the evening the lights are on where people worked today; lanterns and the logo at the entrance glow",
      "cards": "Paper from above: an uploaded document arrives (only with motion “Full”)",
      "people": "People: sit and walk in rooms with new documents, visitors come to the entrance. A placeholder, later based on the questions in the chat",
      "tree": "Knowledge tree beside the house: grows with the new facts in the graph, more topics give more crowns",
      "crane": "Crane: an area under construction, still below 400 documents",
      "infowall": "Info wall on the roof: new documents, new facts and rooms with activity in the period"
    },
    "objects": {
      "inRange": {
        "heute": "today",
        "woche": "in the last 7 days",
        "monat": "in the last 30 days"
      },
      "tree": {
        "title": "Knowledge tree",
        "text_one": "It grows with the new facts in the graph: {{facts}} new fact {{range}}. The crowns stand for {{topics}} topics in the areas. The falling leaves are decoration only.",
        "text_other": "It grows with the new facts in the graph: {{facts}} new facts {{range}}. The crowns stand for {{topics}} topics in the areas. The falling leaves are decoration only."
      },
      "crane": {
        "title": "{{name}} under construction",
        "text_one": "This area has only {{total}} document, fewer than 400. The crane goes once it has grown.",
        "text_other": "This area has only {{total}} documents, fewer than 400. The crane goes once it has grown."
      },
      "infowall": {
        "title": "Info wall",
        "text": "Shows the figures of the selected period for the whole house: new documents, new facts in the graph and rooms with activity. An AI summary will follow later."
      },
      "cafe": {
        "title": "Coffee bar",
        "text": "Decoration only: a meeting point in the foyer. It shows no data."
      },
      "clouds": {
        "title": "Clouds",
        "text": "Decoration only, they show no data."
      },
      "wind": {
        "title": "Wind turbines",
        "text": "Decoration only. Switch them on or off under “View”."
      },
      "van": {
        "title": "Delivery van",
        "text_one": "{{docs}} new document {{range}}. If it was uploaded, now and then someone carries a parcel into the house (only with motion “Full”).",
        "text_other": "{{docs}} new documents {{range}}. If uploads are among them, now and then someone carries a parcel into the house (only with motion “Full”)."
      },
      "people": {
        "title": "People",
        "text": "Placeholder: how many people sit and walk in the house follows the new documents in the period, later the questions in the chat."
      }
    },
    "answerUsed": "The answer in the chat draws on:",
    "answerUsedClose": "Close notice"
  },
  "externalApp": {
    "openInTab": "Open in new tab",
    "loading": "Loading page …",
    "emptyHint": "If the window stays empty, the site does not allow embedding.",
    "slowTitle": "The page does not load",
    "slowBody": "It may not allow embedding, or it needs a sign-in that does not work inside a window. A new tab usually works.",
    "cannotFrameTitle": "This address cannot open in a window",
    "cannotFrameBody": "Only https pages on an address other than cdbOS run in a window. Open the app in a new tab.",
    "tabModeBody": "This app is set to \"Browser tab\"."
  },
  "documentVersions": {
    "badge": {
      "current": "v{{version}}",
      "superseded": "Older version (v{{version}})",
      "archived": "Archived (v{{version}})",
      "currentHint": "Current version {{version}} of this document",
      "supersededHint": "Superseded version {{version}}: still searchable, ranked lower",
      "archivedHint": "Archived version {{version}}: out of search, still downloadable"
    },
    "showOlder": "Show older versions",
    "section": {
      "title": "Versions",
      "empty": "No other versions",
      "download": "Download",
      "uploadNew": "Upload new version",
      "state": {
        "current": "current",
        "superseded": "superseded",
        "archived": "archived"
      },
      "loadFailed": "Versions could not be loaded."
    },
    "delete": {
      "chain_one": "Delete document",
      "chain_other": "Delete all {{count}} versions",
      "versionOnly": "Delete only this version – v{{version}} becomes current again",
      "reprocessHint": "v{{version}} is archived and is processed again for this; it is back in search once that has finished.",
      "olderOnly": "Only this older version is deleted. The current version stays as it is."
    }
  }
}
